/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(93);
	module.exports = __webpack_require__(100);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(66);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 2 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(124),
	    getValue = __webpack_require__(160);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define(factory);
		else if(typeof exports === 'object')
			exports["mojs"] = factory();
		else
			root["mojs"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "build/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(53);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(59);
		__webpack_require__(58);
		module.exports = __webpack_require__(61)('iterator');
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(28);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _module = __webpack_require__(16);
	
		var _module2 = _interopRequireDefault(_module);
	
		var _thenable = __webpack_require__(12);
	
		var _thenable2 = _interopRequireDefault(_thenable);
	
		var _tunable = __webpack_require__(13);
	
		var _tunable2 = _interopRequireDefault(_tunable);
	
		var _tweenable = __webpack_require__(11);
	
		var _tweenable2 = _interopRequireDefault(_tweenable);
	
		var _tween = __webpack_require__(8);
	
		var _tween2 = _interopRequireDefault(_tween);
	
		var _timeline = __webpack_require__(9);
	
		var _timeline2 = _interopRequireDefault(_timeline);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var h = __webpack_require__(19);
		var Bit = __webpack_require__(26);
		var shapesMap = __webpack_require__(20);
	
	
		// TODO
		//  - refactor
		//    - add setIfChanged to Module
		//  --
		//  - tween for every prop
	
		var Shape = function (_Tunable) {
		  (0, _inherits3.default)(Shape, _Tunable);
	
		  function Shape() {
		    (0, _classCallCheck3.default)(this, Shape);
		    return (0, _possibleConstructorReturn3.default)(this, _Tunable.apply(this, arguments));
		  }
	
		  /*
		    Method to declare module's defaults.
		    @private
		  */
	
		  Shape.prototype._declareDefaults = function _declareDefaults() {
		    // DEFAULTS / APIs
		    this._defaults = {
		      // where to append the module to [selector, HTMLElement]
		      parent: document.body,
		      // class name for the `el`
		      className: '',
		      // Possible values: [circle, line, zigzag, rect, polygon, cross, equal ]
		      shape: 'circle',
		      // ∆ :: Possible values: [color name, rgb, rgba, hex]
		      stroke: 'transparent',
		      // ∆ :: Possible values: [ 0..1 ]
		      strokeOpacity: 1,
		      // Possible values: ['butt' | 'round' | 'square']
		      strokeLinecap: '',
		      // ∆ :: Possible values: [ number ]
		      strokeWidth: 2,
		      // ∆ :: Units :: Possible values: [ number, string ]
		      strokeDasharray: 0,
		      // ∆ :: Units :: Possible values: [ number, string ]
		      strokeDashoffset: 0,
		      // ∆ :: Possible values: [color name, rgb, rgba, hex]
		      fill: 'deeppink',
		      // ∆ :: Possible values: [ 0..1 ]
		      fillOpacity: 1,
		      // {Boolean} - if should hide module with `opacity` instead of `display`
		      isSoftHide: true,
		      // {Boolean} - if should trigger composite layer for the `el`
		      isForce3d: false,
		      // ∆ :: Units :: Possible values: [ number, string ]
		      left: '50%',
		      // ∆ :: Units :: Possible values: [ number, string ]
		      top: '50%',
		      // ∆ :: Units :: Possible values: [ number, string ]
		      x: 0,
		      // ∆ :: Units :: Possible values: [ number, string ]
		      y: 0,
		      // ∆ :: Possible values: [ number ]
		      angle: 0,
		      // ∆ :: Possible values: [ number ]
		      scale: 1,
		      // ∆ :: Possible values: [ number ] Fallbacks to `scale`.
		      scaleX: null,
		      // ∆ :: Possible values: [ number ] Fallbacks to `scale`.
		      scaleY: null,
		      // ∆ :: Possible values: [ number, string ]
		      origin: '50% 50%',
		      // ∆ :: Possible values: [ 0..1 ]
		      opacity: 1,
		      // ∆ :: Units :: Possible values: [ number, string ]
		      rx: 0,
		      // ∆ :: Units :: Possible values: [ number, string ]
		      ry: 0,
		      // ∆ :: Possible values: [ number ]
		      points: 3,
		      // ∆ :: Possible values: [ number ]
		      radius: 50,
		      // ∆ :: Possible values: [ number ]
		      radiusX: null,
		      // ∆ :: Possible values: [ number ]
		      radiusY: null,
		      // Possible values: [ boolean ]
		      isShowStart: false,
		      // Possible values: [ boolean ]
		      isShowEnd: true,
		      // Possible values: [ boolean ]
		      isRefreshState: true,
		      // Possible values: [ number > 0 ]
		      duration: 400,
		      // Possible values: [ number ]
	
		      /* technical ones: */
		      // explicit width of the module canvas
		      width: null,
		      // explicit height of the module canvas
		      height: null,
		      // Possible values: [ number ]
		      // sizeGap:          0,
		      /* [boolean] :: If should have child shape. */
		      isWithShape: true,
		      // context for all the callbacks
		      callbacksContext: this
		    };
		  };
		  /*
		    Method to start the animation with optional new options.
		    @public
		    @overrides @ Tunable
		    @param {Object} New options to set on the run.
		    @returns {Object} this.
		  */
	
	
		  Shape.prototype.tune = function tune(o) {
		    _Tunable.prototype.tune.call(this, o);
		    // update shapeModule's size to the max in `then` chain
		    this._getMaxSizeInChain();
		    return this;
		  };
		  /*
		    Method to create a then record for the module.
		    @public
		    @overrides @ Thenable
		    @param    {Object} Options for the next animation.
		    @returns  {Object} this.
		  */
	
	
		  Shape.prototype.then = function then(o) {
		    // this._makeTimeline()
		    _Tunable.prototype.then.call(this, o);
		    // update shapeModule's size to the max in `then` chain
		    this._getMaxSizeInChain();
		    return this;
		  };
	
		  // ^ PUBLIC  METHOD(S) ^
		  // v PRIVATE METHOD(S) v
	
		  /*
		    Method to declare variables.
		    @overrides Thenable
		  */
	
	
		  Shape.prototype._vars = function _vars() {
		    // call _vars method on Thenable
		    _Tunable.prototype._vars.call(this);
		    this._lastSet = {};
		    // save previous module in the chain
		    this._prevChainModule = this._o.prevChainModule;
		    // should draw on foreign svg canvas
		    this.isForeign = !!this._o.ctx;
		    // this._o.isTimelineLess = true;
		    // should take an svg element as self bit
		    return this.isForeignBit = !!this._o.shape;
		  };
		  /*
		    Method to initialize modules presentation.
		    @private
		    @overrides Module
		  */
	
	
		  Shape.prototype._render = function _render() {
		    if (!this._isRendered && !this._isChained) {
		      // create `mojs` shape element
		      this.el = document.createElement('div');
		      // set name on the `el`
		      this.el.setAttribute('data-name', 'mojs-shape');
		      // set class on the `el`
		      this.el.setAttribute('class', this._props.className);
		      // create shape module
		      this._createShape();
		      // append `el` to parent
		      this._props.parent.appendChild(this.el);
		      // set position styles on the el
		      this._setElStyles();
		      // set initial position for the first module in the chain
		      this._setProgress(0, 0);
		      // show at start if `isShowStart`
		      if (this._props.isShowStart) {
		        this._show();
		      } else {
		        this._hide();
		      }
		      // set `_isRendered` hatch
		      this._isRendered = true;
		    } else if (this._isChained) {
		      // save elements from master module
		      this.el = this._masterModule.el;
		      this.shapeModule = this._masterModule.shapeModule;
		    }
	
		    return this;
		  };
		  /*
		    Method to set el styles on initialization.
		    @private
		  */
	
	
		  Shape.prototype._setElStyles = function _setElStyles() {
		    if (!this.el) {
		      return;
		    }
		    // if (!this.isForeign) {
		    var p = this._props,
		        style = this.el.style,
		        width = p.shapeWidth,
		        height = p.shapeHeight;
	
		    style.position = 'absolute';
		    this._setElSizeStyles(width, height);
	
		    if (p.isForce3d) {
		      var name = 'backface-visibility';
		      style['' + name] = 'hidden';
		      style['' + h.prefix.css + name] = 'hidden';
		    }
		    // }
		  };
		  /*
		    Method to set `width`/`height`/`margins` to the `el` styles.
		    @param {Number} Width.
		    @param {height} Height.
		  */
	
	
		  Shape.prototype._setElSizeStyles = function _setElSizeStyles(width, height) {
		    var style = this.el.style;
		    style.width = width + 'px';
		    style.height = height + 'px';
		    style['margin-left'] = -width / 2 + 'px';
		    style['margin-top'] = -height / 2 + 'px';
		  };
		  /*
		    Method to draw shape.
		    @private
		  */
	
	
		  Shape.prototype._draw = function _draw() {
		    if (!this.shapeModule) {
		      return;
		    }
	
		    var p = this._props,
		        bP = this.shapeModule._props;
		    // set props on bit
		    // bP.x                    = this._origin.x;
		    // bP.y                    = this._origin.y;
		    bP.rx = p.rx;
		    bP.ry = p.ry;
		    bP.stroke = p.stroke;
		    bP['stroke-width'] = p.strokeWidth;
		    bP['stroke-opacity'] = p.strokeOpacity;
		    bP['stroke-dasharray'] = p.strokeDasharray;
		    bP['stroke-dashoffset'] = p.strokeDashoffset;
		    bP['stroke-linecap'] = p.strokeLinecap;
		    bP['fill'] = p.fill;
		    bP['fill-opacity'] = p.fillOpacity;
		    bP.radius = p.radius;
		    bP.radiusX = p.radiusX;
		    bP.radiusY = p.radiusY;
		    bP.points = p.points;
	
		    this.shapeModule._draw();
		    this._drawEl();
		  };
		  /*
		    Method to set current modules props to main div el.
		    @private
		  */
	
	
		  Shape.prototype._drawEl = function _drawEl() {
		    // return;
		    if (this.el == null) {
		      return true;
		    }
		    var p = this._props;
		    var style = this.el.style;
	
		    // style.opacity = p.opacity;
		    this._isPropChanged('opacity') && (style.opacity = p.opacity);
		    if (!this.isForeign) {
		      this._isPropChanged('left') && (style.left = p.left);
		      this._isPropChanged('top') && (style.top = p.top);
	
		      var isX = this._isPropChanged('x'),
		          isY = this._isPropChanged('y'),
		          isTranslate = isX || isY,
		          isScaleX = this._isPropChanged('scaleX'),
		          isScaleY = this._isPropChanged('scaleY'),
		          isScale = this._isPropChanged('scale'),
		          isScale = isScale || isScaleX || isScaleY,
		          isRotate = this._isPropChanged('angle');
	
		      if (isTranslate || isScale || isRotate) {
		        var transform = this._fillTransform();
		        style[h.prefix.css + 'transform'] = transform;
		        style['transform'] = transform;
		      }
	
		      if (this._isPropChanged('origin') || this._deltas['origin']) {
		        var origin = this._fillOrigin();
		        style[h.prefix.css + 'transform-origin'] = origin;
		        style['transform-origin'] = origin;
		      }
		    }
		  };
		  /*
		    Method to check if property changed after the latest check.
		    @private
		    @param {String} Name of the property to check.
		    @returns {Boolean}
		  */
	
	
		  Shape.prototype._isPropChanged = function _isPropChanged(name) {
		    // if there is no recod for the property - create it
		    if (this._lastSet[name] == null) {
		      this._lastSet[name] = {};
		    }
		    if (this._lastSet[name].value !== this._props[name]) {
		      this._lastSet[name].value = this._props[name];
		      return true;
		    } else {
		      return false;
		    }
		  };
		  /*
		    Method to tune new option on run.
		    @private
		    @override @ Module
		    @param {Object}  Option to tune on run.
		  */
	
	
		  Shape.prototype._tuneNewOptions = function _tuneNewOptions(o) {
		    // call super on Module
		    _Tunable.prototype._tuneNewOptions.call(this, o);
		    // return if empty object
		    if (!(o != null && (0, _keys2.default)(o).length)) {
		      return 1;
		    }
	
		    // this._calcSize();
		    this._setElStyles();
		  };
		  /*
		    Method to get max radiusX value.
		    @private
		    @param {String} Radius name.
		  */
	
	
		  Shape.prototype._getMaxRadius = function _getMaxRadius(name) {
		    var selfSize, selfSizeX;
		    selfSize = this._getRadiusSize('radius');
		    return this._getRadiusSize(name, selfSize);
		  };
		  /*
		    Method to increase calculated size based on easing.
		    @private
		  */
	
	
		  Shape.prototype._increaseSizeWithEasing = function _increaseSizeWithEasing() {
		    var p = this._props,
		        easing = this._o.easing,
		        isStringEasing = easing && typeof easing === 'string';
	
		    switch (isStringEasing && easing.toLowerCase()) {
		      case 'elastic.out':
		      case 'elastic.inout':
		        p.size *= 1.25;
		        break;
		      case 'back.out':
		      case 'back.inout':
		        p.size *= 1.1;
		    }
		  };
		  /*
		    Method to increase calculated size based on bit ratio.
		    @private
		  */
		  // _increaseSizeWithBitRatio () {
		  //   var p   = this._props;
		  //   // p.size *= this.shape._props.ratio;
		  //   p.size += 2 * p.sizeGap;
		  // }
		  /*
		    Method to get maximum radius size with optional fallback.
		    @private
		    @param {Object}
		      @param key {String} Name of the radius - [radius|radiusX|radiusY].
		      @param @optional fallback {Number}  Optional number to set if there
		                                          is no value for the key.
		  */
	
	
		  Shape.prototype._getRadiusSize = function _getRadiusSize(name) {
		    var fallback = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
		    var delta = this._deltas[name];
		    // if value is delta value
		    if (delta != null) {
		      // get maximum number between start and end values of the delta
		      return Math.max(Math.abs(delta.end), Math.abs(delta.start));
		    } else if (this._props[name] != null) {
		      // else get the value from props object
		      return parseFloat(this._props[name]);
		    } else {
		      return fallback;
		    }
		  };
		  /*
		    Method to get max shape canvas size and save it to _props.
		    @private
		  */
	
	
		  Shape.prototype._getShapeSize = function _getShapeSize() {
		    var p = this._props,
	
		    // get maximum stroke value
		    stroke = this._getMaxStroke();
		    // save shape `width` and `height` to `_props`
		    p.shapeWidth = p.width != null ? p.width : 2 * this._getMaxRadius('radiusX') + stroke;
	
		    p.shapeHeight = p.height != null ? p.height : 2 * this._getMaxRadius('radiusY') + stroke;
		  };
		  /*
		    Method to create shape.
		    @private
		  */
	
	
		  Shape.prototype._createShape = function _createShape() {
		    // calculate max shape canvas size and set to _props
		    this._getShapeSize();
		    // don't create actual shape if !`isWithShape`
		    if (!this._props.isWithShape) {
		      return;
		    }
	
		    var p = this._props;
		    // get shape's class
		    var Shape = shapesMap.getShape(this._props.shape);
		    // create `_shape` module
		    this.shapeModule = new Shape({
		      width: p.shapeWidth,
		      height: p.shapeHeight,
		      parent: this.el
		    });
		  };
		  /*
		    Method to get max size in `then` chain
		    @private
		  */
	
	
		  Shape.prototype._getMaxSizeInChain = function _getMaxSizeInChain() {
		    var p = this._props,
		        maxW = 0,
		        maxH = 0;
	
		    for (var i = 0; i < this._modules.length; i++) {
		      this._modules[i]._getShapeSize();
		      maxW = Math.max(maxW, this._modules[i]._props.shapeWidth);
		      maxH = Math.max(maxH, this._modules[i]._props.shapeHeight);
		    }
	
		    this.shapeModule && this.shapeModule._setSize(maxW, maxH);
		    this._setElSizeStyles(maxW, maxH);
		  };
		  /*
		    Method to get max value of the strokeWidth.
		    @private
		  */
	
	
		  Shape.prototype._getMaxStroke = function _getMaxStroke() {
		    var p = this._props;
		    var dStroke = this._deltas['strokeWidth'];
		    return dStroke != null ? Math.max(dStroke.start, dStroke.end) : p.strokeWidth;
		  };
		  /*
		    Method to draw current progress of the deltas.
		    @private
		    @override @ Module
		    @param   {Number}  EasedProgress to set - [0..1].
		    @param   {Number}  Progress to set - [0..1].
		  */
	
	
		  Shape.prototype._setProgress = function _setProgress(easedProgress, progress) {
		    // call the super on Module
		    _module2.default.prototype._setProgress.call(this, easedProgress, progress);
		    // draw current progress
		    this._draw(easedProgress);
		  };
		  /*
		    Method to add callback overrides to passed object.
		    @private
		    @param {Object} Object to add the overrides to.
		  */
	
	
		  Shape.prototype._applyCallbackOverrides = function _applyCallbackOverrides(obj) {
		    var it = this,
		        p = this._props;
		    // specify control functions for the module
		    obj.callbackOverrides = {
		      onUpdate: function onUpdate(ep, p) {
		        return it._setProgress(ep, p);
		      },
		      onStart: function onStart(isFwd) {
		        // don't touch main `el` onStart in chained elements
		        if (it._isChained) {
		          return;
		        };
		        if (isFwd) {
		          it._show();
		        } else {
		          if (!p.isShowStart) {
		            it._hide();
		          }
		        }
		      },
		      onComplete: function onComplete(isFwd) {
		        // don't touch main `el` if not the last in `then` chain
		        if (!it._isLastInChain()) {
		          return;
		        }
		        if (isFwd) {
		          if (!p.isShowEnd) {
		            it._hide();
		          }
		        } else {
		          it._show();
		        }
		      },
		      onRefresh: function onRefresh(isBefore) {
		        p.isRefreshState && isBefore && it._refreshBefore();
		      }
		    };
		  };
		  /*
		    Method to setup tween and timeline options before creating them.
		    @override @ Tweenable
		    @private  
		  */
	
	
		  Shape.prototype._transformTweenOptions = function _transformTweenOptions() {
		    this._applyCallbackOverrides(this._o);
		  };
		  /*
		    Method to create transform string.
		    @private
		    @returns {String} Transform string.
		  */
	
	
		  Shape.prototype._fillTransform = function _fillTransform() {
		    var p = this._props,
		        scaleX = p.scaleX != null ? p.scaleX : p.scale,
		        scaleY = p.scaleY != null ? p.scaleY : p.scale,
		        scale = scaleX + ', ' + scaleY;
		    return 'translate(' + p.x + ', ' + p.y + ') rotate(' + p.angle + 'deg) scale(' + scale + ')';
		  };
		  /*
		    Method to create transform-origin string.
		    @private
		    @returns {String} Transform string.
		  */
	
	
		  Shape.prototype._fillOrigin = function _fillOrigin() {
		    var p = this._props,
		        str = '';
		    for (var i = 0; i < p.origin.length; i++) {
		      str += p.origin[i].string + ' ';
		    }
		    return str;
		  };
		  /*
		    Method to refresh state befor startTime.
		    @private
		  */
	
	
		  Shape.prototype._refreshBefore = function _refreshBefore() {
		    // call setProgress with eased and normal progress
		    this._setProgress(this.tween._props.easing(0), 0);
	
		    if (this._props.isShowStart) {
		      this._show();
		    } else {
		      this._hide();
		    }
		  };
		  /*
		    Method that gets called on `soft` show of the module,
		    it should restore transform styles of the module.
		    @private
		    @overrides @ Module
		  */
	
	
		  Shape.prototype._showByTransform = function _showByTransform() {
		    // reset the cache of the scale prop
		    this._lastSet.scale = null;
		    // draw el accroding to it's props
		    this._drawEl();
		  };
	
		  return Shape;
		}(_tunable2.default);
	
		exports.default = Shape;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _shape = __webpack_require__(2);
	
		var _shape2 = _interopRequireDefault(_shape);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/*
		  *TODO:*
		  ---
		  - tweak then chains
		*/
	
		var ShapeSwirl = function (_Shape) {
		  (0, _inherits3.default)(ShapeSwirl, _Shape);
	
		  function ShapeSwirl() {
		    (0, _classCallCheck3.default)(this, ShapeSwirl);
		    return (0, _possibleConstructorReturn3.default)(this, _Shape.apply(this, arguments));
		  }
	
		  /*
		    Method to declare _defaults and other default objects.
		    @private
		    @override @ Shape
		  */
	
		  ShapeSwirl.prototype._declareDefaults = function _declareDefaults() {
		    _Shape.prototype._declareDefaults.call(this);
	
		    /* _DEFAULTS ARE - Shape DEFAULTS + THESE: */
	
		    /* [boolean] :: If shape should follow sinusoidal path. */
		    this._defaults.isSwirl = true;
		    /* ∆ :: [number > 0] :: Degree size of the sinusoidal path. */
		    this._defaults.swirlSize = 10;
		    /* ∆ :: [number > 0] :: Frequency of the sinusoidal path. */
		    this._defaults.swirlFrequency = 3;
		    /* ∆ :: [number > 0] :: Sinusoidal path length scale. */
		    this._defaults.pathScale = 1;
		    /* ∆ :: [number] :: Degree shift for the sinusoidal path. */
		    this._defaults.degreeShift = 0;
		    /* ∆ :: [number] :: Radius of the shape. */
		    this._defaults.radius = 5;
		    // ∆ :: Units :: Possible values: [ number, string ]
		    this._defaults.x = 0;
		    // ∆ :: Units :: Possible values: [ number, string ]
		    this._defaults.y = 0;
		    // ∆ :: Possible values: [ number ]
		    this._defaults.scale = { 1: 0 };
		    /* [number: -1, 1] :: Directon of Swirl. */
		    this._defaults.direction = 1;
		  };
	
		  // ^ PUBLIC  METHOD(S) ^
		  // v PRIVATE METHOD(S) v
	
		  /*
		    Method to copy _o options to _props with
		    fallback to _defaults.
		    @private
		    @override @ Module
		  */
	
	
		  ShapeSwirl.prototype._extendDefaults = function _extendDefaults() {
		    _Shape.prototype._extendDefaults.call(this);
		    this._calcPosData();
		  };
		  /*
		    Method to tune new oprions to _o and _props object.
		    @private
		    @overrides @ Module
		    @param {Object} Options object to tune to.
		  */
	
	
		  ShapeSwirl.prototype._tuneNewOptions = function _tuneNewOptions(o) {
		    if (o == null) {
		      return;
		    }
	
		    _Shape.prototype._tuneNewOptions.call(this, o);
		    if (o.x != null || o.y != null) {
		      this._calcPosData();
		    }
		  };
		  /*
		    Method to calculate Swirl's position data.
		    @private
		  */
	
	
		  ShapeSwirl.prototype._calcPosData = function _calcPosData() {
		    var x = this._getPosValue('x'),
		        y = this._getPosValue('y'),
		        angle = 90 + Math.atan(y.delta / x.delta || 0) * _h2.default.RAD_TO_DEG;
	
		    this._posData = {
		      radius: Math.sqrt(x.delta * x.delta + y.delta * y.delta),
		      angle: x.delta < 0 ? angle + 180 : angle,
		      x: x, y: y
		    };
		    // set the last position to _props
		    // this._calcSwirlXY( 1 );
		  };
		  /*
		    Gets `x` or `y` position value.
		    @private
		    @param {String} Name of the property.
		  */
	
	
		  ShapeSwirl.prototype._getPosValue = function _getPosValue(name) {
		    var delta = this._deltas[name];
		    if (delta) {
		      // delete from deltas to prevent normal
		      delete this._deltas[name];
		      return {
		        start: delta.start.value,
		        end: delta.end.value,
		        delta: delta.delta,
		        units: delta.end.unit
		      };
		    } else {
		      var pos = _h2.default.parseUnit(this._props[name]);
		      return { start: pos.value, end: pos.value, delta: 0, units: pos.unit };
		    }
		  };
		  /*
		    Method to calculate the progress of the Swirl.
		    @private
		    @overrides @ Shape
		    @param {Numer} Eased progress of the Swirl in range of [0..1]
		    @param {Numer} Progress of the Swirl in range of [0..1]
		  */
	
	
		  ShapeSwirl.prototype._setProgress = function _setProgress(easedProgress, progress) {
		    this._progress = easedProgress;
		    this._calcCurrentProps(easedProgress, progress);
		    this._calcSwirlXY(easedProgress);
		    // this._calcOrigin();
		    this._draw(easedProgress);
		  };
		  /*
		    Method to calculate x/y for Swirl's progress
		    @private
		    @mutates _props
		    @param {Number} Current progress in [0...1]
		  */
	
	
		  ShapeSwirl.prototype._calcSwirlXY = function _calcSwirlXY(proc) {
		    var p = this._props,
		        angle = this._posData.angle + p.degreeShift,
		        point = _h2.default.getRadialPoint({
		      angle: p.isSwirl ? angle + this._getSwirl(proc) : angle,
		      radius: proc * this._posData.radius * p.pathScale,
		      center: {
		        x: this._posData.x.start,
		        y: this._posData.y.start
		      }
		    });
		    // if foreign svg canvas - set position without units
		    var x = point.x,
		        y = point.y,
		        smallNumber = 0.000001;
	
		    // remove very small numbers to prevent exponential forms
		    if (x > 0 && x < smallNumber) {
		      x = smallNumber;
		    }
		    if (y > 0 && y < smallNumber) {
		      y = smallNumber;
		    }
		    if (x < 0 && x > -smallNumber) {
		      x = -smallNumber;
		    }
		    if (y < 0 && y > -smallNumber) {
		      y = -smallNumber;
		    }
	
		    p.x = this._o.ctx ? x : '' + x + this._posData.x.units;
		    p.y = this._o.ctx ? y : '' + y + this._posData.y.units;
		  };
		  /*
		    Method to get progress of the swirl.
		    @private
		    @param {Number} Progress of the Swirl.
		    @returns {Number} Progress of the swirl.
		  */
	
	
		  ShapeSwirl.prototype._getSwirl = function _getSwirl(proc) {
		    var p = this._props;
		    return p.direction * p.swirlSize * Math.sin(p.swirlFrequency * proc);
		  };
		  /*
		    Method to draw shape.
		    If !isWithShape - draw self el only, but not shape.
		    @private
		    @overrides @ Shape.
		  */
	
	
		  ShapeSwirl.prototype._draw = function _draw() {
		    // call _draw or just _drawEl @ Shape depending if there is `shape`
		    var methodName = this._props.isWithShape ? '_draw' : '_drawEl';
		    _shape2.default.prototype[methodName].call(this);
		  };
	
		  return ShapeSwirl;
		}(_shape2.default);
	
		exports.default = ShapeSwirl;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(28);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _timeline = __webpack_require__(9);
	
		var _timeline2 = _interopRequireDefault(_timeline);
	
		var _shapeSwirl = __webpack_require__(3);
	
		var _shapeSwirl2 = _interopRequireDefault(_shapeSwirl);
	
		var _tunable = __webpack_require__(13);
	
		var _tunable2 = _interopRequireDefault(_tunable);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		// import Shape    from './shape';
	
		var Burst = function (_Tunable) {
		  (0, _inherits3.default)(Burst, _Tunable);
	
		  function Burst() {
		    (0, _classCallCheck3.default)(this, Burst);
		    return (0, _possibleConstructorReturn3.default)(this, _Tunable.apply(this, arguments));
		  }
	
		  /*
		    Method to declare defaults.
		    @override @ ShapeSwirl.
		  */
	
		  Burst.prototype._declareDefaults = function _declareDefaults() {
		    this._defaults = {
		      /* [number > 0] :: Quantity of Burst particles. */
		      count: 5,
		      /* [0 < number < 360] :: Degree of the Burst. */
		      degree: 360,
		      /* ∆ :: [number > 0] :: Radius of the Burst. */
		      radius: { 0: 50 },
		      /* ∆ :: [number > 0] :: X radius of the Burst. */
		      radiusX: null,
		      /* ∆ :: [number > 0] :: Y radius of the Burst. */
		      radiusY: null,
		      /* [number >= 0] :: width of the main swirl. */
		      width: 0,
		      /* [number >= 0] :: height of the main swirl. */
		      height: 0
		    };
		  };
		  /*
		    Method to create a then record for the module.
		    @public
		    overrides @ Thenable
		    @param    {Object} Options for the next animation.
		    @returns  {Object} this.
		  */
	
	
		  Burst.prototype.then = function then(o) {
		    // remove tween properties (not callbacks)
		    this._removeTweenProperties(o);
	
		    var newMaster = this._masterThen(o),
		        newSwirls = this._childThen(o);
	
		    this._setSwirlDuration(newMaster, this._calcPackTime(newSwirls));
	
		    this.timeline._recalcTotalDuration();
		    return this;
		  };
		  /*
		    Method to start the animation with optional new options.
		    @public
		    @param {Object} New options to set on the run.
		    @returns {Object} this.
		  */
	
	
		  Burst.prototype.tune = function tune(o) {
		    if (o == null) {
		      return this;
		    }
		    // save timeline options to _timelineOptions
		    // and delete the timeline options on o
		    // cuz masterSwirl should not get them
		    this._saveTimelineOptions(o);
	
		    // add new timeline properties to timeline
		    this.timeline._setProp(this._timelineOptions);
	
		    // remove tween options (not callbacks)
		    this._removeTweenProperties(o);
	
		    // tune _props
		    this._tuneNewOptions(o);
	
		    // tune master swirl
		    this.masterSwirl.tune(o);
	
		    // tune child swirls
		    this._tuneSwirls(o);
	
		    // recalc time for modules
		    this._recalcModulesTime();
		    return this;
		  };
	
		  // ^ PUBLIC  METHODS ^
		  // v PRIVATE METHODS v
	
		  /*
		    Method to copy `_o` options to `_props` object
		    with fallback to `_defaults`.
		    @private
		    @overrides @ Module
		  */
	
	
		  Burst.prototype._extendDefaults = function _extendDefaults() {
		    // remove tween properties (not callbacks)
		    this._removeTweenProperties(this._o);
		    _Tunable.prototype._extendDefaults.call(this);
		  };
		  /*
		    Method to remove all tween (excluding
		    callbacks) props from object.
		    @private
		    @param {Object} Object which should be cleaned
		                    up from tween properties.
		  */
	
	
		  Burst.prototype._removeTweenProperties = function _removeTweenProperties(o) {
		    for (var key in _h2.default.tweenOptionMap) {
		      // remove all items that are not declared in _defaults
		      if (this._defaults[key] == null) {
		        delete o[key];
		      }
		    }
		  };
		  /*
		    Method to recalc modules chain tween
		    times after tuning new options.
		    @private
		  */
	
	
		  Burst.prototype._recalcModulesTime = function _recalcModulesTime() {
		    var modules = this.masterSwirl._modules,
		        swirls = this._swirls,
		        shiftTime = 0;
	
		    for (var i = 0; i < modules.length; i++) {
		      var tween = modules[i].tween,
		          packTime = this._calcPackTime(swirls[i]);
		      tween._setProp({ 'duration': packTime, 'shiftTime': shiftTime });
		      shiftTime += packTime;
		    }
	
		    this.timeline._recalcTotalDuration();
		  };
		  /*
		    Method to tune Swirls with new options.
		    @private
		    @param {Object} New options.
		  */
	
	
		  Burst.prototype._tuneSwirls = function _tuneSwirls(o) {
		    // get swirls in first pack
		    var pack0 = this._swirls[0];
		    for (var i = 0; i < pack0.length; i++) {
		      var swirl = pack0[i],
		          option = this._getChildOption(o || {}, i);
	
		      // since the `degreeShift` participate in
		      // children position calculations, we need to keep
		      // the old `degreeShift` value if new not set
		      var isDegreeShift = option.degreeShift != null;
		      if (!isDegreeShift) {
		        option.degreeShift = this._swirls[0][i]._props.degreeShift;
		      }
	
		      this._addBurstProperties(option, i);
	
		      // after burst position calculation - delete the old `degreeShift`
		      // from the options, since anyways we have copied it from the swirl
		      if (!isDegreeShift) {
		        delete option.degreeShift;
		      }
	
		      swirl.tune(option);
		      this._refreshBurstOptions(swirl._modules, i);
		    }
		  };
		  /*
		    Method to refresh burst x/y/angle options on further chained 
		    swirls, because they will be overriden after `tune` call on
		    very first swirl.
		    @param {Array} Chained modules array
		    param {Number} Index of the first swirl in the chain.
		  */
	
	
		  Burst.prototype._refreshBurstOptions = function _refreshBurstOptions(modules, i) {
		    for (var j = 1; j < modules.length; j++) {
		      var module = modules[j],
		          options = {};
		      this._addBurstProperties(options, i, j);
		      module._tuneNewOptions(options);
		    }
		  };
		  /*
		    Method to call then on masterSwirl.
		    @param {Object} Then options.
		    @returns {Object} New master swirl.
		  */
	
	
		  Burst.prototype._masterThen = function _masterThen(o) {
		    this.masterSwirl.then(o);
		    // get the latest master swirl in then chain
		    var newMasterSwirl = _h2.default.getLastItem(this.masterSwirl._modules);
		    // save to masterSwirls
		    this._masterSwirls.push(newMasterSwirl);
		    return newMasterSwirl;
		  };
		  /*
		    Method to call then on child swilrs.
		    @param {Object} Then options.
		    @return {Array} Array of new Swirls.
		  */
	
	
		  Burst.prototype._childThen = function _childThen(o) {
		    var pack = this._swirls[0],
		        newPack = [];
	
		    for (var i = 0; i < pack.length; i++) {
		      // get option by modulus
		      var options = this._getChildOption(o, i);
		      var swirl = pack[i];
		      var lastSwirl = _h2.default.getLastItem(swirl._modules);
		      // add new Master Swirl as parent of new childswirl
		      options.parent = this.el;
	
		      this._addBurstProperties(options, i, this._masterSwirls.length - 1);
	
		      swirl.then(options);
	
		      // save the new item in `then` chain
		      newPack.push(_h2.default.getLastItem(swirl._modules));
		    }
		    // save the pack to _swirls object
		    this._swirls[this._masterSwirls.length - 1] = newPack;
		    return newPack;
		  };
		  /*
		    Method to initialize properties.
		    @private
		    @overrides @ Thenable
		  */
	
	
		  Burst.prototype._vars = function _vars() {
		    _Tunable.prototype._vars.call(this);
		    // just buffer timeline for calculations
		    this._bufferTimeline = new _timeline2.default();
		  };
		  /*
		    Method for initial render of the module.
		  */
	
	
		  Burst.prototype._render = function _render() {
		    this._o.isWithShape = false;
		    this._o.isSwirl = this._props.isSwirl;
		    this._o.callbacksContext = this;
		    // save timeline options and remove from _o
		    // cuz the master swirl should not get them
		    this._saveTimelineOptions(this._o);
	
		    this.masterSwirl = new MainSwirl(this._o);
		    this._masterSwirls = [this.masterSwirl];
		    this.el = this.masterSwirl.el;
	
		    this._renderSwirls();
		  };
		  /*
		    Method for initial render of swirls.
		    @private
		  */
	
	
		  Burst.prototype._renderSwirls = function _renderSwirls() {
		    var p = this._props,
		        pack = [];
	
		    for (var i = 0; i < p.count; i++) {
		      var option = this._getChildOption(this._o, i);
		      pack.push(new ChildSwirl(this._addOptionalProps(option, i)));
		    }
		    this._swirls = { 0: pack };
		    this._setSwirlDuration(this.masterSwirl, this._calcPackTime(pack));
		  };
		  /*
		    Method to save timeline options to _timelineOptions
		    and delete the property on the object.
		    @private
		    @param {Object} The object to save the timeline options from.
		  */
	
	
		  Burst.prototype._saveTimelineOptions = function _saveTimelineOptions(o) {
		    this._timelineOptions = o.timeline;
		    delete o.timeline;
		  };
		  /*
		    Method to calculate total time of array of
		    concurrent tweens.
		    @param   {Array}  Pack to calculate the total time for.
		    @returns {Number} Total pack duration.
		  */
	
	
		  Burst.prototype._calcPackTime = function _calcPackTime(pack) {
		    var maxTime = 0;
		    for (var i = 0; i < pack.length; i++) {
		      var tween = pack[i].tween,
		          p = tween._props;
	
		      maxTime = Math.max(p.repeatTime / p.speed, maxTime);
		    }
	
		    return maxTime;
		  };
		  /*
		    Method to set duration for Swirl.
		    @param {Object} Swirl instance to set the duration to.
		    @param {Number} Duration to set.
		  */
	
	
		  Burst.prototype._setSwirlDuration = function _setSwirlDuration(swirl, duration) {
		    swirl.tween._setProp('duration', duration);
		    var isRecalc = swirl.timeline && swirl.timeline._recalcTotalDuration;
		    isRecalc && swirl.timeline._recalcTotalDuration();
		  };
		  /*
		    Method to get childOption form object call by modulus.
		    @private
		    @param   {Object} Object to look in.
		    @param   {Number} Index of the current Swirl.
		    @returns {Object} Options for the current swirl.
		  */
	
	
		  Burst.prototype._getChildOption = function _getChildOption(obj, i) {
		    var options = {};
		    for (var key in obj.children) {
		      options[key] = this._getPropByMod(key, i, obj.children);
		    }
		    return options;
		  };
		  /*
		    Method to get property by modulus.
		    @private
		    @param {String} Name of the property.
		    @param {Number} Index for the modulus.
		    @param {Object} Source object to check in.
		    @returns {Any} Property.
		  */
	
	
		  Burst.prototype._getPropByMod = function _getPropByMod(name, index) {
		    var sourceObj = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
		    var prop = sourceObj[name];
		    return _h2.default.isArray(prop) ? prop[index % prop.length] : prop;
		  };
		  /*
		    Method to add optional Swirls' properties to passed object.
		    @private
		    @param {Object} Object to add the properties to.
		    @param {Number} Index of the property.
		  */
	
	
		  Burst.prototype._addOptionalProps = function _addOptionalProps(options, index) {
		    options.index = index;
		    options.parent = this.masterSwirl.el;
	
		    this._addBurstProperties(options, index);
	
		    return options;
		  };
		  /*
		    Method to add Burst options to object.
		    @private
		    @param {Object} Options to add the properties to.
		    @param {Number} Index of the Swirl.
		    @param {Number} Index of the main swirl.
		  */
	
	
		  Burst.prototype._addBurstProperties = function _addBurstProperties(options, index, i) {
		    // save index of the module
		    var mainIndex = this._index;
		    // temporary change the index to parse index based properties like stagger
		    this._index = index;
		    // parse degree shift for the bit
		    var degreeShift = this._parseProperty('degreeShift', options.degreeShift || 0);
		    // put the index of the module back
		    this._index = mainIndex;
	
		    var p = this._props,
		        degreeCnt = p.degree % 360 === 0 ? p.count : p.count - 1 || 1,
		        step = p.degree / degreeCnt,
		        pointStart = this._getSidePoint('start', index * step + degreeShift, i),
		        pointEnd = this._getSidePoint('end', index * step + degreeShift, i);
	
		    options.x = this._getDeltaFromPoints('x', pointStart, pointEnd);
		    options.y = this._getDeltaFromPoints('y', pointStart, pointEnd);
	
		    options.angle = this._getBitAngle(options.angle || 0, degreeShift, index);
		  };
		  /* 
		    Method to get shapes angle in burst so
		    it will follow circular shape.
		     
		     @param    {Number, Object} Base angle.
		     @param    {Number}         Angle shift for the bit
		     @param    {Number}         Shape's index in burst.
		     @returns  {Number}         Angle in burst.
		  */
	
	
		  Burst.prototype._getBitAngle = function _getBitAngle() {
		    var angleProperty = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		    var angleShift = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
		    var i = arguments[2];
	
		    var p = this._props,
		        degCnt = p.degree % 360 === 0 ? p.count : p.count - 1 || 1,
		        step = p.degree / degCnt,
		        angle = i * step + 90;
	
		    angle += angleShift;
		    // if not delta option
		    if (!this._isDelta(angleProperty)) {
		      angleProperty += angle;
		    } else {
		      var delta = {},
		          keys = (0, _keys2.default)(angleProperty),
		          start = keys[0],
		          end = angleProperty[start];
	
		      start = _h2.default.parseStringOption(start, i);
		      end = _h2.default.parseStringOption(end, i);
		      // new start = newEnd
		      delta[parseFloat(start) + angle] = parseFloat(end) + angle;
	
		      angleProperty = delta;
		    }
		    return angleProperty;
		  };
		  /*
		    Method to get radial point on `start` or `end`.
		    @private
		    @param {String} Name of the side - [start, end].
		    @param {Number} Angle of the radial point.
		    @param {Number} Index of the main swirl.
		    @returns radial point.
		  */
	
	
		  Burst.prototype._getSidePoint = function _getSidePoint(side, angle, i) {
		    var p = this._props,
		        sideRadius = this._getSideRadius(side, i);
	
		    return _h2.default.getRadialPoint({
		      radius: sideRadius.radius,
		      radiusX: sideRadius.radiusX,
		      radiusY: sideRadius.radiusY,
		      angle: angle,
		      // center:  { x: p.center, y: p.center }
		      center: { x: 0, y: 0 }
		    });
		  };
		  /*
		    Method to get radius of the side.
		    @private
		    @param {String} Name of the side - [start, end].
		    @param {Number} Index of the main swirl.
		    @returns {Object} Radius.
		  */
	
	
		  Burst.prototype._getSideRadius = function _getSideRadius(side, i) {
		    return {
		      radius: this._getRadiusByKey('radius', side, i),
		      radiusX: this._getRadiusByKey('radiusX', side, i),
		      radiusY: this._getRadiusByKey('radiusY', side, i)
		    };
		  };
		  /*
		    Method to get radius from ∆ or plain property.
		    @private
		    @param {String} Key name.
		    @param {String} Side name - [start, end].
		    @param {Number} Index of the main swirl.
		    @returns {Number} Radius value.
		  */
	
	
		  Burst.prototype._getRadiusByKey = function _getRadiusByKey(key, side) {
		    var i = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
	
		    var swirl = this._masterSwirls[i],
		        deltas = swirl._deltas,
		        props = swirl._props;
	
		    if (deltas[key] != null) {
		      return deltas[key][side];
		    } else if (props[key] != null) {
		      return props[key];
		    }
		  };
		  /*
		    Method to get delta from start and end position points.
		    @private
		    @param {String} Key name.
		    @param {Object} Start position point.
		    @param {Object} End position point.
		    @returns {Object} Delta of the end/start.
		  */
	
	
		  Burst.prototype._getDeltaFromPoints = function _getDeltaFromPoints(key, pointStart, pointEnd) {
		    var delta = {};
		    if (pointStart[key] === pointEnd[key]) {
		      delta = pointStart[key];
		    } else {
		      delta[pointStart[key]] = pointEnd[key];
		    }
		    return delta;
		  };
		  /*
		    Method to create timeline.
		    @private
		    @override @ Tweenable
		  */
	
	
		  Burst.prototype._makeTimeline = function _makeTimeline() {
		    // restore timeline options that were deleted in _render method
		    this._o.timeline = this._timelineOptions;
		    _Tunable.prototype._makeTimeline.call(this);
		    this.timeline.add(this.masterSwirl, this._swirls[0]);
		  };
		  /*
		    Method to make Tween for the module.
		    @private
		    @override @ Tweenable
		  */
	
	
		  Burst.prototype._makeTween = function _makeTween() {} /* don't create any tween */
		  /*
		    Override `_hide` and `_show` methods on module
		    since we don't have to hide nor show on the module.
		  */
		  ;
	
		  Burst.prototype._hide = function _hide() {/* do nothing */};
	
		  Burst.prototype._show = function _show() {/* do nothing */};
	
		  return Burst;
		}(_tunable2.default);
	
		var ChildSwirl = function (_ShapeSwirl) {
		  (0, _inherits3.default)(ChildSwirl, _ShapeSwirl);
	
		  function ChildSwirl() {
		    (0, _classCallCheck3.default)(this, ChildSwirl);
		    return (0, _possibleConstructorReturn3.default)(this, _ShapeSwirl.apply(this, arguments));
		  }
	
		  ChildSwirl.prototype._declareDefaults = function _declareDefaults() {
		    _ShapeSwirl.prototype._declareDefaults.call(this);
		    this._defaults.isSwirl = false;
		    this._o.duration = this._o.duration != null ? this._o.duration : 700;
		  };
		  // disable degreeshift calculations
	
	
		  ChildSwirl.prototype._calcSwirlXY = function _calcSwirlXY(proc) {
		    var degreeShift = this._props.degreeShift;
	
		    this._props.degreeShift = 0;
		    _ShapeSwirl.prototype._calcSwirlXY.call(this, proc);
		    this._props.degreeShift = degreeShift;
		  };
	
		  return ChildSwirl;
		}(_shapeSwirl2.default);
	
		var MainSwirl = function (_ChildSwirl) {
		  (0, _inherits3.default)(MainSwirl, _ChildSwirl);
	
		  function MainSwirl() {
		    (0, _classCallCheck3.default)(this, MainSwirl);
		    return (0, _possibleConstructorReturn3.default)(this, _ChildSwirl.apply(this, arguments));
		  }
	
		  MainSwirl.prototype._declareDefaults = function _declareDefaults() {
		    _ChildSwirl.prototype._declareDefaults.call(this);
		    this._defaults.scale = 1;
		    this._defaults.width = 0;
		    this._defaults.height = 0;
		    this._defaults.radius = { 25: 75 };
		    // this._defaults.duration = 2000;
		  };
	
		  return MainSwirl;
		}(ChildSwirl);
	
		Burst.ChildSwirl = ChildSwirl;
		Burst.MainSwirl = MainSwirl;
	
		exports.default = Burst;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends4 = __webpack_require__(27);
	
		var _extends5 = _interopRequireDefault(_extends4);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _keys = __webpack_require__(28);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _thenable = __webpack_require__(12);
	
		var _thenable2 = _interopRequireDefault(_thenable);
	
		var _tween = __webpack_require__(8);
	
		var _tween2 = _interopRequireDefault(_tween);
	
		var _deltas = __webpack_require__(15);
	
		var _deltas2 = _interopRequireDefault(_deltas);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var h = __webpack_require__(19);
	
	
		// get tween properties
		var obj = {};
		_tween2.default.prototype._declareDefaults.call(obj);
		var keys = (0, _keys2.default)(obj._defaults);
		for (var i = 0; i < keys.length; i++) {
		  obj._defaults[keys[i]] = 1;
		}
		obj._defaults['timeline'] = 1;
		var TWEEN_PROPERTIES = obj._defaults;
	
		/*
		  TODO:
	
		    - change _props to _propsObj for animations
		    - current values in deltas
		*/
	
		var Html = function (_Thenable) {
		  (0, _inherits3.default)(Html, _Thenable);
	
		  function Html() {
		    (0, _classCallCheck3.default)(this, Html);
		    return (0, _possibleConstructorReturn3.default)(this, _Thenable.apply(this, arguments));
		  }
	
		  Html.prototype._declareDefaults = function _declareDefaults() {
		    this._defaults = {
		      x: 0,
		      y: 0,
		      z: 0,
	
		      skewX: 0,
		      skewY: 0,
	
		      // angle:      0,
		      angleX: 0,
		      angleY: 0,
		      angleZ: 0,
	
		      scale: 1,
		      scaleX: 1,
		      scaleY: 1,
	
		      isSoftHide: true,
		      isShowStart: true,
		      isShowEnd: true,
		      isForce3d: false,
		      isRefreshState: true
	
		    };
		    // exclude from automatic drawing
		    this._drawExclude = { el: 1 };
		    // properties that cause 3d layer
		    this._3dProperties = ['angleX', 'angleY', 'z'];
		    // properties that have array values
		    this._arrayPropertyMap = { transformOrigin: 1, backgroundPosition: 1 };
		    // properties that have no units
		    this._numberPropertyMap = {
		      opacity: 1, scale: 1, scaleX: 1, scaleY: 1,
		      // angle: 1,
		      angleX: 1, angleY: 1, angleZ: 1,
		      skewX: 1, skewY: 1
		    };
		    // properties that should be prefixed
		    this._prefixPropertyMap = { transform: 1, transformOrigin: 1 };
		    // save prefix
		    this._prefix = h.prefix.css;
		  };
	
		  Html.prototype.then = function then(o) {
		    // return if nothing was passed
		    if (o == null || !(0, _keys2.default)(o).length) {
		      return 1;
		    }
	
		    // get the last item in `then` chain
		    var prevModule = h.getLastItem(this._modules);
		    // set deltas to the finish state
		    prevModule.deltas.refresh(false);
		    // copy finish state to the last history record
		    this._history[this._history.length - 1] = prevModule._o;
		    // call super
		    _Thenable.prototype.then.call(this, o);
		    // restore the _props
		    prevModule.deltas.restore();
	
		    return this;
		  };
		  /*
		    Method to pipe startValue of the delta.
		    @private
		    @ovarrides @ Thenable
		    @param {String} Start property name.
		    @param {Any} Start property value.
		    @returns {Any} Start property value.
		  */
	
	
		  Html.prototype._checkStartValue = function _checkStartValue(key, value) {
		    if (value == null) {
		      // return default value for transforms
		      if (this._defaults[key] != null) {
		        return this._defaults[key];
		      }
		      // return default value from _customProps
		      if (this._customProps[key] != null) {
		        return this._customProps[key];
		      }
		      // try to get the default value
		      if (h.defaultStyles[key] != null) {
		        return h.defaultStyles[key];
		      }
		      // at the end return 0
		      return 0;
		    }
	
		    return value;
		  };
		  /*
		    Method to draw _props to el.
		    @private
		  */
	
	
		  Html.prototype._draw = function _draw() {
		    var p = this._props;
		    for (var i = 0; i < this._drawProps.length; i++) {
		      var name = this._drawProps[i];
		      this._setStyle(name, p[name]);
		    }
		    // draw transforms
		    this._drawTransform();
		    // call custom transform callback if exist
		    this._customDraw && this._customDraw(this._props.el, this._props);
		  };
		  /*
		    Method to set transform on element.
		    @private
		  */
	
	
		  Html.prototype._drawTransform = function _drawTransform() {
		    var p = this._props;
		    var string = !this._is3d ? 'translate(' + p.x + ', ' + p.y + ')\n          rotate(' + p.angleZ + 'deg)\n          skew(' + p.skewX + 'deg, ' + p.skewY + 'deg)\n          scale(' + p.scaleX + ', ' + p.scaleY + ')' : 'translate3d(' + p.x + ', ' + p.y + ', ' + p.z + ')\n          rotateX(' + p.angleX + 'deg)\n          rotateY(' + p.angleY + 'deg)\n          rotateZ(' + p.angleZ + 'deg)\n          skew(' + p.skewX + 'deg, ' + p.skewY + 'deg)\n          scale(' + p.scaleX + ', ' + p.scaleY + ')';
	
		    this._setStyle('transform', string);
		  };
		  /*
		    Method to render on initialization.
		    @private
		    @overrides @ Module
		  */
	
	
		  Html.prototype._render = function _render() {
		    // return immediately if not the first in `then` chain
		    if (this._o.prevChainModule) {
		      return;
		    }
	
		    var p = this._props;
	
		    for (var i = 0; i < this._renderProps.length; i++) {
		      var name = this._renderProps[i],
		          value = p[name];
	
		      value = typeof value === 'number' ? value + 'px' : value;
		      this._setStyle(name, value);
		    }
	
		    this._draw();
	
		    if (!p.isShowStart) {
		      this._hide();
		    }
		  };
		  /*
		    Method to set style on el.
		    @private
		    @param {String} Style property name.
		    @param {String} Style property value.
		  */
	
	
		  Html.prototype._setStyle = function _setStyle(name, value) {
		    if (this._state[name] !== value) {
		      var style = this._props.el.style;
		      // set style
		      style[name] = value;
		      // if prefix needed - set it
		      if (this._prefixPropertyMap[name]) {
		        style['' + this._prefix + name] = value;
		      }
		      // cache the last set value
		      this._state[name] = value;
		    }
		  };
		  /*
		    Method to copy `_o` options to `_props` object.
		    @private
		  */
	
	
		  Html.prototype._extendDefaults = function _extendDefaults() {
		    this._props = this._o.props || {};
		    // props for intial render only
		    this._renderProps = [];
		    // props for draw on every frame update
		    this._drawProps = [];
		    // save custom properties if present
		    this._saveCustomProperties(this._o);
		    // copy the options
		    var o = (0, _extends5.default)({}, this._o);
		    // extend options with defaults
		    o = this._addDefaults(o);
	
		    var keys = (0, _keys2.default)(o);
		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];
		      // include the property if it is not in drawExclude object
		      // and not in defaults = not a transform
		      var isInclude = !this._drawExclude[key] && // not in exclude map
		      this._defaults[key] == null && // not transform property
		      !TWEEN_PROPERTIES[key]; // not tween property
	
		      var isCustom = this._customProps[key];
		      // copy all non-delta properties to the props
		      // if not delta then add the property to render
		      // list that is called on initialization
		      // otherwise add it to the draw list that will
		      // be drawed on each frame
		      if (!h.isDelta(o[key]) && !TWEEN_PROPERTIES[key]) {
		        this._parseOption(key, o[key]);
		        if (key === 'el') {
		          this._props.el = h.parseEl(o.el);
		          this.el = this._props.el;
		        }
		        if (isInclude && !isCustom) {
		          this._renderProps.push(key);
		        }
		        // copy delta prop but not transforms
		        // otherwise push it to draw list that gets traversed on every draw
		      } else if (isInclude && !isCustom) {
		          this._drawProps.push(key);
		        }
		    }
	
		    this._createDeltas(o);
		  };
		  /*
		    Method to save customProperties to _customProps.
		    @param {Object} Options of the module.
		  */
	
	
		  Html.prototype._saveCustomProperties = function _saveCustomProperties() {
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		    this._customProps = o.customProperties || {};
		    this._customProps = (0, _extends5.default)({}, this._customProps);
		    this._customDraw = this._customProps.draw;
		    delete this._customProps.draw;
		    delete o.customProperties;
	
		    this._copyDefaultCustomProps();
	
		    // if ( this._customProps ) {}
		    // this._customProps = this._customProps || {};
		  };
	
		  Html.prototype._copyDefaultCustomProps = function _copyDefaultCustomProps() {
		    for (var key in this._customProps) {
		      if (this._o[key] == null) {
		        this._o[key] = this._customProps[key];
		      }
		    }
		  };
		  /*
		    Method to reset some flags on merged options object.
		    @private
		    @overrides @ Thenable
		    @param   {Object} Options object.
		    @returns {Object} Options object.
		  */
	
	
		  Html.prototype._resetMergedFlags = function _resetMergedFlags(o) {
		    _Thenable.prototype._resetMergedFlags.call(this, o);
		    o.props = this._props;
		    o.customProperties = this._customProps;
		    return o;
		  };
		  /*
		    Method to parse option value.
		    @private
		    @param {String} Option name.
		    @param {Any} Option value.
		  */
	
	
		  Html.prototype._parseOption = function _parseOption(key, value) {
		    _Thenable.prototype._parseOption.call(this, key, value);
		    // at this point the property is parsed
		    var parsed = this._props[key];
		    // cast it to string if it is array
		    if (h.isArray(parsed)) {
		      this._props[key] = this._arrToString(parsed);
		    }
		  };
		  /*
		    Method cast array to string value.
		    @private
		    @param {Array} Array of parsed numbers with units.
		    @returns {String} Casted array.
		  */
	
	
		  Html.prototype._arrToString = function _arrToString(arr) {
		    var string = '';
		    for (var i = 0; i < arr.length; i++) {
		      string += arr[i].string + ' ';
		    }
		    return string;
		  };
		  /*
		    Method to add defauls to passed object.
		    @private
		    @param {Object} Object to add defaults to.
		  */
	
	
		  Html.prototype._addDefaults = function _addDefaults(obj) {
		    // flag that after all defaults are set will indicate
		    // if user have set the 3d transform
		    this._is3d = false;
	
		    for (var key in this._defaults) {
		      // skip property if it is listed in _skipProps
		      // if (this._skipProps && this._skipProps[key]) { continue; }
	
		      // copy the properties to the _o object
		      // if it's null - set the default value
		      if (obj[key] == null) {
		        // scaleX and scaleY should fallback to scale
		        if (key === 'scaleX' || key === 'scaleY') {
		          obj[key] = obj['scale'] != null ? obj['scale'] : this._defaults['scale'];
		        } else {
		          obj[key] = this._defaults[key];
		        }
		      } else {
		        // get if 3d property was set.
		        if (this._3dProperties.indexOf(key) !== -1) {
		          this._is3d = true;
		        }
		      }
		    }
	
		    if (this._o.isForce3d) {
		      this._is3d = true;
		    }
	
		    return obj;
		  };
		  /*
		    Lifecycle method to declare variables.
		    @private
		  */
	
	
		  Html.prototype._vars = function _vars() {
		    // set deltas to the last value, so the _props with
		    // end values will be copied to the _history, it is
		    // crucial for `then` chaining
		    this.deltas.refresh(false);
		    // call super vars
		    _Thenable.prototype._vars.call(this);
		    // state of set properties
		    this._state = {};
		    // restore delta values that we have refreshed before
		    this.deltas.restore(false);
		  };
		  /*
		    Method to create deltas from passed object.
		    @private
		    @param {Object} Options object to pass to the Deltas.
		  */
	
	
		  Html.prototype._createDeltas = function _createDeltas(options) {
		    this.deltas = new _deltas2.default({
		      options: options,
		      props: this._props,
		      arrayPropertyMap: this._arrayPropertyMap,
		      numberPropertyMap: this._numberPropertyMap,
		      customProps: this._customProps,
		      callbacksContext: options.callbacksContext || this,
		      isChained: !!this._o.prevChainModule
		    });
	
		    // if chained module set timeline to deltas' timeline
		    if (this._o.prevChainModule) {
		      this.timeline = this.deltas.timeline;
		    }
		  };
		  /* @overrides @ Tweenable */
	
	
		  Html.prototype._makeTween = function _makeTween() {};
	
		  Html.prototype._makeTimeline = function _makeTimeline() {
		    // do not create timeline if module if chained
		    if (this._o.prevChainModule) {
		      return;
		    }
		    // add callbacks overrides
		    this._o.timeline = this._o.timeline || {};
		    this._addCallbackOverrides(this._o.timeline);
		    _Thenable.prototype._makeTimeline.call(this);
		    this.timeline.add(this.deltas);
		  };
		  /*
		    Method to add callback overrides to passed object object.
		    @param {Object} Object to add overrides on.
		  */
	
	
		  Html.prototype._addCallbackOverrides = function _addCallbackOverrides(o) {
		    var it = this;
		    var p = this._props;
		    o.callbackOverrides = {
		      onUpdate: this._draw,
		      onRefresh: this._props.isRefreshState ? this._draw : void 0,
		      onStart: function onStart(isFwd) {
		        // don't touch main `el` onStart in chained elements
		        if (it._isChained) {
		          return;
		        };
		        // show if was hidden at start
		        if (isFwd && !p.isShowStart) {
		          it._show();
		        }
		        // hide if should be hidden at start
		        else {
		            if (!p.isShowStart) {
		              it._hide();
		            }
		          }
		      },
		      onComplete: function onComplete(isFwd) {
		        // don't touch main `el` if not the last in `then` chain
		        if (it._isChained) {
		          return;
		        }
		        if (isFwd) {
		          if (!p.isShowEnd) {
		            it._hide();
		          }
		        } else if (!p.isShowEnd) {
		          it._show();
		        }
		      }
		    };
		  };
	
		  /*
		    Method that gets called on `soft` show of the module,
		    it should restore transform styles of the module.
		    @private
		    @overrides @ Module
		  */
	
	
		  Html.prototype._showByTransform = function _showByTransform() {
		    this._drawTransform();
		  };
	
		  /*
		    Method to merge `start` and `end` for a property in then record.
		    @private
		    @param {String} Property name.
		    @param {Any}    Start value of the property.
		    @param {Any}    End value of the property.
		  */
		  // !! COVER !!
	
	
		  Html.prototype._mergeThenProperty = function _mergeThenProperty(key, startValue, endValue) {
		    // if isnt tween property
		    var isBoolean = typeof endValue === 'boolean',
		        curve,
		        easing;
	
		    if (!h.isTweenProp(key) && !this._nonMergeProps[key] && !isBoolean) {
	
		      var TWEEN_PROPS = {};
		      if (h.isObject(endValue) && endValue.to != null) {
		        for (var _key in endValue) {
		          if (TWEEN_PROPERTIES[_key] || _key === 'curve') {
		            TWEEN_PROPS[_key] = endValue[_key];
		            delete endValue[_key];
		          }
		        }
		        // curve    = endValue.curve;
		        // easing   = endValue.easing;
		        endValue = endValue.to;
		      }
	
		      // if end value is delta - just save it
		      if (this._isDelta(endValue)) {
	
		        var _TWEEN_PROPS = {};
		        for (var _key2 in endValue) {
		          if (TWEEN_PROPERTIES[_key2] || _key2 === 'curve') {
		            _TWEEN_PROPS[_key2] = endValue[_key2];
		            delete endValue[_key2];
		          }
		        }
		        var result = this._parseDeltaValues(key, endValue);
	
		        return (0, _extends5.default)({}, result, _TWEEN_PROPS);
		      } else {
		        var parsedEndValue = this._parsePreArrayProperty(key, endValue);
		        // if end value is not delta - merge with start value
		        if (this._isDelta(startValue)) {
		          var _extends2;
	
		          // if start value is delta - take the end value
		          // as start value of the new delta
		          return (0, _extends5.default)((_extends2 = {}, _extends2[h.getDeltaEnd(startValue)] = parsedEndValue, _extends2), TWEEN_PROPS);
		          // if both start and end value are not ∆ - make ∆
		        } else {
		            var _extends3;
	
		            return (0, _extends5.default)((_extends3 = {}, _extends3[startValue] = parsedEndValue, _extends3), TWEEN_PROPS);
		          }
		      }
		      // copy the tween values unattended
		    } else {
		        return endValue;
		      }
		  };
	
		  return Html;
		}(_thenable2.default);
	
		exports.default = Html;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _keys = __webpack_require__(28);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		var _timeline = __webpack_require__(9);
	
		var _timeline2 = _interopRequireDefault(_timeline);
	
		var _tunable = __webpack_require__(13);
	
		var _tunable2 = _interopRequireDefault(_tunable);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Stagger = function (_Tunable) {
		  (0, _inherits3.default)(Stagger, _Tunable);
	
		  function Stagger(options, Module) {
		    var _ret;
	
		    (0, _classCallCheck3.default)(this, Stagger);
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _Tunable.call(this));
	
		    return _ret = _this._init(options, Module), (0, _possibleConstructorReturn3.default)(_this, _ret);
		  }
		  /*
		    Method to create then chain on child modules.
		    @param {Object} Then options.
		    @return {Object} this.
		  */
	
	
		  Stagger.prototype.then = function then(o) {
		    if (o == null) {
		      return this;
		    }
		    for (var i = 0; i < this._modules.length; i++) {
		      // get child module's option and pass to the child `then`
		      this._modules[i].then(this._getOptionByIndex(i, o));
		    }
		    this.timeline._recalcTotalDuration();
		    return this;
		  };
		  /*
		    Method to tune child modules.
		    @param {Object} Tune options.
		    @return {Object} this.
		  */
	
	
		  Stagger.prototype.tune = function tune(o) {
		    if (o == null) {
		      return this;
		    }
		    for (var i = 0; i < this._modules.length; i++) {
		      // get child module's option and pass to the child `then`
		      this._modules[i].tune(this._getOptionByIndex(i, o));
		    }
		    this.timeline._recalcTotalDuration();
		    return this;
		  };
		  /*
		    Method to generate child modules.
		    @return {Object} this.
		  */
	
	
		  Stagger.prototype.generate = function generate() {
		    for (var i = 0; i < this._modules.length; i++) {
		      // get child module's option and pass to the child `then`
		      this._modules[i].generate();
		    }
		    this.timeline._recalcTotalDuration();
		    return this;
		  };
		  /*
		    Method to get an option by modulo and name.
		    @param {String} Name of the property to get.
		    @param {Number} Index for the modulo calculation.
		    @param {Object} Options hash to look in.
		    @return {Any} Property.
		  */
	
	
		  Stagger.prototype._getOptionByMod = function _getOptionByMod(name, i, store) {
		    var props = store[name];
		    // if not dom list then clone it to array
		    if (props + '' === '[object NodeList]' || props + '' === '[object HTMLCollection]') props = Array.prototype.slice.call(props, 0);
		    // get the value in array or return the value itself
		    var value = _h2.default.isArray(props) ? props[i % props.length] : props;
		    // check if value has the stagger expression, if so parse it
		    return _h2.default.parseIfStagger(value, i);
		  };
		  /*
		    Method to get option by modulo of index.
		    @param {Number} Index for modulo calculations.
		    @param {Object} Options hash to look in.
		  */
	
	
		  Stagger.prototype._getOptionByIndex = function _getOptionByIndex(i, store) {
		    var _this2 = this;
	
		    var options = {};
		    (0, _keys2.default)(store).forEach(function (key) {
		      return options[key] = _this2._getOptionByMod(key, i, store);
		    });
		    return options;
		  };
		  /*
		    Method to get total child modules quantity.
		    @param  {String} Name of quantifier in options hash.
		    @param  {Object} Options hash object.
		    @return {Number} Number of child object that should be defined.
		  */
	
	
		  Stagger.prototype._getChildQuantity = function _getChildQuantity(name, store) {
		    // if number was set
		    if (typeof name === 'number') {
		      return name;
		    }
	
		    var quantifier = store[name];
		    if (_h2.default.isArray(quantifier)) {
		      return quantifier.length;
		    } else if (quantifier + '' === '[object NodeList]') {
		      return quantifier.length;
		    } else if (quantifier + '' === '[object HTMLCollection]') {
		      return Array.prototype.slice.call(quantifier, 0).length;
		    } else if (quantifier instanceof HTMLElement) {
		      return 1;
		    } else if (typeof quantifier == 'string') {
		      return 1;
		    }
		  };
		  /*
		    Method to make stagger form options
		    @param {Object} Options.
		    @param {Object} Child class.
		  */
	
	
		  Stagger.prototype._init = function _init(options, Module) {
		    var count = this._getChildQuantity(options.quantifier || 'el', options);
		    this._createTimeline(options);this._modules = [];
		    for (var i = 0; i < count; i++) {
		      // get child module's option
		      var option = this._getOptionByIndex(i, options);
		      option.isRunLess = true;
		      // set index of the module
		      option.index = i;
		      // create child module
		      var module = new Module(option);this._modules.push(module);
		      // add child module's timeline to the self timeline
		      this.timeline.add(module);
		    }
		    return this;
		  };
		  /*
		    Method to create timeline.
		    @param {Object} Timeline options.
		  */
	
	
		  Stagger.prototype._createTimeline = function _createTimeline() {
		    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		    this.timeline = new _timeline2.default(options.timeline);
		  };
	
		  /* @overrides @ Tweenable */
	
	
		  Stagger.prototype._makeTween = function _makeTween() {};
	
		  Stagger.prototype._makeTimeline = function _makeTimeline() {};
	
		  return Stagger;
		}(_tunable2.default);
	
		module.exports = function (Module) {
		  return function (options) {
		    return new Stagger(options, Module);
		  };
		};
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		var _tween = __webpack_require__(8);
	
		var _tween2 = _interopRequireDefault(_tween);
	
		var _timeline = __webpack_require__(9);
	
		var _timeline2 = _interopRequireDefault(_timeline);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/*
		  Class for toggling opacity on bunch of elements
		  @class Spriter
		  @todo
		    - add isForce3d option
		    - add run new option merging
		    - add then chains
		*/
	
		var Spriter = function () {
		  /*
		    Defaults/APIs
		  */
	
		  Spriter.prototype._declareDefaults = function _declareDefaults() {
		    this._defaults = {
		      /*
		        Duration
		        @property duration
		        @type     {Number}
		      */
		      duration: 500,
		      /*
		        Delay
		        @property delay
		        @type     {Number}
		      */
		      delay: 0,
		      /*
		        Easing. Please see the 
		        [timeline module parseEasing function](timeline.coffee.html#parseEasing)
		        for all avaliable options.
		          @property easing
		        @type     {String, Function}
		      */
		      easing: 'linear.none',
		      /*
		        Repeat times count
		        
		        @property repeat
		        @type     {Number}
		      */
		      repeat: 0,
		      /*
		        Yoyo option defines if animation should be altered on repeat.
		        
		        @property yoyo
		        @type     {Boolean}
		      */
		      yoyo: false,
		      /*
		        isRunLess option prevents animation from running immediately after
		        initialization.
		        
		        @property isRunLess
		        @type     {Boolean}
		      */
		      isRunLess: false,
		      /*
		        isShowEnd option defines if the last frame should be shown when
		        animation completed.
		        
		        @property isShowEnd
		        @type     {Boolean}
		      */
		      isShowEnd: false,
		      /*
		        onStart callback will be called once on animation start.
		        
		        @property onStart
		        @type     {Function}
		      */
		      onStart: null,
		      /*
		        onUpdate callback will be called on every frame of the animation.
		        The current progress in range **[0,1]** will be passed to the callback.
		        
		        @property onUpdate
		        @type     {Function}
		      */
		      onUpdate: null,
		      /*
		        onComplete callback will be called once on animation complete.
		        
		        @property onComplete
		        @type     {Function}
		      */
		      onComplete: null
		    };
		  };
	
		  function Spriter() {
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    (0, _classCallCheck3.default)(this, Spriter);
	
		    this.o = o;
		    if (!this.o.el) {
		      return _h2.default.error('No "el" option specified, aborting');
		    }
		    this._vars();this._declareDefaults();this._extendDefaults();this._parseFrames();
		    if (this._frames.length <= 2) _h2.default.warn('Spriter: only ' + this._frames.length + ' frames found');
		    if (this._frames.length < 1) _h2.default.error("Spriter: there is no frames to animate, aborting");
		    this._createTween();
		    return this;
		  }
		  /*
		    Method to declare some variables.
		    
		    @method run
		    @param  {Object} New options
		    @todo   Implement new object merging
		  */
	
	
		  Spriter.prototype._vars = function _vars() {
		    this._props = _h2.default.cloneObj(this.o);
		    this.el = this.o.el;
		    this._frames = [];
		  };
		  /*
		    Method to run the spriter on demand.
		    
		    @method run
		    @param  {Object} New options
		    @todo   Implement new object merging
		  */
	
	
		  Spriter.prototype.run = function run(o) {
		    return this.timeline.play();
		  };
		  /*
		    Method to extend _props by options(this.o)
		    
		    @method _extendDefaults
		  */
	
	
		  Spriter.prototype._extendDefaults = function _extendDefaults() {
		    return _h2.default.extend(this._props, this._defaults);
		  };
		  /*
		    Method to parse frames as child nodes of el.
		    
		    @method _parseFrames
		  */
	
	
		  Spriter.prototype._parseFrames = function _parseFrames() {
		    this._frames = Array.prototype.slice.call(this.el.children, 0);
		    this._frames.forEach(function (frame, i) {
		      return frame.style.opacity = 0;
		    });
		    this._frameStep = 1 / this._frames.length;
		  };
	
		  /*
		    Method to create tween and timeline and supply callbacks.
		    
		    @method _createTween
		  */
	
	
		  Spriter.prototype._createTween = function _createTween() {
		    var _this = this;
	
		    this._tween = new _tween2.default({
		      duration: this._props.duration,
		      delay: this._props.delay,
		      yoyo: this._props.yoyo,
		      repeat: this._props.repeat,
		      easing: this._props.easing,
		      onStart: function onStart() {
		        return _this._props.onStart && _this._props.onStart();
		      },
		      onComplete: function onComplete() {
		        return _this._props.onComplete && _this._props.onComplete();
		      },
		      onUpdate: function onUpdate(p) {
		        return _this._setProgress(p);
		      }
		    });
		    this.timeline = new _timeline2.default();this.timeline.add(this._tween);
		    if (!this._props.isRunLess) this._startTween();
		  };
	
		  /*
		    Method to start tween
		    
		    @method _startTween
		  */
	
	
		  Spriter.prototype._startTween = function _startTween() {
		    var _this2 = this;
	
		    setTimeout(function () {
		      return _this2.timeline.play();
		    }, 1);
		  };
		  /*
		    Method to set progress of the sprite
		    
		    @method _setProgress
		    @param  {Number} Progress in range **[0,1]**
		  */
	
	
		  Spriter.prototype._setProgress = function _setProgress(p) {
		    // get the frame number
		    var proc = Math.floor(p / this._frameStep);
		    // react only if frame changes
		    if (this._prevFrame != this._frames[proc]) {
		      // if previous frame isnt current one, hide it
		      if (this._prevFrame) {
		        this._prevFrame.style.opacity = 0;
		      }
		      // if end of animation and isShowEnd flag was specified
		      // then show the last frame else show current frame
		      var currentNum = p === 1 && this._props.isShowEnd ? proc - 1 : proc;
		      // show the current frame
		      if (this._frames[currentNum]) {
		        this._frames[currentNum].style.opacity = 1;
		      }
		      // set previous frame as current
		      this._prevFrame = this._frames[proc];
		    }
		    if (this._props.onUpdate) {
		      this._props.onUpdate(p);
		    }
		  };
	
		  return Spriter;
		}();
	
		exports.default = Spriter;
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		var _tweener = __webpack_require__(10);
	
		var _tweener2 = _interopRequireDefault(_tweener);
	
		var _easing = __webpack_require__(22);
	
		var _easing2 = _interopRequireDefault(_easing);
	
		var _module = __webpack_require__(16);
	
		var _module2 = _interopRequireDefault(_module);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		// import h from '../h';
	
		var Tween = function (_Module) {
		  (0, _inherits3.default)(Tween, _Module);
	
		  /*
		    Method do declare defaults with this._defaults object.
		    @private
		  */
	
		  Tween.prototype._declareDefaults = function _declareDefaults() {
		    // DEFAULTS
		    this._defaults = {
		      /* duration of the tween [0..∞] */
		      duration: 350,
		      /* delay of the tween [-∞..∞] */
		      delay: 0,
		      /* repeat of the tween [0..∞], means how much to
		         repeat the tween regardless first run,
		         for instance repeat: 2 will make the tween run 3 times */
		      repeat: 0,
		      /* speed of playback [0..∞], speed that is less then 1
		         will slowdown playback, for instance .5 will make tween
		         run 2x slower. Speed of 2 will speedup the tween to 2x. */
		      speed: 1,
		      /*  flip onUpdate's progress on each even period.
		          note that callbacks order won't flip at least
		          for now (under consideration). */
		      isYoyo: false,
		      /* easing for the tween, could be any easing type [link to easing-types.md] */
		      easing: 'Sin.Out',
		      /*
		        Easing for backward direction of the tweenthe tween,
		        if `null` - fallbacks to `easing` property.
		        forward direction in `yoyo` period is treated as backward for the easing.
		      */
		      backwardEasing: null,
		      /* custom tween's name */
		      name: null,
		      /* custom tween's base name */
		      nameBase: 'Tween',
		      /*
		        onProgress callback runs before any other callback.
		        @param {Number}   The entire, not eased, progress
		                          of the tween regarding repeat option.
		        @param {Boolean}  The direction of the tween.
		                          `true` for forward direction.
		                          `false` for backward direction(tween runs in reverse).
		      */
		      onProgress: null,
		      /*
		        onStart callback runs on very start of the tween just after onProgress
		        one. Runs on very end of the tween if tween is reversed.
		        @param {Boolean}  Direction of the tween.
		                          `true` for forward direction.
		                          `false` for backward direction(tween runs in reverse).
		      */
		      onStart: null,
		      onRefresh: null,
		      onComplete: null,
		      onRepeatStart: null,
		      onRepeatComplete: null,
		      onFirstUpdate: null,
		      onUpdate: null,
		      isChained: false,
		      // playback callbacks
		      onPlaybackStart: null,
		      onPlaybackPause: null,
		      onPlaybackStop: null,
		      onPlaybackComplete: null,
		      // context which all callbacks will be called with
		      callbacksContext: null
		    };
		  };
		  /*
		    API method to play the Tween.
		    @public
		    @param  {Number} Shift time in milliseconds.
		    @return {Object} Self.
		  */
	
	
		  Tween.prototype.play = function play() {
		    var shift = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
		    if (this._state === 'play' && this._isRunning) {
		      return this;
		    }
		    this._props.isReversed = false;
		    this._subPlay(shift, 'play');
		    this._setPlaybackState('play');
		    return this;
		  };
		  /*
		    API method to play the Tween in reverse.
		    @public
		    @param  {Number} Shift time in milliseconds.
		    @return {Object} Self.
		  */
	
	
		  Tween.prototype.playBackward = function playBackward() {
		    var shift = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
		    if (this._state === 'reverse' && this._isRunning) {
		      return this;
		    }
		    this._props.isReversed = true;
		    this._subPlay(shift, 'reverse');
		    this._setPlaybackState('reverse');
		    return this;
		  };
		  /*
		    API method to pause Tween.
		    @public
		    @returns {Object} Self.
		  */
	
	
		  Tween.prototype.pause = function pause() {
		    if (this._state === 'pause' || this._state === 'stop') {
		      return this;
		    }
		    this._removeFromTweener();
		    this._setPlaybackState('pause');
		    return this;
		  };
		  /*
		    API method to stop the Tween.
		    @public
		    @param   {Number} Progress [0..1] to set when stopped.
		    @returns {Object} Self.
		  */
	
	
		  Tween.prototype.stop = function stop(progress) {
		    if (this._state === 'stop') {
		      return this;
		    }
	
		    this._wasUknownUpdate = undefined;
	
		    var stopProc = progress != null ? progress
		    /* if no progress passsed - set 1 if tween
		       is playingBackward, otherwise set to 0 */
		    : this._state === 'reverse' ? 1 : 0;
	
		    this.setProgress(stopProc);
	
		    this.reset();
		    return this;
		  };
		  /*
		    API method to replay(restart) the Tween.
		    @public
		    @param   {Number} Shift time in milliseconds.
		    @returns {Object} Self.
		  */
	
	
		  Tween.prototype.replay = function replay() {
		    var shift = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
		    this.reset();
		    this.play(shift);
		    return this;
		  };
		  /*
		    API method to replay(restart) backward the Tween.
		    @public
		    @param   {Number} Shift time in milliseconds.
		    @returns {Object} Self.
		  */
	
	
		  Tween.prototype.replayBackward = function replayBackward() {
		    var shift = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
		    this.reset();
		    this.playBackward(shift);
		    return this;
		  };
		  /*
		    API method to resume the Tween.
		    @public
		    @param  {Number} Shift time in milliseconds.
		    @return {Object} Self.
		  */
	
	
		  Tween.prototype.resume = function resume() {
		    var shift = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
		    if (this._state !== 'pause') {
		      return this;
		    }
	
		    switch (this._prevState) {
		      case 'play':
		        this.play(shift);
		        break;
		      case 'reverse':
		        this.playBackward(shift);
		        break;
		    }
	
		    return this;
		  };
		  /*
		    API method to set progress on tween.
		    @public
		    @param {Number} Progress to set.
		    @returns {Object} Self.
		  */
	
	
		  Tween.prototype.setProgress = function setProgress(progress) {
		    var p = this._props;
		    // set start time if there is no one yet.
		    !p.startTime && this._setStartTime();
		    // reset play time
		    this._playTime = null;
		    // progress should be in range of [0..1]
		    progress < 0 && (progress = 0);
		    progress > 1 && (progress = 1);
		    // update self with calculated time
		    this._update(p.startTime - p.delay + progress * p.repeatTime);
		    return this;
		  };
		  /*
		    Method to set tween's speed.
		    @public
		    @param {Number} Speed value.
		    @returns this.
		  */
	
	
		  Tween.prototype.setSpeed = function setSpeed(speed) {
		    this._props.speed = speed;
		    // if playing - normalize _startTime and _prevTime to the current point.
		    if (this._state === 'play' || this._state === 'reverse') {
		      this._setResumeTime(this._state);
		    }
		    return this;
		  };
		  /*
		    Method to reset tween's state and properties.
		    @public
		    @returns this.
		  */
	
	
		  Tween.prototype.reset = function reset() {
		    this._removeFromTweener();
		    this._setPlaybackState('stop');
		    this._progressTime = 0;
		    this._isCompleted = false;
		    this._isStarted = false;
		    this._isFirstUpdate = false;
		    this._wasUknownUpdate = undefined;
		    this._prevTime = undefined;
		    this._prevYoyo = undefined;
		    // this._props.startTime  = undefined;
		    this._props.isReversed = false;
		    return this;
		  };
	
		  // ^ PUBLIC  METHOD(S) ^
		  // v PRIVATE METHOD(S) v
	
		  /*
		    Method to launch play. Used as launch
		    method for bothplay and reverse methods.
		    @private
		    @param  {Number} Shift time in milliseconds.
		    @param  {String} Play or reverse state.
		    @return {Object} Self.
		  */
	
	
		  Tween.prototype._subPlay = function _subPlay() {
		    var shift = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
		    var state = arguments[1];
	
		    var resumeTime,
		        startTime,
		        p = this._props,
	
		    // check if direction of playback changes,
		    // if so, the _progressTime needs to be flipped
		    _state = this._state,
		        _prevState = this._prevState,
		        isPause = _state === 'pause',
		        wasPlay = _state === 'play' || isPause && _prevState === 'play',
		        wasReverse = _state === 'reverse' || isPause && _prevState === 'reverse',
		        isFlip = wasPlay && state === 'reverse' || wasReverse && state === 'play';
	
		    // if tween was ended, set progress to 0 if not, set to elapsed progress
		    this._progressTime = this._progressTime >= p.repeatTime ? 0 : this._progressTime;
		    // flip the _progressTime if playback direction changed
		    if (isFlip) {
		      this._progressTime = p.repeatTime - this._progressTime;
		    }
		    // set resume time and normalize prev/start times
		    this._setResumeTime(state, shift);
		    // add self to tweener = play
		    _tweener2.default.add(this);
		    return this;
		  };
		  /*
		    Method to set _resumeTime, _startTime and _prevTime.
		    @private
		    @param {String} Current state. [play, reverse]
		    @param {Number} Time shift. *Default* is 0.
		  */
	
	
		  Tween.prototype._setResumeTime = function _setResumeTime(state) {
		    var shift = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
		    // get current moment as resume time
		    this._resumeTime = performance.now();
		    // set start time regarding passed `shift` and `procTime`
		    var startTime = this._resumeTime - Math.abs(shift) - this._progressTime;
		    this._setStartTime(startTime, false);
		    // if we have prevTime - we need to normalize
		    // it for the current resume time
		    if (this._prevTime != null) {
		      this._prevTime = state === 'play' ? this._normPrevTimeForward() : this._props.endTime - this._progressTime;
		    }
		  };
		  /*
		    Method recalculate _prevTime for forward direction.
		    @private
		    @return {Number} Normalized prev time.
		  */
	
	
		  Tween.prototype._normPrevTimeForward = function _normPrevTimeForward() {
		    var p = this._props;
		    return p.startTime + this._progressTime - p.delay;
		  };
		  /*
		    Constructor of the class.
		    @private
		  */
	
	
		  function Tween() {
		    var _ret;
	
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    (0, _classCallCheck3.default)(this, Tween);
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _Module.call(this, o));
	
		    _this._props.name == null && _this._setSelfName();
		    return _ret = _this, (0, _possibleConstructorReturn3.default)(_this, _ret);
		  }
		  /*
		    Method to set self name to generic one.
		    @private
		  */
	
	
		  Tween.prototype._setSelfName = function _setSelfName() {
		    var globalName = '_' + this._props.nameBase + 's';
		    // track amount of tweens globally
		    _tweener2.default[globalName] = _tweener2.default[globalName] == null ? 1 : ++_tweener2.default[globalName];
		    // and set generic tween's name  || Tween # ||
		    this._props.name = this._props.nameBase + ' ' + _tweener2.default[globalName];
		  };
		  /*
		    Method set playback state string.
		    @private
		    @param {String} State name
		  */
	
	
		  Tween.prototype._setPlaybackState = function _setPlaybackState(state) {
		    // save previous state
		    this._prevState = this._state;
		    this._state = state;
	
		    // callbacks
		    var wasPause = this._prevState === 'pause',
		        wasStop = this._prevState === 'stop',
		        wasPlay = this._prevState === 'play',
		        wasReverse = this._prevState === 'reverse',
		        wasPlaying = wasPlay || wasReverse,
		        wasStill = wasStop || wasPause;
	
		    if ((state === 'play' || state === 'reverse') && wasStill) {
		      this._playbackStart();
		    }
		    if (state === 'pause' && wasPlaying) {
		      this._playbackPause();
		    }
		    if (state === 'stop' && (wasPlaying || wasPause)) {
		      this._playbackStop();
		    }
		  };
		  /*
		    Method to declare some vars.
		    @private
		  */
	
	
		  Tween.prototype._vars = function _vars() {
		    this.progress = 0;
		    this._prevTime = undefined;
		    this._progressTime = 0;
		    this._negativeShift = 0;
		    this._state = 'stop';
		    // if negative delay was specified,
		    // save it to _negativeShift property and
		    // reset it back to 0
		    if (this._props.delay < 0) {
		      this._negativeShift = this._props.delay;
		      this._props.delay = 0;
		    }
	
		    return this._calcDimentions();
		  };
		  /*
		    Method to calculate tween's dimentions.
		    @private
		  */
	
	
		  Tween.prototype._calcDimentions = function _calcDimentions() {
		    this._props.time = this._props.duration + this._props.delay;
		    this._props.repeatTime = this._props.time * (this._props.repeat + 1);
		  };
		  /*
		    Method to extend defaults by options and put them in _props.
		    @private
		  */
	
	
		  Tween.prototype._extendDefaults = function _extendDefaults() {
		    // save callback overrides object with fallback to empty one
		    this._callbackOverrides = this._o.callbackOverrides || {};
		    delete this._o.callbackOverrides;
		    // call the _extendDefaults @ Module
		    _Module.prototype._extendDefaults.call(this);
	
		    var p = this._props;
		    p.easing = _easing2.default.parseEasing(p.easing);
		    p.easing._parent = this;
	
		    // parse only present backward easing to prevent parsing as `linear.none`
		    // because we need to fallback to `easing` in `_setProgress` method
		    if (p.backwardEasing != null) {
		      p.backwardEasing = _easing2.default.parseEasing(p.backwardEasing);
		      p.backwardEasing._parent = this;
		    }
		  };
		  /*
		    Method for setting start and end time to props.
		    @private
		    @param {Number(Timestamp)}, {Null} Start time.
		    @param {Boolean} Should reset flags.
		    @returns this
		  */
	
	
		  Tween.prototype._setStartTime = function _setStartTime(time) {
		    var isResetFlags = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		    var p = this._props,
		        shiftTime = p.shiftTime || 0;
		    // reset flags
		    if (isResetFlags) {
		      this._isCompleted = false;this._isRepeatCompleted = false;
		      this._isStarted = false;
		    }
		    // set start time to passed time or to the current moment
		    var startTime = time == null ? performance.now() : time;
		    // calculate bounds
		    // - negativeShift is negative delay in options hash
		    // - shift time is shift of the parent
		    p.startTime = startTime + p.delay + this._negativeShift + shiftTime;
		    p.endTime = p.startTime + p.repeatTime - p.delay;
		    // set play time to the startTimes
		    // if playback controls are used - use _resumeTime as play time,
		    // else use shifted startTime -- shift is needed for timelines append chains
		    this._playTime = this._resumeTime != null ? this._resumeTime : startTime + shiftTime;
		    this._resumeTime = null;
	
		    return this;
		  };
		  /*
		    Method to update tween's progress.
		    @private
		    @param {Number} Current update time.
		    -- next params only present when parent Timeline calls the method.
		    @param {Number} Previous Timeline's update time.
		    @param {Boolean} Was parent in yoyo period.
		    @param {Number} [-1, 0, 1] If update is on edge.
		                   -1 = edge jump in negative direction.
		                    0 = no edge jump.
		                    1 = edge jump in positive direction.
		  */
	
	
		  Tween.prototype._update = function _update(time, timelinePrevTime, wasYoyo, onEdge) {
		    var p = this._props;
		    // if we don't the _prevTime thus the direction we are heading to,
		    // but prevTime was passed thus we are child of a Timeline
		    // set _prevTime to passed one and pretent that there was unknown
		    // update to not to block start/complete callbacks
		    if (this._prevTime == null && timelinePrevTime != null) {
	
		      if (this._props.speed && this._playTime) {
		        // play point + ( speed * delta )
		        this._prevTime = this._playTime + this._props.speed * (timelinePrevTime - this._playTime);
		      }
		      // this._prevTime = timelinePrevTime;
		      this._wasUknownUpdate = true;
		    }
	
		    // var before = time;
		    // cache vars
		    var startPoint = p.startTime - p.delay;
		    // if speed param was defined - calculate
		    // new time regarding speed
		    if (p.speed && this._playTime) {
		      // play point + ( speed * delta )
		      time = this._playTime + p.speed * (time - this._playTime);
		    }
	
		    // due to javascript precision issues, after speed mapping
		    // we can get very close number that was made from progress of 1
		    // and in fact represents `endTime` if so, set the time to `endTime`
		    if (Math.abs(p.endTime - time) < 0.00000001) {
		      time = p.endTime;
		    }
	
		    // if parent is onEdge but not very start nor very end
		    if (onEdge && wasYoyo != null) {
		      var T = this._getPeriod(time),
		          isYoyo = !!(p.isYoyo && this._props.repeat && T % 2 === 1);
	
		      // for timeline
		      // notify children about edge jump
		      if (this._timelines) {
		        for (var i = 0; i < this._timelines.length; i++) {
		          this._timelines[i]._update(time, timelinePrevTime, wasYoyo, onEdge);
		        }
		      }
		      // forward edge direction
		      if (onEdge === 1) {
		        // jumped from yoyo period?
		        if (wasYoyo) {
		          this._prevTime = time + 1;
		          this._repeatStart(time, isYoyo);
		          this._start(time, isYoyo);
		        } else {
		          this._prevTime = time - 1;
		          this._repeatComplete(time, isYoyo);
		          this._complete(time, isYoyo);
		        }
		        // backward edge direction
		      } else if (onEdge === -1) {
		          // jumped from yoyo period?
		          if (wasYoyo) {
		            this._prevTime = time - 1;
		            this._repeatComplete(time, isYoyo);
		            this._complete(time, isYoyo);
		          } else {
		            // call _start callbacks only if prev time was in active area
		            // not always true for append chains
		            if (this._prevTime >= p.startTime && this._prevTime <= p.endTime) {
		              this._prevTime = time + 1;
		              this._repeatStart(time, isYoyo);
		              this._start(time, isYoyo);
		              // reset isCOmpleted immediately to prevent onComplete cb
		              this._isCompleted = true;
		            }
		          }
		        }
		      // reset the _prevTime - drop one frame to undestand
		      // where we are heading
		      this._prevTime = undefined;
		    }
		    // if in active area and not ended - save progress time
		    // for pause/play purposes.
		    if (time > startPoint && time < p.endTime) {
		      this._progressTime = time - startPoint;
		    }
		    // else if not started or ended set progress time to 0
		    else if (time <= startPoint) {
		        this._progressTime = 0;
		      } else if (time >= p.endTime) {
		        // set progress time to repeat time + tiny cofficient
		        // to make it extend further than the end time
		        this._progressTime = p.repeatTime + .00000000001;
		      }
		    // reverse time if _props.isReversed is set
		    if (p.isReversed) {
		      time = p.endTime - this._progressTime;
		    }
		    // We need to know what direction we are heading to,
		    // so if we don't have the previous update value - this is very first
		    // update, - skip it entirely and wait for the next value
		    if (this._prevTime == null) {
		      this._prevTime = time;
		      this._wasUknownUpdate = true;
		      return false;
		    }
	
		    // ====== AFTER SKIPPED FRAME ======
	
		    // handle onProgress callback
		    if (time >= startPoint && time <= p.endTime) {
		      this._progress((time - startPoint) / p.repeatTime, time);
		    }
		    /*
		      if time is inside the active area of the tween.
		      active area is the area from start time to end time,
		      with all the repeat and delays in it
		    */
		    if (time >= p.startTime && time <= p.endTime) {
		      this._updateInActiveArea(time);
		    } else {
		      // if was in active area - update in inactive area but just once -
		      // right after the active area
		      if (this._isInActiveArea) {
		        this._updateInInactiveArea(time);
		      } else if (!this._isRefreshed) {
		        // onRefresh callback
		        // before startTime
		        if (time < p.startTime && this.progress !== 0) {
		          this._refresh(true);
		          this._isRefreshed = true;
		          // after endTime
		        }
		        // else if ( time > p.endTime ) { }
		      }
		    }
	
		    this._prevTime = time;
		    return time >= p.endTime || time <= startPoint;
		  };
		  /*
		    Method to handle tween's progress in inactive area.
		    @private
		    @param {Number} Current update time.
		  */
	
	
		  Tween.prototype._updateInInactiveArea = function _updateInInactiveArea(time) {
		    if (!this._isInActiveArea) {
		      return;
		    }
		    var p = this._props;
		    // complete if time is larger then end time
		    if (time > p.endTime && !this._isCompleted) {
		      this._progress(1, time);
		      // get period number
		      var T = this._getPeriod(p.endTime),
		          isYoyo = p.isYoyo && T % 2 === 0;
	
		      this._setProgress(isYoyo ? 0 : 1, time, isYoyo);
		      this._repeatComplete(time, isYoyo);
		      this._complete(time, isYoyo);
		    }
		    // if was active and went to - inactive area "-"
		    if (time < this._prevTime && time < p.startTime && !this._isStarted && !this._isCompleted) {
		      // if was in active area and didn't fire onStart callback
		      this._progress(0, time, false);
		      this._setProgress(0, time, false);
		      this._isRepeatStart = false;
		      this._repeatStart(time, false);
		      this._start(time, false);
		    }
		    this._isInActiveArea = false;
		  };
		  /*
		    Method to handle tween's progress in active area.
		    @private
		    @param {Number} Current update time.
		  */
	
	
		  Tween.prototype._updateInActiveArea = function _updateInActiveArea(time) {
	
		    var props = this._props,
		        delayDuration = props.delay + props.duration,
		        startPoint = props.startTime - props.delay,
		        elapsed = (time - props.startTime + props.delay) % delayDuration,
		        TCount = Math.round((props.endTime - props.startTime + props.delay) / delayDuration),
		        T = this._getPeriod(time),
		        TValue = this._delayT,
		        prevT = this._getPeriod(this._prevTime),
		        TPrevValue = this._delayT;
	
		    // "zero" and "one" value regarding yoyo and it's period
		    var isYoyo = props.isYoyo && T % 2 === 1,
		        isYoyoPrev = props.isYoyo && prevT % 2 === 1,
		        yoyoZero = isYoyo ? 1 : 0,
		        yoyoOne = 1 - yoyoZero;
	
		    if (time === props.endTime) {
		      this._wasUknownUpdate = false;
		      // if `time` is equal to `endTime`, T represents the next period,
		      // so we need to decrement T and calculate "one" value regarding yoyo
		      var isYoyo = props.isYoyo && (T - 1) % 2 === 1;
		      this._setProgress(isYoyo ? 0 : 1, time, isYoyo);
		      if (time > this._prevTime) {
		        this._isRepeatCompleted = false;
		      }
		      this._repeatComplete(time, isYoyo);
		      return this._complete(time, isYoyo);
		    }
	
		    // reset callback flags
		    this._isCompleted = false;
		    this._isRefreshed = false;
		    // if time is inside the duration area of the tween
		    if (startPoint + elapsed >= props.startTime) {
		      this._isInActiveArea = true;this._isRepeatCompleted = false;
		      this._isRepeatStart = false;this._isStarted = false;
		      // active zone or larger then end
		      var elapsed2 = (time - props.startTime) % delayDuration,
		          proc = elapsed2 / props.duration;
		      // |=====|=====|=====| >>>
		      //      ^1^2
		      var isOnEdge = T > 0 && prevT < T;
		      // |=====|=====|=====| <<<
		      //      ^2^1
		      var isOnReverseEdge = prevT > T;
	
		      // for use in timeline
		      this._onEdge = 0;
		      isOnEdge && (this._onEdge = 1);
		      isOnReverseEdge && (this._onEdge = -1);
	
		      if (this._wasUknownUpdate) {
		        if (time > this._prevTime) {
		          this._start(time, isYoyo);
		          this._repeatStart(time, isYoyo);
		          this._firstUpdate(time, isYoyo);
		        }
		        // if backward direction and
		        // if ( time < this._prevTime && time !== this._props.startTime ) {
		        if (time < this._prevTime) {
		          this._complete(time, isYoyo);
		          this._repeatComplete(time, isYoyo);
		          this._firstUpdate(time, isYoyo);
		          // reset isCompleted immediately
		          this._isCompleted = false;
		        }
		      }
	
		      if (isOnEdge) {
		        // if not just after delay
		        // |---=====|---=====|---=====| >>>
		        //            ^1 ^2
		        // because we have already handled
		        // 1 and onRepeatComplete in delay gap
		        if (this.progress !== 1) {
		          // prevT
		          var isThisYoyo = props.isYoyo && (T - 1) % 2 === 1;
		          this._repeatComplete(time, isThisYoyo);
		        }
		        // if on edge but not at very start
		        // |=====|=====|=====| >>>
		        // ^!    ^here ^here
		        if (prevT >= 0) {
		          this._repeatStart(time, isYoyo);
		        }
		      }
	
		      if (time > this._prevTime) {
		        //  |=====|=====|=====| >>>
		        // ^1  ^2
		        if (!this._isStarted && this._prevTime <= props.startTime) {
		          this._start(time, isYoyo);
		          this._repeatStart(time, isYoyo);
		          // it was zero anyways
	
		          // restart flags immediately in case if we will
		          // return to '-' inactive area on the next step
		          this._isStarted = false;
		          this._isRepeatStart = false;
		        }
		        this._firstUpdate(time, isYoyo);
		      }
	
		      if (isOnReverseEdge) {
		        // if on edge but not at very end
		        // |=====|=====|=====| <<<
		        //       ^here ^here ^not here
		        if (this.progress !== 0 && this.progress !== 1 && prevT != TCount) {
		          this._repeatStart(time, isYoyoPrev);
		        }
		        // if on very end edge
		        // |=====|=====|=====| <<<
		        //       ^!    ^! ^2 ^1
		        // we have handled the case in this._wasUknownUpdate
		        // block so filter that
		        if (prevT === TCount && !this._wasUknownUpdate) {
		          this._complete(time, isYoyo);
		          this._repeatComplete(time, isYoyo);
		          this._firstUpdate(time, isYoyo);
		          // reset isComplete flag call
		          // cuz we returned to active area
		          // this._isRepeatCompleted = false;
		          this._isCompleted = false;
		        }
		        this._repeatComplete(time, isYoyo);
		      }
	
		      if (prevT === 'delay') {
		        // if just before delay gap
		        // |---=====|---=====|---=====| <<<
		        //               ^2    ^1
		        if (T < TPrevValue) {
		          this._repeatComplete(time, isYoyo);
		        }
		        // if just after delay gap
		        // |---=====|---=====|---=====| >>>
		        //            ^1  ^2
		        if (T === TPrevValue && T > 0) {
		          this._repeatStart(time, isYoyo);
		        }
		      }
	
		      // swap progress and repeatStart based on direction
		      if (time > this._prevTime) {
		        // if progress is equal 0 and progress grows
		        if (proc === 0) {
		          this._repeatStart(time, isYoyo);
		        }
		        if (time !== props.endTime) {
		          this._setProgress(isYoyo ? 1 - proc : proc, time, isYoyo);
		        }
		      } else {
		        if (time !== props.endTime) {
		          this._setProgress(isYoyo ? 1 - proc : proc, time, isYoyo);
		        }
		        // if progress is equal 0 and progress grows
		        if (proc === 0) {
		          this._repeatStart(time, isYoyo);
		        }
		      }
	
		      if (time === props.startTime) {
		        this._start(time, isYoyo);
		      }
		      // delay gap - react only once
		    } else if (this._isInActiveArea) {
		        // because T will be string of "delay" here,
		        // let's normalize it be setting to TValue
		        var t = T === 'delay' ? TValue : T,
		            isGrows = time > this._prevTime;
		        // decrement period if forward direction of update
		        isGrows && t--;
		        // calculate normalized yoyoZero value
		        yoyoZero = props.isYoyo && t % 2 === 1 ? 1 : 0;
		        // if was in active area and previous time was larger
		        // |---=====|---=====|---=====| <<<
		        //   ^2 ^1    ^2 ^1    ^2 ^1
		        if (time < this._prevTime) {
		          this._setProgress(yoyoZero, time, yoyoZero === 1);
		          this._repeatStart(time, yoyoZero === 1);
		        }
		        // set 1 or 0 regarding direction and yoyo
		        this._setProgress(isGrows ? 1 - yoyoZero : yoyoZero, time, yoyoZero === 1);
		        // if time grows
		        if (time > this._prevTime) {
		          // if reverse direction and in delay gap, then progress will be 0
		          // if so we don't need to call the onRepeatComplete callback
		          // |---=====|---=====|---=====| <<<
		          //   ^0       ^0       ^0  
		          // OR we have flipped 0 to 1 regarding yoyo option
		          if (this.progress !== 0 || yoyoZero === 1) {
		            // since we repeatComplete for previous period
		            // invert isYoyo option
		            // is elapsed is 0 - count as previous period
		            this._repeatComplete(time, yoyoZero === 1);
		          }
		        }
		        // set flag to indicate inactive area
		        this._isInActiveArea = false;
		      }
		    // we've got the first update now
		    this._wasUknownUpdate = false;
		  };
		  /*
		    Method to remove the Tween from the tweener.
		    @private
		    @returns {Object} Self.
		  */
	
	
		  Tween.prototype._removeFromTweener = function _removeFromTweener() {
		    _tweener2.default.remove(this);return this;
		  };
		  /*
		    Method to get current period number.
		    @private
		    @param {Number} Time to get the period for.
		    @returns {Number} Current period number.
		  */
	
	
		  Tween.prototype._getPeriod = function _getPeriod(time) {
		    var p = this._props,
		        TTime = p.delay + p.duration,
		        dTime = p.delay + time - p.startTime,
		        T = dTime / TTime,
	
		    // if time if equal to endTime we need to set the elapsed
		    // time to 0 to fix the occasional precision js bug, which
		    // causes 0 to be something like 1e-12
		    elapsed = time < p.endTime ? dTime % TTime : 0;
		    // If the latest period, round the result, otherwise floor it.
		    // Basically we always can floor the result, but because of js
		    // precision issues, sometimes the result is 2.99999998 which
		    // will result in 2 instead of 3 after the floor operation.
		    T = time >= p.endTime ? Math.round(T) : Math.floor(T);
		    // if time is larger then the end time
		    if (time > p.endTime) {
		      // set equal to the periods count
		      T = Math.round((p.endTime - p.startTime + p.delay) / TTime);
		      // if in delay gap, set _delayT to current
		      // period number and return "delay"
		    } else if (elapsed > 0 && elapsed < p.delay) {
		        this._delayT = T;T = 'delay';
		      }
		    // if the end of period and there is a delay
		    return T;
		  };
		  /*
		    Method to set Tween's progress and call onUpdate callback.
		    @private
		    @override @ Module
		    @param {Number} Progress to set.
		    @param {Number} Current update time.
		    @param {Boolean} Is yoyo perido. Used in Timeline to pass to Tween.
		    @returns {Object} Self.
		  */
	
	
		  Tween.prototype._setProgress = function _setProgress(proc, time, isYoyo) {
		    var p = this._props,
		        isYoyoChanged = p.wasYoyo !== isYoyo,
		        isForward = time > this._prevTime;
	
		    this.progress = proc;
		    // get the current easing for `forward` direction regarding `yoyo`
		    if (isForward && !isYoyo || !isForward && isYoyo) {
		      this.easedProgress = p.easing(proc);
		      // get the current easing for `backward` direction regarding `yoyo`
		    } else if (!isForward && !isYoyo || isForward && isYoyo) {
		        var easing = p.backwardEasing != null ? p.backwardEasing : p.easing;
	
		        this.easedProgress = easing(proc);
		      }
	
		    if (p.prevEasedProgress !== this.easedProgress || isYoyoChanged) {
		      if (p.onUpdate != null && typeof p.onUpdate === 'function') {
		        p.onUpdate.call(p.callbacksContext || this, this.easedProgress, this.progress, isForward, isYoyo);
		      }
		    }
		    p.prevEasedProgress = this.easedProgress;
		    p.wasYoyo = isYoyo;
		    return this;
		  };
		  /*
		    Method to set tween's state to start and call onStart callback.
		    @method _start
		    @private
		    @param {Number} Progress to set.
		    @param {Boolean} Is yoyo period.
		  */
	
	
		  Tween.prototype._start = function _start(time, isYoyo) {
		    if (this._isStarted) {
		      return;
		    }
		    var p = this._props;
		    if (p.onStart != null && typeof p.onStart === 'function') {
		      p.onStart.call(p.callbacksContext || this, time > this._prevTime, isYoyo);
		    }
		    this._isCompleted = false;this._isStarted = true;
		    this._isFirstUpdate = false;
		  };
		  /*
		    Method to call onPlaybackStart callback
		    @private
		  */
	
	
		  Tween.prototype._playbackStart = function _playbackStart() {
		    var p = this._props;
		    if (p.onPlaybackStart != null && typeof p.onPlaybackStart === 'function') {
		      p.onPlaybackStart.call(p.callbacksContext || this);
		    }
		  };
		  /*
		    Method to call onPlaybackPause callback
		    @private
		  */
	
	
		  Tween.prototype._playbackPause = function _playbackPause() {
		    var p = this._props;
		    if (p.onPlaybackPause != null && typeof p.onPlaybackPause === 'function') {
		      p.onPlaybackPause.call(p.callbacksContext || this);
		    }
		  };
		  /*
		    Method to call onPlaybackStop callback
		    @private
		  */
	
	
		  Tween.prototype._playbackStop = function _playbackStop() {
		    var p = this._props;
		    if (p.onPlaybackStop != null && typeof p.onPlaybackStop === 'function') {
		      p.onPlaybackStop.call(p.callbacksContext || this);
		    }
		  };
		  /*
		    Method to call onPlaybackComplete callback
		    @private
		  */
	
	
		  Tween.prototype._playbackComplete = function _playbackComplete() {
		    var p = this._props;
		    if (p.onPlaybackComplete != null && typeof p.onPlaybackComplete === 'function') {
		      p.onPlaybackComplete.call(p.callbacksContext || this);
		    }
		  };
		  /*
		    Method to set tween's state to complete.
		    @method _complete
		    @private
		    @param {Number} Current time.
		    @param {Boolean} Is yoyo period.
		  */
	
	
		  Tween.prototype._complete = function _complete(time, isYoyo) {
		    if (this._isCompleted) {
		      return;
		    }
		    var p = this._props;
		    if (p.onComplete != null && typeof p.onComplete === 'function') {
		      p.onComplete.call(p.callbacksContext || this, time > this._prevTime, isYoyo);
		    }
	
		    this._isCompleted = true;this._isStarted = false;
		    this._isFirstUpdate = false;
		    // reset _prevYoyo for timeline usage
		    this._prevYoyo = undefined;
		  };
	
		  /*
		    Method to run onFirstUpdate callback.
		    @method _firstUpdate
		    @private
		    @param {Number} Current update time.
		    @param {Boolean} Is yoyo period.
		  */
	
	
		  Tween.prototype._firstUpdate = function _firstUpdate(time, isYoyo) {
		    if (this._isFirstUpdate) {
		      return;
		    }
		    var p = this._props;
		    if (p.onFirstUpdate != null && typeof p.onFirstUpdate === 'function') {
		      // onFirstUpdate should have tween pointer
		      p.onFirstUpdate.tween = this;
		      p.onFirstUpdate.call(p.callbacksContext || this, time > this._prevTime, isYoyo);
		    }
		    this._isFirstUpdate = true;
		  };
		  /*
		    Method call onRepeatComplete calback and set flags.
		    @private
		    @param {Number} Current update time.
		    @param {Boolean} Is repeat period.
		  */
	
	
		  Tween.prototype._repeatComplete = function _repeatComplete(time, isYoyo) {
		    if (this._isRepeatCompleted) {
		      return;
		    }
		    var p = this._props;
		    if (p.onRepeatComplete != null && typeof p.onRepeatComplete === 'function') {
		      p.onRepeatComplete.call(p.callbacksContext || this, time > this._prevTime, isYoyo);
		    }
		    this._isRepeatCompleted = true;
		    // this._prevYoyo = null;
		  };
	
		  /*
		    Method call onRepeatStart calback and set flags.
		    @private
		    @param {Number} Current update time.
		    @param {Boolean} Is yoyo period.
		  */
	
	
		  Tween.prototype._repeatStart = function _repeatStart(time, isYoyo) {
		    if (this._isRepeatStart) {
		      return;
		    }
		    var p = this._props;
		    if (p.onRepeatStart != null && typeof p.onRepeatStart === 'function') {
		      p.onRepeatStart.call(p.callbacksContext || this, time > this._prevTime, isYoyo);
		    }
		    this._isRepeatStart = true;
		  };
		  /*
		    Method to launch onProgress callback.
		    @method _progress
		    @private
		    @param {Number} Progress to set.
		  */
	
	
		  Tween.prototype._progress = function _progress(progress, time) {
		    var p = this._props;
		    if (p.onProgress != null && typeof p.onProgress === 'function') {
		      p.onProgress.call(p.callbacksContext || this, progress, time > this._prevTime);
		    }
		  };
		  /*
		    Method to launch onRefresh callback.
		    @method _refresh
		    @private
		    @param {Boolean} If refresh even before start time.
		  */
	
	
		  Tween.prototype._refresh = function _refresh(isBefore) {
		    var p = this._props;
		    if (p.onRefresh != null) {
		      var context = p.callbacksContext || this,
		          progress = isBefore ? 0 : 1;
	
		      p.onRefresh.call(context, isBefore, p.easing(progress), progress);
		    }
		  };
		  /*
		    Method which is called when the tween is removed from tweener.
		    @private
		  */
	
	
		  Tween.prototype._onTweenerRemove = function _onTweenerRemove() {};
		  /*
		    Method which is called when the tween is removed
		    from tweener when finished.
		    @private
		  */
	
	
		  Tween.prototype._onTweenerFinish = function _onTweenerFinish() {
		    this._setPlaybackState('stop');
		    this._playbackComplete();
		  };
		  /*
		    Method to set property[s] on Tween.
		    @private
		    @override @ Module
		    @param {Object, String} Hash object of key/value pairs, or property name.
		    @param {_} Property's value to set.
		  */
	
	
		  Tween.prototype._setProp = function _setProp(obj, value) {
		    _Module.prototype._setProp.call(this, obj, value);
		    this._calcDimentions();
		  };
		  /*
		    Method to set single property.
		    @private
		    @override @ Module
		    @param {String} Name of the property.
		    @param {Any} Value for the property.
		  */
	
	
		  Tween.prototype._assignProp = function _assignProp(key, value) {
		    // fallback to defaults
		    if (value == null) {
		      value = this._defaults[key];
		    }
		    // parse easing
		    if (key === 'easing') {
		      value = _easing2.default.parseEasing(value);
		      value._parent = this;
		    }
		    // handle control callbacks overrides
		    var control = this._callbackOverrides[key],
		        isntOverriden = !value || !value.isMojsCallbackOverride;
		    if (control && isntOverriden) {
		      value = this._overrideCallback(value, control);
		    }
		    // call super on Module
		    _Module.prototype._assignProp.call(this, key, value);
		  };
		  /*
		    Method to override callback for controll pupropes.
		    @private
		    @param {String}    Callback name.
		    @parma {Function}  Method to call  
		  */
	
	
		  Tween.prototype._overrideCallback = function _overrideCallback(callback, fun) {
		    var isCallback = callback && typeof callback === 'function',
		        override = function callbackOverride() {
		      // call overriden callback if it exists
		      isCallback && callback.apply(this, arguments);
		      // call the passed cleanup function
		      fun.apply(this, arguments);
		    };
		    // add overridden flag
		    override.isMojsCallbackOverride = true;
		    return override;
		  };
	
		  // _visualizeProgress(time) {
		  //   var str = '|',
		  //       procStr = ' ',
		  //       p = this._props,
		  //       proc = p.startTime - p.delay;
	
		  //   while ( proc < p.endTime ) {
		  //     if (p.delay > 0 ) {
		  //       var newProc = proc + p.delay;
		  //       if ( time > proc && time < newProc ) {
		  //         procStr += ' ^ ';
		  //       } else {
		  //         procStr += '   ';
		  //       }
		  //       proc = newProc;
		  //       str  += '---';
		  //     }
		  //     var newProc = proc + p.duration;
		  //     if ( time > proc && time < newProc ) {
		  //       procStr += '  ^   ';
		  //     } else if (time === proc) {
		  //       procStr += '^     ';
		  //     } else if (time === newProc) {
		  //       procStr += '    ^ ';
		  //     } else {
		  //       procStr += '      ';
		  //     }
		  //     proc = newProc;
		  //     str += '=====|';
		  //   }
	
		  //   console.log(str);
		  //   console.log(procStr);
		  // }
	
	
		  return Tween;
		}(_module2.default);
	
		exports.default = Tween;
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(29);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		var _tweener = __webpack_require__(10);
	
		var _tweener2 = _interopRequireDefault(_tweener);
	
		var _tween = __webpack_require__(8);
	
		var _tween2 = _interopRequireDefault(_tween);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Timeline = function (_Tween) {
		  (0, _inherits3.default)(Timeline, _Tween);
	
		  /*
		    API method to add child tweens/timelines.
		    @public
		    @param {Object, Array} Tween/Timeline or an array of such.
		    @returns {Object} Self.
		  */
	
		  Timeline.prototype.add = function add() {
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
	
		    this._pushTimelineArray(args);
		    this._calcDimentions();
		    return this;
		  };
		  /*
		    API method to append the Tween/Timeline to the end of the
		    timeline. Each argument is treated as a new append.
		    Array of tweens is treated as a parallel sequence. 
		    @public
		    @param {Object, Array} Tween/Timeline to append or array of such.
		    @returns {Object} Self.
		  */
	
	
		  Timeline.prototype.append = function append() {
		    for (var _len2 = arguments.length, timeline = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		      timeline[_key2] = arguments[_key2];
		    }
	
		    for (var _iterator = timeline, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var tm = _ref;
	
		      if (_h2.default.isArray(tm)) {
		        this._appendTimelineArray(tm);
		      } else {
		        this._appendTimeline(tm, this._timelines.length);
		      }
		      this._calcDimentions();
		    }
		    return this;
		  };
		  /*
		    API method to stop the Tween.
		    @public
		    @param   {Number} Progress [0..1] to set when stopped.
		    @returns {Object} Self.
		  */
	
	
		  Timeline.prototype.stop = function stop(progress) {
		    _Tween.prototype.stop.call(this, progress);
		    this._stopChildren(progress);
		    return this;
		  };
		  /*
		    Method to reset tween's state and properties.
		    @public
		    @overrides @ Tween
		    @returns this.
		  */
	
	
		  Timeline.prototype.reset = function reset() {
		    _Tween.prototype.reset.call(this);
		    this._resetChildren();
		    return this;
		  };
		  /*
		    Method to call `reset` method on all children.
		    @private
		  */
	
	
		  Timeline.prototype._resetChildren = function _resetChildren() {
		    for (var i = 0; i < this._timelines.length; i++) {
		      this._timelines[i].reset();
		    }
		  };
		  /*
		    Method to call `stop` method on all children.
		    @private
		    @param   {Number} Progress [0..1] to set when stopped.
		  */
	
	
		  Timeline.prototype._stopChildren = function _stopChildren(progress) {
		    for (var i = this._timelines.length - 1; i >= 0; i--) {
		      this._timelines[i].stop(progress);
		    }
		  };
		  /*
		    Method to set tween's state to complete.
		    @private
		    @overrides @ Tween
		    @param {Number} Current time.
		    @param {Boolean} Is yoyo period.
		  */
		  // _complete ( time, isYoyo ) {
		  //   // this._updateChildren( 1, time, isYoyo );
		  //   // this._setProgress( 1, time, isYoyo );
		  //   super._complete( time, isYoyo );
		  //   // this._resetChildren();
		  // }
	
		  // ^ PUBLIC  METHOD(S) ^
		  // v PRIVATE METHOD(S) v
	
		  /*
		    Method to append Tween/Timeline array or mix of such.
		    @private
		    @param {Array} Array of Tweens/Timelines.
		  */
	
	
		  Timeline.prototype._appendTimelineArray = function _appendTimelineArray(timelineArray) {
		    var i = timelineArray.length,
		        time = this._props.repeatTime - this._props.delay,
		        len = this._timelines.length;
	
		    while (i--) {
		      this._appendTimeline(timelineArray[i], len, time);
		    }
		  };
		  /*
		    Method to append a single timeline to the Timeline.
		    @private
		    @param {Object} Tween/Timline to append.
		    @param {Number} Index of the append.
		    @param {Number} Shift time.
		  */
	
	
		  Timeline.prototype._appendTimeline = function _appendTimeline(timeline, index, time) {
		    // if timeline is a module with timeline property then extract it
		    if (timeline.timeline instanceof Timeline) {
		      timeline = timeline.timeline;
		    }
		    if (timeline.tween instanceof _tween2.default) {
		      timeline = timeline.tween;
		    }
	
		    var shift = time != null ? time : this._props.duration;
		    shift += timeline._props.shiftTime || 0;
		    timeline.index = index;this._pushTimeline(timeline, shift);
		  };
		  /*
		    PrivateMethod to push Tween/Timeline array.
		    @private
		    @param {Array} Array of Tweens/Timelines.
		  */
	
	
		  Timeline.prototype._pushTimelineArray = function _pushTimelineArray(array) {
		    for (var i = 0; i < array.length; i++) {
		      var tm = array[i];
		      // recursive push to handle arrays of arrays
		      if (_h2.default.isArray(tm)) {
		        this._pushTimelineArray(tm);
		      } else {
		        this._pushTimeline(tm);
		      }
		    };
		  };
		  /*
		    Method to push a single Tween/Timeline.
		    @private
		    @param {Object} Tween or Timeline to push.
		    @param {Number} Number of milliseconds to shift the start time
		                    of the Tween/Timeline.
		  */
	
	
		  Timeline.prototype._pushTimeline = function _pushTimeline(timeline, shift) {
		    // if timeline is a module with timeline property then extract it
		    if (timeline.timeline instanceof Timeline) {
		      timeline = timeline.timeline;
		    }
		    if (timeline.tween instanceof _tween2.default) {
		      timeline = timeline.tween;
		    }
		    // add self delay to the timeline
		    shift != null && timeline._setProp({ 'shiftTime': shift });
		    this._timelines.push(timeline);
		    this._recalcDuration(timeline);
		  };
		  /*
		    Method set progress on self and child Tweens/Timelines.
		    @private
		    @param {Number} Progress to set.
		    @param {Number} Current update time.
		  */
	
	
		  Timeline.prototype._setProgress = function _setProgress(p, time, isYoyo) {
		    // we need to pass self previous time to children
		    // to prevent initial _wasUnknownUpdate nested waterfall
		    // if not yoyo option set, pass the previous time
		    // otherwise, pass previous or next time regarding yoyo period.
	
		    // COVER CURRENT SWAPPED ORDER
		    this._updateChildren(p, time, isYoyo);
	
		    _tween2.default.prototype._setProgress.call(this, p, time);
		  };
	
		  Timeline.prototype._updateChildren = function _updateChildren(p, time, isYoyo) {
		    var coef = time > this._prevTime ? -1 : 1;
		    if (this._props.isYoyo && isYoyo) {
		      coef *= -1;
		    }
		    var timeToTimelines = this._props.startTime + p * this._props.duration,
		        prevTimeToTimelines = timeToTimelines + coef,
		        len = this._timelines.length;
	
		    for (var i = 0; i < len; i++) {
		      // specify the children's array update loop direction
		      // if time > prevTime go from 0->length else from length->0
		      // var j = ( time > this._prevTime ) ? i : (len-1) - i ;
		      var j = timeToTimelines > prevTimeToTimelines ? i : len - 1 - i;
		      this._timelines[j]._update(timeToTimelines, prevTimeToTimelines, this._prevYoyo, this._onEdge);
		    }
		    this._prevYoyo = isYoyo;
		  };
		  /*
		    Method calculate self duration based on timeline's duration.
		    @private
		    @param {Object} Tween or Timeline to calculate.
		  */
	
	
		  Timeline.prototype._recalcDuration = function _recalcDuration(timeline) {
		    var p = timeline._props,
		        timelineTime = p.repeatTime / p.speed + (p.shiftTime || 0) + timeline._negativeShift;
	
		    this._props.duration = Math.max(timelineTime, this._props.duration);
		  };
		  /*
		    Method calculate self duration from skretch.
		    @private
		  */
	
	
		  Timeline.prototype._recalcTotalDuration = function _recalcTotalDuration() {
		    var i = this._timelines.length;
		    this._props.duration = 0;
		    while (i--) {
		      var tm = this._timelines[i];
		      // recalc total duration on child timelines
		      tm._recalcTotalDuration && tm._recalcTotalDuration();
		      // add the timeline's duration to selft duration
		      this._recalcDuration(tm);
		    }
		    this._calcDimentions();
		  };
		  /*
		    Method set start and end times.
		    @private
		    @param {Number, Null} Time to start with.
		  */
	
	
		  Timeline.prototype._setStartTime = function _setStartTime(time) {
		    var isReset = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		    _Tween.prototype._setStartTime.call(this, time);
		    this._startTimelines(this._props.startTime, isReset);
		  };
		  /*
		    Method calculate self duration based on timeline's duration.
		    @private
		    @param {Number, Null} Time to start with.
		  */
	
	
		  Timeline.prototype._startTimelines = function _startTimelines(time) {
		    var isReset = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		    var p = this._props,
		        isStop = this._state === 'stop';
	
		    time == null && (time = this._props.startTime);
	
		    for (var i = 0; i < this._timelines.length; i++) {
		      var tm = this._timelines[i];
		      tm._setStartTime(time, isReset);
		      // if from `_subPlay` and `_prevTime` is set and state is `stop`
		      // prevTime normalizing is for play/pause functionality, so no
		      // need to normalize if the timeline is in `stop` state.
		      if (!isReset && tm._prevTime != null && !isStop) {
		        tm._prevTime = tm._normPrevTimeForward();
		      }
		    }
		  };
		  /*
		    Method to launch onRefresh callback.
		    @method _refresh
		    @private
		    @overrides @ Tween
		    @param {Boolean} If refresh even before start time.
		  */
	
	
		  Timeline.prototype._refresh = function _refresh(isBefore) {
		    var len = this._timelines.length;
		    for (var i = 0; i < len; i++) {
		      this._timelines[i]._refresh(isBefore);
		    }
		    _Tween.prototype._refresh.call(this, isBefore);
		  };
		  /*
		    Method do declare defaults by this._defaults object
		    @private
		  */
	
	
		  Timeline.prototype._declareDefaults = function _declareDefaults() {
		    // if duration was passed on initialization stage, warn user and reset it.
		    if (this._o.duration != null) {
		      _h2.default.error('Duration can not be declared on Timeline, but "' + this._o.duration + '" is. You probably want to use Tween instead.');
		      this._o.duration = 0;
		    }
		    _Tween.prototype._declareDefaults.call(this);
		    // remove default
		    this._defaults.duration = 0;
		    this._defaults.easing = 'Linear.None';
		    this._defaults.backwardEasing = 'Linear.None';
		    this._defaults.nameBase = 'Timeline';
		  };
	
		  function Timeline() {
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    (0, _classCallCheck3.default)(this, Timeline);
		    return (0, _possibleConstructorReturn3.default)(this, _Tween.call(this, o));
		  }
		  /*
		    Method to declare some vars.
		    @private
		  */
	
	
		  Timeline.prototype._vars = function _vars() {
		    this._timelines = [];
		    _Tween.prototype._vars.call(this);
		  };
	
		  return Timeline;
		}(_tween2.default);
	
		exports.default = Timeline;
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		__webpack_require__(30);
	
		__webpack_require__(31);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Tweener = function () {
		  function Tweener() {
		    (0, _classCallCheck3.default)(this, Tweener);
	
		    this._vars();
		    this._listenVisibilityChange();
		    return this;
		  }
	
		  Tweener.prototype._vars = function _vars() {
		    this.tweens = [];
		    this._loop = this._loop.bind(this);
		    this._onVisibilityChange = this._onVisibilityChange.bind(this);
		  };
		  /*
		    Main animation loop. Should have only one concurrent loop.
		    @private
		    @returns this
		  */
	
	
		  Tweener.prototype._loop = function _loop() {
		    if (!this._isRunning) {
		      return false;
		    }
		    this._update(window.performance.now());
		    if (!this.tweens.length) {
		      return this._isRunning = false;
		    }
		    requestAnimationFrame(this._loop);
		    return this;
		  };
		  /*
		    Method to start animation loop.
		    @private
		  */
	
	
		  Tweener.prototype._startLoop = function _startLoop() {
		    if (this._isRunning) {
		      return;
		    };this._isRunning = true;
		    requestAnimationFrame(this._loop);
		  };
		  /*
		    Method to stop animation loop.
		    @private
		  */
	
	
		  Tweener.prototype._stopLoop = function _stopLoop() {
		    this._isRunning = false;
		  };
		  /*
		    Method to update every tween/timeline on animation frame.
		    @private
		  */
	
	
		  Tweener.prototype._update = function _update(time) {
		    var i = this.tweens.length;
		    while (i--) {
		      // cache the current tween
		      var tween = this.tweens[i];
		      if (tween && tween._update(time) === true) {
		        this.remove(tween);
		        tween._onTweenerFinish();
		        tween._prevTime = undefined;
		      }
		    }
		  };
		  /*
		    Method to add a Tween/Timeline to loop pool.
		    @param {Object} Tween/Timeline to add.
		  */
	
	
		  Tweener.prototype.add = function add(tween) {
		    // return if tween is already running
		    if (tween._isRunning) {
		      return;
		    }
		    tween._isRunning = true;
		    this.tweens.push(tween);
		    this._startLoop();
		  };
		  /*
		    Method stop updating all the child tweens/timelines.
		    @private
		  */
	
	
		  Tweener.prototype.removeAll = function removeAll() {
		    this.tweens.length = 0;
		  };
		  /*
		    Method to remove specific tween/timeline form updating.
		    @private
		  */
	
	
		  Tweener.prototype.remove = function remove(tween) {
		    var index = typeof tween === 'number' ? tween : this.tweens.indexOf(tween);
	
		    if (index !== -1) {
		      tween = this.tweens[index];
		      if (tween) {
		        tween._isRunning = false;
		        this.tweens.splice(index, 1);
		        tween._onTweenerRemove();
		      }
		    }
		  };
	
		  /*
		    Method to initialize event listeners to visibility change events.
		    @private
		  */
	
	
		  Tweener.prototype._listenVisibilityChange = function _listenVisibilityChange() {
		    if (typeof document.hidden !== "undefined") {
		      this._visibilityHidden = "hidden";
		      this._visibilityChange = "visibilitychange";
		    } else if (typeof document.mozHidden !== "undefined") {
		      this._visibilityHidden = "mozHidden";
		      this._visibilityChange = "mozvisibilitychange";
		    } else if (typeof document.msHidden !== "undefined") {
		      this._visibilityHidden = "msHidden";
		      this._visibilityChange = "msvisibilitychange";
		    } else if (typeof document.webkitHidden !== "undefined") {
		      this._visibilityHidden = "webkitHidden";
		      this._visibilityChange = "webkitvisibilitychange";
		    }
	
		    document.addEventListener(this._visibilityChange, this._onVisibilityChange, false);
		  };
		  /*
		    Method that will fire on visibility change.
		  */
	
	
		  Tweener.prototype._onVisibilityChange = function _onVisibilityChange() {
		    if (document[this._visibilityHidden]) {
		      this._savePlayingTweens();
		    } else {
		      this._restorePlayingTweens();
		    }
		  };
		  /*
		    Method to save all playing tweens.
		    @private
		  */
	
	
		  Tweener.prototype._savePlayingTweens = function _savePlayingTweens() {
		    this._savedTweens = this.tweens.slice(0);
		    for (var i = 0; i < this._savedTweens.length; i++) {
		      this._savedTweens[i].pause();
		    }
		  };
		  /*
		    Method to restore all playing tweens.
		    @private
		  */
	
	
		  Tweener.prototype._restorePlayingTweens = function _restorePlayingTweens() {
		    for (var i = 0; i < this._savedTweens.length; i++) {
		      this._savedTweens[i].resume();
		    }
		  };
	
		  return Tweener;
		}();
	
		var t = new Tweener();
		exports.default = t;
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _tween = __webpack_require__(8);
	
		var _tween2 = _interopRequireDefault(_tween);
	
		var _timeline = __webpack_require__(9);
	
		var _timeline2 = _interopRequireDefault(_timeline);
	
		var _module = __webpack_require__(16);
	
		var _module2 = _interopRequireDefault(_module);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/*
		  Class to define a module ancestor
		  with timeline and tween options and functionality.
		  All runable modules should inherit from this class.
	
		  @class Tweenable
		*/
	
		var Tweenable = function (_Module) {
		  (0, _inherits3.default)(Tweenable, _Module);
	
		  /*
		    `play` method for the timeline.
		    @public
		    @param {Number} Time shift.
		    @returns this.
		  */
	
		  Tweenable.prototype.play = function play() {
		    this.timeline.play.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    `playBackward` method for the timeline.
		    @public
		    @param {Number} Time shift.
		    @returns this.
		  */
	
	
		  Tweenable.prototype.playBackward = function playBackward() {
		    this.timeline.playBackward.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    `pause` method for the timeline.
		    @public
		    @returns this.
		  */
	
	
		  Tweenable.prototype.pause = function pause() {
		    this.timeline.pause.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    `stop` method for the timeline.
		    @public
		    @param {Number} [0...1] Progress to set on stop.
		                            *Default* is `0` if `play`
		                            and `1` if `playBAckward`.
		    @returns this.
		  */
	
	
		  Tweenable.prototype.stop = function stop() {
		    this.timeline.stop.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    `reset` method for the timeline.
		    @public
		    @returns this.
		  */
	
	
		  Tweenable.prototype.reset = function reset() {
		    this.timeline.reset.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    `replay` method for the timeline.
		    @public
		    @returns this.
		  */
	
	
		  Tweenable.prototype.replay = function replay() {
		    this.timeline.replay.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    `replay` method for the timeline.
		    @public
		    @returns this.
		  */
	
	
		  Tweenable.prototype.replayBackward = function replayBackward() {
		    this.timeline.replayBackward.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    `resume` method for the timeline.
		    @public
		    @param {Number} Time shift.
		    @returns this.
		  */
	
	
		  Tweenable.prototype.resume = function resume() {
		    var shift = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
	
		    this.timeline.resume.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    `setProgress` method for the timeline.
		    @public
		    @param {Number} [0...1] Progress value.
		    @returns this.
		  */
	
	
		  Tweenable.prototype.setProgress = function setProgress() {
		    this.timeline.setProgress.apply(this.timeline, arguments);
		    return this;
		  };
		  /*
		    setSpeed method for the timeline.
		    @param {Number} Speed value.
		    @returns this.
		  */
	
	
		  Tweenable.prototype.setSpeed = function setSpeed(speed) {
		    this.timeline.setSpeed.apply(this.timeline, arguments);
		    return this;
		  };
	
		  // ^ PUBLIC  METHOD(S) ^
		  // v PRIVATE METHOD(S) v
	
		  function Tweenable() {
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    (0, _classCallCheck3.default)(this, Tweenable);
	
		    // pipe function for _o object
		    // before creating tween/timeline
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _Module.call(this, o));
		    // super of Module
	
	
		    _this._transformTweenOptions();
		    // make tween only if isTweenLess option is not set
		    !_this._o.isTweenLess && _this._makeTween();
		    // make timeline only if isTimelineLess option is not set
		    !_this._o.isTimelineLess && _this._makeTimeline();
		    return _this;
		  }
		  /*
		    Placeholder method that should be overrided
		    and will be called before tween/timeline creation.
		    @private
		  */
	
	
		  Tweenable.prototype._transformTweenOptions = function _transformTweenOptions() {};
		  /*
		    Method to create tween.
		    @private
		  */
	
	
		  Tweenable.prototype._makeTween = function _makeTween() {
		    // pass callbacks context
		    this._o.callbacksContext = this._o.callbacksContext || this;
		    this.tween = new _tween2.default(this._o);
		    // make timeline property point to tween one is "no timeline" mode
		    this._o.isTimelineLess && (this.timeline = this.tween);
		  };
		  /*
		    Method to create timeline.
		    @private
		    @param {Object} Timeline's options.
		                    An object which contains "timeline" property with
		                    timeline options.
		  */
	
	
		  Tweenable.prototype._makeTimeline = function _makeTimeline() {
		    // pass callbacks context
		    this._o.timeline = this._o.timeline || {};
		    this._o.timeline.callbacksContext = this._o.callbacksContext || this;
		    this.timeline = new _timeline2.default(this._o.timeline);
		    // set the flag to indicate that real timeline is present
		    this._isTimeline = true;
		    // if tween exist - add it to the timeline there is some
		    // modules like burst and stagger that have no tween
		    this.tween && this.timeline.add(this.tween);
		  };
	
		  return Tweenable;
		}(_module2.default);
	
		exports.default = Tweenable;
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(28);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _tweenable = __webpack_require__(11);
	
		var _tweenable2 = _interopRequireDefault(_tweenable);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/*
		  The Thenable class adds .then public method and
		  the ability to chain API calls.
		*/
	
		var Thenable = function (_Tweenable) {
		  (0, _inherits3.default)(Thenable, _Tweenable);
	
		  function Thenable() {
		    (0, _classCallCheck3.default)(this, Thenable);
		    return (0, _possibleConstructorReturn3.default)(this, _Tweenable.apply(this, arguments));
		  }
	
		  /*
		    Method to create a then record for the module.
		    @public
		    @param    {Object} Options for the next animation.
		    @returns  {Object} this.
		  */
	
		  Thenable.prototype.then = function then(o) {
		    // return if nothing was passed
		    if (o == null || !(0, _keys2.default)(o).length) {
		      return 1;
		    }
		    // merge then options with the current ones
		    var prevRecord = this._history[this._history.length - 1],
		        prevModule = this._modules[this._modules.length - 1],
		        merged = this._mergeThenOptions(prevRecord, o);
	
		    this._resetMergedFlags(merged);
		    // create a submodule of the same type as the master module
		    var module = new this.constructor(merged);
		    // set `this` as amster module of child module
		    module._masterModule = this;
		    // save the modules to the _modules array
		    this._modules.push(module);
		    // add module's tween into master timeline
		    this.timeline.append(module);
	
		    return this;
		  };
	
		  // ^ PUBLIC  METHOD(S) ^
		  // v PRIVATE METHOD(S) v
	
		  /*
		    Method to reset some flags on merged options object.
		    @private
		    @param   {Object} Options object.
		    @returns {Object} Options object.
		  */
	
	
		  Thenable.prototype._resetMergedFlags = function _resetMergedFlags(obj) {
		    // set the submodule to be without timeline for perf reasons
		    obj.isTimelineLess = true;
		    // reset isShowStart flag for the submodules
		    obj.isShowStart = false;
		    // reset isRefreshState flag for the submodules
		    obj.isRefreshState = false;
		    // set the submodule callbacks context
		    obj.callbacksContext = this._props.callbacksContext || this;
		    // set previous module
		    obj.prevChainModule = _h2.default.getLastItem(this._modules);
		    // pass the `this` as master module
		    obj.masterModule = this;
		    return obj;
		  };
		  /*
		    Method to initialize properties.
		    @private
		  */
	
	
		  Thenable.prototype._vars = function _vars() {
		    _Tweenable.prototype._vars.call(this);
		    // save _master module
		    this._masterModule = this._o.masterModule;
		    // set isChained flag based on prevChainModule option
		    this._isChained = !!this._masterModule;
		    // we are expect that the _o object
		    // have been already extended by defaults
		    var initialRecord = _h2.default.cloneObj(this._props);
		    for (var key in this._arrayPropertyMap) {
		      if (this._o[key]) {
		        var preParsed = this._parsePreArrayProperty(key, this._o[key]);
		        initialRecord[key] = preParsed;
		      }
		    }
	
		    this._history = [initialRecord];
		    // the array holds all modules in the then chain
		    this._modules = [this];
		    // the props that to exclude from then merge
		    this._nonMergeProps = { shape: 1 };
		  };
		  /*
		    Method to merge two options into one. Used in .then chains.
		    @private
		    @param {Object} Start options for the merge.
		    @param {Object} End options for the merge.
		    @returns {Object} Merged options.
		  */
	
	
		  Thenable.prototype._mergeThenOptions = function _mergeThenOptions(start, end) {
		    var o = {};
		    this._mergeStartLoop(o, start);
		    this._mergeEndLoop(o, start, end);
		    this._history.push(o);
		    return o;
		  };
		  /*
		    Method to pipe startValue of the delta.
		    @private
		    @param {String} Start property name.
		    @param {Any} Start property value.
		    @returns {Any} Start property value.
		  */
	
	
		  Thenable.prototype._checkStartValue = function _checkStartValue(name, value) {
		    return value;
		  };
		  /*
		    Originally part of the _mergeThenOptions.
		    Loops thru start object and copies all the props from it.
		    @param {Object} An object to copy in.
		    @parma {Object} Start options object.
		  */
	
	
		  Thenable.prototype._mergeStartLoop = function _mergeStartLoop(o, start) {
		    // loop thru start options object
		    for (var key in start) {
		      var value = start[key];
		      if (start[key] == null) {
		        continue;
		      };
		      // copy all values from start if not tween prop or duration
		      if (!_h2.default.isTweenProp(key) || key === 'duration') {
		        // if delta - copy only the end value
		        if (this._isDelta(value)) {
		          o[key] = _h2.default.getDeltaEnd(value);
		        } else {
		          o[key] = value;
		        }
		      }
		    }
		  };
		  /*
		    Originally part of the _mergeThenOptions.
		    Loops thru start object and merges all the props from it.
		    @param {Object} An object to copy in.
		    @parma {Object} Start options object.
		    @parma {Object} End options object.
		  */
	
	
		  Thenable.prototype._mergeEndLoop = function _mergeEndLoop(o, start, end) {
		    var endKeys = (0, _keys2.default)(end);
	
		    for (var key in end) {
		      // just copy parent option
		      if (key == 'parent') {
		        o[key] = end[key];continue;
		      };
	
		      // get key/value of the end object
		      // endKey - name of the property, endValue - value of the property
		      var endValue = end[key],
		          startValue = start[key] != null ? start[key] : this._defaults[key];
	
		      startValue = this._checkStartValue(key, startValue);
		      if (endValue == null) {
		        continue;
		      };
		      // make ∆ of start -> end
		      // if key name is radiusX/radiusY and
		      // the startValue is not set fallback to radius value
		      var isSubRadius = key === 'radiusX' || key === 'radiusY';
		      if (isSubRadius && startValue == null) {
		        startValue = start.radius;
		      }
	
		      var isSubRadius = key === 'scaleX' || key === 'scaleY';
		      if (isSubRadius && startValue == null) {
		        startValue = start.scale;
		      }
	
		      o[key] = this._mergeThenProperty(key, startValue, endValue);
		    }
		  };
		  /*
		    Method to merge `start` and `end` for a property in then record.
		    @private
		    @param {String} Property name.
		    @param {Any}    Start value of the property.
		    @param {Any}    End value of the property.
		  */
	
	
		  Thenable.prototype._mergeThenProperty = function _mergeThenProperty(key, startValue, endValue) {
		    // if isnt tween property
		    var isBoolean = typeof endValue === 'boolean',
		        curve,
		        easing;
	
		    if (!_h2.default.isTweenProp(key) && !this._nonMergeProps[key] && !isBoolean) {
	
		      if (_h2.default.isObject(endValue) && endValue.to != null) {
		        curve = endValue.curve;
		        easing = endValue.easing;
		        endValue = endValue.to;
		      }
	
		      // if end value is delta - just save it
		      if (this._isDelta(endValue)) {
		        return this._parseDeltaValues(key, endValue);
		      } else {
		        var parsedEndValue = this._parsePreArrayProperty(key, endValue);
		        // if end value is not delta - merge with start value
		        if (this._isDelta(startValue)) {
		          var _ref;
	
		          // if start value is delta - take the end value
		          // as start value of the new delta
		          return _ref = {}, _ref[_h2.default.getDeltaEnd(startValue)] = parsedEndValue, _ref.easing = easing, _ref.curve = curve, _ref;
		          // if both start and end value are not ∆ - make ∆
		        } else {
		            var _ref2;
	
		            return _ref2 = {}, _ref2[startValue] = parsedEndValue, _ref2.easing = easing, _ref2.curve = curve, _ref2;
		          }
		      }
		      // copy the tween values unattended
		    } else {
		        return endValue;
		      }
		  };
		  /*
		    Method to retreive array's length and return -1 for
		    all other types.
		    @private
		    @param {Array, Any} Array to get the width for.
		    @returns {Number} Array length or -1 if not array.
		  */
	
	
		  Thenable.prototype._getArrayLength = function _getArrayLength(arr) {
		    return _h2.default.isArray(arr) ? arr.length : -1;
		  };
		  /*
		    Method to check if the property is delta property.
		    @private
		    @param {Any} Parameter value to check.
		    @returns {Boolean}
		  */
	
	
		  Thenable.prototype._isDelta = function _isDelta(optionsValue) {
		    var isObject = _h2.default.isObject(optionsValue);
		    isObject = isObject && !optionsValue.unit;
		    return !(!isObject || _h2.default.isArray(optionsValue) || _h2.default.isDOM(optionsValue));
		  };
		  /*
		    Method to check if the module is first in `then` chain.
		    @private
		    @returns {Boolean} If the module is the first in module chain.
		  */
	
	
		  Thenable.prototype._isFirstInChain = function _isFirstInChain() {
		    return !this._masterModule;
		  };
		  /*
		    Method to check if the module is last in `then` chain.
		    @private
		    @returns {Boolean} If the module is the last in module chain.
		  */
	
	
		  Thenable.prototype._isLastInChain = function _isLastInChain() {
		    var master = this._masterModule;
		    // if there is no master field - check the modules length
		    // if module length is 1 thus there is no modules chain
		    // it is the last one, otherwise it isnt
		    if (!master) {
		      return this._modules.length === 1;
		    }
		    // if there is master - check if it is the last item in _modules chain
		    return this === _h2.default.getLastItem(master._modules);
		  };
	
		  return Thenable;
		}(_tweenable2.default);
	
		exports.default = Thenable;
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(28);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		var _thenable = __webpack_require__(12);
	
		var _thenable2 = _interopRequireDefault(_thenable);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Tuneable = function (_Thenable) {
		  (0, _inherits3.default)(Tuneable, _Thenable);
	
		  function Tuneable() {
		    (0, _classCallCheck3.default)(this, Tuneable);
		    return (0, _possibleConstructorReturn3.default)(this, _Thenable.apply(this, arguments));
		  }
	
		  /*
		    Method to start the animation with optional new options.
		    @public
		    @param {Object} New options to set on the run.
		    @returns {Object} this.
		  */
	
		  Tuneable.prototype.tune = function tune(o) {
		    // if options object was passed
		    if (o && (0, _keys2.default)(o).length) {
		      this._transformHistory(o);
		      this._tuneNewOptions(o);
		      // restore array prop values because _props
		      // contain them as parsed arrays
		      // but we need the as strings to store in history
		      // and merge in history chains
		      this._history[0] = _h2.default.cloneObj(this._props);
		      for (var key in this._arrayPropertyMap) {
		        if (o[key] != null) {
		          this._history[0][key] = this._preparsePropValue(key, o[key]);
		        }
		      }
	
		      this._tuneSubModules();
		      this._resetTweens();
		    }
		    return this;
		  };
		  /*
		    Method to regenerate all the random properties form initial object.
		    @public
		    @returns this.
		  */
	
	
		  Tuneable.prototype.generate = function generate() {
		    return this.tune(this._o);
		  };
	
		  // ^ PUBLIC  METHOD(S) ^
		  // v PRIVATE METHOD(S) v
	
		  /*
		    Method to preparse options in object.
		    @private
		    @param {Object} Object to preparse properties on.
		    @returns {Object} Passed object with preparsed props.
		  */
		  // _preParseOptions ( o ) {
		  //   for (var key in o) {
		  //     o[key] = this._preparsePropValue( key, o[key] );
		  //   }
		  //   return o;
		  // }
		  /*
		    Method to transform history rewrite new options object chain on run.
		    @private
		    @param {Object} New options to tune for.
		  */
	
	
		  Tuneable.prototype._transformHistory = function _transformHistory(o) {
		    for (var key in o) {
		      var value = o[key];
		      // don't transform for childOptions
		      // if ( key === 'childOptions' ) { continue; }
		      this._transformHistoryFor(key, this._preparsePropValue(key, value));
		    }
		  };
		  /*
		    Method to transform history chain for specific key/value.
		    @param {String} Name of the property to transform history for.
		    @param {Any} The new property's value.
		  */
	
	
		  Tuneable.prototype._transformHistoryFor = function _transformHistoryFor(key, value) {
		    for (var i = 0; i < this._history.length; i++) {
		      if (value = this._transformHistoryRecord(i, key, value)) {
		        // break if no further history modifications needed
		        if (value == null) {
		          break;
		        }
		      }
		    }
		  };
		  /*
		    Method to transform history recod with key/value.
		    @param {Number} Index of the history record to transform.
		    @param {String} Property name to transform.
		    @param {Any} Property value to transform to.
		    @param {Object} Optional the current history record.
		    @param {Object} Optional the next history record.
		    @returns {Boolean} Returns true if no further
		                       history modifications is needed.
		  */
	
	
		  Tuneable.prototype._transformHistoryRecord = function _transformHistoryRecord(index, key, newVal, currRecord, nextRecord) {
		    // newVal = this._parseProperty( key, newVal );
		    if (newVal == null) {
		      return null;
		    }
	
		    // fallback to history records, if wasn't specified
		    currRecord = currRecord == null ? this._history[index] : currRecord;
		    nextRecord = nextRecord == null ? this._history[index + 1] : nextRecord;
	
		    var oldVal = currRecord[key],
		        nextVal = nextRecord == null ? null : nextRecord[key];
	
		    // if index is 0 - always save the newVal
		    // and return non-delta for subsequent modifications
		    if (index === 0) {
		      currRecord[key] = newVal;
		      // always return on tween properties
		      if (_h2.default.isTweenProp(key) && key !== 'duration') {
		        return null;
		      }
		      // nontween properties
		      var isRewriteNext = this._isRewriteNext(oldVal, nextVal),
		          returnVal = this._isDelta(newVal) ? _h2.default.getDeltaEnd(newVal) : newVal;
		      return isRewriteNext ? returnVal : null;
		    } else {
		      // if was delta and came none-deltta - rewrite
		      // the start of the delta and stop
		      if (this._isDelta(oldVal)) {
		        var _currRecord$key;
	
		        currRecord[key] = (_currRecord$key = {}, _currRecord$key[newVal] = _h2.default.getDeltaEnd(oldVal), _currRecord$key);
		        return null;
		      } else {
		        // if the old value is not delta and the new one is
		        currRecord[key] = newVal;
		        // if the next item has the same value - return the
		        // item for subsequent modifications or stop
		        return this._isRewriteNext(oldVal, nextVal) ? newVal : null;
		      }
		    }
		  };
		  /*
		    Method to check if the next item should
		    be rewrited in transform history operation.
		    @private
		    @param {Any} Current value.
		    @param {Any} Next value.
		    @returns {Boolean} If need to rewrite the next value.
		  */
	
	
		  Tuneable.prototype._isRewriteNext = function _isRewriteNext(currVal, nextVal) {
		    // return false if nothing to rewrite next
		    if (nextVal == null && currVal != null) {
		      return false;
		    }
	
		    var isEqual = currVal === nextVal,
		        isNextDelta = this._isDelta(nextVal),
		        isDelta = this._isDelta(currVal),
		        isValueDeltaChain = false,
		        isDeltaChain = false;
	
		    if (isDelta && isNextDelta) {
		      if (_h2.default.getDeltaEnd(currVal) == _h2.default.getDeltaStart(nextVal)) {
		        isDeltaChain = true;
		      }
		    } else if (isNextDelta) {
		      isValueDeltaChain = _h2.default.getDeltaStart(nextVal) === '' + currVal;
		    }
	
		    return isEqual || isValueDeltaChain || isDeltaChain;
		  };
		  /*
		    Method to tune new history options to all the submodules.
		    @private
		  */
	
	
		  Tuneable.prototype._tuneSubModules = function _tuneSubModules() {
		    for (var i = 1; i < this._modules.length; i++) {
		      this._modules[i]._tuneNewOptions(this._history[i]);
		    }
		  };
		  /*
		    Method to set new options on run.
		    @param {Boolean} If foreign context.
		    @private
		  */
	
	
		  Tuneable.prototype._resetTweens = function _resetTweens() {
		    var i = 0,
		        shift = 0,
		        tweens = this.timeline._timelines;
	
		    // if `isTimelineLess` return
		    if (tweens == null) {
		      return;
		    }
	
		    for (var i = 0; i < tweens.length; i++) {
		      var tween = tweens[i],
		          prevTween = tweens[i - 1];
	
		      shift += prevTween ? prevTween._props.repeatTime : 0;
		      this._resetTween(tween, this._history[i], shift);
		    }
		    this.timeline._setProp(this._props.timeline);
		    this.timeline._recalcTotalDuration();
		  };
		  /*
		    Method to reset tween with new options.
		    @param {Object} Tween to reset.
		    @param {Object} Tween's to reset tween with.
		    @param {Number} Optional number to shift tween start time.
		  */
	
	
		  Tuneable.prototype._resetTween = function _resetTween(tween, o) {
		    var shift = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
	
		    o.shiftTime = shift;tween._setProp(o);
		  };
	
		  return Tuneable;
		}(_thenable2.default);
	
		exports.default = Tuneable;
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _tween = __webpack_require__(8);
	
		var _tween2 = _interopRequireDefault(_tween);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var h = __webpack_require__(19);
	
		var Delta = function () {
		  function Delta() {
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    (0, _classCallCheck3.default)(this, Delta);
	
		    this._o = o;
		    this._createTween(o.tweenOptions);
		    // initial properties render
		    !this._o.isChained && this.refresh(true);
		  }
		  /*
		    Method to call `_refresh` method on `tween`.
		    Use switch between `0` and `1` progress for delta value.
		    @public
		    @param {Boolean} If refresh before start time or after.
		    @returns this.
		  */
	
	
		  Delta.prototype.refresh = function refresh(isBefore) {
		    this._previousValues = [];
	
		    var deltas = this._o.deltas;
		    for (var i = 0; i < deltas.length; i++) {
		      var name = deltas[i].name;
		      this._previousValues.push({
		        name: name, value: this._o.props[name]
		      });
		    }
	
		    this.tween._refresh(isBefore);
		    return this;
		  };
		  /*
		    Method to restore all saved properties from `_previousValues` array.
		    @public
		    @returns this.
		  */
	
	
		  Delta.prototype.restore = function restore() {
		    var prev = this._previousValues;
		    for (var i = 0; i < prev.length; i++) {
		      var record = prev[i];
		      this._o.props[record.name] = record.value;
		    }
		    return this;
		  };
		  /*
		    Method to create tween of the delta.
		    @private
		    @param {Object} Options object.
		  */
	
	
		  Delta.prototype._createTween = function _createTween() {
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		    var it = this;
		    o.callbackOverrides = {
		      onUpdate: function onUpdate(ep, p) {
		        it._calcCurrentProps(ep, p);
		      }
		    };
	
		    // if not chained - add the onRefresh callback
		    // to refresh the tween when needed
		    if (!this._o.isChained) {
		      o.callbackOverrides.onRefresh = function (isBefore, ep, p) {
		        it._calcCurrentProps(ep, p);
		      };
		    }
	
		    o.callbacksContext = this._o.callbacksContext;
		    this.tween = new _tween2.default(o);
		  };
		  /*
		    Method to calculate current progress of the deltas.
		    @private
		    @param {Number} Eased progress to calculate - [0..1].
		    @param {Number} Progress to calculate - [0..1].
		  */
	
	
		  Delta.prototype._calcCurrentProps = function _calcCurrentProps(easedProgress, p) {
		    var deltas = this._o.deltas;
		    for (var i = 0; i < deltas.length; i++) {
		      var type = deltas[i].type;
		      this['_calcCurrent_' + type](deltas[i], easedProgress, p);
		    }
		  };
		  /*
		    Method to calc the current color delta value.
		    @param {Object} Delta
		    @param {Number} Eased progress [0..1].
		    @param {Number} Plain progress [0..1].
		  */
	
	
		  Delta.prototype._calcCurrent_color = function _calcCurrent_color(delta, ep, p) {
		    var r,
		        g,
		        b,
		        a,
		        start = delta.start,
		        d = delta.delta;
		    if (!delta.curve) {
		      r = parseInt(start.r + ep * d.r, 10);
		      g = parseInt(start.g + ep * d.g, 10);
		      b = parseInt(start.b + ep * d.b, 10);
		      a = parseFloat(start.a + ep * d.a);
		    } else {
		      var cp = delta.curve(p);
		      r = parseInt(cp * (start.r + p * d.r), 10);
		      g = parseInt(cp * (start.g + p * d.g), 10);
		      b = parseInt(cp * (start.b + p * d.b), 10);
		      a = parseFloat(cp * (start.a + p * d.a));
		    }
		    this._o.props[delta.name] = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
		  };
		  /*
		    Method to calc the current number delta value.
		    @param {Object} Delta
		    @param {Number} Eased progress [0..1].
		    @param {Number} Plain progress [0..1].
		  */
	
	
		  Delta.prototype._calcCurrent_number = function _calcCurrent_number(delta, ep, p) {
		    this._o.props[delta.name] = !delta.curve ? delta.start + ep * delta.delta : delta.curve(p) * (delta.start + p * delta.delta);
		  };
		  /*
		    Method to calc the current number with units delta value.
		    @param {Object} Delta
		    @param {Number} Eased progress [0..1].
		    @param {Number} Plain progress [0..1].
		  */
	
	
		  Delta.prototype._calcCurrent_unit = function _calcCurrent_unit(delta, ep, p) {
		    var currentValue = !delta.curve ? delta.start.value + ep * delta.delta : delta.curve(p) * (delta.start.value + p * delta.delta);
	
		    this._o.props[delta.name] = '' + currentValue + delta.end.unit;
		  };
		  /*
		    Method to calc the current array delta value.
		    @param {Object} Delta
		    @param {Number} Eased progress [0..1].
		    @param {Number} Plain progress [0..1].
		  */
	
	
		  Delta.prototype._calcCurrent_array = function _calcCurrent_array(delta, ep, p) {
		    // var arr,
		    var name = delta.name,
		        props = this._o.props,
		        string = '';
	
		    // to prevent GC bothering with arrays garbage
		    // if ( h.isArray( props[name] ) ) {
		    //   arr = props[name];
		    //   arr.length = 0;
		    // } else { arr = []; }
	
		    // just optimization to prevent curve
		    // calculations on every array item
		    var proc = delta.curve ? delta.curve(p) : null;
	
		    for (var i = 0; i < delta.delta.length; i++) {
		      var item = delta.delta[i],
		          dash = !delta.curve ? delta.start[i].value + ep * item.value : proc * (delta.start[i].value + p * item.value);
	
		      string += '' + dash + item.unit + ' ';
		      // arr.push({
		      //   string: `${dash}${item.unit}`,
		      //   value:  dash,
		      //   unit:   item.unit,
		      // });
		    }
		    props[name] = string;
		  };
	
		  return Delta;
		}();
	
		exports.default = Delta;
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _extends2 = __webpack_require__(27);
	
		var _extends3 = _interopRequireDefault(_extends2);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _keys = __webpack_require__(28);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _timeline = __webpack_require__(9);
	
		var _timeline2 = _interopRequireDefault(_timeline);
	
		var _tween = __webpack_require__(8);
	
		var _tween2 = _interopRequireDefault(_tween);
	
		var _delta = __webpack_require__(14);
	
		var _delta2 = _interopRequireDefault(_delta);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/*
		  This module's target is to parse options object,
		  find deltas in it and send them to `Delta` classes.
		  The `Delta` class is dull - they expect actual parsed deltas
		  and separated tween options, so we should parse them here.
		  The timeline of the module controls the `Delta` modules' tweens.
	
		  @param {Object} props Object to set deltas result to (pass to the Delta classes).
		  @param {Object} options Object to parse the deltas from.
		  @param {Function} onUpdate onUpdate callback.
		  @param optional {Object} arrayPropertyMap List of properties with truthy
		                                            values which describe properties
		                                            that should be parsed as arrays.
		  @param optional {Object} numberPropertyMap List of properties with truthy
		                                            values which describe properties
		                                            that should be parsed as numbers
		                                            without units.
		*/
	
		// TODO:
		// - colors with curves change alpha level too
		// const html = new mojs.Html({
		//   el: '#js-el',
		//   x: { 0: 100 },
		//   onUpdate () {
		//     console.log(this._props.originX);
		//   },
		//   originX: { 'white': 'black', curve: 'M0,100 L100, 0' },
		//   customProperties: {
		//     originX: {
		//       type: 'color',
		//       default: 'cyan'
		//     },
		//     draw() { console.log('draw'); }
		//   }
		// });
	
		var easing = __webpack_require__(22);
		var h = __webpack_require__(19);
	
	
		// get tween properties
		var obj = {};
		_tween2.default.prototype._declareDefaults.call(obj);
		var keys = (0, _keys2.default)(obj._defaults);
		for (var i = 0; i < keys.length; i++) {
		  obj._defaults[keys[i]] = 1;
		}
		obj._defaults['timeline'] = 1;
		var TWEEN_PROPERTIES = obj._defaults;
	
		var Deltas = function () {
		  function Deltas() {
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    (0, _classCallCheck3.default)(this, Deltas);
	
		    this._o = o;
	
		    this._shortColors = {
		      transparent: 'rgba(0,0,0,0)',
		      none: 'rgba(0,0,0,0)',
		      aqua: 'rgb(0,255,255)',
		      black: 'rgb(0,0,0)',
		      blue: 'rgb(0,0,255)',
		      fuchsia: 'rgb(255,0,255)',
		      gray: 'rgb(128,128,128)',
		      green: 'rgb(0,128,0)',
		      lime: 'rgb(0,255,0)',
		      maroon: 'rgb(128,0,0)',
		      navy: 'rgb(0,0,128)',
		      olive: 'rgb(128,128,0)',
		      purple: 'rgb(128,0,128)',
		      red: 'rgb(255,0,0)',
		      silver: 'rgb(192,192,192)',
		      teal: 'rgb(0,128,128)',
		      white: 'rgb(255,255,255)',
		      yellow: 'rgb(255,255,0)',
		      orange: 'rgb(255,128,0)'
		    };
	
		    this._ignoreDeltasMap = { prevChainModule: 1, masterModule: 1 };
	
		    this._parseDeltas(o.options);
		    this._createDeltas();
		    this._createTimeline(this._mainTweenOptions);
		  }
		  /*
		    Method to call `refresh` on all child `delta` objects.
		    @public
		    @param {Boolean} If before start time (true) or after end time (false).
		  */
	
	
		  Deltas.prototype.refresh = function refresh(isBefore) {
		    for (var i = 0; i < this._deltas.length; i++) {
		      this._deltas[i].refresh(isBefore);
		    }
		    return this;
		  };
		  /*
		    Method to call `restore` on all child `delta` objects.
		    @public
		  */
	
	
		  Deltas.prototype.restore = function restore() {
		    for (var i = 0; i < this._deltas.length; i++) {
		      this._deltas[i].restore();
		    }
		    return this;
		  };
		  /*
		    Method to create Timeline.
		    @private
		    @param {Object} Timeline options.
		  */
	
	
		  Deltas.prototype._createTimeline = function _createTimeline() {
		    var opts = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		    // const o = this._o;
		    // opts.timeline = opts.timeline || {};
		    // opts.timeline.callbackOverrides = {
		    //   onUpdate:   o.onUpdate,
		    //   onRefresh:  o.onUpdate
		    // }
		    // send callbacksContext to timeline if set
		    // o.callbacksContext && (opts.timeline.callbacksContext = o.callbacksContext);
		    // opts.timeline
		    this.timeline = new _timeline2.default();
		    this.timeline.add(this._deltas);
		  };
		  /*
		    Method to create Deltas from parsed options.
		    @private
		  */
	
	
		  Deltas.prototype._createDeltas = function _createDeltas() {
		    this._deltas = [];
	
		    // create main delta object
		    this._deltas.push(this._createDelta(this._mainDeltas, this._mainTweenOptions));
	
		    // create child delta object
		    for (var i = 0; i < this._childDeltas.length; i++) {
		      var delta = this._childDeltas[i];
		      this._deltas.push(this._createDelta([delta.delta], delta.tweenOptions));
		    }
		  };
		  /*
		    Method to create Delta object with passed options.
		    @private
		    @param {Array} Array of deltas.
		    @param {Object} Tween properties.
		    @returns {Object} Delta object
		  */
	
	
		  Deltas.prototype._createDelta = function _createDelta(deltas, tweenOptions) {
		    var o = this._o;
		    return new _delta2.default({
		      deltas: deltas, tweenOptions: tweenOptions,
		      props: o.props,
		      isChained: o.isChained,
		      callbacksContext: o.callbacksContext
		    });
		  };
		  /*
		    Method to parse delta objects from options.
		    @private
		    @param {Object} Options object to parse the deltas from.
		  */
	
	
		  Deltas.prototype._parseDeltas = function _parseDeltas(obj) {
		    // spilt main animation properties and main tween properties
		    var mainSplit = this._splitTweenOptions(obj);
		    // main animation properties
		    var opts = mainSplit.delta;
		    // main tween properties
		    this._mainTweenOptions = mainSplit.tweenOptions;
	
		    this._mainDeltas = [];
		    this._childDeltas = [];
		    var keys = (0, _keys2.default)(opts);
		    // loop thru all properties without tween ones
		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];
		      // is property is delta - parse it
		      if (this._isDelta(opts[key]) && !this._ignoreDeltasMap[key]) {
		        var delta = this._splitAndParseDelta(key, opts[key]);
		        // if parsed object has no tween values - it's delta of the main object
		        if (!delta.tweenOptions) {
		          this._mainDeltas.push(delta.delta);
		        }
		        // otherwise it is distinct delta object
		        else {
		            this._childDeltas.push(delta);
		          }
		      }
		    }
		  };
		  /*
		    Method to split tween values and parse single delta record.
		    @private
		    @param {String} Property name.
		    @param {Object} Raw delta object.
		    @returns {Object} Split object.
		                @param {Object} tweenOptions Tween properties.
		                @param {Object} delta Parsed delta.
		  */
	
	
		  Deltas.prototype._splitAndParseDelta = function _splitAndParseDelta(name, object) {
		    var split = this._splitTweenOptions(object);
		    // parse delta in the object
		    split.delta = this._parseDelta(name, split.delta);
		    return split;
		  };
		  /*
		    Method to parse delta by delegating the variables to _parse*Delta methods.
		    @private
		    @param {String} Property name.
		    @param {Object} Raw delta object.
		    @param {Number} Module index.
		  */
	
	
		  Deltas.prototype._parseDelta = function _parseDelta(name, object, index) {
		    // if name is in _o.customProps - parse it regarding the type
		    return this._o.customProps && this._o.customProps[name] != null ? this._parseDeltaByCustom(name, object, index) : this._parseDeltaByGuess(name, object, index);
		  };
		  /**
		    Method to parse delta by taking the type from the customProps object.
		    @private
		    @param {String} Property name.
		    @param {Object} Raw delta object.
		    @param {Number} Module index.
		  */
	
	
		  Deltas.prototype._parseDeltaByCustom = function _parseDeltaByCustom(name, object, index) {
		    return this._parseNumberDelta(name, object, index);
		    // const customRecord = this._o.customProps[name];
		    // switch ( customRecord.type.toLowerCase() ) {
		    //   case 'color':  { return this._parseColorDelta( name, object ); }
		    //   case 'array':  { return this._parseArrayDelta( name, object ); }
		    //   case 'number': { return this._parseNumberDelta( name, object, index ); }
		    //   case 'unit':   { return this._parseUnitDelta( name, object, index ); }
		    // }
		  };
		  /**
		    Method to parse delta by reasoning about it's value.
		    @private
		    @param {String} Property name.
		    @param {Object} Raw delta object.
		    @param {Number} Module index.
		  */
	
	
		  Deltas.prototype._parseDeltaByGuess = function _parseDeltaByGuess(name, object, index) {
		    var _preparseDelta2 = this._preparseDelta(object);
	
		    var start = _preparseDelta2.start;
	
		    var o = this._o;
	
		    // color values
		    if (isNaN(parseFloat(start)) && !start.match(/rand\(/) && !start.match(/stagger\(/)) {
		      return this._parseColorDelta(name, object);
		      // array values
		    } else if (o.arrayPropertyMap && o.arrayPropertyMap[name]) {
		        return this._parseArrayDelta(name, object);
		        // unit or number values
		      } else {
		          return o.numberPropertyMap && o.numberPropertyMap[name] ?
		          // if the property is in the number property map - parse it like number
		          this._parseNumberDelta(name, object, index)
		          // otherwise - like number with units
		          : this._parseUnitDelta(name, object, index);
		        }
		  };
		  /*
		    Method to separate tween options from delta properties.
		    @param {Object} Object for separation.
		    @returns {Object} Object that contains 2 objects
		                        - one delta options
		                        - one tween options ( could be empty if no tween opts )
		  */
	
	
		  Deltas.prototype._splitTweenOptions = function _splitTweenOptions(delta) {
		    delta = (0, _extends3.default)({}, delta);
	
		    var keys = (0, _keys2.default)(delta),
		        tweenOptions = {};
		    var isTween = null;
	
		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];
		      if (TWEEN_PROPERTIES[key]) {
		        if (delta[key] != null) {
		          tweenOptions[key] = delta[key];
		          isTween = true;
		        }
		        delete delta[key];
		      }
		    }
		    return {
		      delta: delta,
		      tweenOptions: isTween ? tweenOptions : undefined
		    };
		  };
		  /*
		    Method to check if the property is delta property.
		    @private
		    @param {Any} Parameter value to check.
		    @returns {Boolean}
		  */
	
	
		  Deltas.prototype._isDelta = function _isDelta(optionsValue) {
		    var isObject = h.isObject(optionsValue);
		    isObject = isObject && !optionsValue.unit;
		    return !(!isObject || h.isArray(optionsValue) || h.isDOM(optionsValue));
		  };
		  /*
		    Method to parse color delta values.
		    @private
		    @param {String} Name of the property.
		    @param {Any} Property value.
		    @returns {Object} Parsed delta.
		  */
	
	
		  Deltas.prototype._parseColorDelta = function _parseColorDelta(key, value) {
		    if (key === 'strokeLinecap') {
		      h.warn('Sorry, stroke-linecap property is not animatable yet, using the start(#{start}) value instead', value);
		      return {};
		    }
		    var preParse = this._preparseDelta(value);
	
		    var startColorObj = this._makeColorObj(preParse.start),
		        endColorObj = this._makeColorObj(preParse.end);
	
		    var delta = {
		      type: 'color',
		      name: key,
		      start: startColorObj,
		      end: endColorObj,
		      curve: preParse.curve,
		      delta: {
		        r: endColorObj.r - startColorObj.r,
		        g: endColorObj.g - startColorObj.g,
		        b: endColorObj.b - startColorObj.b,
		        a: endColorObj.a - startColorObj.a
		      }
		    };
		    return delta;
		  };
		  /*
		    Method to parse array delta values.
		    @private
		    @param {String} Name of the property.
		    @param {Any} Property value.
		    @returns {Object} Parsed delta.
		  */
	
	
		  Deltas.prototype._parseArrayDelta = function _parseArrayDelta(key, value) {
		    var preParse = this._preparseDelta(value);
	
		    var startArr = this._strToArr(preParse.start),
		        endArr = this._strToArr(preParse.end);
	
		    h.normDashArrays(startArr, endArr);
	
		    for (var i = 0; i < startArr.length; i++) {
		      var end = endArr[i];
		      h.mergeUnits(startArr[i], end, key);
		    }
	
		    var delta = {
		      type: 'array',
		      name: key,
		      start: startArr,
		      end: endArr,
		      delta: h.calcArrDelta(startArr, endArr),
		      curve: preParse.curve
		    };
	
		    return delta;
		  };
		  /*
		    Method to parse numeric delta values with units.
		    @private
		    @param {String} Name of the property.
		    @param {Any} Property value.
		    @param {Number} Index of the module.
		    @returns {Object} Parsed delta.
		  */
	
	
		  Deltas.prototype._parseUnitDelta = function _parseUnitDelta(key, value, index) {
		    var preParse = this._preparseDelta(value);
	
		    var end = h.parseUnit(h.parseStringOption(preParse.end, index)),
		        start = h.parseUnit(h.parseStringOption(preParse.start, index));
	
		    h.mergeUnits(start, end, key);
		    var delta = {
		      type: 'unit',
		      name: key,
		      start: start,
		      end: end,
		      delta: end.value - start.value,
		      curve: preParse.curve
		    };
		    return delta;
		  };
		  /*
		    Method to parse numeric delta values without units.
		    @private
		    @param {String} Name of the property.
		    @param {Any} Property value.
		    @param {Number} Index of the module.
		    @returns {Object} Parsed delta.
		  */
	
	
		  Deltas.prototype._parseNumberDelta = function _parseNumberDelta(key, value, index) {
		    var preParse = this._preparseDelta(value);
	
		    var end = parseFloat(h.parseStringOption(preParse.end, index)),
		        start = parseFloat(h.parseStringOption(preParse.start, index));
	
		    var delta = {
		      type: 'number',
		      name: key,
		      start: start,
		      end: end,
		      delta: end - start,
		      curve: preParse.curve
		    };
	
		    return delta;
		  };
		  /*
		    Method to extract `curve` and `start`/`end` values.
		    @private
		    @param {Object} Delta object.
		    @returns {Object} Preparsed delta.
		              @property {String} Start value.
		              @property {String, Number} End value.
		  */
	
	
		  Deltas.prototype._preparseDelta = function _preparseDelta(value) {
		    // clone value object
		    value = (0, _extends3.default)({}, value);
		    // parse curve if exist
		    var curve = value.curve;
		    if (curve != null) {
		      curve = easing.parseEasing(curve);
		      curve._parent = this;
		    }
		    delete value.curve;
		    // parse start and end values
		    var start = (0, _keys2.default)(value)[0],
		        end = value[start];
	
		    return { start: start, end: end, curve: curve };
		  };
		  /*
		    Method to parse color into usable object.
		    @private
		    @param {String} Color string.
		    @returns {Object} Parsed color value.
		  */
	
	
		  Deltas.prototype._makeColorObj = function _makeColorObj(color) {
		    // HEX
		    var colorObj = {};
		    if (color[0] === '#') {
		      var result = /^#?([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})$/i.exec(color);
		      if (result) {
		        var r = result[1].length === 2 ? result[1] : result[1] + result[1],
		            g = result[2].length === 2 ? result[2] : result[2] + result[2],
		            b = result[3].length === 2 ? result[3] : result[3] + result[3];
	
		        colorObj = {
		          r: parseInt(r, 16), g: parseInt(g, 16), b: parseInt(b, 16), a: 1
		        };
		      }
		    }
	
		    // not HEX
		    // shorthand color and rgb()
		    if (color[0] !== '#') {
		      var isRgb = color[0] === 'r' && color[1] === 'g' && color[2] === 'b';
		      var rgbColor = undefined;
		      // rgb color
		      if (isRgb) {
		        rgbColor = color;
		      };
		      // shorthand color name
		      if (!isRgb) {
		        if (!this._shortColors[color]) {
		          h.div.style.color = color;
		          rgbColor = h.computedStyle(h.div).color;
		        } else {
		          rgbColor = this._shortColors[color];
		        }
		      }
	
		      var regexString1 = '^rgba?\\((\\d{1,3}),\\s?(\\d{1,3}),',
		          regexString2 = '\\s?(\\d{1,3}),?\\s?(\\d{1}|0?\\.\\d{1,})?\\)$',
		          result = new RegExp(regexString1 + regexString2, 'gi').exec(rgbColor),
		          alpha = parseFloat(result[4] || 1);
	
		      if (result) {
		        colorObj = {
		          r: parseInt(result[1], 10),
		          g: parseInt(result[2], 10),
		          b: parseInt(result[3], 10),
		          a: alpha != null && !isNaN(alpha) ? alpha : 1
		        };
		      }
		    }
	
		    return colorObj;
		  };
		  /*
		    Method to parse string into array.
		    @private
		    @param {String, Number} String or number to parse.
		    @returns {Array} Parsed array.
		  */
	
	
		  Deltas.prototype._strToArr = function _strToArr(string) {
		    var arr = [];
		    // plain number
		    if (typeof string === 'number' && !isNaN(string)) {
		      arr.push(h.parseUnit(string));
		      return arr;
		    }
		    // string array
		    string.trim().split(/\s+/gim).forEach(function (str) {
		      arr.push(h.parseUnit(h.parseIfRand(str)));
		    });
		    return arr;
		  };
	
		  return Deltas;
		}();
	
		exports.default = Deltas;
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(18);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/*
		  Base class for module. Extends and parses defaults.
		*/
	
		var Module = function () {
		  function Module() {
		    var o = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		    (0, _classCallCheck3.default)(this, Module);
	
		    // this._isIt = o.isIt;
		    // delete o.isIt;
		    this._o = o;
		    this._index = this._o.index || 0;
		    // map of props that should be
		    // parsed to arrays of values
		    this._arrayPropertyMap = {
		      strokeDashoffset: 1,
		      strokeDasharray: 1,
		      origin: 1
		    };
	
		    this._skipPropsDelta = {
		      timeline: 1,
		      prevChainModule: 1,
		      callbacksContext: 1
		    };
	
		    this._declareDefaults();
		    this._extendDefaults();
	
		    this._vars();
		    this._render();
		  }
		  /*
		    Method to declare defaults.
		    @private
		  */
	
	
		  Module.prototype._declareDefaults = function _declareDefaults() {
		    this._defaults = {};
		  };
		  /*
		    Method to declare module's variables.
		    @private
		  */
	
	
		  Module.prototype._vars = function _vars() {
		    this._progress = 0;
		    this._strokeDasharrayBuffer = [];
		  };
		  /*
		    Method to render on initialization.
		    @private
		  */
	
	
		  Module.prototype._render = function _render() {};
		  /*
		    Method to set property on the module.
		    @private
		    @param {String, Object} Name of the property to set
		                            or object with properties to set.
		    @param {Any} Value for the property to set. Could be
		                  undefined if the first param is object.
		  */
	
	
		  Module.prototype._setProp = function _setProp(attr, value) {
		    if ((typeof attr === 'undefined' ? 'undefined' : (0, _typeof3.default)(attr)) === 'object') {
		      for (var key in attr) {
		        this._assignProp(key, attr[key]);
		      }
		    } else {
		      this._assignProp(attr, value);
		    }
		  };
		  /*
		    Method to assign single property's value.
		    @private
		    @param {String} Property name.
		    @param {Any}    Property value.
		  */
	
	
		  Module.prototype._assignProp = function _assignProp(key, value) {
		    this._props[key] = value;
		  };
		  /*
		    Method to show element.
		    @private
		  */
	
	
		  Module.prototype._show = function _show() {
		    var p = this._props;
		    if (!this.el) {
		      return;
		    }
	
		    if (p.isSoftHide) {
		      // this.el.style.opacity = p.opacity;
		      this._showByTransform();
		    } else {
		      this.el.style.display = 'block';
		    }
	
		    this._isShown = true;
		  };
		  /*
		    Method to hide element.
		    @private
		  */
	
	
		  Module.prototype._hide = function _hide() {
		    if (!this.el) {
		      return;
		    }
	
		    if (this._props.isSoftHide) {
		      // this.el.style.opacity = 0;
		      _h2.default.setPrefixedStyle(this.el, 'transform', 'scale(0)');
		    } else {
		      this.el.style.display = 'none';
		    }
	
		    this._isShown = false;
		  };
		  /*
		    Method to show element by applying transform back to normal.
		    @private
		  */
	
	
		  Module.prototype._showByTransform = function _showByTransform() {};
		  /*
		    Method to parse option string.
		    Searches for stagger and rand values and parses them.
		    Leaves the value unattended otherwise.
		    @param {Any} Option value to parse.
		    @returns {Number} Parsed options value.
		  */
	
	
		  Module.prototype._parseOptionString = function _parseOptionString(value) {
		    if (typeof value === 'string') {
		      if (value.match(/stagger/)) {
		        value = _h2.default.parseStagger(value, this._index);
		      }
		    }
		    if (typeof value === 'string') {
		      if (value.match(/rand/)) {
		        value = _h2.default.parseRand(value);
		      }
		    }
		    return value;
		  };
		  /*
		    Method to parse postion option.
		    @param {String} Property name.
		    @param {Any} Property Value.
		    @returns {String} Parsed options value.
		  */
	
	
		  Module.prototype._parsePositionOption = function _parsePositionOption(key, value) {
		    if (_h2.default.unitOptionMap[key]) {
		      value = _h2.default.parseUnit(value).string;
		    }
		    return value;
		  };
		  /*
		    Method to parse strokeDash.. option.
		    @param {String} Property name.
		    @param {Any}    Property value.
		    @returns {String} Parsed options value.
		  */
	
	
		  Module.prototype._parseStrokeDashOption = function _parseStrokeDashOption(key, value) {
		    var result = value;
		    // parse numeric/percent values for strokeDash.. properties
		    if (this._arrayPropertyMap[key]) {
		      var result = [];
		      switch (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) {
		        case 'number':
		          result.push(_h2.default.parseUnit(value));
		          break;
		        case 'string':
		          var array = value.split(' ');
		          for (var i = 0; i < array.length; i++) {
		            result.push(_h2.default.parseUnit(array[i]));
		          }
		          break;
		      }
		    }
		    return result;
		  };
		  /*
		    Method to check if the property is delta property.
		    @private
		    @param {Any} Parameter value to check.
		    @returns {Boolean}
		  */
	
	
		  Module.prototype._isDelta = function _isDelta(optionsValue) {
		    var isObject = _h2.default.isObject(optionsValue);
		    isObject = isObject && !optionsValue.unit;
		    return !(!isObject || _h2.default.isArray(optionsValue) || _h2.default.isDOM(optionsValue));
		  };
		  /*
		    Method to get delta from property and set
		    the property's start value to the props object.
		    @private
		    @param {String} Key name to get delta for.
		    @param {Object} Option value to get the delta for.
		  */
	
	
		  Module.prototype._getDelta = function _getDelta(key, optionsValue) {
		    var delta;
		    if ((key === 'left' || key === 'top') && !this._o.ctx) {
		      _h2.default.warn('Consider to animate x/y properties instead of left/top,\n        as it would be much more performant', optionsValue);
		    }
		    // skip delta calculation for a property if it is listed
		    // in skipPropsDelta object
		    if (this._skipPropsDelta && this._skipPropsDelta[key]) {
		      return;
		    }
		    // get delta
		    delta = _h2.default.parseDelta(key, optionsValue, this._index);
		    // if successfully parsed - save it
		    if (delta.type != null) {
		      this._deltas[key] = delta;
		    }
	
		    var deltaEnd = (0, _typeof3.default)(delta.end) === 'object' ? delta.end.value === 0 ? 0 : delta.end.string : delta.end;
		    // set props to end value of the delta
		    // 0 should be 0 regardless units
		    this._props[key] = deltaEnd;
		  };
		  /*
		    Method to copy `_o` options to `_props` object
		    with fallback to `_defaults`.
		    @private
		  */
	
	
		  Module.prototype._extendDefaults = function _extendDefaults() {
		    this._props = {};
		    this._deltas = {};
		    for (var key in this._defaults) {
		      // skip property if it is listed in _skipProps
		      // if (this._skipProps && this._skipProps[key]) { continue; }
		      // copy the properties to the _o object
		      var value = this._o[key] != null ? this._o[key] : this._defaults[key];
		      // parse option
		      this._parseOption(key, value);
		    }
		  };
		  /*
		    Method to tune new oprions to _o and _props object.
		    @private
		    @param {Object} Options object to tune to.
		  */
	
	
		  Module.prototype._tuneNewOptions = function _tuneNewOptions(o) {
		    // hide the module before tuning it's options
		    // cuz the user could see the change
		    this._hide();
		    for (var key in o) {
		      // skip property if it is listed in _skipProps
		      // if (this._skipProps && this._skipProps[key]) { continue; }
		      // copy the properties to the _o object
		      // delete the key from deltas
		      o && delete this._deltas[key];
		      // rewrite _o record
		      this._o[key] = o[key];
		      // save the options to _props
		      this._parseOption(key, o[key]);
		    }
		  };
		  /*
		    Method to parse option value.
		    @private
		    @param {String} Option name.
		    @param {Any} Option value.
		  */
	
	
		  Module.prototype._parseOption = function _parseOption(name, value) {
		    // if delta property
		    if (this._isDelta(value) && !this._skipPropsDelta[name]) {
		      this._getDelta(name, value);
		      var deltaEnd = _h2.default.getDeltaEnd(value);
		      return this._assignProp(name, this._parseProperty(name, deltaEnd));
		    }
	
		    this._assignProp(name, this._parseProperty(name, value));
		  };
		  /*
		    Method to parse postion and string props.
		    @private
		    @param {String} Property name.
		    @param {Any}    Property value.
		    @returns {Any}  Parsed property value.
		  */
	
	
		  Module.prototype._parsePreArrayProperty = function _parsePreArrayProperty(name, value) {
		    // parse stagger and rand values
		    value = this._parseOptionString(value);
		    // parse units for position properties
		    return this._parsePositionOption(name, value);
		  };
		  /*
		    Method to parse property value.
		    @private
		    @param {String} Property name.
		    @param {Any}    Property value.
		    @returns {Any}  Parsed property value.
		  */
	
	
		  Module.prototype._parseProperty = function _parseProperty(name, value) {
		    // parse `HTML` element in `parent` option
		    if (name === 'parent') {
		      return _h2.default.parseEl(value);
		    }
		    // parse `stagger`, `rand` and `position`
		    value = this._parsePreArrayProperty(name, value);
		    // parse numeric/percent values for strokeDash.. properties
		    return this._parseStrokeDashOption(name, value);
		  };
		  /*
		    Method to parse values inside ∆.
		    @private
		    @param {String} Key name.
		    @param {Object} Delta.
		    @returns {Object} Delta with parsed parameters.
		  */
	
	
		  Module.prototype._parseDeltaValues = function _parseDeltaValues(name, delta) {
		    // return h.parseDelta( name, delta, this._index );
	
		    var d = {};
		    for (var key in delta) {
		      var value = delta[key];
	
		      // delete delta[key];
		      // add parsed properties
		      var newEnd = this._parsePreArrayProperty(name, value);
		      d[this._parsePreArrayProperty(name, key)] = newEnd;
		    }
		    return d;
		  };
		  /*
		    Method to parse delta and nondelta properties.
		    @private
		    @param {String} Property name.
		    @param {Any}    Property value.
		    @returns {Any}  Parsed property value.
		  */
	
	
		  Module.prototype._preparsePropValue = function _preparsePropValue(key, value) {
		    return this._isDelta(value) ? this._parseDeltaValues(key, value) : this._parsePreArrayProperty(key, value);
		  };
		  /*
		    Method to calculate current progress of the deltas.
		    @private
		    @param {Number} Eased progress to calculate - [0..1].
		    @param {Number} Progress to calculate - [0..1].
		  */
	
	
		  Module.prototype._calcCurrentProps = function _calcCurrentProps(easedProgress, p) {
	
		    for (var key in this._deltas) {
	
		      var value = this._deltas[key];
	
		      // get eased progress from delta easing if defined and not curve
		      var isCurve = !!value.curve;
		      var ep = value.easing != null && !isCurve ? value.easing(p) : easedProgress;
	
		      if (value.type === 'array') {
		        var arr;
		        // if prop property is array - reuse it else - create an array
		        if (_h2.default.isArray(this._props[key])) {
		          arr = this._props[key];
		          arr.length = 0;
		        } else {
		          arr = [];
		        }
	
		        // just optimization to prevent curve
		        // calculations on every array item
		        var proc = isCurve ? value.curve(p) : null;
	
		        for (var i = 0; i < value.delta.length; i++) {
		          var item = value.delta[i],
		              dash = !isCurve ? value.start[i].value + ep * item.value : proc * (value.start[i].value + p * item.value);
		          arr.push({
		            string: '' + dash + item.unit,
		            value: dash,
		            unit: item.unit
		          });
		        }
	
		        this._props[key] = arr;
		      } else if (value.type === 'number') {
		        this._props[key] = !isCurve ? value.start + ep * value.delta : value.curve(p) * (value.start + p * value.delta);
		      } else if (value.type === 'unit') {
		        var currentValue = !isCurve ? value.start.value + ep * value.delta : value.curve(p) * (value.start.value + p * value.delta);
	
		        this._props[key] = '' + currentValue + value.end.unit;
		      } else if (value.type === 'color') {
		        var r, g, b, a;
		        if (!isCurve) {
		          r = parseInt(value.start.r + ep * value.delta.r, 10);
		          g = parseInt(value.start.g + ep * value.delta.g, 10);
		          b = parseInt(value.start.b + ep * value.delta.b, 10);
		          a = parseFloat(value.start.a + ep * value.delta.a);
		        } else {
		          var cp = value.curve(p);
		          r = parseInt(cp * (value.start.r + p * value.delta.r), 10);
		          g = parseInt(cp * (value.start.g + p * value.delta.g), 10);
		          b = parseInt(cp * (value.start.b + p * value.delta.b), 10);
		          a = parseFloat(cp * (value.start.a + p * value.delta.a));
		        }
		        this._props[key] = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
		      }
		    }
		  };
		  /*
		    Method to calculate current progress and probably draw it in children.
		    @private
		    @param {Number} Eased progress to set - [0..1].
		    @param {Number} Progress to set - [0..1].
		  */
	
	
		  Module.prototype._setProgress = function _setProgress(easedProgress, progress) {
		    this._progress = easedProgress;
		    this._calcCurrentProps(easedProgress, progress);
		  };
	
		  return Module;
		}();
	
		exports.default = Module;
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = function(module) {
			if(!module.webpackPolyfill) {
				module.deprecate = function() {};
				module.paths = [];
				// module.parent = undefined by default
				module.children = [];
				module.webpackPolyfill = 1;
			}
			return module;
		}
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _typeof = typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _Symbol === "function" && obj.constructor === _Symbol ? "symbol" : typeof obj; };
	
		exports.__esModule = true;
	
		var _iterator = __webpack_require__(32);
	
		var _iterator2 = _interopRequireDefault(_iterator);
	
		var _symbol = __webpack_require__(33);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
		  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
		} : function (obj) {
		  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
		};
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Helpers, h;
	
		Helpers = (function() {
		  Helpers.prototype.NS = 'http://www.w3.org/2000/svg';
	
		  Helpers.prototype.logBadgeCss = 'background:#3A0839;color:#FF512F;border-radius:5px; padding: 1px 5px 2px; border: 1px solid #FF512F;';
	
		  Helpers.prototype.shortColors = {
		    transparent: 'rgba(0,0,0,0)',
		    none: 'rgba(0,0,0,0)',
		    aqua: 'rgb(0,255,255)',
		    black: 'rgb(0,0,0)',
		    blue: 'rgb(0,0,255)',
		    fuchsia: 'rgb(255,0,255)',
		    gray: 'rgb(128,128,128)',
		    green: 'rgb(0,128,0)',
		    lime: 'rgb(0,255,0)',
		    maroon: 'rgb(128,0,0)',
		    navy: 'rgb(0,0,128)',
		    olive: 'rgb(128,128,0)',
		    purple: 'rgb(128,0,128)',
		    red: 'rgb(255,0,0)',
		    silver: 'rgb(192,192,192)',
		    teal: 'rgb(0,128,128)',
		    white: 'rgb(255,255,255)',
		    yellow: 'rgb(255,255,0)',
		    orange: 'rgb(255,128,0)'
		  };
	
		  Helpers.prototype.chainOptionMap = {};
	
		  Helpers.prototype.callbacksMap = {
		    onRefresh: 1,
		    onStart: 1,
		    onComplete: 1,
		    onFirstUpdate: 1,
		    onUpdate: 1,
		    onProgress: 1,
		    onRepeatStart: 1,
		    onRepeatComplete: 1,
		    onPlaybackStart: 1,
		    onPlaybackPause: 1,
		    onPlaybackStop: 1,
		    onPlaybackComplete: 1
		  };
	
		  Helpers.prototype.tweenOptionMap = {
		    duration: 1,
		    delay: 1,
		    speed: 1,
		    repeat: 1,
		    easing: 1,
		    backwardEasing: 1,
		    isYoyo: 1,
		    shiftTime: 1,
		    isReversed: 1,
		    callbacksContext: 1
		  };
	
		  Helpers.prototype.unitOptionMap = {
		    left: 1,
		    top: 1,
		    x: 1,
		    y: 1,
		    rx: 1,
		    ry: 1
		  };
	
		  Helpers.prototype.RAD_TO_DEG = 180 / Math.PI;
	
		  function Helpers() {
		    this.vars();
		  }
	
		  Helpers.prototype.vars = function() {
		    var ua;
		    this.prefix = this.getPrefix();
		    this.getRemBase();
		    this.isFF = this.prefix.lowercase === 'moz';
		    this.isIE = this.prefix.lowercase === 'ms';
		    ua = navigator.userAgent;
		    this.isOldOpera = ua.match(/presto/gim);
		    this.isSafari = ua.indexOf('Safari') > -1;
		    this.isChrome = ua.indexOf('Chrome') > -1;
		    this.isOpera = ua.toLowerCase().indexOf("op") > -1;
		    this.isChrome && this.isSafari && (this.isSafari = false);
		    (ua.match(/PhantomJS/gim)) && (this.isSafari = false);
		    this.isChrome && this.isOpera && (this.isChrome = false);
		    this.is3d = this.checkIf3d();
		    this.uniqIDs = -1;
		    this.div = document.createElement('div');
		    document.body.appendChild(this.div);
		    return this.defaultStyles = this.computedStyle(this.div);
		  };
	
		  Helpers.prototype.cloneObj = function(obj, exclude) {
		    var i, key, keys, newObj;
		    keys = Object.keys(obj);
		    newObj = {};
		    i = keys.length;
		    while (i--) {
		      key = keys[i];
		      if (exclude != null) {
		        if (!exclude[key]) {
		          newObj[key] = obj[key];
		        }
		      } else {
		        newObj[key] = obj[key];
		      }
		    }
		    return newObj;
		  };
	
		  Helpers.prototype.extend = function(objTo, objFrom) {
		    var key, value;
		    for (key in objFrom) {
		      value = objFrom[key];
		      if (objTo[key] == null) {
		        objTo[key] = objFrom[key];
		      }
		    }
		    return objTo;
		  };
	
		  Helpers.prototype.getRemBase = function() {
		    var html, style;
		    html = document.querySelector('html');
		    style = getComputedStyle(html);
		    return this.remBase = parseFloat(style.fontSize);
		  };
	
		  Helpers.prototype.clamp = function(value, min, max) {
		    if (value < min) {
		      return min;
		    } else if (value > max) {
		      return max;
		    } else {
		      return value;
		    }
		  };
	
		  Helpers.prototype.setPrefixedStyle = function(el, name, value) {
		    (name === 'transform') && (el.style["" + this.prefix.css + name] = value);
		    return el.style[name] = value;
		  };
	
		  Helpers.prototype.style = function(el, name, value) {
		    var key, keys, len, results;
		    if (typeof name === 'object') {
		      keys = Object.keys(name);
		      len = keys.length;
		      results = [];
		      while (len--) {
		        key = keys[len];
		        value = name[key];
		        results.push(this.setPrefixedStyle(el, key, value));
		      }
		      return results;
		    } else {
		      return this.setPrefixedStyle(el, name, value);
		    }
		  };
	
		  Helpers.prototype.prepareForLog = function(args) {
		    args = Array.prototype.slice.apply(args);
		    args.unshift('::');
		    args.unshift(this.logBadgeCss);
		    args.unshift('%cmo·js%c');
		    return args;
		  };
	
		  Helpers.prototype.log = function() {
		    if (mojs.isDebug === false) {
		      return;
		    }
		    return console.log.apply(console, this.prepareForLog(arguments));
		  };
	
		  Helpers.prototype.warn = function() {
		    if (mojs.isDebug === false) {
		      return;
		    }
		    return console.warn.apply(console, this.prepareForLog(arguments));
		  };
	
		  Helpers.prototype.error = function() {
		    if (mojs.isDebug === false) {
		      return;
		    }
		    return console.error.apply(console, this.prepareForLog(arguments));
		  };
	
		  Helpers.prototype.parseUnit = function(value) {
		    var amount, isStrict, ref, regex, returnVal, unit;
		    if (typeof value === 'number') {
		      return returnVal = {
		        unit: 'px',
		        isStrict: false,
		        value: value,
		        string: value === 0 ? "" + value : value + "px"
		      };
		    } else if (typeof value === 'string') {
		      regex = /px|%|rem|em|ex|cm|ch|mm|in|pt|pc|vh|vw|vmin|deg/gim;
		      unit = (ref = value.match(regex)) != null ? ref[0] : void 0;
		      isStrict = true;
		      if (!unit) {
		        unit = 'px';
		        isStrict = false;
		      }
		      amount = parseFloat(value);
		      return returnVal = {
		        unit: unit,
		        isStrict: isStrict,
		        value: amount,
		        string: amount === 0 ? "" + amount : "" + amount + unit
		      };
		    }
		    return value;
		  };
	
		  Helpers.prototype.bind = function(func, context) {
		    var bindArgs, wrapper;
		    wrapper = function() {
		      var args, unshiftArgs;
		      args = Array.prototype.slice.call(arguments);
		      unshiftArgs = bindArgs.concat(args);
		      return func.apply(context, unshiftArgs);
		    };
		    bindArgs = Array.prototype.slice.call(arguments, 2);
		    return wrapper;
		  };
	
		  Helpers.prototype.getRadialPoint = function(o) {
		    var point, radAngle, radiusX, radiusY;
		    if (o == null) {
		      o = {};
		    }
		    radAngle = (o.angle - 90) * 0.017453292519943295;
		    radiusX = o.radiusX != null ? o.radiusX : o.radius;
		    radiusY = o.radiusY != null ? o.radiusY : o.radius;
		    return point = {
		      x: o.center.x + (Math.cos(radAngle) * radiusX),
		      y: o.center.y + (Math.sin(radAngle) * radiusY)
		    };
		  };
	
		  Helpers.prototype.getPrefix = function() {
		    var dom, pre, styles, v;
		    styles = window.getComputedStyle(document.documentElement, "");
		    v = Array.prototype.slice.call(styles).join("").match(/-(moz|webkit|ms)-/);
		    pre = (v || (styles.OLink === "" && ["", "o"]))[1];
		    dom = "WebKit|Moz|MS|O".match(new RegExp("(" + pre + ")", "i"))[1];
		    return {
		      dom: dom,
		      lowercase: pre,
		      css: "-" + pre + "-",
		      js: pre[0].toUpperCase() + pre.substr(1)
		    };
		  };
	
		  Helpers.prototype.strToArr = function(string) {
		    var arr;
		    arr = [];
		    if (typeof string === 'number' && !isNaN(string)) {
		      arr.push(this.parseUnit(string));
		      return arr;
		    }
		    string.trim().split(/\s+/gim).forEach((function(_this) {
		      return function(str) {
		        return arr.push(_this.parseUnit(_this.parseIfRand(str)));
		      };
		    })(this));
		    return arr;
		  };
	
		  Helpers.prototype.calcArrDelta = function(arr1, arr2) {
		    var delta, i, j, len1, num;
		    delta = [];
		    for (i = j = 0, len1 = arr1.length; j < len1; i = ++j) {
		      num = arr1[i];
		      delta[i] = this.parseUnit("" + (arr2[i].value - arr1[i].value) + arr2[i].unit);
		    }
		    return delta;
		  };
	
		  Helpers.prototype.isArray = function(variable) {
		    return variable instanceof Array;
		  };
	
		  Helpers.prototype.normDashArrays = function(arr1, arr2) {
		    var arr1Len, arr2Len, currItem, i, j, k, lenDiff, ref, ref1, startI;
		    arr1Len = arr1.length;
		    arr2Len = arr2.length;
		    if (arr1Len > arr2Len) {
		      lenDiff = arr1Len - arr2Len;
		      startI = arr2.length;
		      for (i = j = 0, ref = lenDiff; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
		        currItem = i + startI;
		        arr2.push(this.parseUnit("0" + arr1[currItem].unit));
		      }
		    } else if (arr2Len > arr1Len) {
		      lenDiff = arr2Len - arr1Len;
		      startI = arr1.length;
		      for (i = k = 0, ref1 = lenDiff; 0 <= ref1 ? k < ref1 : k > ref1; i = 0 <= ref1 ? ++k : --k) {
		        currItem = i + startI;
		        arr1.push(this.parseUnit("0" + arr2[currItem].unit));
		      }
		    }
		    return [arr1, arr2];
		  };
	
		  Helpers.prototype.makeColorObj = function(color) {
		    var alpha, b, colorObj, g, isRgb, r, regexString1, regexString2, result, rgbColor;
		    if (color[0] === '#') {
		      result = /^#?([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})$/i.exec(color);
		      colorObj = {};
		      if (result) {
		        r = result[1].length === 2 ? result[1] : result[1] + result[1];
		        g = result[2].length === 2 ? result[2] : result[2] + result[2];
		        b = result[3].length === 2 ? result[3] : result[3] + result[3];
		        colorObj = {
		          r: parseInt(r, 16),
		          g: parseInt(g, 16),
		          b: parseInt(b, 16),
		          a: 1
		        };
		      }
		    }
		    if (color[0] !== '#') {
		      isRgb = color[0] === 'r' && color[1] === 'g' && color[2] === 'b';
		      if (isRgb) {
		        rgbColor = color;
		      }
		      if (!isRgb) {
		        rgbColor = !this.shortColors[color] ? (this.div.style.color = color, this.computedStyle(this.div).color) : this.shortColors[color];
		      }
		      regexString1 = '^rgba?\\((\\d{1,3}),\\s?(\\d{1,3}),';
		      regexString2 = '\\s?(\\d{1,3}),?\\s?(\\d{1}|0?\\.\\d{1,})?\\)$';
		      result = new RegExp(regexString1 + regexString2, 'gi').exec(rgbColor);
		      colorObj = {};
		      alpha = parseFloat(result[4] || 1);
		      if (result) {
		        colorObj = {
		          r: parseInt(result[1], 10),
		          g: parseInt(result[2], 10),
		          b: parseInt(result[3], 10),
		          a: (alpha != null) && !isNaN(alpha) ? alpha : 1
		        };
		      }
		    }
		    return colorObj;
		  };
	
		  Helpers.prototype.computedStyle = function(el) {
		    return getComputedStyle(el);
		  };
	
		  Helpers.prototype.capitalize = function(str) {
		    if (typeof str !== 'string') {
		      throw Error('String expected - nothing to capitalize');
		    }
		    return str.charAt(0).toUpperCase() + str.substring(1);
		  };
	
		  Helpers.prototype.parseRand = function(string) {
		    var rand, randArr, units;
		    randArr = string.split(/rand\(|\,|\)/);
		    units = this.parseUnit(randArr[2]);
		    rand = this.rand(parseFloat(randArr[1]), parseFloat(randArr[2]));
		    if (units.unit && randArr[2].match(units.unit)) {
		      return rand + units.unit;
		    } else {
		      return rand;
		    }
		  };
	
		  Helpers.prototype.parseStagger = function(string, index) {
		    var base, number, splittedValue, unit, unitValue, value;
		    value = string.split(/stagger\(|\)$/)[1].toLowerCase();
		    splittedValue = value.split(/(rand\(.*?\)|[^\(,\s]+)(?=\s*,|\s*$)/gim);
		    value = splittedValue.length > 3 ? (base = this.parseUnit(this.parseIfRand(splittedValue[1])), splittedValue[3]) : (base = this.parseUnit(0), splittedValue[1]);
		    value = this.parseIfRand(value);
		    unitValue = this.parseUnit(value);
		    number = index * unitValue.value + base.value;
		    unit = base.isStrict ? base.unit : unitValue.isStrict ? unitValue.unit : '';
		    if (unit) {
		      return "" + number + unit;
		    } else {
		      return number;
		    }
		  };
	
		  Helpers.prototype.parseIfStagger = function(value, i) {
		    if (!(typeof value === 'string' && value.match(/stagger/g))) {
		      return value;
		    } else {
		      return this.parseStagger(value, i);
		    }
		  };
	
		  Helpers.prototype.parseIfRand = function(str) {
		    if (typeof str === 'string' && str.match(/rand\(/)) {
		      return this.parseRand(str);
		    } else {
		      return str;
		    }
		  };
	
		  Helpers.prototype.parseDelta = function(key, value, index) {
		    var curve, delta, easing, end, endArr, endColorObj, i, j, len1, start, startArr, startColorObj;
		    value = this.cloneObj(value);
		    easing = value.easing;
		    if (easing != null) {
		      easing = mojs.easing.parseEasing(easing);
		    }
		    delete value.easing;
		    curve = value.curve;
		    if (curve != null) {
		      curve = mojs.easing.parseEasing(curve);
		    }
		    delete value.curve;
		    start = Object.keys(value)[0];
		    end = value[start];
		    delta = {
		      start: start
		    };
		    if (isNaN(parseFloat(start)) && !start.match(/rand\(/) && !start.match(/stagger\(/)) {
		      if (key === 'strokeLinecap') {
		        this.warn("Sorry, stroke-linecap property is not animatable yet, using the start(" + start + ") value instead", value);
		        return delta;
		      }
		      startColorObj = this.makeColorObj(start);
		      endColorObj = this.makeColorObj(end);
		      delta = {
		        type: 'color',
		        name: key,
		        start: startColorObj,
		        end: endColorObj,
		        easing: easing,
		        curve: curve,
		        delta: {
		          r: endColorObj.r - startColorObj.r,
		          g: endColorObj.g - startColorObj.g,
		          b: endColorObj.b - startColorObj.b,
		          a: endColorObj.a - startColorObj.a
		        }
		      };
		    } else if (key === 'strokeDasharray' || key === 'strokeDashoffset' || key === 'origin') {
		      startArr = this.strToArr(start);
		      endArr = this.strToArr(end);
		      this.normDashArrays(startArr, endArr);
		      for (i = j = 0, len1 = startArr.length; j < len1; i = ++j) {
		        start = startArr[i];
		        end = endArr[i];
		        this.mergeUnits(start, end, key);
		      }
		      delta = {
		        type: 'array',
		        name: key,
		        start: startArr,
		        end: endArr,
		        delta: this.calcArrDelta(startArr, endArr),
		        easing: easing,
		        curve: curve
		      };
		    } else {
		      if (!this.callbacksMap[key] && !this.tweenOptionMap[key]) {
		        if (this.unitOptionMap[key]) {
		          end = this.parseUnit(this.parseStringOption(end, index));
		          start = this.parseUnit(this.parseStringOption(start, index));
		          this.mergeUnits(start, end, key);
		          delta = {
		            type: 'unit',
		            name: key,
		            start: start,
		            end: end,
		            delta: end.value - start.value,
		            easing: easing,
		            curve: curve
		          };
		        } else {
		          end = parseFloat(this.parseStringOption(end, index));
		          start = parseFloat(this.parseStringOption(start, index));
		          delta = {
		            type: 'number',
		            name: key,
		            start: start,
		            end: end,
		            delta: end - start,
		            easing: easing,
		            curve: curve
		          };
		        }
		      }
		    }
		    return delta;
		  };
	
		  Helpers.prototype.mergeUnits = function(start, end, key) {
		    if (!end.isStrict && start.isStrict) {
		      end.unit = start.unit;
		      return end.string = "" + end.value + end.unit;
		    } else if (end.isStrict && !start.isStrict) {
		      start.unit = end.unit;
		      return start.string = "" + start.value + start.unit;
		    } else if (end.isStrict && start.isStrict) {
		      if (end.unit !== start.unit) {
		        start.unit = end.unit;
		        start.string = "" + start.value + start.unit;
		        return this.warn("Two different units were specified on \"" + key + "\" delta property, mo · js will fallback to end \"" + end.unit + "\" unit ");
		      }
		    }
		  };
	
		  Helpers.prototype.rand = function(min, max) {
		    return (Math.random() * (max - min)) + min;
		  };
	
		  Helpers.prototype.isDOM = function(o) {
		    var isNode;
		    if (o == null) {
		      return false;
		    }
		    isNode = typeof o.nodeType === 'number' && typeof o.nodeName === 'string';
		    return typeof o === 'object' && isNode;
		  };
	
		  Helpers.prototype.getChildElements = function(element) {
		    var childNodes, children, i;
		    childNodes = element.childNodes;
		    children = [];
		    i = childNodes.length;
		    while (i--) {
		      if (childNodes[i].nodeType === 1) {
		        children.unshift(childNodes[i]);
		      }
		    }
		    return children;
		  };
	
		  Helpers.prototype.delta = function(start, end) {
		    var isType1, isType2, obj, type1, type2;
		    type1 = typeof start;
		    type2 = typeof end;
		    isType1 = type1 === 'string' || type1 === 'number' && !isNaN(start);
		    isType2 = type2 === 'string' || type2 === 'number' && !isNaN(end);
		    if (!isType1 || !isType2) {
		      this.error("delta method expects Strings or Numbers at input but got - " + start + ", " + end);
		      return;
		    }
		    obj = {};
		    obj[start] = end;
		    return obj;
		  };
	
		  Helpers.prototype.getUniqID = function() {
		    return ++this.uniqIDs;
		  };
	
		  Helpers.prototype.parsePath = function(path) {
		    var domPath;
		    if (typeof path === 'string') {
		      if (path.charAt(0).toLowerCase() === 'm') {
		        domPath = document.createElementNS(this.NS, 'path');
		        domPath.setAttributeNS(null, 'd', path);
		        return domPath;
		      } else {
		        return document.querySelector(path);
		      }
		    }
		    if (path.style) {
		      return path;
		    }
		  };
	
		  Helpers.prototype.closeEnough = function(num1, num2, eps) {
		    return Math.abs(num1 - num2) < eps;
		  };
	
		  Helpers.prototype.checkIf3d = function() {
		    var div, prefixed, style, tr;
		    div = document.createElement('div');
		    this.style(div, 'transform', 'translateZ(0)');
		    style = div.style;
		    prefixed = this.prefix.css + "transform";
		    tr = style[prefixed] != null ? style[prefixed] : style.transform;
		    return tr !== '';
		  };
	
	
		  /*
		    Method to check if variable holds pointer to an object.
		    @param {Any} Variable to test
		    @returns {Boolean} If variable is object.
		   */
	
		  Helpers.prototype.isObject = function(variable) {
		    return variable !== null && typeof variable === 'object';
		  };
	
	
		  /*
		    Method to get first value of the object.
		    Used to get end value on ∆s.
		    @param {Object} Object to get the value of.
		    @returns {Any} The value of the first object' property.
		   */
	
		  Helpers.prototype.getDeltaEnd = function(obj) {
		    var key;
		    key = Object.keys(obj)[0];
		    return obj[key];
		  };
	
	
		  /*
		    Method to get first key of the object.
		    Used to get start value on ∆s.
		    @param {Object} Object to get the value of.
		    @returns {String} The key of the first object' property.
		   */
	
		  Helpers.prototype.getDeltaStart = function(obj) {
		    var key;
		    key = Object.keys(obj)[0];
		    return key;
		  };
	
	
		  /*
		    Method to check if propery exists in callbacksMap or tweenOptionMap.
		    @param {String} Property name to check for
		    @returns {Boolean} If property is tween property.
		   */
	
		  Helpers.prototype.isTweenProp = function(keyName) {
		    return this.tweenOptionMap[keyName] || this.callbacksMap[keyName];
		  };
	
	
		  /*
		    Method to parse string property value
		    which can include both `rand` and `stagger `
		    value in various positions.
		    @param {String} Property name to check for.
		    @param {Number} Optional index for stagger.
		    @returns {Number} Parsed option value.
		   */
	
		  Helpers.prototype.parseStringOption = function(value, index) {
		    if (index == null) {
		      index = 0;
		    }
		    if (typeof value === 'string') {
		      value = this.parseIfStagger(value, index);
		      value = this.parseIfRand(value);
		    }
		    return value;
		  };
	
	
		  /*
		    Method to get the last item of array.
		    @private
		    @param {Array} Array to get the last item in.
		    @returns {Any} The last item of array.
		   */
	
		  Helpers.prototype.getLastItem = function(arr) {
		    return arr[arr.length - 1];
		  };
	
	
		  /*
		    Method parse HTMLElement.
		    @private
		    @param {String, Object} Selector string or HTMLElement.
		    @returns {Object} HTMLElement.
		   */
	
		  Helpers.prototype.parseEl = function(el) {
		    if (h.isDOM(el)) {
		      return el;
		    } else if (typeof el === 'string') {
		      el = document.querySelector(el);
		    }
		    if (el === null) {
		      h.error("Can't parse HTML element: ", el);
		    }
		    return el;
		  };
	
	
		  /*
		    Method force compositor layer on HTMLElement.
		    @private
		    @param {Object} HTMLElement.
		    @returns {Object} HTMLElement.
		   */
	
		  Helpers.prototype.force3d = function(el) {
		    this.setPrefixedStyle(el, 'backface-visibility', 'hidden');
		    return el;
		  };
	
	
		  /*
		    Method to check if value is delta.
		    @private
		    @param {Any} Property to check.
		    @returns {Boolean} If value is delta.
		   */
	
		  Helpers.prototype.isDelta = function(optionsValue) {
		    var isObject;
		    isObject = this.isObject(optionsValue);
		    isObject = isObject && !optionsValue.unit;
		    return !(!isObject || this.isArray(optionsValue) || this.isDOM(optionsValue));
		  };
	
		  return Helpers;
	
		})();
	
		h = new Helpers;
	
		module.exports = h;
	
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Bit, BitsMap, Circle, Cross, Curve, Custom, Equal, Line, Polygon, Rect, Zigzag, h;
	
		Bit = __webpack_require__(26)["default"] || __webpack_require__(26);
	
		Custom = __webpack_require__(36)["default"] || __webpack_require__(36);
	
		Circle = __webpack_require__(37);
	
		Line = __webpack_require__(38);
	
		Zigzag = __webpack_require__(39);
	
		Rect = __webpack_require__(35);
	
		Polygon = __webpack_require__(40);
	
		Cross = __webpack_require__(41);
	
		Curve = __webpack_require__(42)["default"] || __webpack_require__(42);
	
		Equal = __webpack_require__(43);
	
		h = __webpack_require__(19);
	
		BitsMap = (function() {
		  function BitsMap() {
		    this.addShape = h.bind(this.addShape, this);
		  }
	
		  BitsMap.prototype.bit = Bit;
	
		  BitsMap.prototype.custom = Custom;
	
		  BitsMap.prototype.circle = Circle;
	
		  BitsMap.prototype.line = Line;
	
		  BitsMap.prototype.zigzag = Zigzag;
	
		  BitsMap.prototype.rect = Rect;
	
		  BitsMap.prototype.polygon = Polygon;
	
		  BitsMap.prototype.cross = Cross;
	
		  BitsMap.prototype.equal = Equal;
	
		  BitsMap.prototype.curve = Curve;
	
		  BitsMap.prototype.getShape = function(name) {
		    return this[name] || h.error("no \"" + name + "\" shape available yet, please choose from this list:", ['circle', 'line', 'zigzag', 'rect', 'polygon', 'cross', 'equal', 'curve']);
		  };
	
	
		  /*
		    Method to add shape to the map.
		    @public
		    @param {String} Name of the shape module.
		    @param {Object} Shape module class.
		   */
	
		  BitsMap.prototype.addShape = function(name, Module) {
		    return this[name] = Module;
		  };
	
		  return BitsMap;
	
		})();
	
		module.exports = new BitsMap;
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		var MotionPath, Timeline, Tween, h, resize,
		  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
		h = __webpack_require__(19);
	
		resize = __webpack_require__(34);
	
		Tween = __webpack_require__(8)["default"];
	
		Timeline = __webpack_require__(9)["default"];
	
		MotionPath = (function() {
		  MotionPath.prototype.defaults = {
		    path: null,
		    curvature: {
		      x: '75%',
		      y: '50%'
		    },
		    isCompositeLayer: true,
		    delay: 0,
		    duration: 1000,
		    easing: null,
		    repeat: 0,
		    yoyo: false,
		    onStart: null,
		    onComplete: null,
		    onUpdate: null,
		    offsetX: 0,
		    offsetY: 0,
		    angleOffset: null,
		    pathStart: 0,
		    pathEnd: 1,
		    motionBlur: 0,
		    transformOrigin: null,
		    isAngle: false,
		    isReverse: false,
		    isRunLess: false,
		    isPresetPosition: true
		  };
	
		  function MotionPath(o1) {
		    this.o = o1 != null ? o1 : {};
		    this.calcHeight = bind(this.calcHeight, this);
		    if (this.vars()) {
		      return;
		    }
		    this.createTween();
		    this;
		  }
	
		  MotionPath.prototype.vars = function() {
		    this.getScaler = h.bind(this.getScaler, this);
		    this.resize = resize;
		    this.props = h.cloneObj(this.defaults);
		    this.extendOptions(this.o);
		    this.isMotionBlurReset = h.isSafari || h.isIE;
		    this.isMotionBlurReset && (this.props.motionBlur = 0);
		    this.history = [h.cloneObj(this.props)];
		    return this.postVars();
		  };
	
		  MotionPath.prototype.curveToPath = function(o) {
		    var angle, curvature, curvatureX, curvatureY, curvePoint, curveXPoint, dX, dY, endPoint, path, percent, radius, start;
		    path = document.createElementNS(h.NS, 'path');
		    start = o.start;
		    endPoint = {
		      x: start.x + o.shift.x,
		      y: start.x + o.shift.y
		    };
		    curvature = o.curvature;
		    dX = o.shift.x;
		    dY = o.shift.y;
		    radius = Math.sqrt(dX * dX + dY * dY);
		    percent = radius / 100;
		    angle = Math.atan(dY / dX) * (180 / Math.PI) + 90;
		    if (o.shift.x < 0) {
		      angle = angle + 180;
		    }
		    curvatureX = h.parseUnit(curvature.x);
		    curvatureX = curvatureX.unit === '%' ? curvatureX.value * percent : curvatureX.value;
		    curveXPoint = h.getRadialPoint({
		      center: {
		        x: start.x,
		        y: start.y
		      },
		      radius: curvatureX,
		      angle: angle
		    });
		    curvatureY = h.parseUnit(curvature.y);
		    curvatureY = curvatureY.unit === '%' ? curvatureY.value * percent : curvatureY.value;
		    curvePoint = h.getRadialPoint({
		      center: {
		        x: curveXPoint.x,
		        y: curveXPoint.y
		      },
		      radius: curvatureY,
		      angle: angle + 90
		    });
		    path.setAttribute('d', "M" + start.x + "," + start.y + " Q" + curvePoint.x + "," + curvePoint.y + " " + endPoint.x + "," + endPoint.y);
		    return path;
		  };
	
		  MotionPath.prototype.postVars = function() {
		    this.props.pathStart = h.clamp(this.props.pathStart, 0, 1);
		    this.props.pathEnd = h.clamp(this.props.pathEnd, this.props.pathStart, 1);
		    this.angle = 0;
		    this.speedX = 0;
		    this.speedY = 0;
		    this.blurX = 0;
		    this.blurY = 0;
		    this.prevCoords = {};
		    this.blurAmount = 20;
		    this.props.motionBlur = h.clamp(this.props.motionBlur, 0, 1);
		    this.onUpdate = this.props.onUpdate;
		    if (!this.o.el) {
		      h.error('Missed "el" option. It could be a selector, DOMNode or another module.');
		      return true;
		    }
		    this.el = this.parseEl(this.props.el);
		    this.props.motionBlur > 0 && this.createFilter();
		    this.path = this.getPath();
		    if (!this.path.getAttribute('d')) {
		      h.error('Path has no coordinates to work with, aborting');
		      return true;
		    }
		    this.len = this.path.getTotalLength();
		    this.slicedLen = this.len * (this.props.pathEnd - this.props.pathStart);
		    this.startLen = this.props.pathStart * this.len;
		    this.fill = this.props.fill;
		    if (this.fill != null) {
		      this.container = this.parseEl(this.props.fill.container);
		      this.fillRule = this.props.fill.fillRule || 'all';
		      this.getScaler();
		      if (this.container != null) {
		        this.removeEvent(this.container, 'onresize', this.getScaler);
		        return this.addEvent(this.container, 'onresize', this.getScaler);
		      }
		    }
		  };
	
		  MotionPath.prototype.addEvent = function(el, type, handler) {
		    return el.addEventListener(type, handler, false);
		  };
	
		  MotionPath.prototype.removeEvent = function(el, type, handler) {
		    return el.removeEventListener(type, handler, false);
		  };
	
		  MotionPath.prototype.createFilter = function() {
		    var div, svg;
		    div = document.createElement('div');
		    this.filterID = "filter-" + (h.getUniqID());
		    div.innerHTML = "<svg id=\"svg-" + this.filterID + "\"\n    style=\"visibility:hidden; width:0px; height:0px\">\n  <filter id=\"" + this.filterID + "\" y=\"-20\" x=\"-20\" width=\"40\" height=\"40\">\n    <feOffset\n      id=\"blur-offset\" in=\"SourceGraphic\"\n      dx=\"0\" dy=\"0\" result=\"offset2\"></feOffset>\n    <feGaussianblur\n      id=\"blur\" in=\"offset2\"\n      stdDeviation=\"0,0\" result=\"blur2\"></feGaussianblur>\n    <feMerge>\n      <feMergeNode in=\"SourceGraphic\"></feMergeNode>\n      <feMergeNode in=\"blur2\"></feMergeNode>\n    </feMerge>\n  </filter>\n</svg>";
		    svg = div.querySelector("#svg-" + this.filterID);
		    this.filter = svg.querySelector('#blur');
		    this.filterOffset = svg.querySelector('#blur-offset');
		    document.body.insertBefore(svg, document.body.firstChild);
		    this.el.style['filter'] = "url(#" + this.filterID + ")";
		    return this.el.style[h.prefix.css + "filter"] = "url(#" + this.filterID + ")";
		  };
	
		  MotionPath.prototype.parseEl = function(el) {
		    if (typeof el === 'string') {
		      return document.querySelector(el);
		    }
		    if (el instanceof HTMLElement) {
		      return el;
		    }
		    if (el._setProp != null) {
		      this.isModule = true;
		      return el;
		    }
		  };
	
		  MotionPath.prototype.getPath = function() {
		    var path;
		    path = h.parsePath(this.props.path);
		    if (path) {
		      return path;
		    }
		    if (this.props.path.x || this.props.path.y) {
		      return this.curveToPath({
		        start: {
		          x: 0,
		          y: 0
		        },
		        shift: {
		          x: this.props.path.x || 0,
		          y: this.props.path.y || 0
		        },
		        curvature: {
		          x: this.props.curvature.x || this.defaults.curvature.x,
		          y: this.props.curvature.y || this.defaults.curvature.y
		        }
		      });
		    }
		  };
	
		  MotionPath.prototype.getScaler = function() {
		    var end, size, start;
		    this.cSize = {
		      width: this.container.offsetWidth || 0,
		      height: this.container.offsetHeight || 0
		    };
		    start = this.path.getPointAtLength(0);
		    end = this.path.getPointAtLength(this.len);
		    size = {};
		    this.scaler = {};
		    size.width = end.x >= start.x ? end.x - start.x : start.x - end.x;
		    size.height = end.y >= start.y ? end.y - start.y : start.y - end.y;
		    switch (this.fillRule) {
		      case 'all':
		        this.calcWidth(size);
		        return this.calcHeight(size);
		      case 'width':
		        this.calcWidth(size);
		        return this.scaler.y = this.scaler.x;
		      case 'height':
		        this.calcHeight(size);
		        return this.scaler.x = this.scaler.y;
		    }
		  };
	
		  MotionPath.prototype.calcWidth = function(size) {
		    this.scaler.x = this.cSize.width / size.width;
		    return !isFinite(this.scaler.x) && (this.scaler.x = 1);
		  };
	
		  MotionPath.prototype.calcHeight = function(size) {
		    this.scaler.y = this.cSize.height / size.height;
		    return !isFinite(this.scaler.y) && (this.scaler.y = 1);
		  };
	
		  MotionPath.prototype.run = function(o) {
		    var fistItem, key, value;
		    if (o) {
		      fistItem = this.history[0];
		      for (key in o) {
		        value = o[key];
		        if (h.callbacksMap[key] || h.tweenOptionMap[key]) {
		          h.warn("the property \"" + key + "\" property can not be overridden on run yet");
		          delete o[key];
		        } else {
		          this.history[0][key] = value;
		        }
		      }
		      this.tuneOptions(o);
		    }
		    return this.startTween();
		  };
	
		  MotionPath.prototype.createTween = function() {
		    this.tween = new Tween({
		      duration: this.props.duration,
		      delay: this.props.delay,
		      yoyo: this.props.yoyo,
		      repeat: this.props.repeat,
		      easing: this.props.easing,
		      onStart: (function(_this) {
		        return function() {
		          var ref;
		          return (ref = _this.props.onStart) != null ? ref.apply(_this) : void 0;
		        };
		      })(this),
		      onComplete: (function(_this) {
		        return function() {
		          var ref;
		          _this.props.motionBlur && _this.setBlur({
		            blur: {
		              x: 0,
		              y: 0
		            },
		            offset: {
		              x: 0,
		              y: 0
		            }
		          });
		          return (ref = _this.props.onComplete) != null ? ref.apply(_this) : void 0;
		        };
		      })(this),
		      onUpdate: (function(_this) {
		        return function(p) {
		          return _this.setProgress(p);
		        };
		      })(this),
		      onFirstUpdate: (function(_this) {
		        return function(isForward, isYoyo) {
		          if (!isForward) {
		            return _this.history.length > 1 && _this.tuneOptions(_this.history[0]);
		          }
		        };
		      })(this)
		    });
		    this.timeline = new Timeline;
		    this.timeline.add(this.tween);
		    !this.props.isRunLess && this.startTween();
		    return this.props.isPresetPosition && this.setProgress(0, true);
		  };
	
		  MotionPath.prototype.startTween = function() {
		    return setTimeout(((function(_this) {
		      return function() {
		        var ref;
		        return (ref = _this.timeline) != null ? ref.play() : void 0;
		      };
		    })(this)), 1);
		  };
	
		  MotionPath.prototype.setProgress = function(p, isInit) {
		    var len, point, x, y;
		    len = this.startLen + (!this.props.isReverse ? p * this.slicedLen : (1 - p) * this.slicedLen);
		    point = this.path.getPointAtLength(len);
		    x = point.x + this.props.offsetX;
		    y = point.y + this.props.offsetY;
		    this._getCurrentAngle(point, len, p);
		    this._setTransformOrigin(p);
		    this._setTransform(x, y, p, isInit);
		    return this.props.motionBlur && this.makeMotionBlur(x, y);
		  };
	
		  MotionPath.prototype.setElPosition = function(x, y, p) {
		    var composite, isComposite, rotate, transform;
		    rotate = this.angle !== 0 ? "rotate(" + this.angle + "deg)" : '';
		    isComposite = this.props.isCompositeLayer && h.is3d;
		    composite = isComposite ? 'translateZ(0)' : '';
		    transform = "translate(" + x + "px," + y + "px) " + rotate + " " + composite;
		    return h.setPrefixedStyle(this.el, 'transform', transform);
		  };
	
		  MotionPath.prototype.setModulePosition = function(x, y) {
		    this.el._setProp({
		      shiftX: x + "px",
		      shiftY: y + "px",
		      angle: this.angle
		    });
		    return this.el._draw();
		  };
	
		  MotionPath.prototype._getCurrentAngle = function(point, len, p) {
		    var atan, isTransformFunOrigin, prevPoint, x1, x2;
		    isTransformFunOrigin = typeof this.props.transformOrigin === 'function';
		    if (this.props.isAngle || (this.props.angleOffset != null) || isTransformFunOrigin) {
		      prevPoint = this.path.getPointAtLength(len - 1);
		      x1 = point.y - prevPoint.y;
		      x2 = point.x - prevPoint.x;
		      atan = Math.atan(x1 / x2);
		      !isFinite(atan) && (atan = 0);
		      this.angle = atan * h.RAD_TO_DEG;
		      if ((typeof this.props.angleOffset) !== 'function') {
		        return this.angle += this.props.angleOffset || 0;
		      } else {
		        return this.angle = this.props.angleOffset.call(this, this.angle, p);
		      }
		    } else {
		      return this.angle = 0;
		    }
		  };
	
		  MotionPath.prototype._setTransform = function(x, y, p, isInit) {
		    var transform;
		    if (this.scaler) {
		      x *= this.scaler.x;
		      y *= this.scaler.y;
		    }
		    transform = null;
		    if (!isInit) {
		      transform = typeof this.onUpdate === "function" ? this.onUpdate(p, {
		        x: x,
		        y: y,
		        angle: this.angle
		      }) : void 0;
		    }
		    if (this.isModule) {
		      return this.setModulePosition(x, y);
		    } else {
		      if (typeof transform !== 'string') {
		        return this.setElPosition(x, y, p);
		      } else {
		        return h.setPrefixedStyle(this.el, 'transform', transform);
		      }
		    }
		  };
	
		  MotionPath.prototype._setTransformOrigin = function(p) {
		    var isTransformFunOrigin, tOrigin;
		    if (this.props.transformOrigin) {
		      isTransformFunOrigin = typeof this.props.transformOrigin === 'function';
		      tOrigin = !isTransformFunOrigin ? this.props.transformOrigin : this.props.transformOrigin(this.angle, p);
		      return h.setPrefixedStyle(this.el, 'transform-origin', tOrigin);
		    }
		  };
	
		  MotionPath.prototype.makeMotionBlur = function(x, y) {
		    var absoluteAngle, coords, dX, dY, signX, signY, tailAngle;
		    tailAngle = 0;
		    signX = 1;
		    signY = 1;
		    if ((this.prevCoords.x == null) || (this.prevCoords.y == null)) {
		      this.speedX = 0;
		      this.speedY = 0;
		    } else {
		      dX = x - this.prevCoords.x;
		      dY = y - this.prevCoords.y;
		      if (dX > 0) {
		        signX = -1;
		      }
		      if (signX < 0) {
		        signY = -1;
		      }
		      this.speedX = Math.abs(dX);
		      this.speedY = Math.abs(dY);
		      tailAngle = Math.atan(dY / dX) * (180 / Math.PI) + 90;
		    }
		    absoluteAngle = tailAngle - this.angle;
		    coords = this.angToCoords(absoluteAngle);
		    this.blurX = h.clamp((this.speedX / 16) * this.props.motionBlur, 0, 1);
		    this.blurY = h.clamp((this.speedY / 16) * this.props.motionBlur, 0, 1);
		    this.setBlur({
		      blur: {
		        x: 3 * this.blurX * this.blurAmount * Math.abs(coords.x),
		        y: 3 * this.blurY * this.blurAmount * Math.abs(coords.y)
		      },
		      offset: {
		        x: 3 * signX * this.blurX * coords.x * this.blurAmount,
		        y: 3 * signY * this.blurY * coords.y * this.blurAmount
		      }
		    });
		    this.prevCoords.x = x;
		    return this.prevCoords.y = y;
		  };
	
		  MotionPath.prototype.setBlur = function(o) {
		    if (!this.isMotionBlurReset) {
		      this.filter.setAttribute('stdDeviation', o.blur.x + "," + o.blur.y);
		      this.filterOffset.setAttribute('dx', o.offset.x);
		      return this.filterOffset.setAttribute('dy', o.offset.y);
		    }
		  };
	
		  MotionPath.prototype.extendDefaults = function(o) {
		    var key, results, value;
		    results = [];
		    for (key in o) {
		      value = o[key];
		      results.push(this[key] = value);
		    }
		    return results;
		  };
	
		  MotionPath.prototype.extendOptions = function(o) {
		    var key, results, value;
		    results = [];
		    for (key in o) {
		      value = o[key];
		      results.push(this.props[key] = value);
		    }
		    return results;
		  };
	
		  MotionPath.prototype.then = function(o) {
		    var it, key, opts, prevOptions, value;
		    prevOptions = this.history[this.history.length - 1];
		    opts = {};
		    for (key in prevOptions) {
		      value = prevOptions[key];
		      if (!h.callbacksMap[key] && !h.tweenOptionMap[key] || key === 'duration') {
		        if (o[key] == null) {
		          o[key] = value;
		        }
		      } else {
		        if (o[key] == null) {
		          o[key] = void 0;
		        }
		      }
		      if (h.tweenOptionMap[key]) {
		        opts[key] = key !== 'duration' ? o[key] : o[key] != null ? o[key] : prevOptions[key];
		      }
		    }
		    this.history.push(o);
		    it = this;
		    opts.onUpdate = (function(_this) {
		      return function(p) {
		        return _this.setProgress(p);
		      };
		    })(this);
		    opts.onStart = (function(_this) {
		      return function() {
		        var ref;
		        return (ref = _this.props.onStart) != null ? ref.apply(_this) : void 0;
		      };
		    })(this);
		    opts.onComplete = (function(_this) {
		      return function() {
		        var ref;
		        return (ref = _this.props.onComplete) != null ? ref.apply(_this) : void 0;
		      };
		    })(this);
		    opts.onFirstUpdate = function() {
		      return it.tuneOptions(it.history[this.index]);
		    };
		    opts.isChained = !o.delay;
		    this.timeline.append(new Tween(opts));
		    return this;
		  };
	
		  MotionPath.prototype.tuneOptions = function(o) {
		    this.extendOptions(o);
		    return this.postVars();
		  };
	
		  MotionPath.prototype.angToCoords = function(angle) {
		    var radAngle, x, y;
		    angle = angle % 360;
		    radAngle = ((angle - 90) * Math.PI) / 180;
		    x = Math.cos(radAngle);
		    y = Math.sin(radAngle);
		    x = x < 0 ? Math.max(x, -0.7) : Math.min(x, .7);
		    y = y < 0 ? Math.max(y, -0.7) : Math.min(y, .7);
		    return {
		      x: x * 1.428571429,
		      y: y * 1.428571429
		    };
		  };
	
		  return MotionPath;
	
		})();
	
		module.exports = MotionPath;
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Easing, PI, PathEasing, approximate, bezier, easing, h, mix, sin;
	
		bezier = __webpack_require__(44);
	
		PathEasing = __webpack_require__(45);
	
		mix = __webpack_require__(46);
	
		h = __webpack_require__(19);
	
		approximate = __webpack_require__(47)["default"] || __webpack_require__(47);
	
		sin = Math.sin;
	
		PI = Math.PI;
	
		Easing = (function() {
		  function Easing() {}
	
		  Easing.prototype.bezier = bezier;
	
		  Easing.prototype.PathEasing = PathEasing;
	
		  Easing.prototype.path = (new PathEasing('creator')).create;
	
		  Easing.prototype.approximate = approximate;
	
		  Easing.prototype.inverse = function(p) {
		    return 1 - p;
		  };
	
		  Easing.prototype.linear = {
		    none: function(k) {
		      return k;
		    }
		  };
	
		  Easing.prototype.ease = {
		    "in": bezier.apply(Easing, [0.42, 0, 1, 1]),
		    out: bezier.apply(Easing, [0, 0, 0.58, 1]),
		    inout: bezier.apply(Easing, [0.42, 0, 0.58, 1])
		  };
	
		  Easing.prototype.sin = {
		    "in": function(k) {
		      return 1 - Math.cos(k * PI / 2);
		    },
		    out: function(k) {
		      return sin(k * PI / 2);
		    },
		    inout: function(k) {
		      return 0.5 * (1 - Math.cos(PI * k));
		    }
		  };
	
		  Easing.prototype.quad = {
		    "in": function(k) {
		      return k * k;
		    },
		    out: function(k) {
		      return k * (2 - k);
		    },
		    inout: function(k) {
		      if ((k *= 2) < 1) {
		        return 0.5 * k * k;
		      }
		      return -0.5 * (--k * (k - 2) - 1);
		    }
		  };
	
		  Easing.prototype.cubic = {
		    "in": function(k) {
		      return k * k * k;
		    },
		    out: function(k) {
		      return --k * k * k + 1;
		    },
		    inout: function(k) {
		      if ((k *= 2) < 1) {
		        return 0.5 * k * k * k;
		      }
		      return 0.5 * ((k -= 2) * k * k + 2);
		    }
		  };
	
		  Easing.prototype.quart = {
		    "in": function(k) {
		      return k * k * k * k;
		    },
		    out: function(k) {
		      return 1 - (--k * k * k * k);
		    },
		    inout: function(k) {
		      if ((k *= 2) < 1) {
		        return 0.5 * k * k * k * k;
		      }
		      return -0.5 * ((k -= 2) * k * k * k - 2);
		    }
		  };
	
		  Easing.prototype.quint = {
		    "in": function(k) {
		      return k * k * k * k * k;
		    },
		    out: function(k) {
		      return --k * k * k * k * k + 1;
		    },
		    inout: function(k) {
		      if ((k *= 2) < 1) {
		        return 0.5 * k * k * k * k * k;
		      }
		      return 0.5 * ((k -= 2) * k * k * k * k + 2);
		    }
		  };
	
		  Easing.prototype.expo = {
		    "in": function(k) {
		      if (k === 0) {
		        return 0;
		      } else {
		        return Math.pow(1024, k - 1);
		      }
		    },
		    out: function(k) {
		      if (k === 1) {
		        return 1;
		      } else {
		        return 1 - Math.pow(2, -10 * k);
		      }
		    },
		    inout: function(k) {
		      if (k === 0) {
		        return 0;
		      }
		      if (k === 1) {
		        return 1;
		      }
		      if ((k *= 2) < 1) {
		        return 0.5 * Math.pow(1024, k - 1);
		      }
		      return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
		    }
		  };
	
		  Easing.prototype.circ = {
		    "in": function(k) {
		      return 1 - Math.sqrt(1 - k * k);
		    },
		    out: function(k) {
		      return Math.sqrt(1 - (--k * k));
		    },
		    inout: function(k) {
		      if ((k *= 2) < 1) {
		        return -0.5 * (Math.sqrt(1 - k * k) - 1);
		      }
		      return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
		    }
		  };
	
		  Easing.prototype.back = {
		    "in": function(k) {
		      var s;
		      s = 1.70158;
		      return k * k * ((s + 1) * k - s);
		    },
		    out: function(k) {
		      var s;
		      s = 1.70158;
		      return --k * k * ((s + 1) * k + s) + 1;
		    },
		    inout: function(k) {
		      var s;
		      s = 1.70158 * 1.525;
		      if ((k *= 2) < 1) {
		        return 0.5 * (k * k * ((s + 1) * k - s));
		      }
		      return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
		    }
		  };
	
		  Easing.prototype.elastic = {
		    "in": function(k) {
		      var a, p, s;
		      s = void 0;
		      p = 0.4;
		      if (k === 0) {
		        return 0;
		      }
		      if (k === 1) {
		        return 1;
		      }
		      a = 1;
		      s = p / 4;
		      return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
		    },
		    out: function(k) {
		      var a, p, s;
		      s = void 0;
		      p = 0.4;
		      if (k === 0) {
		        return 0;
		      }
		      if (k === 1) {
		        return 1;
		      }
		      a = 1;
		      s = p / 4;
		      return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
		    },
		    inout: function(k) {
		      var a, p, s;
		      s = void 0;
		      p = 0.4;
		      if (k === 0) {
		        return 0;
		      }
		      if (k === 1) {
		        return 1;
		      }
		      a = 1;
		      s = p / 4;
		      if ((k *= 2) < 1) {
		        return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
		      }
		      return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
		    }
		  };
	
		  Easing.prototype.bounce = {
		    "in": function(k) {
		      return 1 - easing.bounce.out(1 - k);
		    },
		    out: function(k) {
		      if (k < (1 / 2.75)) {
		        return 7.5625 * k * k;
		      } else if (k < (2 / 2.75)) {
		        return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
		      } else if (k < (2.5 / 2.75)) {
		        return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
		      } else {
		        return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
		      }
		    },
		    inout: function(k) {
		      if (k < 0.5) {
		        return easing.bounce["in"](k * 2) * 0.5;
		      }
		      return easing.bounce.out(k * 2 - 1) * 0.5 + 0.5;
		    }
		  };
	
		  Easing.prototype.parseEasing = function(easing) {
		    var easingParent, type;
		    if (easing == null) {
		      easing = 'linear.none';
		    }
		    type = typeof easing;
		    if (type === 'string') {
		      if (easing.charAt(0).toLowerCase() === 'm') {
		        return this.path(easing);
		      } else {
		        easing = this._splitEasing(easing);
		        easingParent = this[easing[0]];
		        if (!easingParent) {
		          h.error("Easing with name \"" + easing[0] + "\" was not found, fallback to \"linear.none\" instead");
		          return this['linear']['none'];
		        }
		        return easingParent[easing[1]];
		      }
		    }
		    if (h.isArray(easing)) {
		      return this.bezier.apply(this, easing);
		    }
		    if ('function') {
		      return easing;
		    }
		  };
	
		  Easing.prototype._splitEasing = function(string) {
		    var firstPart, secondPart, split;
		    if (typeof string === 'function') {
		      return string;
		    }
		    if (typeof string === 'string' && string.length) {
		      split = string.split('.');
		      firstPart = split[0].toLowerCase() || 'linear';
		      secondPart = split[1].toLowerCase() || 'none';
		      return [firstPart, secondPart];
		    } else {
		      return ['linear', 'none'];
		    }
		  };
	
		  return Easing;
	
		})();
	
		easing = new Easing;
	
		easing.mix = mix(easing);
	
		module.exports = easing;
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		};
	
	/***/ },
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(18);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function (self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }
	
		  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
		};
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _setPrototypeOf = __webpack_require__(48);
	
		var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
		var _create = __webpack_require__(49);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _typeof2 = __webpack_require__(18);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function (subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
		  }
	
		  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
		    constructor: {
		      value: subClass,
		      enumerable: false,
		      writable: true,
		      configurable: true
		    }
		  });
		  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
		};
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(18);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _module = __webpack_require__(16);
	
		var _module2 = _interopRequireDefault(_module);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Bit = function (_Module) {
		  (0, _inherits3.default)(Bit, _Module);
	
		  function Bit() {
		    (0, _classCallCheck3.default)(this, Bit);
		    return (0, _possibleConstructorReturn3.default)(this, _Module.apply(this, arguments));
		  }
	
		  /*
		    Method to declare module's defaults.
		    @private
		  */
	
		  Bit.prototype._declareDefaults = function _declareDefaults() {
		    this._defaults = {
		      'ns': 'http://www.w3.org/2000/svg',
		      'tag': 'ellipse',
		      'parent': document.body,
		      'ratio': 1,
		      'radius': 50,
		      'radiusX': null,
		      'radiusY': null,
		      'stroke': 'hotpink',
		      'stroke-dasharray': '',
		      'stroke-dashoffset': '',
		      'stroke-linecap': '',
		      'stroke-width': 2,
		      'stroke-opacity': 1,
		      'fill': 'transparent',
		      'fill-opacity': 1,
		      'width': 0,
		      'height': 0
		    };
		    this._drawMap = ['stroke', 'stroke-width', 'stroke-opacity', 'stroke-dasharray', 'fill', 'stroke-dashoffset', 'stroke-linecap', 'fill-opacity', 'transform'];
		  };
	
		  Bit.prototype._vars = function _vars() {
		    this._state = {};
		    this._drawMapLength = this._drawMap.length;
		  };
		  /*
		    Method for initial render of the shape.
		    @private
		  */
	
	
		  Bit.prototype._render = function _render() {
		    if (this._isRendered) {
		      return;
		    }
		    // set `_isRendered` hatch
		    this._isRendered = true;
		    // create `SVG` canvas to draw in
		    this._createSVGCanvas();
		    // set canvas size
		    this._setCanvasSize();
		    // draw the initial state
		    // this._draw();
		    // append the canvas to the parent from props
		    this._props.parent.appendChild(this._canvas);
		  };
		  /*
		    Method to create `SVG` canvas to draw in.
		    @private
		  */
	
	
		  Bit.prototype._createSVGCanvas = function _createSVGCanvas() {
		    var p = this._props;
		    // create canvas - `svg` element to draw in
		    this._canvas = document.createElementNS(p.ns, 'svg');
		    // create the element shape element and add it to the canvas
		    this.el = document.createElementNS(p.ns, p.tag);
		    this._canvas.appendChild(this.el);
		  };
		  /*
		    Method to set size of the _canvas.
		    @private
		  */
	
	
		  Bit.prototype._setCanvasSize = function _setCanvasSize() {
		    var p = this._props,
		        style = this._canvas.style;
	
		    style.display = 'block';
		    style.width = '100%';
		    style.height = '100%';
		    style.left = '0px';
		    style.top = '0px';
		  };
		  /*
		    Method to draw the shape.
		    Called on every frame.
		    @private
		  */
	
	
		  Bit.prototype._draw = function _draw() {
		    this._props.length = this._getLength();
	
		    var state = this._state,
		        props = this._props;
	
		    var len = this._drawMapLength;
		    while (len--) {
		      var name = this._drawMap[len];
		      switch (name) {
		        case 'stroke-dasharray':
		        case 'stroke-dashoffset':
		          this.castStrokeDash(name);
		      }
		      this._setAttrIfChanged(name, this._props[name]);
		    }
		    this._state.radius = this._props.radius;
		  };
	
		  Bit.prototype.castStrokeDash = function castStrokeDash(name) {
		    // # if array of values
		    var p = this._props;
		    if (_h2.default.isArray(p[name])) {
		      var stroke = '';
		      for (var i = 0; i < p[name].length; i++) {
		        var dash = p[name][i],
		            cast = dash.unit === '%' ? this.castPercent(dash.value) : dash.value;
		        stroke += cast + ' ';
		      }
		      p[name] = stroke === '0 ' ? stroke = '' : stroke;
		      return p[name] = stroke;
		    }
		    // # if single value
		    if ((0, _typeof3.default)(p[name]) === 'object') {
		      stroke = p[name].unit === '%' ? this.castPercent(p[name].value) : p[name].value;
		      p[name] = stroke === 0 ? stroke = '' : stroke;
		    }
		  };
	
		  Bit.prototype.castPercent = function castPercent(percent) {
		    return percent * (this._props.length / 100);
		  };
	
		  /*
		    Method to set props to attributes and cache the values.
		    @private
		  */
	
	
		  Bit.prototype._setAttrIfChanged = function _setAttrIfChanged(name, value) {
		    if (this._state[name] !== value) {
		      // this.el.style[name] = value;
		      this.el.setAttribute(name, value);
		      this._state[name] = value;
		    }
		  };
		  /*
		    Method to length of the shape.
		    @private
		    @returns {Number} Length of the shape.
		  */
	
	
		  Bit.prototype._getLength = function _getLength() {
		    var p = this._props,
		        len = 0,
		        isGetLength = !!(this.el && this.el.getTotalLength);
	
		    if (isGetLength && this.el.getAttribute('d')) {
		      len = this.el.getTotalLength();
		    } else {
		      len = 2 * (p.radiusX != null ? p.radiusX : p.radius);
		    }
		    return len;
		  };
		  /*
		    Method to calculate total sum between points.
		    @private
		    @param {Array} Array of points.
		    @returns {Number} Distance bewtween all points.
		  */
	
	
		  Bit.prototype._getPointsPerimiter = function _getPointsPerimiter(points) {
		    var sum = 0;
	
		    for (var i = 1; i < points.length; i++) {
		      sum += this._pointsDelta(points[i - 1], points[i]);
		    }
	
		    sum += this._pointsDelta(points[0], _h2.default.getLastItem(points));
		    return sum;
		  };
		  /*
		    Method to get delta from two points.
		    @private
		    @param {Object} Point 1.
		    @param {Object} Point 2.
		    @returns {Number} Distance between the pooints.
		  */
	
	
		  Bit.prototype._pointsDelta = function _pointsDelta(point1, point2) {
		    var dx = Math.abs(point1.x - point2.x),
		        dy = Math.abs(point1.y - point2.y);
		    return Math.sqrt(dx * dx + dy * dy);
		  };
		  /*
		    Method to set module's size.
		    @private
		    @param {Number} Module width.
		    @param {Number} Module height.
		  */
	
	
		  Bit.prototype._setSize = function _setSize(width, height) {
		    var p = this._props;
		    p.width = width;
		    p.height = height;
		    this._draw();
		  };
	
		  return Bit;
		}(_module2.default);
	
		exports.default = Bit;
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _assign = __webpack_require__(50);
	
		var _assign2 = _interopRequireDefault(_assign);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _assign2.default || function (target) {
		  for (var i = 1; i < arguments.length; i++) {
		    var source = arguments[i];
	
		    for (var key in source) {
		      if (Object.prototype.hasOwnProperty.call(source, key)) {
		        target[key] = source[key];
		      }
		    }
		  }
	
		  return target;
		};
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(52), __esModule: true };
	
	/***/ },
	/* 29 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(51), __esModule: true };
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		(function() {
		  'use strict';
		  var cancel, i, isOldBrowser, lastTime, vendors, vp, w;
		  vendors = ['webkit', 'moz'];
		  i = 0;
		  w = window;
		  while (i < vendors.length && !w.requestAnimationFrame) {
		    vp = vendors[i];
		    w.requestAnimationFrame = w[vp + 'RequestAnimationFrame'];
		    cancel = w[vp + 'CancelAnimationFrame'];
		    w.cancelAnimationFrame = cancel || w[vp + 'CancelRequestAnimationFrame'];
		    ++i;
		  }
		  isOldBrowser = !w.requestAnimationFrame || !w.cancelAnimationFrame;
		  if (/iP(ad|hone|od).*OS 6/.test(w.navigator.userAgent) || isOldBrowser) {
		    lastTime = 0;
		    w.requestAnimationFrame = function(callback) {
		      var nextTime, now;
		      now = Date.now();
		      nextTime = Math.max(lastTime + 16, now);
		      return setTimeout((function() {
		        callback(lastTime = nextTime);
		      }), nextTime - now);
		    };
		    w.cancelAnimationFrame = clearTimeout;
		  }
		})();
	
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		(function(root) {
		  var offset, ref, ref1;
		  if (root.performance == null) {
		    root.performance = {};
		  }
		  Date.now = Date.now || function() {
		    return (new Date).getTime();
		  };
		  if (root.performance.now == null) {
		    offset = ((ref = root.performance) != null ? (ref1 = ref.timing) != null ? ref1.navigationStart : void 0 : void 0) ? performance.timing.navigationStart : Date.now();
		    return root.performance.now = function() {
		      return Date.now() - offset;
		    };
		  }
		})(window);
	
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(1), __esModule: true };
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(54), __esModule: true };
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
		/*!
		  LegoMushroom @legomushroom http://legomushroom.com
		  MIT License 2014
		 */
	
		/* istanbul ignore next */
		(function() {
		  var Main;
		  Main = (function() {
		    function Main(o) {
		      this.o = o != null ? o : {};
		      if (window.isAnyResizeEventInited) {
		        return;
		      }
		      this.vars();
		      this.redefineProto();
		    }
	
		    Main.prototype.vars = function() {
		      window.isAnyResizeEventInited = true;
		      this.allowedProtos = [HTMLDivElement, HTMLFormElement, HTMLLinkElement, HTMLBodyElement, HTMLParagraphElement, HTMLFieldSetElement, HTMLLegendElement, HTMLLabelElement, HTMLButtonElement, HTMLUListElement, HTMLOListElement, HTMLLIElement, HTMLHeadingElement, HTMLQuoteElement, HTMLPreElement, HTMLBRElement, HTMLFontElement, HTMLHRElement, HTMLModElement, HTMLParamElement, HTMLMapElement, HTMLTableElement, HTMLTableCaptionElement, HTMLImageElement, HTMLTableCellElement, HTMLSelectElement, HTMLInputElement, HTMLTextAreaElement, HTMLAnchorElement, HTMLObjectElement, HTMLTableColElement, HTMLTableSectionElement, HTMLTableRowElement];
		      return this.timerElements = {
		        img: 1,
		        textarea: 1,
		        input: 1,
		        embed: 1,
		        object: 1,
		        svg: 1,
		        canvas: 1,
		        tr: 1,
		        tbody: 1,
		        thead: 1,
		        tfoot: 1,
		        a: 1,
		        select: 1,
		        option: 1,
		        optgroup: 1,
		        dl: 1,
		        dt: 1,
		        br: 1,
		        basefont: 1,
		        font: 1,
		        col: 1,
		        iframe: 1
		      };
		    };
	
		    Main.prototype.redefineProto = function() {
		      var i, it, proto, t;
		      it = this;
		      return t = (function() {
		        var j, len, ref, results;
		        ref = this.allowedProtos;
		        results = [];
		        for (i = j = 0, len = ref.length; j < len; i = ++j) {
		          proto = ref[i];
		          if (proto.prototype == null) {
		            continue;
		          }
		          results.push((function(proto) {
		            var listener, remover;
		            listener = proto.prototype.addEventListener || proto.prototype.attachEvent;
		            (function(listener) {
		              var wrappedListener;
		              wrappedListener = function() {
		                var option;
		                if (this !== window || this !== document) {
		                  option = arguments[0] === 'onresize' && !this.isAnyResizeEventInited;
		                  option && it.handleResize({
		                    args: arguments,
		                    that: this
		                  });
		                }
		                return listener.apply(this, arguments);
		              };
		              if (proto.prototype.addEventListener) {
		                return proto.prototype.addEventListener = wrappedListener;
		              } else if (proto.prototype.attachEvent) {
		                return proto.prototype.attachEvent = wrappedListener;
		              }
		            })(listener);
		            remover = proto.prototype.removeEventListener || proto.prototype.detachEvent;
		            return (function(remover) {
		              var wrappedRemover;
		              wrappedRemover = function() {
		                this.isAnyResizeEventInited = false;
		                this.iframe && this.removeChild(this.iframe);
		                return remover.apply(this, arguments);
		              };
		              if (proto.prototype.removeEventListener) {
		                return proto.prototype.removeEventListener = wrappedRemover;
		              } else if (proto.prototype.detachEvent) {
		                return proto.prototype.detachEvent = wrappedListener;
		              }
		            })(remover);
		          })(proto));
		        }
		        return results;
		      }).call(this);
		    };
	
		    Main.prototype.handleResize = function(args) {
		      var computedStyle, el, iframe, isEmpty, isNoPos, isStatic, ref;
		      el = args.that;
		      if (!this.timerElements[el.tagName.toLowerCase()]) {
		        iframe = document.createElement('iframe');
		        el.appendChild(iframe);
		        iframe.style.width = '100%';
		        iframe.style.height = '100%';
		        iframe.style.position = 'absolute';
		        iframe.style.zIndex = -999;
		        iframe.style.opacity = 0;
		        iframe.style.top = 0;
		        iframe.style.left = 0;
		        computedStyle = window.getComputedStyle ? getComputedStyle(el) : el.currentStyle;
		        isNoPos = el.style.position === '';
		        isStatic = computedStyle.position === 'static' && isNoPos;
		        isEmpty = computedStyle.position === '' && el.style.position === '';
		        if (isStatic || isEmpty) {
		          el.style.position = 'relative';
		        }
		        if ((ref = iframe.contentWindow) != null) {
		          ref.onresize = (function(_this) {
		            return function(e) {
		              return _this.dispatchEvent(el);
		            };
		          })(this);
		        }
		        el.iframe = iframe;
		      } else {
		        this.initTimer(el);
		      }
		      return el.isAnyResizeEventInited = true;
		    };
	
		    Main.prototype.initTimer = function(el) {
		      var height, width;
		      width = 0;
		      height = 0;
		      return this.interval = setInterval((function(_this) {
		        return function() {
		          var newHeight, newWidth;
		          newWidth = el.offsetWidth;
		          newHeight = el.offsetHeight;
		          if (newWidth !== width || newHeight !== height) {
		            _this.dispatchEvent(el);
		            width = newWidth;
		            return height = newHeight;
		          }
		        };
		      })(this), this.o.interval || 62.5);
		    };
	
		    Main.prototype.dispatchEvent = function(el) {
		      var e;
		      if (document.createEvent) {
		        e = document.createEvent('HTMLEvents');
		        e.initEvent('onresize', false, false);
		        return el.dispatchEvent(e);
		      } else if (document.createEventObject) {
		        e = document.createEventObject();
		        return el.fireEvent('onresize', e);
		      } else {
		        return false;
		      }
		    };
	
		    Main.prototype.destroy = function() {
		      var i, it, j, len, proto, ref, results;
		      clearInterval(this.interval);
		      this.interval = null;
		      window.isAnyResizeEventInited = false;
		      it = this;
		      ref = this.allowedProtos;
		      results = [];
		      for (i = j = 0, len = ref.length; j < len; i = ++j) {
		        proto = ref[i];
		        if (proto.prototype == null) {
		          continue;
		        }
		        results.push((function(proto) {
		          var listener;
		          listener = proto.prototype.addEventListener || proto.prototype.attachEvent;
		          if (proto.prototype.addEventListener) {
		            proto.prototype.addEventListener = Element.prototype.addEventListener;
		          } else if (proto.prototype.attachEvent) {
		            proto.prototype.attachEvent = Element.prototype.attachEvent;
		          }
		          if (proto.prototype.removeEventListener) {
		            return proto.prototype.removeEventListener = Element.prototype.removeEventListener;
		          } else if (proto.prototype.detachEvent) {
		            return proto.prototype.detachEvent = Element.prototype.detachEvent;
		          }
		        })(proto));
		      }
		      return results;
		    };
	
		    return Main;
	
		  })();
		  if (true) {
		    return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		      return new Main;
		    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  } else if ((typeof module === "object") && (typeof module.exports === "object")) {
		    return module.exports = new Main;
		  } else {
		    if (typeof window !== "undefined" && window !== null) {
		      window.AnyResizeEvent = Main;
		    }
		    return typeof window !== "undefined" && window !== null ? window.anyResizeEvent = new Main : void 0;
		  }
		})();
	
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		var Bit, Rect,
		  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		  hasProp = {}.hasOwnProperty;
	
		Bit = __webpack_require__(26)["default"] || __webpack_require__(26);
	
		Rect = (function(superClass) {
		  extend(Rect, superClass);
	
		  function Rect() {
		    return Rect.__super__.constructor.apply(this, arguments);
		  }
	
		  Rect.prototype._declareDefaults = function() {
		    Rect.__super__._declareDefaults.apply(this, arguments);
		    this._defaults.tag = 'rect';
		    this._defaults.rx = 0;
		    return this._defaults.ry = 0;
		  };
	
		  Rect.prototype._draw = function() {
		    var p, radiusX, radiusY;
		    Rect.__super__._draw.apply(this, arguments);
		    p = this._props;
		    radiusX = p.radiusX != null ? p.radiusX : p.radius;
		    radiusY = p.radiusY != null ? p.radiusY : p.radius;
		    this._setAttrIfChanged('width', 2 * radiusX);
		    this._setAttrIfChanged('height', 2 * radiusY);
		    this._setAttrIfChanged('x', (p.width / 2) - radiusX);
		    this._setAttrIfChanged('y', (p.height / 2) - radiusY);
		    this._setAttrIfChanged('rx', p.rx);
		    return this._setAttrIfChanged('ry', p.ry);
		  };
	
		  Rect.prototype._getLength = function() {
		    var radiusX, radiusY;
		    radiusX = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    radiusY = this._props.radiusY != null ? this._props.radiusY : this._props.radius;
		    return 2 * (2 * radiusX + 2 * radiusY);
		  };
	
		  return Rect;
	
		})(Bit);
	
		module.exports = Rect;
	
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _bit = __webpack_require__(26);
	
		var _bit2 = _interopRequireDefault(_bit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Custom = function (_Bit) {
		  (0, _inherits3.default)(Custom, _Bit);
	
		  function Custom() {
		    (0, _classCallCheck3.default)(this, Custom);
		    return (0, _possibleConstructorReturn3.default)(this, _Bit.apply(this, arguments));
		  }
	
		  /*
		    Method to declare module's defaults.
		    @private
		    @overrides @ Bit
		  */
	
		  Custom.prototype._declareDefaults = function _declareDefaults() {
		    _Bit.prototype._declareDefaults.call(this);
	
		    this._defaults.tag = 'path';
		    this._defaults.parent = null;
	
		    // remove `stroke-width` from `_drawMap`
		    // because we need to recal strokeWidth size regarding scale
		    for (var i = 0; i < this._drawMap.length; i++) {
		      if (this._drawMap[i] === 'stroke-width') {
		        this._drawMap.splice(i, 1);
		      }
		    }
		  };
		  /*
		    Method to get shape to set on module's path.
		    @public
		    @returns {String} Empty string.
		  */
	
	
		  Custom.prototype.getShape = function getShape() {
		    return '';
		  };
		  /*
		    Method to get shape perimeter length.
		    @public
		    @returns {Number} Default length string.
		  */
	
	
		  Custom.prototype.getLength = function getLength() {
		    return 100;
		  };
		  /*
		    Method to draw the shape.
		    Called on every frame.
		    @private
		    @overrides @ Bit
		  */
	
	
		  Custom.prototype._draw = function _draw() {
		    var p = this._props,
		        state = this._state,
		        radiusXChange = state['radiusX'] !== p.radiusX,
		        radiusYChange = state['radiusY'] !== p.radiusY,
		        radiusChange = state['radius'] !== p.radius;
	
		    // update transform only if one of radiuses changed
		    if (radiusXChange || radiusYChange || radiusChange) {
		      this.el.setAttribute('transform', this._getScale());
		      state['radiusX'] = p.radiusX;
		      state['radiusY'] = p.radiusY;
		      state['radius'] = p.radius;
		    }
	
		    this._setAttrIfChanged('stroke-width', p['stroke-width'] / p.maxScale);
	
		    _Bit.prototype._draw.call(this);
		  };
		  /*
		    Method for initial render of the shape.
		    @private
		    @overrides @ Bit
		  */
	
	
		  Custom.prototype._render = function _render() {
		    if (this._isRendered) {
		      return;
		    }
		    this._isRendered = true;
	
		    this._length = this.getLength();
	
		    var p = this._props;
		    p.parent.innerHTML = '<svg id="js-mojs-shape-canvas" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink"><g id="js-mojs-shape-el">' + this.getShape() + '</g></svg>';
	
		    this._canvas = p.parent.querySelector('#js-mojs-shape-canvas');
		    this.el = p.parent.querySelector('#js-mojs-shape-el');
		    this._setCanvasSize();
		  };
		  /*
		    Method to get scales for the shape.
		    @private
		    @mutates @props
		  */
	
	
		  Custom.prototype._getScale = function _getScale() {
		    var p = this._props,
		        radiusX = p.radiusX ? p.radiusX : p.radius,
		        radiusY = p.radiusY ? p.radiusY : p.radius;
	
		    p.scaleX = 2 * radiusX / 100;
		    p.scaleY = 2 * radiusY / 100;
		    p.maxScale = Math.max(p.scaleX, p.scaleY);
	
		    p.shiftX = p.width / 2 - 50 * p.scaleX;
		    p.shiftY = p.height / 2 - 50 * p.scaleY;
	
		    var translate = 'translate(' + p.shiftX + ', ' + p.shiftY + ')';
		    return translate + ' scale(' + p.scaleX + ', ' + p.scaleY + ')';
		  };
		  /*
		    Method to length of the shape.
		    @private
		    @returns {Number} Length of the shape.
		  */
	
	
		  Custom.prototype._getLength = function _getLength() {
		    return this._length;
		  };
	
		  return Custom;
		}(_bit2.default);
	
		exports.default = Custom;
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		var Bit, Circle,
		  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		  hasProp = {}.hasOwnProperty;
	
		Bit = __webpack_require__(26)["default"] || __webpack_require__(26);
	
		Circle = (function(superClass) {
		  extend(Circle, superClass);
	
		  function Circle() {
		    return Circle.__super__.constructor.apply(this, arguments);
		  }
	
		  Circle.prototype._declareDefaults = function() {
		    Circle.__super__._declareDefaults.apply(this, arguments);
		    return this._defaults.shape = 'ellipse';
		  };
	
		  Circle.prototype._draw = function() {
		    var rx, ry;
		    rx = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    ry = this._props.radiusY != null ? this._props.radiusY : this._props.radius;
		    this._setAttrIfChanged('rx', rx);
		    this._setAttrIfChanged('ry', ry);
		    this._setAttrIfChanged('cx', this._props.width / 2);
		    this._setAttrIfChanged('cy', this._props.height / 2);
		    return Circle.__super__._draw.apply(this, arguments);
		  };
	
		  Circle.prototype._getLength = function() {
		    var radiusX, radiusY;
		    radiusX = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    radiusY = this._props.radiusY != null ? this._props.radiusY : this._props.radius;
		    return 2 * Math.PI * Math.sqrt((radiusX * radiusX + radiusY * radiusY) / 2);
		  };
	
		  return Circle;
	
		})(Bit);
	
		module.exports = Circle;
	
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		var Bit, Line,
		  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		  hasProp = {}.hasOwnProperty;
	
		Bit = __webpack_require__(26)["default"] || __webpack_require__(26);
	
		Line = (function(superClass) {
		  extend(Line, superClass);
	
		  function Line() {
		    return Line.__super__.constructor.apply(this, arguments);
		  }
	
		  Line.prototype._declareDefaults = function() {
		    Line.__super__._declareDefaults.apply(this, arguments);
		    return this._defaults.tag = 'line';
		  };
	
		  Line.prototype._draw = function() {
		    var radiusX, x, y;
		    radiusX = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    x = this._props.width / 2;
		    y = this._props.height / 2;
		    this._setAttrIfChanged('x1', x - radiusX);
		    this._setAttrIfChanged('x2', x + radiusX);
		    this._setAttrIfChanged('y1', y);
		    this._setAttrIfChanged('y2', y);
		    return Line.__super__._draw.apply(this, arguments);
		  };
	
		  return Line;
	
		})(Bit);
	
		module.exports = Line;
	
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		var Bit, Zigzag,
		  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		  hasProp = {}.hasOwnProperty;
	
		Bit = __webpack_require__(26)["default"] || __webpack_require__(26);
	
		Zigzag = (function(superClass) {
		  extend(Zigzag, superClass);
	
		  function Zigzag() {
		    return Zigzag.__super__.constructor.apply(this, arguments);
		  }
	
		  Zigzag.prototype._declareDefaults = function() {
		    Zigzag.__super__._declareDefaults.apply(this, arguments);
		    this._defaults.tag = 'path';
		    return this._defaults.points = 3;
		  };
	
		  Zigzag.prototype._draw = function() {
		    var currentX, currentY, delta, i, isPoints, isRadiusX, isRadiusY, j, length, p, points, radiusX, radiusY, ref, stepX, x, y, yFlip;
		    Zigzag.__super__._draw.apply(this, arguments);
		    p = this._props;
		    if (!this._props.points) {
		      return;
		    }
		    radiusX = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    radiusY = this._props.radiusY != null ? this._props.radiusY : this._props.radius;
		    isRadiusX = radiusX === this._prevRadiusX;
		    isRadiusY = radiusY === this._prevRadiusY;
		    isPoints = p.points === this._prevPoints;
		    if (isRadiusX && isRadiusY && isPoints) {
		      return;
		    }
		    x = p.width / 2;
		    y = p.height / 2;
		    currentX = x - radiusX;
		    currentY = y;
		    stepX = (2 * radiusX) / (p.points - 1);
		    yFlip = -1;
		    delta = Math.sqrt(stepX * stepX + radiusY * radiusY);
		    length = -delta;
		    points = "M" + currentX + ", " + y + " ";
		    for (i = j = 0, ref = p.points; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
		      points += "L" + currentX + ", " + currentY + " ";
		      currentX += stepX;
		      length += delta;
		      currentY = yFlip === -1 ? y - radiusY : y;
		      yFlip = -yFlip;
		    }
		    this._length = length;
		    this.el.setAttribute('d', points);
		    this._prevPoints = p.points;
		    this._prevRadiusX = radiusX;
		    return this._prevRadiusY = radiusY;
		  };
	
		  Zigzag.prototype._getLength = function() {
		    return this._length;
		  };
	
		  return Zigzag;
	
		})(Bit);
	
		module.exports = Zigzag;
	
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		var Bit, Polygon, h,
		  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		  hasProp = {}.hasOwnProperty;
	
		Bit = __webpack_require__(26)["default"] || __webpack_require__(26);
	
		h = __webpack_require__(19);
	
		Polygon = (function(superClass) {
		  extend(Polygon, superClass);
	
		  function Polygon() {
		    return Polygon.__super__.constructor.apply(this, arguments);
		  }
	
	
		  /*
		    Method to declare defaults.
		    @overrides @ Bit
		   */
	
		  Polygon.prototype._declareDefaults = function() {
		    Polygon.__super__._declareDefaults.apply(this, arguments);
		    this._defaults.tag = 'path';
		    return this._defaults.points = 3;
		  };
	
	
		  /*
		    Method to draw the shape.
		    @overrides @ Bit
		   */
	
		  Polygon.prototype._draw = function() {
		    var char, d, i, isPoints, isRadiusX, isRadiusY, j, k, len, p, point, radiusX, radiusY, ref, ref1, step;
		    p = this._props;
		    radiusX = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    radiusY = this._props.radiusY != null ? this._props.radiusY : this._props.radius;
		    isRadiusX = radiusX === this._prevRadiusX;
		    isRadiusY = radiusY === this._prevRadiusY;
		    isPoints = p.points === this._prevPoints;
		    if (!(isRadiusX && isRadiusY && isPoints)) {
		      step = 360 / this._props.points;
		      if (this._radialPoints == null) {
		        this._radialPoints = [];
		      } else {
		        this._radialPoints.length = 0;
		      }
		      for (i = j = 0, ref = this._props.points; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
		        this._radialPoints.push(h.getRadialPoint({
		          radius: this._props.radius,
		          radiusX: this._props.radiusX,
		          radiusY: this._props.radiusY,
		          angle: i * step,
		          center: {
		            x: p.width / 2,
		            y: p.height / 2
		          }
		        }));
		      }
		      d = '';
		      ref1 = this._radialPoints;
		      for (i = k = 0, len = ref1.length; k < len; i = ++k) {
		        point = ref1[i];
		        char = i === 0 ? 'M' : 'L';
		        d += "" + char + (point.x.toFixed(4)) + "," + (point.y.toFixed(4)) + " ";
		      }
		      this._prevPoints = p.points;
		      this._prevRadiusX = radiusX;
		      this._prevRadiusY = radiusY;
		      this.el.setAttribute('d', (d += 'z'));
		    }
		    return Polygon.__super__._draw.apply(this, arguments);
		  };
	
	
		  /*
		    Method to get length of the shape.
		    @overrides @ Bit
		   */
	
		  Polygon.prototype._getLength = function() {
		    return this._getPointsPerimiter(this._radialPoints);
		  };
	
		  return Polygon;
	
		})(Bit);
	
		module.exports = Polygon;
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		var Bit, Cross,
		  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		  hasProp = {}.hasOwnProperty;
	
		Bit = __webpack_require__(26)["default"] || __webpack_require__(26);
	
		Cross = (function(superClass) {
		  extend(Cross, superClass);
	
		  function Cross() {
		    return Cross.__super__.constructor.apply(this, arguments);
		  }
	
		  Cross.prototype._declareDefaults = function() {
		    Cross.__super__._declareDefaults.apply(this, arguments);
		    return this._defaults.tag = 'path';
		  };
	
		  Cross.prototype._draw = function() {
		    var d, isRadiusX, isRadiusY, line1, line2, p, radiusX, radiusY, x, x1, x2, y, y1, y2;
		    Cross.__super__._draw.apply(this, arguments);
		    p = this._props;
		    radiusX = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    radiusY = this._props.radiusY != null ? this._props.radiusY : this._props.radius;
		    isRadiusX = radiusX === this._prevRadiusX;
		    isRadiusY = radiusY === this._prevRadiusY;
		    if (isRadiusX && isRadiusY) {
		      return;
		    }
		    x = this._props.width / 2;
		    y = this._props.height / 2;
		    x1 = x - radiusX;
		    x2 = x + radiusX;
		    line1 = "M" + x1 + "," + y + " L" + x2 + "," + y;
		    y1 = y - radiusY;
		    y2 = y + radiusY;
		    line2 = "M" + x + "," + y1 + " L" + x + "," + y2;
		    d = line1 + " " + line2;
		    this.el.setAttribute('d', d);
		    this._prevRadiusX = radiusX;
		    return this._prevRadiusY = radiusY;
		  };
	
		  Cross.prototype._getLength = function() {
		    var radiusX, radiusY;
		    radiusX = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    radiusY = this._props.radiusY != null ? this._props.radiusY : this._props.radius;
		    return 2 * (radiusX + radiusY);
		  };
	
		  return Cross;
	
		})(Bit);
	
		module.exports = Cross;
	
	
	/***/ },
	/* 42 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(23);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(24);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(25);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _bit = __webpack_require__(26);
	
		var _bit2 = _interopRequireDefault(_bit);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Curve = function (_Bit) {
		  (0, _inherits3.default)(Curve, _Bit);
	
		  function Curve() {
		    (0, _classCallCheck3.default)(this, Curve);
		    return (0, _possibleConstructorReturn3.default)(this, _Bit.apply(this, arguments));
		  }
	
		  /*
		    Method to declare module's defaults.
		    @private
		    @overrides @ Bit
		  */
	
		  Curve.prototype._declareDefaults = function _declareDefaults() {
		    _Bit.prototype._declareDefaults.call(this);
		    this._defaults.tag = 'path';
		  };
		  /*
		    Method to draw the module.
		    @private
		    @overrides @ Bit
		  */
	
	
		  Curve.prototype._draw = function _draw() {
		    _Bit.prototype._draw.call(this);
		    var p = this._props;
	
		    var radiusX = p.radiusX != null ? p.radiusX : p.radius;
		    var radiusY = p.radiusY != null ? p.radiusY : p.radius;
	
		    var isRadiusX = radiusX === this._prevRadiusX;
		    var isRadiusY = radiusY === this._prevRadiusY;
		    var isPoints = p.points === this._prevPoints;
		    // skip if nothing changed
		    if (isRadiusX && isRadiusY && isPoints) {
		      return;
		    }
	
		    var x = p.width / 2;
		    var y = p.height / 2;
		    var x1 = x - radiusX;
		    var x2 = x + radiusX;
	
		    var d = 'M' + x1 + ' ' + y + ' Q ' + x + ' ' + (y - 2 * radiusY) + ' ' + x2 + ' ' + y;
	
		    // set the `d` attribute and save it to `_prevD`
		    this.el.setAttribute('d', d);
		    // save the properties
		    this._prevPoints = p.points;
		    this._prevRadiusX = radiusX;
		    this._prevRadiusY = radiusY;
		  };
	
		  Curve.prototype._getLength = function _getLength() {
		    var p = this._props;
	
		    var radiusX = p.radiusX != null ? p.radiusX : p.radius;
		    var radiusY = p.radiusY != null ? p.radiusY : p.radius;
	
		    var dRadius = radiusX + radiusY;
		    var sqrt = Math.sqrt((3 * radiusX + radiusY) * (radiusX + 3 * radiusY));
	
		    return .5 * Math.PI * (3 * dRadius - sqrt);
		  };
	
		  return Curve;
		}(_bit2.default); // istanbul ignore next
	
	
		exports.default = Curve;
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
		
		/* istanbul ignore next */
		var Bit, Equal,
		  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
		  hasProp = {}.hasOwnProperty;
	
		Bit = __webpack_require__(26)["default"] || __webpack_require__(26);
	
		Equal = (function(superClass) {
		  extend(Equal, superClass);
	
		  function Equal() {
		    return Equal.__super__.constructor.apply(this, arguments);
		  }
	
		  Equal.prototype._declareDefaults = function() {
		    Equal.__super__._declareDefaults.apply(this, arguments);
		    this._defaults.tag = 'path';
		    return this._defaults.points = 2;
		  };
	
		  Equal.prototype._draw = function() {
		    var d, i, isPoints, isRadiusX, isRadiusY, j, p, radiusX, radiusY, ref, x, x1, x2, y, yStart, yStep;
		    Equal.__super__._draw.apply(this, arguments);
		    p = this._props;
		    if (!this._props.points) {
		      return;
		    }
		    radiusX = this._props.radiusX != null ? this._props.radiusX : this._props.radius;
		    radiusY = this._props.radiusY != null ? this._props.radiusY : this._props.radius;
		    isRadiusX = radiusX === this._prevRadiusX;
		    isRadiusY = radiusY === this._prevRadiusY;
		    isPoints = p.points === this._prevPoints;
		    if (isRadiusX && isRadiusY && isPoints) {
		      return;
		    }
		    x = this._props.width / 2;
		    y = this._props.height / 2;
		    x1 = x - radiusX;
		    x2 = x + radiusX;
		    d = '';
		    yStep = 2 * radiusY / (this._props.points - 1);
		    yStart = y - radiusY;
		    for (i = j = 0, ref = this._props.points; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
		      y = "" + (i * yStep + yStart);
		      d += "M" + x1 + ", " + y + " L" + x2 + ", " + y + " ";
		    }
		    this.el.setAttribute('d', d);
		    this._prevPoints = p.points;
		    this._prevRadiusX = radiusX;
		    return this._prevRadiusY = radiusY;
		  };
	
		  Equal.prototype._getLength = function() {
		    return 2 * (this._props.radiusX != null ? this._props.radiusX : this._props.radius);
		  };
	
		  return Equal;
	
		})(Bit);
	
		module.exports = Equal;
	
	
	/***/ },
	/* 44 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global) {var BezierEasing, bezierEasing, h,
		  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
		h = __webpack_require__(19);
	
	
		/**
		 * Copyright (c) 2014 Gaëtan Renaudeau http://goo.gl/El3k7u
		 * Adopted from https://github.com/gre/bezier-easing
		 */
	
		BezierEasing = (function() {
		  function BezierEasing(o) {
		    this.vars();
		    return this.generate;
		  }
	
		  BezierEasing.prototype.vars = function() {
		    return this.generate = h.bind(this.generate, this);
		  };
	
		  BezierEasing.prototype.generate = function(mX1, mY1, mX2, mY2) {
		    var A, B, C, NEWTON_ITERATIONS, NEWTON_MIN_SLOPE, SUBDIVISION_MAX_ITERATIONS, SUBDIVISION_PRECISION, _precomputed, arg, binarySubdivide, calcBezier, calcSampleValues, f, float32ArraySupported, getSlope, getTForX, i, j, kSampleStepSize, kSplineTableSize, mSampleValues, newtonRaphsonIterate, precompute, str;
		    if (arguments.length < 4) {
		      return this.error('Bezier function expects 4 arguments');
		    }
		    for (i = j = 0; j < 4; i = ++j) {
		      arg = arguments[i];
		      if (typeof arg !== "number" || isNaN(arg) || !isFinite(arg)) {
		        return this.error('Bezier function expects 4 arguments');
		      }
		    }
		    if (mX1 < 0 || mX1 > 1 || mX2 < 0 || mX2 > 1) {
		      return this.error('Bezier x values should be > 0 and < 1');
		    }
		    NEWTON_ITERATIONS = 4;
		    NEWTON_MIN_SLOPE = 0.001;
		    SUBDIVISION_PRECISION = 0.0000001;
		    SUBDIVISION_MAX_ITERATIONS = 10;
		    kSplineTableSize = 11;
		    kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
		    float32ArraySupported = indexOf.call(global, 'Float32Array') >= 0;
		    A = function(aA1, aA2) {
		      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
		    };
		    B = function(aA1, aA2) {
		      return 3.0 * aA2 - 6.0 * aA1;
		    };
		    C = function(aA1) {
		      return 3.0 * aA1;
		    };
		    calcBezier = function(aT, aA1, aA2) {
		      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
		    };
		    getSlope = function(aT, aA1, aA2) {
		      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
		    };
		    newtonRaphsonIterate = function(aX, aGuessT) {
		      var currentSlope, currentX;
		      i = 0;
		      while (i < NEWTON_ITERATIONS) {
		        currentSlope = getSlope(aGuessT, mX1, mX2);
	
		        /* istanbul ignore if */
		        if (currentSlope === 0.0) {
		          return aGuessT;
		        }
		        currentX = calcBezier(aGuessT, mX1, mX2) - aX;
		        aGuessT -= currentX / currentSlope;
		        ++i;
		      }
		      return aGuessT;
		    };
		    calcSampleValues = function() {
		      i = 0;
		      while (i < kSplineTableSize) {
		        mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
		        ++i;
		      }
		    };
	
		    /* istanbul ignore next */
		    binarySubdivide = function(aX, aA, aB) {
		      var currentT, currentX, isBig;
		      currentX = void 0;
		      currentT = void 0;
		      i = 0;
		      while (true) {
		        currentT = aA + (aB - aA) / 2.0;
		        currentX = calcBezier(currentT, mX1, mX2) - aX;
		        if (currentX > 0.0) {
		          aB = currentT;
		        } else {
		          aA = currentT;
		        }
		        isBig = Math.abs(currentX) > SUBDIVISION_PRECISION;
		        if (!(isBig && ++i < SUBDIVISION_MAX_ITERATIONS)) {
		          break;
		        }
		      }
		      return currentT;
		    };
		    getTForX = function(aX) {
		      var currentSample, delta, dist, guessForT, initialSlope, intervalStart, lastSample;
		      intervalStart = 0.0;
		      currentSample = 1;
		      lastSample = kSplineTableSize - 1;
		      while (currentSample !== lastSample && mSampleValues[currentSample] <= aX) {
		        intervalStart += kSampleStepSize;
		        ++currentSample;
		      }
		      --currentSample;
		      delta = mSampleValues[currentSample + 1] - mSampleValues[currentSample];
		      dist = (aX - mSampleValues[currentSample]) / delta;
		      guessForT = intervalStart + dist * kSampleStepSize;
		      initialSlope = getSlope(guessForT, mX1, mX2);
		      if (initialSlope >= NEWTON_MIN_SLOPE) {
		        return newtonRaphsonIterate(aX, guessForT);
		      } else {
	
		        /* istanbul ignore next */
		        if (initialSlope === 0.0) {
		          return guessForT;
		        } else {
		          return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
		        }
		      }
		    };
		    precompute = function() {
		      var _precomputed;
		      _precomputed = true;
		      if (mX1 !== mY1 || mX2 !== mY2) {
		        return calcSampleValues();
		      }
		    };
		    mSampleValues = !float32ArraySupported ? new Array(kSplineTableSize) : new Float32Array(kSplineTableSize);
		    _precomputed = false;
		    f = function(aX) {
		      if (!_precomputed) {
		        precompute();
		      }
		      if (mX1 === mY1 && mX2 === mY2) {
		        return aX;
		      }
		      if (aX === 0) {
		        return 0;
		      }
		      if (aX === 1) {
		        return 1;
		      }
		      return calcBezier(getTForX(aX), mY1, mY2);
		    };
		    str = "bezier(" + [mX1, mY1, mX2, mY2] + ")";
		    f.toStr = function() {
		      return str;
		    };
		    return f;
		  };
	
		  BezierEasing.prototype.error = function(msg) {
		    return h.error(msg);
		  };
	
		  return BezierEasing;
	
		})();
	
		bezierEasing = new BezierEasing;
	
		module.exports = bezierEasing;
	
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ },
	/* 45 */
	/***/ function(module, exports, __webpack_require__) {
	
		var PathEasing, h;
	
		h = __webpack_require__(19);
	
		PathEasing = (function() {
		  PathEasing.prototype._vars = function() {
		    this._precompute = h.clamp(this.o.precompute || 1450, 100, 10000);
		    this._step = 1 / this._precompute;
		    this._rect = this.o.rect || 100;
		    this._approximateMax = this.o.approximateMax || 5;
		    this._eps = this.o.eps || 0.001;
		    return this._boundsPrevProgress = -1;
		  };
	
		  function PathEasing(path, o1) {
		    this.o = o1 != null ? o1 : {};
		    if (path === 'creator') {
		      return;
		    }
		    this.path = h.parsePath(path);
		    if (this.path == null) {
		      return h.error('Error while parsing the path');
		    }
		    this._vars();
		    this.path.setAttribute('d', this._normalizePath(this.path.getAttribute('d')));
		    this.pathLength = this.path.getTotalLength();
		    this.sample = h.bind(this.sample, this);
		    this._hardSample = h.bind(this._hardSample, this);
		    this._preSample();
		    this;
		  }
	
		  PathEasing.prototype._preSample = function() {
		    var i, j, length, point, progress, ref, results;
		    this._samples = [];
		    results = [];
		    for (i = j = 0, ref = this._precompute; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
		      progress = i * this._step;
		      length = this.pathLength * progress;
		      point = this.path.getPointAtLength(length);
		      results.push(this._samples[i] = {
		        point: point,
		        length: length,
		        progress: progress
		      });
		    }
		    return results;
		  };
	
		  PathEasing.prototype._findBounds = function(array, p) {
		    var buffer, direction, end, i, j, len, loopEnd, pointP, pointX, ref, ref1, start, value;
		    if (p === this._boundsPrevProgress) {
		      return this._prevBounds;
		    }
		    if (this._boundsStartIndex == null) {
		      this._boundsStartIndex = 0;
		    }
		    len = array.length;
		    if (this._boundsPrevProgress > p) {
		      loopEnd = 0;
		      direction = 'reverse';
		    } else {
		      loopEnd = len;
		      direction = 'forward';
		    }
		    if (direction === 'forward') {
		      start = array[0];
		      end = array[array.length - 1];
		    } else {
		      start = array[array.length - 1];
		      end = array[0];
		    }
		    for (i = j = ref = this._boundsStartIndex, ref1 = loopEnd; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
		      value = array[i];
		      pointX = value.point.x / this._rect;
		      pointP = p;
		      if (direction === 'reverse') {
		        buffer = pointX;
		        pointX = pointP;
		        pointP = buffer;
		      }
		      if (pointX < pointP) {
		        start = value;
		        this._boundsStartIndex = i;
		      } else {
		        end = value;
		        break;
		      }
		    }
		    this._boundsPrevProgress = p;
		    return this._prevBounds = {
		      start: start,
		      end: end
		    };
		  };
	
		  PathEasing.prototype.sample = function(p) {
		    var bounds, res;
		    p = h.clamp(p, 0, 1);
		    bounds = this._findBounds(this._samples, p);
		    res = this._checkIfBoundsCloseEnough(p, bounds);
		    if (res != null) {
		      return res;
		    }
		    return this._findApproximate(p, bounds.start, bounds.end);
		  };
	
		  PathEasing.prototype._checkIfBoundsCloseEnough = function(p, bounds) {
		    var point, y;
		    point = void 0;
		    y = this._checkIfPointCloseEnough(p, bounds.start.point);
		    if (y != null) {
		      return y;
		    }
		    return this._checkIfPointCloseEnough(p, bounds.end.point);
		  };
	
		  PathEasing.prototype._checkIfPointCloseEnough = function(p, point) {
		    if (h.closeEnough(p, point.x / this._rect, this._eps)) {
		      return this._resolveY(point);
		    }
		  };
	
		  PathEasing.prototype._approximate = function(start, end, p) {
		    var deltaP, percentP;
		    deltaP = end.point.x - start.point.x;
		    percentP = (p - (start.point.x / this._rect)) / (deltaP / this._rect);
		    return start.length + percentP * (end.length - start.length);
		  };
	
		  PathEasing.prototype._findApproximate = function(p, start, end, approximateMax) {
		    var approximation, args, newPoint, point, x;
		    if (approximateMax == null) {
		      approximateMax = this._approximateMax;
		    }
		    approximation = this._approximate(start, end, p);
		    point = this.path.getPointAtLength(approximation);
		    x = point.x / this._rect;
		    if (h.closeEnough(p, x, this._eps)) {
		      return this._resolveY(point);
		    } else {
		      if (--approximateMax < 1) {
		        return this._resolveY(point);
		      }
		      newPoint = {
		        point: point,
		        length: approximation
		      };
		      args = p < x ? [p, start, newPoint, approximateMax] : [p, newPoint, end, approximateMax];
		      return this._findApproximate.apply(this, args);
		    }
		  };
	
		  PathEasing.prototype._resolveY = function(point) {
		    return 1 - (point.y / this._rect);
		  };
	
		  PathEasing.prototype._normalizePath = function(path) {
		    var commands, endIndex, normalizedPath, points, startIndex, svgCommandsRegexp;
		    svgCommandsRegexp = /[M|L|H|V|C|S|Q|T|A]/gim;
		    points = path.split(svgCommandsRegexp);
		    points.shift();
		    commands = path.match(svgCommandsRegexp);
		    startIndex = 0;
		    points[startIndex] = this._normalizeSegment(points[startIndex]);
		    endIndex = points.length - 1;
		    points[endIndex] = this._normalizeSegment(points[endIndex], this._rect || 100);
		    return normalizedPath = this._joinNormalizedPath(commands, points);
		  };
	
		  PathEasing.prototype._joinNormalizedPath = function(commands, points) {
		    var command, i, j, len1, normalizedPath, space;
		    normalizedPath = '';
		    for (i = j = 0, len1 = commands.length; j < len1; i = ++j) {
		      command = commands[i];
		      space = i === 0 ? '' : ' ';
		      normalizedPath += "" + space + command + (points[i].trim());
		    }
		    return normalizedPath;
		  };
	
		  PathEasing.prototype._normalizeSegment = function(segment, value) {
		    var i, j, lastPoint, len1, nRgx, pairs, parsedX, point, space, x;
		    if (value == null) {
		      value = 0;
		    }
		    segment = segment.trim();
		    nRgx = /(-|\+)?((\d+(\.(\d|\e(-|\+)?)+)?)|(\.?(\d|\e|(\-|\+))+))/gim;
		    pairs = this._getSegmentPairs(segment.match(nRgx));
		    lastPoint = pairs[pairs.length - 1];
		    x = lastPoint[0];
		    parsedX = Number(x);
		    if (parsedX !== value) {
		      segment = '';
		      lastPoint[0] = value;
		      for (i = j = 0, len1 = pairs.length; j < len1; i = ++j) {
		        point = pairs[i];
		        space = i === 0 ? '' : ' ';
		        segment += "" + space + point[0] + "," + point[1];
		      }
		    }
		    return segment;
		  };
	
		  PathEasing.prototype._getSegmentPairs = function(array) {
		    var i, j, len1, newArray, pair, value;
		    if (array.length % 2 !== 0) {
		      h.error('Failed to parse the path - segment pairs are not even.', array);
		    }
		    newArray = [];
		    for (i = j = 0, len1 = array.length; j < len1; i = j += 2) {
		      value = array[i];
		      pair = [array[i], array[i + 1]];
		      newArray.push(pair);
		    }
		    return newArray;
		  };
	
		  PathEasing.prototype.create = function(path, o) {
		    var handler;
		    handler = new PathEasing(path, o);
		    handler.sample.path = handler.path;
		    return handler.sample;
		  };
	
		  return PathEasing;
	
		})();
	
		module.exports = PathEasing;
	
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		var create, easing, getNearest, mix, parseIfEasing, sort,
		  slice = [].slice;
	
		easing = null;
	
		parseIfEasing = function(item) {
		  if (typeof item.value === 'number') {
		    return item.value;
		  } else {
		    return easing.parseEasing(item.value);
		  }
		};
	
		sort = function(a, b) {
		  var returnValue;
		  a.value = parseIfEasing(a);
		  b.value = parseIfEasing(b);
		  returnValue = 0;
		  a.to < b.to && (returnValue = -1);
		  a.to > b.to && (returnValue = 1);
		  return returnValue;
		};
	
		getNearest = function(array, progress) {
		  var i, index, j, len, value;
		  index = 0;
		  for (i = j = 0, len = array.length; j < len; i = ++j) {
		    value = array[i];
		    index = i;
		    if (value.to > progress) {
		      break;
		    }
		  }
		  return index;
		};
	
		mix = function() {
		  var args;
		  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
		  if (args.length > 1) {
		    args = args.sort(sort);
		  } else {
		    args[0].value = parseIfEasing(args[0]);
		  }
		  return function(progress) {
		    var index, value;
		    index = getNearest(args, progress);
		    if (index !== -1) {
		      value = args[index].value;
		      if (index === args.length - 1 && progress > args[index].to) {
		        return 1;
		      }
		      if (typeof value === 'function') {
		        return value(progress);
		      } else {
		        return value;
		      }
		    }
		  };
		};
	
		create = function(e) {
		  easing = e;
		  return mix;
		};
	
		module.exports = create;
	
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(18);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/*
		  Method to bootstrap approximation function.
		  @private
		  @param   {Object} Samples Object.
		  @returns {Function} Approximate function.
		*/
		var _proximate = function _proximate(samples) {
		  var n = samples.base,
		      samplesAmount = Math.pow(10, n),
		      samplesStep = 1 / samplesAmount;
	
		  function RoundNumber(input, numberDecimals) {
		    numberDecimals = +numberDecimals || 0; // +var magic!
	
		    var multiplyer = Math.pow(10.0, numberDecimals);
	
		    return Math.round(input * multiplyer) / multiplyer;
		  }
	
		  var cached = function cached(p) {
		    var newKey = RoundNumber(p, n),
		        sample = samples[newKey.toString()];
	
		    if (Math.abs(p - newKey) < samplesStep) {
		      return sample;
		    }
	
		    if (p > newKey) {
		      var nextIndex = newKey + samplesStep;
		      var nextValue = samples[nextIndex];
		    } else {
		      var nextIndex = newKey - samplesStep;
		      var nextValue = samples[nextIndex];
		    }
	
		    var dLength = nextIndex - newKey;
		    var dValue = nextValue - sample;
		    if (dValue < samplesStep) {
		      return sample;
		    }
	
		    var progressScale = (p - newKey) / dLength;
		    var coef = nextValue > sample ? -1 : 1;
		    var scaledDifference = coef * progressScale * dValue;
	
		    return sample + scaledDifference;
		  };
	
		  cached.getSamples = function () {
		    return samples;
		  };
	
		  return cached;
		};
		/*
		    Method to take samples of the function and call the _proximate
		    method with the dunction and samples. Or if samples passed - pipe
		    them to the _proximate method without sampling.
		    @private
		    @param {Function} Function to sample.
		    @param {Number, Object, String} Precision or precomputed samples.
		  */
		var _sample = function _sample(fn) {
		  var n = arguments.length <= 1 || arguments[1] === undefined ? 4 : arguments[1];
	
	
		  var nType = typeof n === 'undefined' ? 'undefined' : (0, _typeof3.default)(n);
	
		  var samples = {};
		  if (nType === 'number') {
		    var p = 0,
		        samplesCount = Math.pow(10, n),
		        step = 1 / samplesCount;
	
		    samples[0] = fn(0);
		    for (var i = 0; i < samplesCount - 1; i++) {
		      p += step;
	
		      var index = parseFloat(p.toFixed(n));
		      samples[index] = fn(p);
		    }
		    samples[1] = fn(1);
	
		    samples.base = n;
		  } else if (nType === 'object') {
		    samples = n;
		  } else if (nType === 'string') {
		    samples = JSON.parse(n);
		  }
	
		  return Approximate._sample._proximate(samples);
		};
	
		var Approximate = { _sample: _sample, _proximate: _proximate };
		Approximate._sample._proximate = Approximate._proximate;
	
		exports.default = Approximate._sample;
	
	/***/ },
	/* 48 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(55), __esModule: true };
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(56), __esModule: true };
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = { "default": __webpack_require__(57), __esModule: true };
	
	/***/ },
	/* 51 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(58);
		__webpack_require__(59);
		module.exports = __webpack_require__(60);
	
	/***/ },
	/* 52 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(67);
		module.exports = __webpack_require__(64).Object.keys;
	
	/***/ },
	/* 53 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(18);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _h = __webpack_require__(19);
	
		var _h2 = _interopRequireDefault(_h);
	
		var _shapesMap = __webpack_require__(20);
	
		var _shapesMap2 = _interopRequireDefault(_shapesMap);
	
		var _shape = __webpack_require__(2);
	
		var _shape2 = _interopRequireDefault(_shape);
	
		var _shapeSwirl = __webpack_require__(3);
	
		var _shapeSwirl2 = _interopRequireDefault(_shapeSwirl);
	
		var _burst = __webpack_require__(4);
	
		var _burst2 = _interopRequireDefault(_burst);
	
		var _html = __webpack_require__(5);
	
		var _html2 = _interopRequireDefault(_html);
	
		var _stagger = __webpack_require__(6);
	
		var _stagger2 = _interopRequireDefault(_stagger);
	
		var _spriter = __webpack_require__(7);
	
		var _spriter2 = _interopRequireDefault(_spriter);
	
		var _motionPath = __webpack_require__(21);
	
		var _motionPath2 = _interopRequireDefault(_motionPath);
	
		var _tween = __webpack_require__(8);
	
		var _tween2 = _interopRequireDefault(_tween);
	
		var _timeline = __webpack_require__(9);
	
		var _timeline2 = _interopRequireDefault(_timeline);
	
		var _tweener = __webpack_require__(10);
	
		var _tweener2 = _interopRequireDefault(_tweener);
	
		var _tweenable = __webpack_require__(11);
	
		var _tweenable2 = _interopRequireDefault(_tweenable);
	
		var _thenable = __webpack_require__(12);
	
		var _thenable2 = _interopRequireDefault(_thenable);
	
		var _tunable = __webpack_require__(13);
	
		var _tunable2 = _interopRequireDefault(_tunable);
	
		var _delta = __webpack_require__(14);
	
		var _delta2 = _interopRequireDefault(_delta);
	
		var _deltas = __webpack_require__(15);
	
		var _deltas2 = _interopRequireDefault(_deltas);
	
		var _module = __webpack_require__(16);
	
		var _module2 = _interopRequireDefault(_module);
	
		var _easing = __webpack_require__(22);
	
		var _easing2 = _interopRequireDefault(_easing);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var mojs = {
		  revision: '0.288.1', isDebug: true, helpers: _h2.default,
		  Shape: _shape2.default, ShapeSwirl: _shapeSwirl2.default, Burst: _burst2.default, Html: _html2.default, stagger: _stagger2.default, Spriter: _spriter2.default, MotionPath: _motionPath2.default,
		  Tween: _tween2.default, Timeline: _timeline2.default, Tweenable: _tweenable2.default, Thenable: _thenable2.default, Tunable: _tunable2.default, Module: _module2.default,
		  tweener: _tweener2.default, easing: _easing2.default, shapesMap: _shapesMap2.default, _pool: { Delta: _delta2.default, Deltas: _deltas2.default }
		};
	
		// functions alias
		mojs.h = mojs.helpers;
		mojs.delta = mojs.h.delta;
		// custom shape add function and class
		mojs.addShape = mojs.shapesMap.addShape;
		mojs.CustomShape = mojs.shapesMap.custom;
		// module alias
		mojs.Transit = mojs.Shape;
		mojs.Swirl = mojs.ShapeSwirl;
	
		// TODO:
		/*
		  H/V in paths
	
		  rand for direction
		  burst children angle after tune
		  burst pathScale after tune
		  swirl then issue
		  'rand' angle flick with `then`
		  not able to `play()` in `onComplete` callback
		  ---
		  module names
		  swirls in then chains for x/y
		  parse rand(stagger(20, 10), 20) values
		  percentage for radius
	
		  issue:
		    const shape = new mojs.Shape({
		      scale: { 0: 1 },
		      duration: 1000
		    })
		    .then({ scale: 0 })
		    .then({ scale: 1, onComplete () { this.pause(); } })
		    .then({ scale: 0 })
		    .then({ scale: 1 })
		    ;
	
		    document.addEventListener('click', () => {
		      shape
		        .tune({ fill: 'cyan' })
		        .play();
		    });
		*/
	
		// istanbul ignore next
		if (true) {
		  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		    return mojs;
		  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		// istanbul ignore next
		if ((false ? 'undefined' : (0, _typeof3.default)(module)) === "object" && (0, _typeof3.default)(module.exports) === "object") {
		  module.exports = mojs;
		}
	
		exports.default = mojs;
	
	
		typeof window !== 'undefined' && (window.mojs = mojs);
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)(module)))
	
	/***/ },
	/* 54 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(62);
		__webpack_require__(63);
		module.exports = __webpack_require__(64).Symbol;
	
	/***/ },
	/* 55 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(65);
		module.exports = __webpack_require__(64).Object.setPrototypeOf;
	
	/***/ },
	/* 56 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $ = __webpack_require__(66);
		module.exports = function create(P, D){
		  return $.create(P, D);
		};
	
	/***/ },
	/* 57 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(68);
		module.exports = __webpack_require__(64).Object.assign;
	
	/***/ },
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
		__webpack_require__(69);
		var Iterators = __webpack_require__(70);
		Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		var $at  = __webpack_require__(71)(true);
	
		// 21.1.3.27 String.prototype[@@iterator]()
		__webpack_require__(72)(String, 'String', function(iterated){
		  this._t = String(iterated); // target
		  this._i = 0;                // next index
		// 21.1.5.2.1 %StringIteratorPrototype%.next()
		}, function(){
		  var O     = this._t
		    , index = this._i
		    , point;
		  if(index >= O.length)return {value: undefined, done: true};
		  point = $at(O, index);
		  this._i += point.length;
		  return {value: point, done: false};
		});
	
	/***/ },
	/* 60 */
	/***/ function(module, exports, __webpack_require__) {
	
		var anObject = __webpack_require__(73)
		  , get      = __webpack_require__(74);
		module.exports = __webpack_require__(64).getIterator = function(it){
		  var iterFn = get(it);
		  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
		  return anObject(iterFn.call(it));
		};
	
	/***/ },
	/* 61 */
	/***/ function(module, exports, __webpack_require__) {
	
		var store  = __webpack_require__(75)('wks')
		  , uid    = __webpack_require__(76)
		  , Symbol = __webpack_require__(77).Symbol;
		module.exports = function(name){
		  return store[name] || (store[name] =
		    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
		};
	
	/***/ },
	/* 62 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		// ECMAScript 6 symbols shim
		var $              = __webpack_require__(66)
		  , global         = __webpack_require__(77)
		  , has            = __webpack_require__(78)
		  , DESCRIPTORS    = __webpack_require__(79)
		  , $export        = __webpack_require__(80)
		  , redefine       = __webpack_require__(81)
		  , $fails         = __webpack_require__(82)
		  , shared         = __webpack_require__(75)
		  , setToStringTag = __webpack_require__(83)
		  , uid            = __webpack_require__(76)
		  , wks            = __webpack_require__(61)
		  , keyOf          = __webpack_require__(84)
		  , $names         = __webpack_require__(85)
		  , enumKeys       = __webpack_require__(86)
		  , isArray        = __webpack_require__(87)
		  , anObject       = __webpack_require__(73)
		  , toIObject      = __webpack_require__(88)
		  , createDesc     = __webpack_require__(89)
		  , getDesc        = $.getDesc
		  , setDesc        = $.setDesc
		  , _create        = $.create
		  , getNames       = $names.get
		  , $Symbol        = global.Symbol
		  , $JSON          = global.JSON
		  , _stringify     = $JSON && $JSON.stringify
		  , setter         = false
		  , HIDDEN         = wks('_hidden')
		  , isEnum         = $.isEnum
		  , SymbolRegistry = shared('symbol-registry')
		  , AllSymbols     = shared('symbols')
		  , useNative      = typeof $Symbol == 'function'
		  , ObjectProto    = Object.prototype;
	
		// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
		var setSymbolDesc = DESCRIPTORS && $fails(function(){
		  return _create(setDesc({}, 'a', {
		    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
		  })).a != 7;
		}) ? function(it, key, D){
		  var protoDesc = getDesc(ObjectProto, key);
		  if(protoDesc)delete ObjectProto[key];
		  setDesc(it, key, D);
		  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
		} : setDesc;
	
		var wrap = function(tag){
		  var sym = AllSymbols[tag] = _create($Symbol.prototype);
		  sym._k = tag;
		  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
		    configurable: true,
		    set: function(value){
		      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
		      setSymbolDesc(this, tag, createDesc(1, value));
		    }
		  });
		  return sym;
		};
	
		var isSymbol = function(it){
		  return typeof it == 'symbol';
		};
	
		var $defineProperty = function defineProperty(it, key, D){
		  if(D && has(AllSymbols, key)){
		    if(!D.enumerable){
		      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
		      it[HIDDEN][key] = true;
		    } else {
		      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
		      D = _create(D, {enumerable: createDesc(0, false)});
		    } return setSymbolDesc(it, key, D);
		  } return setDesc(it, key, D);
		};
		var $defineProperties = function defineProperties(it, P){
		  anObject(it);
		  var keys = enumKeys(P = toIObject(P))
		    , i    = 0
		    , l = keys.length
		    , key;
		  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
		  return it;
		};
		var $create = function create(it, P){
		  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
		};
		var $propertyIsEnumerable = function propertyIsEnumerable(key){
		  var E = isEnum.call(this, key);
		  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
		    ? E : true;
		};
		var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
		  var D = getDesc(it = toIObject(it), key);
		  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
		  return D;
		};
		var $getOwnPropertyNames = function getOwnPropertyNames(it){
		  var names  = getNames(toIObject(it))
		    , result = []
		    , i      = 0
		    , key;
		  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
		  return result;
		};
		var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
		  var names  = getNames(toIObject(it))
		    , result = []
		    , i      = 0
		    , key;
		  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
		  return result;
		};
		var $stringify = function stringify(it){
		  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
		  var args = [it]
		    , i    = 1
		    , $$   = arguments
		    , replacer, $replacer;
		  while($$.length > i)args.push($$[i++]);
		  replacer = args[1];
		  if(typeof replacer == 'function')$replacer = replacer;
		  if($replacer || !isArray(replacer))replacer = function(key, value){
		    if($replacer)value = $replacer.call(this, key, value);
		    if(!isSymbol(value))return value;
		  };
		  args[1] = replacer;
		  return _stringify.apply($JSON, args);
		};
		var buggyJSON = $fails(function(){
		  var S = $Symbol();
		  // MS Edge converts symbol values to JSON as {}
		  // WebKit converts symbol values to JSON as null
		  // V8 throws on boxed symbols
		  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
		});
	
		// 19.4.1.1 Symbol([description])
		if(!useNative){
		  $Symbol = function Symbol(){
		    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
		    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
		  };
		  redefine($Symbol.prototype, 'toString', function toString(){
		    return this._k;
		  });
	
		  isSymbol = function(it){
		    return it instanceof $Symbol;
		  };
	
		  $.create     = $create;
		  $.isEnum     = $propertyIsEnumerable;
		  $.getDesc    = $getOwnPropertyDescriptor;
		  $.setDesc    = $defineProperty;
		  $.setDescs   = $defineProperties;
		  $.getNames   = $names.get = $getOwnPropertyNames;
		  $.getSymbols = $getOwnPropertySymbols;
	
		  if(DESCRIPTORS && !__webpack_require__(90)){
		    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
		  }
		}
	
		var symbolStatics = {
		  // 19.4.2.1 Symbol.for(key)
		  'for': function(key){
		    return has(SymbolRegistry, key += '')
		      ? SymbolRegistry[key]
		      : SymbolRegistry[key] = $Symbol(key);
		  },
		  // 19.4.2.5 Symbol.keyFor(sym)
		  keyFor: function keyFor(key){
		    return keyOf(SymbolRegistry, key);
		  },
		  useSetter: function(){ setter = true; },
		  useSimple: function(){ setter = false; }
		};
		// 19.4.2.2 Symbol.hasInstance
		// 19.4.2.3 Symbol.isConcatSpreadable
		// 19.4.2.4 Symbol.iterator
		// 19.4.2.6 Symbol.match
		// 19.4.2.8 Symbol.replace
		// 19.4.2.9 Symbol.search
		// 19.4.2.10 Symbol.species
		// 19.4.2.11 Symbol.split
		// 19.4.2.12 Symbol.toPrimitive
		// 19.4.2.13 Symbol.toStringTag
		// 19.4.2.14 Symbol.unscopables
		$.each.call((
		  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
		  'species,split,toPrimitive,toStringTag,unscopables'
		).split(','), function(it){
		  var sym = wks(it);
		  symbolStatics[it] = useNative ? sym : wrap(sym);
		});
	
		setter = true;
	
		$export($export.G + $export.W, {Symbol: $Symbol});
	
		$export($export.S, 'Symbol', symbolStatics);
	
		$export($export.S + $export.F * !useNative, 'Object', {
		  // 19.1.2.2 Object.create(O [, Properties])
		  create: $create,
		  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
		  defineProperty: $defineProperty,
		  // 19.1.2.3 Object.defineProperties(O, Properties)
		  defineProperties: $defineProperties,
		  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
		  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
		  // 19.1.2.7 Object.getOwnPropertyNames(O)
		  getOwnPropertyNames: $getOwnPropertyNames,
		  // 19.1.2.8 Object.getOwnPropertySymbols(O)
		  getOwnPropertySymbols: $getOwnPropertySymbols
		});
	
		// 24.3.2 JSON.stringify(value [, replacer [, space]])
		$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
		// 19.4.3.5 Symbol.prototype[@@toStringTag]
		setToStringTag($Symbol, 'Symbol');
		// 20.2.1.9 Math[@@toStringTag]
		setToStringTag(Math, 'Math', true);
		// 24.3.3 JSON[@@toStringTag]
		setToStringTag(global.JSON, 'JSON', true);
	
	/***/ },
	/* 63 */
	/***/ function(module, exports, __webpack_require__) {
	
		
	
	/***/ },
	/* 64 */
	/***/ function(module, exports, __webpack_require__) {
	
		var core = module.exports = {version: '1.2.6'};
		if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
	
	/***/ },
	/* 65 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.3.19 Object.setPrototypeOf(O, proto)
		var $export = __webpack_require__(80);
		$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(91).set});
	
	/***/ },
	/* 66 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $Object = Object;
		module.exports = {
		  create:     $Object.create,
		  getProto:   $Object.getPrototypeOf,
		  isEnum:     {}.propertyIsEnumerable,
		  getDesc:    $Object.getOwnPropertyDescriptor,
		  setDesc:    $Object.defineProperty,
		  setDescs:   $Object.defineProperties,
		  getKeys:    $Object.keys,
		  getNames:   $Object.getOwnPropertyNames,
		  getSymbols: $Object.getOwnPropertySymbols,
		  each:       [].forEach
		};
	
	/***/ },
	/* 67 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.14 Object.keys(O)
		var toObject = __webpack_require__(92);
	
		__webpack_require__(93)('keys', function($keys){
		  return function keys(it){
		    return $keys(toObject(it));
		  };
		});
	
	/***/ },
	/* 68 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.3.1 Object.assign(target, source)
		var $export = __webpack_require__(80);
	
		$export($export.S + $export.F, 'Object', {assign: __webpack_require__(94)});
	
	/***/ },
	/* 69 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		var addToUnscopables = __webpack_require__(95)
		  , step             = __webpack_require__(96)
		  , Iterators        = __webpack_require__(70)
		  , toIObject        = __webpack_require__(88);
	
		// 22.1.3.4 Array.prototype.entries()
		// 22.1.3.13 Array.prototype.keys()
		// 22.1.3.29 Array.prototype.values()
		// 22.1.3.30 Array.prototype[@@iterator]()
		module.exports = __webpack_require__(72)(Array, 'Array', function(iterated, kind){
		  this._t = toIObject(iterated); // target
		  this._i = 0;                   // next index
		  this._k = kind;                // kind
		// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
		}, function(){
		  var O     = this._t
		    , kind  = this._k
		    , index = this._i++;
		  if(!O || index >= O.length){
		    this._t = undefined;
		    return step(1);
		  }
		  if(kind == 'keys'  )return step(0, index);
		  if(kind == 'values')return step(0, O[index]);
		  return step(0, [index, O[index]]);
		}, 'values');
	
		// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
		Iterators.Arguments = Iterators.Array;
	
		addToUnscopables('keys');
		addToUnscopables('values');
		addToUnscopables('entries');
	
	/***/ },
	/* 70 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = {};
	
	/***/ },
	/* 71 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toInteger = __webpack_require__(97)
		  , defined   = __webpack_require__(98);
		// true  -> String#at
		// false -> String#codePointAt
		module.exports = function(TO_STRING){
		  return function(that, pos){
		    var s = String(defined(that))
		      , i = toInteger(pos)
		      , l = s.length
		      , a, b;
		    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
		    a = s.charCodeAt(i);
		    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
		      ? TO_STRING ? s.charAt(i) : a
		      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
		  };
		};
	
	/***/ },
	/* 72 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		var LIBRARY        = __webpack_require__(90)
		  , $export        = __webpack_require__(80)
		  , redefine       = __webpack_require__(81)
		  , hide           = __webpack_require__(99)
		  , has            = __webpack_require__(78)
		  , Iterators      = __webpack_require__(70)
		  , $iterCreate    = __webpack_require__(100)
		  , setToStringTag = __webpack_require__(83)
		  , getProto       = __webpack_require__(66).getProto
		  , ITERATOR       = __webpack_require__(61)('iterator')
		  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
		  , FF_ITERATOR    = '@@iterator'
		  , KEYS           = 'keys'
		  , VALUES         = 'values';
	
		var returnThis = function(){ return this; };
	
		module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
		  $iterCreate(Constructor, NAME, next);
		  var getMethod = function(kind){
		    if(!BUGGY && kind in proto)return proto[kind];
		    switch(kind){
		      case KEYS: return function keys(){ return new Constructor(this, kind); };
		      case VALUES: return function values(){ return new Constructor(this, kind); };
		    } return function entries(){ return new Constructor(this, kind); };
		  };
		  var TAG        = NAME + ' Iterator'
		    , DEF_VALUES = DEFAULT == VALUES
		    , VALUES_BUG = false
		    , proto      = Base.prototype
		    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
		    , $default   = $native || getMethod(DEFAULT)
		    , methods, key;
		  // Fix native
		  if($native){
		    var IteratorPrototype = getProto($default.call(new Base));
		    // Set @@toStringTag to native iterators
		    setToStringTag(IteratorPrototype, TAG, true);
		    // FF fix
		    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
		    // fix Array#{values, @@iterator}.name in V8 / FF
		    if(DEF_VALUES && $native.name !== VALUES){
		      VALUES_BUG = true;
		      $default = function values(){ return $native.call(this); };
		    }
		  }
		  // Define iterator
		  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
		    hide(proto, ITERATOR, $default);
		  }
		  // Plug for library
		  Iterators[NAME] = $default;
		  Iterators[TAG]  = returnThis;
		  if(DEFAULT){
		    methods = {
		      values:  DEF_VALUES  ? $default : getMethod(VALUES),
		      keys:    IS_SET      ? $default : getMethod(KEYS),
		      entries: !DEF_VALUES ? $default : getMethod('entries')
		    };
		    if(FORCED)for(key in methods){
		      if(!(key in proto))redefine(proto, key, methods[key]);
		    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
		  }
		  return methods;
		};
	
	/***/ },
	/* 73 */
	/***/ function(module, exports, __webpack_require__) {
	
		var isObject = __webpack_require__(101);
		module.exports = function(it){
		  if(!isObject(it))throw TypeError(it + ' is not an object!');
		  return it;
		};
	
	/***/ },
	/* 74 */
	/***/ function(module, exports, __webpack_require__) {
	
		var classof   = __webpack_require__(102)
		  , ITERATOR  = __webpack_require__(61)('iterator')
		  , Iterators = __webpack_require__(70);
		module.exports = __webpack_require__(64).getIteratorMethod = function(it){
		  if(it != undefined)return it[ITERATOR]
		    || it['@@iterator']
		    || Iterators[classof(it)];
		};
	
	/***/ },
	/* 75 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global = __webpack_require__(77)
		  , SHARED = '__core-js_shared__'
		  , store  = global[SHARED] || (global[SHARED] = {});
		module.exports = function(key){
		  return store[key] || (store[key] = {});
		};
	
	/***/ },
	/* 76 */
	/***/ function(module, exports, __webpack_require__) {
	
		var id = 0
		  , px = Math.random();
		module.exports = function(key){
		  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
		};
	
	/***/ },
	/* 77 */
	/***/ function(module, exports, __webpack_require__) {
	
		// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		var global = module.exports = typeof window != 'undefined' && window.Math == Math
		  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
		if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
	
	/***/ },
	/* 78 */
	/***/ function(module, exports, __webpack_require__) {
	
		var hasOwnProperty = {}.hasOwnProperty;
		module.exports = function(it, key){
		  return hasOwnProperty.call(it, key);
		};
	
	/***/ },
	/* 79 */
	/***/ function(module, exports, __webpack_require__) {
	
		// Thank's IE8 for his funny defineProperty
		module.exports = !__webpack_require__(82)(function(){
		  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
		});
	
	/***/ },
	/* 80 */
	/***/ function(module, exports, __webpack_require__) {
	
		var global    = __webpack_require__(77)
		  , core      = __webpack_require__(64)
		  , ctx       = __webpack_require__(103)
		  , PROTOTYPE = 'prototype';
	
		var $export = function(type, name, source){
		  var IS_FORCED = type & $export.F
		    , IS_GLOBAL = type & $export.G
		    , IS_STATIC = type & $export.S
		    , IS_PROTO  = type & $export.P
		    , IS_BIND   = type & $export.B
		    , IS_WRAP   = type & $export.W
		    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
		    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
		    , key, own, out;
		  if(IS_GLOBAL)source = name;
		  for(key in source){
		    // contains in native
		    own = !IS_FORCED && target && key in target;
		    if(own && key in exports)continue;
		    // export native or passed
		    out = own ? target[key] : source[key];
		    // prevent global pollution for namespaces
		    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
		    // bind timers to global for call from export context
		    : IS_BIND && own ? ctx(out, global)
		    // wrap global constructors for prevent change them in library
		    : IS_WRAP && target[key] == out ? (function(C){
		      var F = function(param){
		        return this instanceof C ? new C(param) : C(param);
		      };
		      F[PROTOTYPE] = C[PROTOTYPE];
		      return F;
		    // make static versions for prototype methods
		    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
		    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
		  }
		};
		// type bitmap
		$export.F = 1;  // forced
		$export.G = 2;  // global
		$export.S = 4;  // static
		$export.P = 8;  // proto
		$export.B = 16; // bind
		$export.W = 32; // wrap
		module.exports = $export;
	
	/***/ },
	/* 81 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(99);
	
	/***/ },
	/* 82 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = function(exec){
		  try {
		    return !!exec();
		  } catch(e){
		    return true;
		  }
		};
	
	/***/ },
	/* 83 */
	/***/ function(module, exports, __webpack_require__) {
	
		var def = __webpack_require__(66).setDesc
		  , has = __webpack_require__(78)
		  , TAG = __webpack_require__(61)('toStringTag');
	
		module.exports = function(it, tag, stat){
		  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
		};
	
	/***/ },
	/* 84 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $         = __webpack_require__(66)
		  , toIObject = __webpack_require__(88);
		module.exports = function(object, el){
		  var O      = toIObject(object)
		    , keys   = $.getKeys(O)
		    , length = keys.length
		    , index  = 0
		    , key;
		  while(length > index)if(O[key = keys[index++]] === el)return key;
		};
	
	/***/ },
	/* 85 */
	/***/ function(module, exports, __webpack_require__) {
	
		// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
		var toIObject = __webpack_require__(88)
		  , getNames  = __webpack_require__(66).getNames
		  , toString  = {}.toString;
	
		var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
		  ? Object.getOwnPropertyNames(window) : [];
	
		var getWindowNames = function(it){
		  try {
		    return getNames(it);
		  } catch(e){
		    return windowNames.slice();
		  }
		};
	
		module.exports.get = function getOwnPropertyNames(it){
		  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
		  return getNames(toIObject(it));
		};
	
	/***/ },
	/* 86 */
	/***/ function(module, exports, __webpack_require__) {
	
		// all enumerable object keys, includes symbols
		var $ = __webpack_require__(66);
		module.exports = function(it){
		  var keys       = $.getKeys(it)
		    , getSymbols = $.getSymbols;
		  if(getSymbols){
		    var symbols = getSymbols(it)
		      , isEnum  = $.isEnum
		      , i       = 0
		      , key;
		    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
		  }
		  return keys;
		};
	
	/***/ },
	/* 87 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.2.2 IsArray(argument)
		var cof = __webpack_require__(104);
		module.exports = Array.isArray || function(arg){
		  return cof(arg) == 'Array';
		};
	
	/***/ },
	/* 88 */
	/***/ function(module, exports, __webpack_require__) {
	
		// to indexed object, toObject with fallback for non-array-like ES3 strings
		var IObject = __webpack_require__(105)
		  , defined = __webpack_require__(98);
		module.exports = function(it){
		  return IObject(defined(it));
		};
	
	/***/ },
	/* 89 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = function(bitmap, value){
		  return {
		    enumerable  : !(bitmap & 1),
		    configurable: !(bitmap & 2),
		    writable    : !(bitmap & 4),
		    value       : value
		  };
		};
	
	/***/ },
	/* 90 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = true;
	
	/***/ },
	/* 91 */
	/***/ function(module, exports, __webpack_require__) {
	
		// Works with __proto__ only. Old v8 can't work with null proto objects.
		/* eslint-disable no-proto */
		var getDesc  = __webpack_require__(66).getDesc
		  , isObject = __webpack_require__(101)
		  , anObject = __webpack_require__(73);
		var check = function(O, proto){
		  anObject(O);
		  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
		};
		module.exports = {
		  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
		    function(test, buggy, set){
		      try {
		        set = __webpack_require__(103)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
		        set(test, []);
		        buggy = !(test instanceof Array);
		      } catch(e){ buggy = true; }
		      return function setPrototypeOf(O, proto){
		        check(O, proto);
		        if(buggy)O.__proto__ = proto;
		        else set(O, proto);
		        return O;
		      };
		    }({}, false) : undefined),
		  check: check
		};
	
	/***/ },
	/* 92 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.13 ToObject(argument)
		var defined = __webpack_require__(98);
		module.exports = function(it){
		  return Object(defined(it));
		};
	
	/***/ },
	/* 93 */
	/***/ function(module, exports, __webpack_require__) {
	
		// most Object methods by ES6 should accept primitives
		var $export = __webpack_require__(80)
		  , core    = __webpack_require__(64)
		  , fails   = __webpack_require__(82);
		module.exports = function(KEY, exec){
		  var fn  = (core.Object || {})[KEY] || Object[KEY]
		    , exp = {};
		  exp[KEY] = exec(fn);
		  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
		};
	
	/***/ },
	/* 94 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 19.1.2.1 Object.assign(target, source, ...)
		var $        = __webpack_require__(66)
		  , toObject = __webpack_require__(92)
		  , IObject  = __webpack_require__(105);
	
		// should work with symbols and should have deterministic property order (V8 bug)
		module.exports = __webpack_require__(82)(function(){
		  var a = Object.assign
		    , A = {}
		    , B = {}
		    , S = Symbol()
		    , K = 'abcdefghijklmnopqrst';
		  A[S] = 7;
		  K.split('').forEach(function(k){ B[k] = k; });
		  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
		}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
		  var T     = toObject(target)
		    , $$    = arguments
		    , $$len = $$.length
		    , index = 1
		    , getKeys    = $.getKeys
		    , getSymbols = $.getSymbols
		    , isEnum     = $.isEnum;
		  while($$len > index){
		    var S      = IObject($$[index++])
		      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
		      , length = keys.length
		      , j      = 0
		      , key;
		    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
		  }
		  return T;
		} : Object.assign;
	
	/***/ },
	/* 95 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = function(){ /* empty */ };
	
	/***/ },
	/* 96 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = function(done, value){
		  return {value: value, done: !!done};
		};
	
	/***/ },
	/* 97 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.1.4 ToInteger
		var ceil  = Math.ceil
		  , floor = Math.floor;
		module.exports = function(it){
		  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
		};
	
	/***/ },
	/* 98 */
	/***/ function(module, exports, __webpack_require__) {
	
		// 7.2.1 RequireObjectCoercible(argument)
		module.exports = function(it){
		  if(it == undefined)throw TypeError("Can't call method on  " + it);
		  return it;
		};
	
	/***/ },
	/* 99 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $          = __webpack_require__(66)
		  , createDesc = __webpack_require__(89);
		module.exports = __webpack_require__(79) ? function(object, key, value){
		  return $.setDesc(object, key, createDesc(1, value));
		} : function(object, key, value){
		  object[key] = value;
		  return object;
		};
	
	/***/ },
	/* 100 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		var $              = __webpack_require__(66)
		  , descriptor     = __webpack_require__(89)
		  , setToStringTag = __webpack_require__(83)
		  , IteratorPrototype = {};
	
		// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
		__webpack_require__(99)(IteratorPrototype, __webpack_require__(61)('iterator'), function(){ return this; });
	
		module.exports = function(Constructor, NAME, next){
		  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
		  setToStringTag(Constructor, NAME + ' Iterator');
		};
	
	/***/ },
	/* 101 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = function(it){
		  return typeof it === 'object' ? it !== null : typeof it === 'function';
		};
	
	/***/ },
	/* 102 */
	/***/ function(module, exports, __webpack_require__) {
	
		// getting tag from 19.1.3.6 Object.prototype.toString()
		var cof = __webpack_require__(104)
		  , TAG = __webpack_require__(61)('toStringTag')
		  // ES3 wrong here
		  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
		module.exports = function(it){
		  var O, T, B;
		  return it === undefined ? 'Undefined' : it === null ? 'Null'
		    // @@toStringTag case
		    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
		    // builtinTag case
		    : ARG ? cof(O)
		    // ES3 arguments fallback
		    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
		};
	
	/***/ },
	/* 103 */
	/***/ function(module, exports, __webpack_require__) {
	
		// optional / simple context binding
		var aFunction = __webpack_require__(106);
		module.exports = function(fn, that, length){
		  aFunction(fn);
		  if(that === undefined)return fn;
		  switch(length){
		    case 1: return function(a){
		      return fn.call(that, a);
		    };
		    case 2: return function(a, b){
		      return fn.call(that, a, b);
		    };
		    case 3: return function(a, b, c){
		      return fn.call(that, a, b, c);
		    };
		  }
		  return function(/* ...args */){
		    return fn.apply(that, arguments);
		  };
		};
	
	/***/ },
	/* 104 */
	/***/ function(module, exports, __webpack_require__) {
	
		var toString = {}.toString;
	
		module.exports = function(it){
		  return toString.call(it).slice(8, -1);
		};
	
	/***/ },
	/* 105 */
	/***/ function(module, exports, __webpack_require__) {
	
		// fallback for non-array-like ES3 and non-enumerable old V8 strings
		var cof = __webpack_require__(104);
		module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
		  return cof(it) == 'String' ? it.split('') : Object(it);
		};
	
	/***/ },
	/* 106 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = function(it){
		  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
		  return it;
		};
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 7 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(6),
	    getRawTag = __webpack_require__(159),
	    objectToString = __webpack_require__(191);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(10);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(8),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(46),
	    baseKeys = __webpack_require__(56),
	    isArrayLike = __webpack_require__(86);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(176),
	    listCacheDelete = __webpack_require__(177),
	    listCacheGet = __webpack_require__(178),
	    listCacheHas = __webpack_require__(179),
	    listCacheSet = __webpack_require__(180);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(36);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(49),
	    baseAssignValue = __webpack_require__(51);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(14),
	    isObject = __webpack_require__(3);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(173);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(14),
	    baseLodash = __webpack_require__(28);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4),
	    root = __webpack_require__(1);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(181),
	    mapCacheDelete = __webpack_require__(182),
	    mapCacheGet = __webpack_require__(183),
	    mapCacheHas = __webpack_require__(184),
	    mapCacheSet = __webpack_require__(185);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(12),
	    stackClear = __webpack_require__(197),
	    stackDelete = __webpack_require__(198),
	    stackGet = __webpack_require__(199),
	    stackHas = __webpack_require__(200),
	    stackSet = __webpack_require__(201);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 25 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(44);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(58),
	    createBind = __webpack_require__(150),
	    createCurry = __webpack_require__(151),
	    createHybrid = __webpack_require__(62),
	    createPartial = __webpack_require__(152),
	    getData = __webpack_require__(68),
	    mergeData = __webpack_require__(187),
	    setData = __webpack_require__(78),
	    setWrapToString = __webpack_require__(81),
	    toInteger = __webpack_require__(90);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(112),
	    stubArray = __webpack_require__(89);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 32 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(2),
	    isSymbol = __webpack_require__(10);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 34 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 35 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(120),
	    isObjectLike = __webpack_require__(7);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(1),
	    stubFalse = __webpack_require__(224);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(8),
	    isObject = __webpack_require__(3);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 41 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(14),
	    baseLodash = __webpack_require__(28);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4),
	    root = __webpack_require__(1);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(134),
	    isArguments = __webpack_require__(38),
	    isArray = __webpack_require__(2),
	    isBuffer = __webpack_require__(39),
	    isIndex = __webpack_require__(32),
	    isTypedArray = __webpack_require__(87);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(57);
	
	/**
	 * A specialized version of `_.sample` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to sample.
	 * @returns {*} Returns the random element.
	 */
	function arraySample(array) {
	  var length = array.length;
	  return length ? array[baseRandom(0, length - 1)] : undefined;
	}
	
	module.exports = arraySample;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(51),
	    eq = __webpack_require__(36);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(16),
	    keys = __webpack_require__(11);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(64);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(23),
	    arrayEach = __webpack_require__(25),
	    assignValue = __webpack_require__(49),
	    baseAssign = __webpack_require__(50),
	    baseAssignIn = __webpack_require__(115),
	    cloneBuffer = __webpack_require__(139),
	    copyArray = __webpack_require__(15),
	    copySymbols = __webpack_require__(146),
	    copySymbolsIn = __webpack_require__(147),
	    getAllKeys = __webpack_require__(67),
	    getAllKeysIn = __webpack_require__(156),
	    getTag = __webpack_require__(72),
	    initCloneArray = __webpack_require__(168),
	    initCloneByTag = __webpack_require__(169),
	    initCloneObject = __webpack_require__(170),
	    isArray = __webpack_require__(2),
	    isBuffer = __webpack_require__(39),
	    isObject = __webpack_require__(3),
	    keys = __webpack_require__(11);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(59),
	    toKey = __webpack_require__(9);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(27),
	    isArray = __webpack_require__(2);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(121),
	    isObjectLike = __webpack_require__(7);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(34),
	    nativeKeys = __webpack_require__(188);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 57 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	module.exports = baseRandom;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(37),
	    metaMap = __webpack_require__(76);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(2),
	    isKey = __webpack_require__(33),
	    stringToPath = __webpack_require__(83),
	    toString = __webpack_require__(91);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 60 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 61 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(60),
	    composeArgsRight = __webpack_require__(61),
	    countHolders = __webpack_require__(149),
	    createCtor = __webpack_require__(17),
	    createRecurry = __webpack_require__(63),
	    getHolder = __webpack_require__(69),
	    reorder = __webpack_require__(194),
	    replaceHolders = __webpack_require__(35),
	    root = __webpack_require__(1);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(174),
	    setData = __webpack_require__(78),
	    setWrapToString = __webpack_require__(81);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(109),
	    arraySome = __webpack_require__(114),
	    cacheHas = __webpack_require__(138);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 66 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(54),
	    getSymbols = __webpack_require__(31),
	    keys = __webpack_require__(11);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(76),
	    noop = __webpack_require__(220);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(77);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(27),
	    getPrototype = __webpack_require__(70),
	    getSymbols = __webpack_require__(31),
	    stubArray = __webpack_require__(89);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(105),
	    Map = __webpack_require__(21),
	    Promise = __webpack_require__(107),
	    Set = __webpack_require__(108),
	    WeakMap = __webpack_require__(45),
	    baseGetTag = __webpack_require__(8),
	    toSource = __webpack_require__(84);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(45);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(58),
	    shortOut = __webpack_require__(82);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(133),
	    shortOut = __webpack_require__(82);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(161),
	    insertWrapDetails = __webpack_require__(171),
	    setToString = __webpack_require__(80),
	    updateWrapDetails = __webpack_require__(203);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ },
/* 82 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(186);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 84 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 85 */
/***/ function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(40),
	    isLength = __webpack_require__(41);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(125),
	    baseUnary = __webpack_require__(136),
	    nodeUtil = __webpack_require__(190);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(46),
	    baseKeysIn = __webpack_require__(127),
	    isArrayLike = __webpack_require__(86);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(225);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(135);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(94);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(232).enable();
	  window.Promise = __webpack_require__(231);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(233);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(230);


/***/ },
/* 94 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by frimko on 24.01.2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _moJs = __webpack_require__(5);
	
	var _moJs2 = _interopRequireDefault(_moJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FirstRainbow = function () {
	    function FirstRainbow(data) {
	        _classCallCheck(this, FirstRainbow);
	
	        this.params = data.PARAMS;
	        this.defaultParamsForBurst = data.defaultParamsForBurst;
	        this.defaultParamsForBurstChild = data.defaultParamsForBurstChild;
	        return data.timeLine(this);
	    }
	
	    _createClass(FirstRainbow, [{
	        key: 'rainbow',
	        value: function rainbow(duration, delay, simbol, word, number) {
	            var point = void 0;
	            if (!isNaN(number)) {
	                point = this.params.COORDINATES_X[word][simbol][Number(number)];
	            } else {
	                point = this.params.COORDINATES_X[word][simbol];
	            }
	
	            var params = _extends({}, this.defaultParamsForBurst, {
	                children: _extends({}, this.defaultParamsForBurstChild, {
	                    duration: duration,
	                    delay: delay
	                })
	            });
	
	            return [new _moJs2.default.Burst(params).tune({ x: point, y: this.params.EndPointY }), this.burstRainbowEnd(delay + duration, simbol, word, number)];
	        }
	    }, {
	        key: 'firstD',
	        value: function firstD() {
	            var firstBurst = new _moJs2.default.Burst(_extends({}, this.defaultParamsForBurst, {
	                children: _extends({}, this.defaultParamsForBurstChild, {
	                    duration: 200,
	                    delay: 300
	                })
	            })).tune({ x: this.params.COORDINATES_X.str1['D'], y: this.params.EndPointY });
	
	            return [firstBurst, this.burstRainbowEnd(500, 'D', 'str1')];
	        }
	
	        /*стандартный эффект*/
	
	    }, {
	        key: 'burstRainbowEnd1',
	        value: function burstRainbowEnd1(delay, simbol, word, number) {
	            var point = void 0;
	            if (!isNaN(number)) {
	                point = this.params.COORDINATES_X[word][simbol][Number(number)];
	            } else {
	                point = this.params.COORDINATES_X[word][simbol];
	            }
	            return new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                y: this.params.EndPointY - 30,
	                degree: 180,
	                angle: 90,
	                radius: { 10: 25 },
	                count: 5,
	                children: {
	                    shape: 'line',
	                    radius: 5,
	                    radiusY: 0,
	                    scale: 1,
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '-100%': '100%' },
	                    stroke: ['#F9DD5E', '#FC2D79', '#11CDC5'],
	                    easing: 'linear.none',
	                    duration: 800,
	                    delay: delay
	                }
	            }).tune({ x: point, y: this.params.EndPointY });
	        }
	
	        /*модифицированный эффект*/
	
	    }, {
	        key: 'burstRainbowEnd',
	        value: function burstRainbowEnd(delay, simbol, word, number) {
	            var _this = this;
	
	            var point = void 0;
	            if (!isNaN(number)) {
	                point = this.params.COORDINATES_X[word][simbol][Number(number)];
	            } else {
	                point = this.params.COORDINATES_X[word][simbol];
	            }
	            var RADIUS = 20;
	            var CIRCLE_RADIUS = 25;
	            var circle = function circle(addDuration) {
	                return new _moJs2.default.Shape({
	                    parent: _this.params.parentTag,
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '50%': '50%' },
	                    stroke: { '#E5214A': '#37e3f5' },
	                    strokeWidth: { 3: 0 },
	                    fill: 'none',
	                    scale: { 0: 1 },
	                    radius: CIRCLE_RADIUS,
	                    duration: 400 + (addDuration ? addDuration : 0),
	                    delay: delay,
	                    easing: 'cubic.out'
	
	                });
	            };
	            var burst = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                radius: { 4: RADIUS },
	                count: 20,
	                y: this.params.EndPointY - 30,
	                degree: 180,
	                angle: 90,
	                children: {
	                    radius: 1,
	                    fill: [{ '#9EC9F5': '#9ED8C6' }, { '#91D3F7': '#9AE4CF' }, { '#DC93CF': '#E3D36B' }, { '#CF8EEF': '#CBEB98' }, { '#87E9C6': '#1FCC93' }, { '#A7ECD0': '#9AE4CF' }, { '#87E9C6': '#A635D9' }, { '#D58EB3': '#E0B6F5' }, { '#F48BA2': '#CF8EEF' }, { '#91D3F7': '#A635D9' }, { '#CF8EEF': '#CBEB98' }, { '#87E9C6': '#A635D9' }],
	                    scale: { 1: 0, easing: 'quad.in' },
	                    pathScale: [.8, null],
	                    degreeShift: [13, null],
	                    duration: [400, 700],
	                    easing: 'quint.out',
	                    delay: delay
	                }
	            });
	            return [burst.tune({ x: point, y: this.params.EndPointY }), circle().tune({ x: point, y: this.params.EndPointY }), circle(400).tune({ x: point, y: this.params.EndPointY }), circle(800).tune({ x: point, y: this.params.EndPointY })];
	        }
	    }]);
	
	    return FirstRainbow;
	}();
	
	exports.default = FirstRainbow;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by frimko on 28.01.2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _moJs = __webpack_require__(5);
	
	var _moJs2 = _interopRequireDefault(_moJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Letters = function () {
	    function Letters(data) {
	        _classCallCheck(this, Letters);
	
	        this.params = data.PARAMS;
	        return data.timeLine(this);
	    }
	
	    _createClass(Letters, [{
	        key: 'bubble',
	        value: function bubble(duration, delay, coords) {
	            var _this = this;
	
	            var CIRCLE_RADIUS = 15;
	            var RADIUS = 15;
	            var circle = function circle(addDuration) {
	                return new _moJs2.default.Shape({
	                    parent: _this.params.parentTag,
	                    stroke: { '#E5214A': '#37e3f5' },
	                    className: 'bubble',
	                    strokeWidth: { 3: 0 },
	                    fill: 'none',
	                    scale: { 0: 1 },
	                    radius: CIRCLE_RADIUS,
	                    duration: +duration + 400 + (addDuration ? addDuration : 0),
	                    delay: delay,
	                    easing: 'cubic.out'
	
	                });
	            };
	            var burst = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                radius: { 4: RADIUS },
	                angle: 45,
	                count: 10,
	                timeline: { delay: +delay + 100 },
	                children: {
	                    className: 'bubble_point',
	                    radius: 1,
	                    fill: [{ '#9EC9F5': '#9ED8C6' }, { '#91D3F7': '#9AE4CF' }, { '#DC93CF': '#E3D36B' }, { '#CF8EEF': '#CBEB98' }, { '#87E9C6': '#1FCC93' }, { '#A7ECD0': '#9AE4CF' }, { '#87E9C6': '#A635D9' }, { '#D58EB3': '#E0B6F5' }, { '#F48BA2': '#CF8EEF' }, { '#91D3F7': '#A635D9' }, { '#CF8EEF': '#CBEB98' }, { '#87E9C6': '#A635D9' }],
	                    scale: { 1: 0, easing: 'quad.in' },
	                    pathScale: [.8, null],
	                    degreeShift: [13, null],
	                    duration: [+duration + 400, 700],
	                    easing: 'quint.out'
	                }
	            });
	            return [burst.tune(coords), circle().tune(coords), circle(400).tune(coords), circle(800).tune(coords)];
	        }
	    }, {
	        key: 'horLine',
	        value: function horLine(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: 90,
	                y: this.params.EndPointY,
	                children: {
	                    className: 'hor_line',
	                    shape: 'line',
	                    stroke: ['#11CDC5', '#FC2D79', '#F9DD5E'],
	                    scale: 1,
	                    y: this.params.EndPointY,
	                    radius: 600,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            });
	
	            return [leftLine];
	        }
	    }, {
	        key: 'horLine2',
	        value: function horLine2(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: 90,
	                y: this.params.EndPointY - 90,
	                children: {
	                    className: 'hor_line',
	                    shape: 'line',
	                    stroke: ['#11CDC5', '#FC2D79', '#F9DD5E'],
	                    scale: 1,
	                    y: this.params.EndPointY - 90,
	                    radius: 600,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            });
	
	            return [leftLine];
	        }
	    }, {
	        key: 'plant_D',
	        value: function plant_D(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                isSoftHide: false,
	                children: {
	                    className: 'label_d_1',
	                    x: this.params.COORDINATES_X.str1['D'],
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str1['D'], y: this.params.EndPointY - 45 });
	
	            var equal = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                x: +this.params.COORDINATES_X.str1.D + 34,
	                y: 3,
	                degree: 0,
	                isSoftHide: false,
	                children: {
	                    className: 'label_d_2',
	                    origin: '50% 100%',
	                    angle: -90,
	                    shape: 'elipceD',
	                    fill: 'none',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radiusY: 32.5,
	                    radiusX: 40,
	                    rotate: 0,
	                    strokeWidth: 6,
	                    duration: +duration + 1600,
	                    delay: delayModify(200),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            });
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = equal.el.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var el = _step.value;
	
	                    el.style['height'] = '180px';
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return [leftLine].concat(_toConsumableArray(this.bubble(duration, +delay + 600, {
	                x: this.params.COORDINATES_X.str1['D'],
	                y: this.params.EndPointY - 85
	            })), [equal]);
	        }
	    }, {
	        key: 'plant_A',
	        value: function plant_A(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 0,
	                degree: 0,
	                angle: 0,
	                children: {
	                    className: 'label_a_1',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 45,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({
	                x: this.params.COORDINATES_X.str1['A'],
	                y: this.params.EndPointY - 45
	            }).then({
	                x: this.params.COORDINATES_X.str1['A'] - 16,
	                angle: 25,
	                y: this.params.EndPointY - 44
	            });
	
	            var rightLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 0,
	                degree: 0,
	                angle: 0,
	                children: {
	                    className: 'label_a_2',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 45,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({
	                x: +this.params.COORDINATES_X.str1['A'],
	                y: this.params.EndPointY - 45
	            }).then({
	                x: +this.params.COORDINATES_X.str1['A'] + 16,
	                angle: -25,
	                y: this.params.EndPointY - 44
	            });
	
	            var horLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 0,
	                degree: 0,
	                angle: 90,
	                x: this.params.COORDINATES_X.str1['A'],
	                y: this.params.EndPointY - 20,
	                children: {
	                    className: 'label_a_3',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 0,
	                    radiusX: 0,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(200),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).then({
	                children: {
	                    radiusX: { 0: 33 }
	                }
	            });
	            return [leftLine, rightLine, horLine].concat(_toConsumableArray(this.bubble(duration, +delay + 600, {
	                x: this.params.COORDINATES_X.str1['A'],
	                y: this.params.EndPointY - 20
	            })));
	        }
	    }, {
	        key: 'plant_R',
	        value: function plant_R(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_r_1',
	                    x: this.params.COORDINATES_X.str1['R'][0],
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 44,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str1['R'][0], y: this.params.EndPointY - 44 });
	            var equal = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                x: +this.params.COORDINATES_X.str1['R'][0] + 34,
	                y: 3,
	                degree: 0,
	                children: {
	                    className: 'label_r_2',
	                    angle: -90,
	                    shape: 'elipceR',
	                    fill: 'none',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radiusY: 32,
	                    radiusX: 40,
	                    rotate: 0,
	                    strokeWidth: 6,
	                    duration: +duration + 1600,
	                    delay: delayModify(300),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '150%': '50%'
	                    }
	                }
	            });
	            var equal2 = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                x: +this.params.COORDINATES_X.str1['R'][0] + 34,
	                y: 3,
	                degree: 0,
	                children: {
	                    className: 'label_r_3',
	                    origin: '0% 100%',
	                    angle: -90,
	                    shape: 'elipceR2',
	                    fill: 'none',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radiusY: 32,
	                    radiusX: 40,
	                    rotate: 0,
	                    strokeWidth: 6,
	                    duration: +duration + 400,
	                    delay: delayModify(300),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            });
	            var rightLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: -30,
	                children: {
	                    className: 'label_r_4',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 20,
	                    radiusY: 20,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['R'][0] + 40, y: this.params.EndPointY - 18.5 });
	
	            return [leftLine, equal, equal2, rightLine].concat(_toConsumableArray(this.bubble(duration, +delay + +duration, {
	                x: +this.params.COORDINATES_X.str1['R'][0] + 31,
	                y: this.params.EndPointY - 37
	            })));
	        }
	    }, {
	        key: 'plant_N',
	        value: function plant_N(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_n_1',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str1['N'][0], y: this.params.EndPointY - 45 });
	            var rightLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_n_2',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['N'][1], y: this.params.EndPointY - 45 });
	            var leftLineToRight = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: 140,
	                children: {
	                    className: 'label_n_1_1',
	                    rx: 0,
	                    ry: 0,
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 28,
	                    strokeWidth: 6,
	                    duration: +duration + 600,
	                    delay: delayModify(+duration),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['N'][0] + 10, y: +this.params.EndPointY - 70 });
	            var rightLineToLeft = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: -38,
	                children: {
	                    className: 'label_n_2_1',
	                    rx: 0,
	                    ry: 0,
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 28,
	                    strokeWidth: 6,
	                    duration: +duration + 600,
	                    delay: delayModify(+duration),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['N'][1] - 13, y: +this.params.EndPointY - 24 });
	
	            return [leftLine, rightLine, leftLineToRight].concat(_toConsumableArray(this.bubble(duration, +delay + 700, {
	                x: +this.params.COORDINATES_X.str1['N'][0],
	                y: this.params.EndPointY - 83
	            })), _toConsumableArray(this.bubble(duration, +delay + 700, {
	                x: +this.params.COORDINATES_X.str1['N'][1],
	                y: this.params.EndPointY - 7
	            })), [rightLineToLeft]);
	        }
	    }, {
	        key: 'plant_E',
	        value: function plant_E(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_e_1',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str1['E'], y: this.params.EndPointY - 45 });
	
	            var horLineTop = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: 90,
	                timeline: {
	                    delay: 600
	                },
	                children: {
	                    className: 'label_e_2',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 20,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '200%' }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['E'] + 15, y: this.params.EndPointY - 80 }).then({
	                children: {
	                    radius: 25
	                }
	            });
	
	            var horLineCenter = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: 90,
	                timeline: {
	                    delay: 200
	                },
	                children: {
	                    className: 'label_e_3',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 17,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(100),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['E'] + 15, y: this.params.EndPointY - 45 }).then({
	                x: +this.params.COORDINATES_X.str1['E'] + 13,
	                children: {
	                    radius: 24
	                }
	            });
	
	            var horLineBottom = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: 90,
	                children: {
	                    className: 'label_e_4',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 20,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['E'] + 15, y: this.params.EndPointY - 10 }).then({
	                children: {
	                    radius: 25
	                }
	            });
	
	            return [leftLine].concat(_toConsumableArray(this.bubble(duration, +delay + 600, {
	                x: +this.params.COORDINATES_X.str1['E'],
	                y: this.params.EndPointY - 80
	            })), _toConsumableArray(this.bubble(duration, +delay + 200, {
	                x: +this.params.COORDINATES_X.str1['E'],
	                y: this.params.EndPointY - 45
	            })), _toConsumableArray(this.bubble(duration, +delay, {
	                x: +this.params.COORDINATES_X.str1['E'],
	                y: this.params.EndPointY - 10
	            })), [horLineTop, horLineBottom, horLineCenter]);
	        }
	    }, {
	        key: 'plant_O',
	        value: function plant_O(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var rootLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_o',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 9,
	                    strokeWidth: 6,
	                    duration: +duration + 100,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str1['O'], y: this.params.EndPointY - 10 });
	            var rightLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                fill: 'none',
	                children: {
	                    className: 'label_o_1',
	                    shape: 'circle',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 40,
	                    //radiusY:          250,
	                    strokeWidth: 6,
	                    duration: +duration + 600,
	                    delay: delayModify(600),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '150%' }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str1['O'], y: this.params.EndPointY - 45 });
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                //angle:180,
	                fill: 'none',
	                children: {
	                    className: 'label_o_2',
	                    shape: 'circle',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 40,
	                    strokeWidth: 6,
	                    duration: +duration + 600,
	                    delay: delayModify(600),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '50%' }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['O'], y: this.params.EndPointY - 45 });
	            var innerRightLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                fill: 'none',
	                children: {
	                    className: 'label_o_1',
	                    shape: 'circle',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 30,
	                    //radiusY:          250,
	                    strokeWidth: 6,
	                    duration: +duration + 1000,
	                    delay: delayModify(1000),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '140%' }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str1['O'], y: this.params.EndPointY - 45 });
	
	            var innerLeftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                //angle:180,
	                fill: 'none',
	                children: {
	                    className: 'label_o_2',
	                    shape: 'circle',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 30,
	                    strokeWidth: 6,
	                    duration: +duration + 1000,
	                    delay: delayModify(1000),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '60%' }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str1['O'], y: this.params.EndPointY - 45 });
	            return [rootLine, leftLine, rightLine, innerRightLine, innerLeftLine].concat(_toConsumableArray(this.bubble(duration, +delay + 400, {
	                x: +this.params.COORDINATES_X.str1['O'],
	                y: this.params.EndPointY - 5
	            })), _toConsumableArray(this.bubble(duration, +delay + 1000, {
	                x: +this.params.COORDINATES_X.str1['O'],
	                y: this.params.EndPointY - 15
	            })));
	        }
	    }, {
	        key: 'plant_S',
	        value: function plant_S(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var sLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: -90,
	                fill: 'none',
	                children: {
	                    className: 'label_s_1',
	                    shape: 'S',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 40,
	                    //radiusY:          250,
	                    strokeWidth: 6,
	                    duration: +duration + 600,
	                    delay: delayModify(600),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '200%' }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str2['S'] + 10, y: this.params.EndPointY - 45 });
	            var sLine2 = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: -90,
	                fill: 'none',
	                children: {
	                    className: 'label_s_1',
	                    shape: 'S2',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 40,
	                    strokeWidth: 6,
	                    duration: +duration + 600,
	                    delay: delayModify(400),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '150%': '50%' }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str2['S'] + 10, y: this.params.EndPointY - 45 });
	            return [sLine, sLine2].concat(_toConsumableArray(this.bubble(duration, +delay + 700, {
	                x: +this.params.COORDINATES_X.str2['S'] - 3,
	                y: this.params.EndPointY - 7
	            })));
	        }
	    }, {
	        key: 'plant_T',
	        value: function plant_T(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var midleLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_t_1',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str2['T'], y: this.params.EndPointY - 45 });
	            var topHorLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: 90,
	                children: {
	                    className: 'label_t_2',
	                    rx: 0,
	                    ry: 0,
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 0,
	                    strokeWidth: 6,
	                    delay: delayModify(200),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({
	                x: +this.params.COORDINATES_X.str2['T'] - 3,
	                y: +this.params.EndPointY - 83
	            }).then({
	                children: {
	                    duration: +duration + 600,
	                    radius: 29,
	                    delay: 'stagger(0,125)'
	                }
	            });
	
	            return [midleLine, topHorLine].concat(_toConsumableArray(this.bubble(duration, +delay + 700, {
	                x: +this.params.COORDINATES_X.str2['T'],
	                y: this.params.EndPointY - 83
	            })));
	        }
	    }, {
	        key: 'plant_U',
	        value: function plant_U(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_u_1',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({
	                x: this.params.COORDINATES_X.str2['U'][0],
	                y: this.params.EndPointY - 45
	            }).then({
	                y: this.params.EndPointY - 60,
	                children: {
	                    delay: 0,
	                    radius: 28
	                }
	            });
	            var rightLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_u_2',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({
	                x: +this.params.COORDINATES_X.str2['U'][1],
	                y: this.params.EndPointY - 45
	            }).then({
	                y: this.params.EndPointY - 60,
	                children: {
	                    delay: 0,
	                    radius: 28
	                }
	            });
	            var leftLineU = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: -90,
	                children: {
	                    className: 'label_u_3',
	                    shape: 'U1',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 40,
	                    fill: 'none',
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(+duration + 500),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str2['U'][0] + 42, y: this.params.EndPointY - 45 });
	            var rightLineU = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                angle: 90,
	                children: {
	                    className: 'label_u_4',
	                    shape: 'U2',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 40,
	                    fill: 'none',
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(+duration + 500),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str2['U'][1] - 42, y: this.params.EndPointY - 45 });
	            return [leftLineU, rightLineU, leftLine, rightLine].concat(_toConsumableArray(this.bubble(duration, +delay + 700, {
	                x: +this.params.COORDINATES_X.str2['U'][0],
	                y: this.params.EndPointY - 87
	            })), _toConsumableArray(this.bubble(duration, +delay + 700, {
	                x: +this.params.COORDINATES_X.str2['U'][1],
	                y: this.params.EndPointY - 87
	            })));
	        }
	    }, {
	        key: 'plant_D2',
	        value: function plant_D2(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_d2_1',
	                    x: this.params.COORDINATES_X.str2['D'],
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str2['D'], y: this.params.EndPointY - 45 });
	
	            var equal = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                x: +this.params.COORDINATES_X.str2.D + 34,
	                y: 3,
	                degree: 0,
	                children: {
	                    className: 'label_d2_2',
	                    origin: '50% 100%',
	                    angle: -90,
	                    shape: 'elipceD',
	                    fill: 'none',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radiusY: 32.5,
	                    radiusX: 40,
	                    rotate: 0,
	                    strokeWidth: 6,
	                    duration: +duration + 1600,
	                    delay: delayModify(200),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            });
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = equal.el.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var el = _step2.value;
	
	                    el.style['height'] = '180px';
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return [leftLine].concat(_toConsumableArray(this.bubble(duration, +delay + 600, {
	                x: this.params.COORDINATES_X.str2['D'],
	                y: this.params.EndPointY - 85
	            })), [equal]);
	        }
	    }, {
	        key: 'plant_I',
	        value: function plant_I(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var middleLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_i_1',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 43,
	                    radiusY: 250,
	                    strokeWidth: 6,
	                    duration: duration,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str2['I'], y: this.params.EndPointY - 45 });
	            return [middleLine];
	        }
	    }, {
	        key: 'plant_O2',
	        value: function plant_O2(duration, delay) {
	            var delayModify = function delayModify(additionalDelay) {
	                additionalDelay = additionalDelay ? Number(additionalDelay) : 0;
	                return 'stagger(' + (Number(delay) + additionalDelay) + ',125)';
	            };
	            var rootLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                children: {
	                    className: 'label_o2',
	                    shape: 'line',
	                    stroke: this.params.COLORS,
	                    scale: 1,
	                    radius: 9,
	                    strokeWidth: 6,
	                    duration: +duration + 100,
	                    delay: delayModify(),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: {
	                        '100%': '200%'
	                    }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str2['O'], y: this.params.EndPointY - 10 });
	            var rightLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                fill: 'none',
	                children: {
	                    className: 'label_o2_1',
	                    shape: 'circle',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 40,
	                    //radiusY:          250,
	                    strokeWidth: 6,
	                    duration: +duration + 600,
	                    delay: delayModify(600),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '150%' }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str2['O'], y: this.params.EndPointY - 45 });
	            var leftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                //angle:180,
	                fill: 'none',
	                children: {
	                    className: 'label_o2_2',
	                    shape: 'circle',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 40,
	                    strokeWidth: 6,
	                    duration: +duration + 600,
	                    delay: delayModify(600),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '50%' }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str2['O'], y: this.params.EndPointY - 45 });
	            var innerRightLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                fill: 'none',
	                children: {
	                    className: 'label_o2_1',
	                    shape: 'circle',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 30,
	                    //radiusY:          250,
	                    strokeWidth: 6,
	                    duration: +duration + 1000,
	                    delay: delayModify(1000),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '140%' }
	                }
	            }).tune({ x: this.params.COORDINATES_X.str2['O'], y: this.params.EndPointY - 45 });
	
	            var innerLeftLine = new _moJs2.default.Burst({
	                parent: this.params.parentTag,
	                count: 3,
	                radius: 2,
	                degree: 0,
	                //angle:180,
	                fill: 'none',
	                children: {
	                    className: 'label_o2_2',
	                    shape: 'circle',
	                    stroke: this.params.COLORS,
	                    fill: 'none',
	                    scale: 1,
	                    radius: 30,
	                    strokeWidth: 6,
	                    duration: +duration + 1000,
	                    delay: delayModify(1000),
	                    strokeDasharray: '100%',
	                    strokeDashoffset: { '100%': '60%' }
	                }
	            }).tune({ x: +this.params.COORDINATES_X.str2['O'], y: this.params.EndPointY - 45 });
	            return [rootLine, leftLine, rightLine, innerRightLine, innerLeftLine].concat(_toConsumableArray(this.bubble(duration, +delay + 400, {
	                x: +this.params.COORDINATES_X.str2['O'],
	                y: this.params.EndPointY - 5
	            })), _toConsumableArray(this.bubble(duration, +delay + 1000, {
	                x: +this.params.COORDINATES_X.str2['O'],
	                y: this.params.EndPointY - 15
	            })));
	        }
	    }, {
	        key: 'hideLetters',
	        value: function hideLetters(duration, delay) {
	            if (this.curentLetters) {
	                this.curentLetters.forEach(function (obj) {
	                    var time = obj.timeline._props.time;
	                    if (obj._o.children !== undefined && obj._o.children.className !== 'bubble_point') {
	                        console.log(obj);
	                        obj.then({
	                            children: {
	                                angle: obj._o.children.angle,
	                                duration: duration,
	                                delay: delay - time,
	                                opacity: 0
	                            }
	                        });
	                    }
	                });
	            }
	        }
	    }]);
	
	    return Letters;
	}();
	
	exports.default = Letters;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by frimko on 28.01.2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _moJs = __webpack_require__(5);
	
	var _moJs2 = _interopRequireDefault(_moJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MoonRise = function () {
	    function MoonRise(data) {
	        _classCallCheck(this, MoonRise);
	
	        this.params = data.PARAMS;
	        return data.timeLine(this);
	    }
	
	    _createClass(MoonRise, [{
	        key: 'moon',
	        value: function moon(duration, delay) {
	            var moon = new _moJs2.default.Shape({
	                parent: this.params.parentTag,
	                className: 'moon',
	                shape: 'moon',
	                stroke: 'none',
	                delay: delay,
	                duration: duration,
	                x: { 450: 300 },
	                y: { 0: -80 },
	                opacity: { 0: 1 },
	                scale: 1,
	                radius: 75,
	                isRefreshState: true,
	                isShowEnd: true
	            });
	            var moonArea = new _moJs2.default.Shape({
	                parent: this.params.parentTag,
	                className: 'moon',
	                delay: delay,
	                duration: duration,
	                stroke: '#dad9d0',
	                x: 400,
	                opacity: 0,
	                strokeOpacity: 0.2,
	                strokeWidth: 20,
	                y: _defineProperty({}, +this.params.EndPointY + 50, this.params.EndPointY),
	                scale: 1,
	                fill: '#dad9d0',
	                radius: 40,
	                isRefreshState: true,
	                isShowEnd: true
	            });
	            moon.el.style['z-index'] = 949;
	            moonArea.el.style['z-index'] = 949;
	            return moon;
	        }
	    }, {
	        key: 'mountains',
	        value: function mountains(duration, delay) {
	            var mountains = new _moJs2.default.Shape({
	                parent: this.params.parentTag,
	                className: 'mountains',
	                shape: 'mountains',
	                x: 400,
	                opacity: { 0: 1 },
	                y: _defineProperty({}, +this.params.EndPointY + 50, this.params.EndPointY),
	                scale: 1,
	                radius: 169,
	                stroke: 'none',
	                fill: '#4c585c',
	                strokeWidth: 1,
	                delay: delay,
	                duration: duration,
	                isRefreshState: true,
	                isShowEnd: true
	            });
	            mountains.el.style['z-index'] = 950;
	            return mountains;
	        }
	    }, {
	        key: 'horizonLine',
	        value: function horizonLine(duration, delay) {
	            var horizonLine = new _moJs2.default.Shape({
	                parent: this.params.parentTag,
	                className: 'horizontLine',
	                shape: 'horizontLine',
	                stroke: '#adb9bd',
	                fill: 'none',
	                scale: 1,
	                x: -150,
	                y: _defineProperty({}, +this.params.EndPointY + 115, +this.params.EndPointY + 65),
	                radius: 169,
	                opacity: 0.3,
	                radiusX: 438,
	                strokeWidth: 6,
	                delay: delay,
	                duration: duration,
	                strokeDasharray: '100%',
	                strokeDashoffset: { '100%': '200%' },
	
	                isRefreshState: true,
	                isShowEnd: true
	
	            });
	            horizonLine.el.style['z-index'] = 948;
	            return horizonLine;
	        }
	    }, {
	        key: 'hideMoonRise',
	        value: function hideMoonRise(duration, delay) {
	            if (this.curentMoonItems) {
	                this.curentMoonItems.forEach(function (obj) {
	                    var time = obj.timeline._props.time;
	                    return obj.then({
	                        duration: duration,
	                        delay: delay - time,
	                        isShowEnd: false
	                    });
	                });
	            }
	        }
	    }]);
	
	    return MoonRise;
	}();
	
	exports.default = MoonRise;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by Сергей on 03.02.2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _moJs = __webpack_require__(5);
	
	var _moJs2 = _interopRequireDefault(_moJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PointsTimer = function () {
	    function PointsTimer(data) {
	        _classCallCheck(this, PointsTimer);
	
	        this.params = data.PARAMS;
	        return data.timeLine(this);
	    }
	
	    _createClass(PointsTimer, [{
	        key: 'bubble',
	        value: function bubble(duration, delay, coords) {
	            var _this = this;
	
	            var CIRCLE_RADIUS = 15;
	            var RADIUS = 15;
	            var circle = function circle(addDuration) {
	                return new _moJs2.default.Shape(_extends({
	                    parent: _this.params.parentTag,
	                    stroke: '#37e3f5',
	                    className: 'bubbleTimer',
	                    fill: 'none',
	                    radius: CIRCLE_RADIUS - 5,
	                    easing: 'cubic.out',
	                    strokeWidth: { 3: 1 },
	                    scale: { 0: 1 },
	                    angle: 0,
	                    strokeOpacity: 0.3
	                }, coords, {
	                    duration: 1500
	                })).then({
	                    stroke: '#E5214A',
	                    strokeWidth: 0,
	                    scale: 0,
	                    angle: 360,
	                    duration: +duration + 400 + (addDuration ? addDuration : 0),
	                    delay: delay,
	                    radius: CIRCLE_RADIUS,
	                    strokeOpacity: 1
	                });
	            };
	            var burst = new _moJs2.default.Burst(_extends({
	                parent: this.params.parentTag,
	                radius: { 4: RADIUS },
	                count: 15
	            }, coords, {
	                duration: 1500,
	                scale: { 0: 1, easing: 'quad.in' },
	                children: {
	                    angle: [0, 360],
	                    className: 'bubbleTimerPoint',
	                    radius: 1,
	                    fill: [{ '#9EC9F5': '#9ED8C6' }, { '#91D3F7': '#9AE4CF' }, { '#DC93CF': '#E3D36B' }, { '#CF8EEF': '#CBEB98' }, { '#87E9C6': '#A635D9' }, { '#D58EB3': '#E0B6F5' }, { '#F48BA2': '#CF8EEF' }, { '#91D3F7': '#A635D9' }, { '#CF8EEF': '#CBEB98' }, { '#87E9C6': '#A635D9' }],
	                    scale: { 0: 1, easing: 'quad.in' },
	                    pathScale: [null, .5],
	                    degreeShift: [null, 12],
	                    easing: 'quint.out'
	                }
	            })).then({
	                radius: 0,
	                angle: 360,
	                children: {
	                    delay: +delay + 100,
	                    scale: { 1: 0, easing: 'quad.in' },
	                    duration: [+duration + 100, +duration + 700]
	                }
	            });
	            return [burst, circle(), circle(400), circle(800)];
	        }
	    }]);
	
	    return PointsTimer;
	}();
	
	exports.default = PointsTimer;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by frimko on 28.01.2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _moJs = __webpack_require__(5);
	
	var _moJs2 = _interopRequireDefault(_moJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var sample = __webpack_require__(215);
	var baseRandom = __webpack_require__(57);
	
	var Stars = function () {
	    function Stars(data) {
	        _classCallCheck(this, Stars);
	
	        this.blurTime = 19690;
	
	        this.params = data.PARAMS;
	        this.color = data.PARAMS.STARS_COLOR;
	        return data.timeLine(this);
	    }
	
	    _createClass(Stars, [{
	        key: 'star',
	        value: function star(duration, delay, count) {
	            count = count ? count : 5;
	            var arStars = [],
	                arStarRim = [];
	            var blurTime = this.blurTime;
	            for (var i = 0; i <= count; i++) {
	                var color = this.color;
	                var star = new _moJs2.default.Shape({
	                    parent: this.params.parentTag,
	                    className: 'star',
	                    x: 'rand(-550, 550)',
	                    y: 'rand(-130, -50)',
	                    stroke: '#fdee88',
	                    fill: '#fdee88',
	                    delay: delay,
	                    radius: 'rand(0.2, 2.5)',
	                    strokeWidth: 0.1,
	                    opacity: 'rand(0.1, 1)',
	                    duration: duration
	                }).then({
	                    easing: 'sin.in',
	                    duration: +duration + 2400,
	                    stroke: sample(color),
	                    fill: sample(color),
	                    delay: 300
	                }).then({
	                    stroke: sample(color),
	                    fill: sample(color),
	                    delay: 200
	                }).then({
	                    stroke: sample(color),
	                    fill: sample(color),
	                    delay: 200
	                }).then({
	                    stroke: sample(color),
	                    fill: sample(color),
	                    delay: 200
	                }).then({
	                    isShowEnd: false,
	                    //opacity: 0,
	                    fill: sample(color),
	                    delay: 1000
	                });
	
	                var starRim = new _moJs2.default.Shape({
	                    parent: this.params.parentTag,
	                    className: 'star_rim',
	                    x: star._props.x.replace('px', ''),
	                    y: star._props.y.replace('px', ''),
	                    stroke: star._props.fill,
	                    fill: 'none',
	                    radius: star._props.radius / 2 + 0.7,
	                    strokeOpacity: star._props.opacity - 0.1,
	                    strokeWidth: star._props.radius / 4,
	                    duration: +duration + 1300,
	                    delay: delay
	                }).then({
	                    stroke: sample(color),
	                    fill: sample(color),
	                    strokeOpacity: star._props.opacity * 3,
	                    delay: blurTime - delay - (+duration + 1300),
	                    radius: star._props.radius * 2,
	                    duration: 10,
	                    strokeWidth: star._props.radius * 3
	                }).then({
	                    stroke: sample(color),
	                    fill: sample(color),
	                    delay: 0,
	                    duration: 500,
	                    strokeOpacity: star._props.opacity - 0.1,
	                    opacity: star._props.opacity,
	                    radius: star._props.radius + 0.7,
	                    strokeWidth: star._props.radius / 2
	                });
	                star.el.style['z-index'] = 948;
	                starRim.el.style['z-index'] = 948;
	                arStarRim.push(starRim);
	                arStars.push(star);
	            }
	            return [].concat(arStarRim, arStars);
	        }
	    }, {
	        key: 'shineFarFarStar',
	        value: function shineFarFarStar(duration, delay, coords) {
	
	            var OPT_STEP2 = {
	                delay: 0,
	                duration: 300
	            };
	            var OPT_STEP3 = {
	                delay: 100,
	                radius: 0,
	                opacity: 0,
	                duration: 10,
	                isShowEnd: false
	            };
	            var FarFarStar = new _moJs2.default.Shape(_extends({
	                parent: this.params.parentTag,
	                className: 'FarFarStar',
	                shape: 'star',
	                stroke: '#fdee88',
	                fill: 'none',
	                delay: delay,
	                radius: 0,
	                opacity: 0,
	                strokeWidth: 1,
	                duration: duration,
	                isShowEnd: false
	            }, coords)).then(_extends({}, OPT_STEP2, {
	                opacity: 1,
	                radius: 2
	            })).then(OPT_STEP3);
	
	            var shineFarFarStar = new _moJs2.default.Shape(_extends({
	                parent: this.params.parentTag,
	                className: 'FarFarStar',
	                shape: 'star',
	                stroke: '#ffffff',
	                fill: 'none',
	                delay: delay,
	                radius: 0,
	                opacity: 0,
	                strokeWidth: .5,
	                duration: duration,
	                isShowEnd: false
	            }, coords)).then(_extends({}, OPT_STEP2, {
	                opacity: 0.8,
	                radius: 6
	            })).then(OPT_STEP3);
	
	            return [FarFarStar, shineFarFarStar];
	        }
	    }, {
	        key: 'shineStars',
	        value: function shineStars(duration, delay, arrStars, count) {
	            var _this = this;
	
	            var sideX = 50;
	            count = count ? Number(count) : 1;
	            if (!this.curRimStar) {
	                this.curRimStar = [];
	                this.curRimShineStar = [];
	                arrStars.forEach(function (o) {
	                    if (o._o.className === "star_rim") {
	                        _this.curRimStar.push(o);
	                    }
	                });
	            }
	            for (var i = 0; i < count; i++) {
	                var length = this.curRimStar.length;
	                var randKey = baseRandom(0, length - 1);
	                var rimStar = length ? this.curRimStar[randKey] : undefined;
	                var randCurRimStar = this.curRimStar[randKey];
	                if (Number(randCurRimStar._props.x.replace('px', '')) > sideX) {
	                    this.curRimShineStar.push(randCurRimStar);
	                }
	                this.curRimStar.splice(randKey, 1);
	                if (rimStar) {
	                    var color = this.color;
	                    rimStar.then({
	                        className: 'star_rim_shine',
	                        radius: rimStar._props.radius * 3,
	                        stroke: sample(color),
	                        fill: sample(color),
	                        delay: delay - rimStar.timeline._props.time,
	                        duration: duration,
	                        opacity: rimStar._props.opacity * 8
	                    }).then({
	                        duration: 600,
	                        delay: 10,
	                        radius: rimStar._props.radius,
	                        opacity: rimStar._props.opacity
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'blurShineStars',
	        value: function blurShineStars(duration, delay) {
	            var _this2 = this;
	
	            if (this.curRimShineStar) {
	                this.curRimShineStar.forEach(function (rimStar) {
	                    var color = _this2.color;
	                    var radius = rimStar._props.radius;
	                    rimStar.then({
	                        duration: duration,
	                        radius: radius * 3,
	                        delay: delay - rimStar.timeline._props.time,
	                        stroke: sample(color),
	                        fill: sample(color)
	                    }).then({
	                        duration: 200,
	                        delay: 0,
	                        radius: radius
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'shootingStar',
	        value: function shootingStar(duration, delay, coordLast) {
	            if (this.curRimShineStar) {
	                var length = this.curRimShineStar.length;
	                var randKey = baseRandom(0, length - 1);
	                var rimStar = length ? this.curRimShineStar[randKey] : undefined;
	                this.curRimShineStar.splice(randKey, 1);
	                if (rimStar) {
	                    var color = sample(this.color);
	
	                    var coordFirst = {
	                        x: rimStar._props.x.replace('px', ''),
	                        y: rimStar._props.y.replace('px', '')
	                    };
	                    var katet1 = coordFirst.y - coordLast.y;
	                    var katet2 = coordFirst.x - coordLast.x;
	                    var hepotinuze = Math.sqrt(Math.pow(katet1, 2) + Math.pow(katet2, 2));
	                    var angle = Math.atan(katet2 / katet1) / Math.PI * 180;
	                    var radius = rimStar._props.radius;
	                    var shot = rimStar.then({
	                        duration: 0,
	                        angle: -90 - angle,
	                        radiusX: radius * 1.5,
	                        radius: radius,
	                        delay: delay - rimStar.timeline._props.time
	                    }).then({
	                        radius: _defineProperty({}, radius / 2, radius),
	                        className: 'star_rim_shine_shot',
	                        x: coordLast.x,
	                        y: coordLast.y,
	                        stroke: color,
	                        fill: color,
	                        opacity: { 1: 0, easing: _moJs2.default.easing.path('M0, 100 C0, 100 95, 95 95, 95 C95, 95 100, 0 100, 0') },
	                        radiusX: _defineProperty({}, radius * 3, radius),
	                        duration: duration,
	                        delay: 0,
	                        easing: 'cubic.out'
	                    });
	
	                    var trailOpts = {
	                        parent: shot.el,
	                        fill: 'none',
	                        stroke: color,
	                        shape: 'line',
	                        radiusY: 0,
	                        radiusX: { 0: radius / 2 * hepotinuze },
	                        strokeDasharray: '100%',
	                        strokeDashoffset: {
	                            '0%': '100%'
	                        },
	                        duration: duration,
	                        strokeWidth: _defineProperty({}, radius / 2, radius / 4),
	                        opacity: .75,
	                        x: 10,
	                        delay: delay,
	                        left: { 0: radius / 2 * hepotinuze },
	                        easing: 'cubic.out',
	                        y: 1
	
	                    };
	
	                    var trail2Opts = _extends({}, trailOpts, {
	                        y: 0
	                    });
	                    var trail3Opts = _extends({}, trailOpts, {
	                        y: -1
	                    });
	                    var trailReturn = {
	                        delay: 0,
	                        easing: 'quad.in',
	                        strokeDashoffset: '100%',
	                        duration: duration / 2,
	                        radiusX: 0,
	                        x: 0,
	                        left: hepotinuze / 2 * 10
	                    };
	
	                    var trail1 = new _moJs2.default.Shape(trailOpts).then(_extends({
	                        duration: duration / 6
	                    }, trailReturn));
	
	                    var trail2 = new _moJs2.default.Shape(trail2Opts).then(_extends({
	                        duration: duration / 2
	                    }, trailReturn));
	                    var trail3 = new _moJs2.default.Shape(trail3Opts).then(_extends({
	                        duration: duration / 6
	                    }, trailReturn));
	
	                    if (this.curentStars) {
	                        this.curentStars = this.curentStars.concat([trail1, trail2, trail3]);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'hideStars',
	        value: function hideStars(duration, delay) {
	            if (this.curentStars) {
	                this.curentStars.forEach(function (obj) {
	                    var time = obj.timeline._props.time;
	                    return obj.then({
	                        duration: duration,
	                        delay: delay - time,
	                        isShowEnd: false
	                    });
	                });
	            }
	        }
	    }]);
	
	    return Stars;
	}();
	
	exports.default = Stars;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by Сергей on 01.02.2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _moJs = __webpack_require__(5);
	
	var _moJs2 = _interopRequireDefault(_moJs);
	
	var _howler = __webpack_require__(104);
	
	var _FirstRainbow = __webpack_require__(95);
	
	var _FirstRainbow2 = _interopRequireDefault(_FirstRainbow);
	
	var _Stars = __webpack_require__(99);
	
	var _Stars2 = _interopRequireDefault(_Stars);
	
	var _MoonRise = __webpack_require__(97);
	
	var _MoonRise2 = _interopRequireDefault(_MoonRise);
	
	var _Letters = __webpack_require__(96);
	
	var _Letters2 = _interopRequireDefault(_Letters);
	
	var _PointsTimer = __webpack_require__(98);
	
	var _PointsTimer2 = _interopRequireDefault(_PointsTimer);
	
	var _resorce = __webpack_require__(101);
	
	__webpack_require__(102);
	
	__webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*global
	 $
	 */
	_moJs2.default.isDebug = false;
	var PARAMS = {
	    COORDINATES_X: {
	        str1: {
	            'D': '-530',
	            'A': '-414',
	            'R': ['-345', '-295'],
	            'N': ['-255', '-195'],
	            'E': '-155',
	            'O': '-50'
	        },
	        str2: {
	            'S': '86',
	            'T': '165',
	            'U': ['221', '275'],
	            'D': '318',
	            'I': '419',
	            'O': '501'
	        }
	    },
	    startPointY: -100,
	    EndPointY: 55,
	    parentTag: '#animate_logo',
	    COLORS: ['#F9DD5E', '#FC2D79', '#11CDC5'],
	    STARS_COLOR: ['#ECCAFD', '#B89AC9', '#FFEAD7', '#FDF47E', '#FDFD40'],
	    endTimeSong: 34014
	};
	
	var Animation = function () {
	    function Animation(data) {
	        var _this = this;
	
	        _classCallCheck(this, Animation);
	
	        this.delay = 1000;
	
	        this.soundSrc = data.soundSrc;
	        this.sound = this.initSound();
	        this.initResorce();
	        this.timeline = this.timeLine();
	        this.addOverley(this.delay);
	        this.initLastPointsTimer(function () {
	            return _this.removeOverflow();
	        });
	        this.onEndAnimation = data.onEndAnimation;
	    }
	
	    _createClass(Animation, [{
	        key: 'start',
	        value: function start() {
	            return this.startAnimation(500);
	        }
	    }, {
	        key: 'stopAnimation',
	        value: function stopAnimation() {
	            this.sound.stop();
	            this.timeline.stop();
	            this.timeline.reset();
	        }
	    }, {
	        key: 'startAnimation',
	        value: function startAnimation(delay) {
	            var _this2 = this;
	
	            setTimeout(function () {
	                _this2.sound.play();
	                _this2.timeline.play();
	            }, +this.delay + delay);
	        }
	    }, {
	        key: 'restartAnimation',
	        value: function restartAnimation() {
	            this.timelineLastPointsTimer.stop();
	            this.timelineLastPointsTimer.reset();
	            this.stopAnimation();
	            this.startAnimation(500);
	        }
	    }, {
	        key: 'initSound',
	        value: function initSound() {
	            var that = this;
	            var sound = new _howler.Howl({
	                src: [that.soundSrc]
	            });
	            this.durationSound = PARAMS.endTimeSong;
	            return sound;
	        }
	    }, {
	        key: 'initResorce',
	        value: function initResorce() {
	            _moJs2.default.addShape('elipceR2', _resorce.elipceR2);
	            _moJs2.default.addShape('elipceD', _resorce.elipceD);
	            _moJs2.default.addShape('elipceR', _resorce.elipceR);
	            _moJs2.default.addShape('U1', _resorce.U1);
	            _moJs2.default.addShape('U2', _resorce.U2);
	            _moJs2.default.addShape('S', _resorce.S);
	            _moJs2.default.addShape('S2', _resorce.S2);
	            _moJs2.default.addShape('mountains', _resorce.mountains);
	            _moJs2.default.addShape('horizontLine', _resorce.horizontLine);
	            _moJs2.default.addShape('moon', _resorce.moon);
	            _moJs2.default.addShape('star', _resorce.star);
	        }
	    }, {
	        key: 'getTimeLineClasses',
	        value: function getTimeLineClasses() {
	            var durationSound = this.durationSound;
	            var TimeLineFR = new _FirstRainbow2.default({
	                PARAMS: PARAMS,
	                defaultParamsForBurstChild: {
	                    shape: 'line',
	                    stroke: PARAMS.COLORS,
	                    radius: 60,
	                    strokeWidth: 8,
	                    isForce3d: true
	                },
	                defaultParamsForBurst: {
	                    parent: PARAMS.parentTag,
	                    y: _defineProperty({}, PARAMS.startPointY, PARAMS.EndPointY),
	                    count: 3,
	                    degree: 7,
	                    radius: { 250: 0 },
	                    isRefreshState: false,
	                    isShowEnd: false
	                },
	                timeLine: function timeLine(o) {
	                    var that = o;
	                    return [that.firstD()].concat(_toConsumableArray(that.rainbow(200, 500, 'A', 'str1')), _toConsumableArray(that.rainbow(200, 850, 'R', 'str1', 0)), _toConsumableArray(that.rainbow(200, 850, 'R', 'str1', 1)), _toConsumableArray(that.rainbow(200, 1400, 'N', 'str1', 0)), _toConsumableArray(that.rainbow(200, 1400, 'N', 'str1', 1)), _toConsumableArray(that.rainbow(200, 2000, 'E', 'str1')), _toConsumableArray(that.rainbow(200, 2500, 'O', 'str1')), _toConsumableArray(that.rainbow(200, 3200, 'S', 'str2')), _toConsumableArray(that.rainbow(200, 3700, 'T', 'str2')), _toConsumableArray(that.rainbow(200, 4300, 'U', 'str2', 0)), _toConsumableArray(that.rainbow(200, 4300, 'U', 'str2', 1)), _toConsumableArray(that.rainbow(200, 5000, 'D', 'str2')), _toConsumableArray(that.rainbow(200, 5350, 'I', 'str2')), _toConsumableArray(that.rainbow(200, 5600, 'O', 'str2')), _toConsumableArray(that.rainbow(200, 6150, 'O', 'str1')), _toConsumableArray(that.rainbow(200, 6150, 'D', 'str2')), _toConsumableArray(that.rainbow(200, 6800, 'R', 'str1', 0)), _toConsumableArray(that.rainbow(200, 6800, 'T', 'str2')), _toConsumableArray(that.rainbow(200, 7400, 'O', 'str1')), _toConsumableArray(that.rainbow(200, 7400, 'S', 'str2')), _toConsumableArray(that.rainbow(200, 7900, 'D', 'str1')), _toConsumableArray(that.rainbow(200, 7900, 'O', 'str2')), _toConsumableArray(that.rainbow(200, 8400, 'R', 'str1', 0)), _toConsumableArray(that.rainbow(200, 8400, 'D', 'str2')));
	                }
	            });
	            var TimeLineLetters = new _Letters2.default({
	                PARAMS: PARAMS,
	                timeLine: function timeLine(o) {
	                    var that = o;
	                    that.curentLetters = [].concat(_toConsumableArray(that.plant_D(800, 10111)), _toConsumableArray(that.plant_A(800, 10200)), _toConsumableArray(that.plant_R(800, 10300)), _toConsumableArray(that.plant_N(800, 10400)), _toConsumableArray(that.plant_E(800, 10500)), _toConsumableArray(that.plant_O(800, 10600)), _toConsumableArray(that.plant_S(800, 12500)), _toConsumableArray(that.plant_T(800, 13100)), _toConsumableArray(that.plant_U(800, 13400)), _toConsumableArray(that.plant_D2(800, 13700)), _toConsumableArray(that.plant_I(800, 14000)), _toConsumableArray(that.plant_O2(800, 14300)));
	                    //that.hideLetters(1000, +durationSound+300);
	                    return that.curentLetters;
	                }
	            });
	            var TimeLineMR = new _MoonRise2.default({
	                PARAMS: PARAMS,
	                timeLine: function timeLine(o) {
	                    var that = o;
	                    that.curentMoonItems = [that.moon(5000, 20000), that.mountains(1500, 18500), that.horizonLine(1600, 18500)];
	                    that.hideMoonRise(500, durationSound);
	                    return that.curentMoonItems;
	                }
	            });
	            var TimeLineStars = new _Stars2.default({
	                PARAMS: PARAMS,
	                timeLine: function timeLine(o) {
	                    var that = o;
	                    that.curentStars = [].concat(_toConsumableArray(that.star(200, 17050, 5)), _toConsumableArray(that.star(200, 17300, 15)), _toConsumableArray(that.star(200, 17600, 25)), _toConsumableArray(that.star(200, 17900, 30)), _toConsumableArray(that.star(200, 18200, 35)));
	                    that.shineStars(10, 21200, that.curentStars, 3);
	                    that.shineStars(10, 21600, that.curentStars, 3);
	                    that.shineStars(10, 21900, that.curentStars, 3);
	
	                    that.shineStars(10, 22100, that.curentStars, 4);
	                    that.shineStars(10, 22400, that.curentStars, 4);
	                    that.shineStars(10, 22700, that.curentStars, 4);
	
	                    that.shineStars(10, 23300, that.curentStars, 10);
	                    that.shineStars(10, 23900, that.curentStars, 15);
	                    that.shineStars(10, 24500, that.curentStars, 12);
	
	                    that.shineStars(10, 25150, that.curentStars, 9);
	                    that.shineStars(10, 25700, that.curentStars, 6);
	                    that.shineStars(10, 26300, that.curentStars, 7);
	                    that.shineStars(10, 26600, that.curentStars, 4);
	                    that.shineStars(10, 27200, that.curentStars, 8);
	                    that.shineStars(10, 28170, that.curentStars, 3);
	
	                    that.blurShineStars(100, 29300);
	
	                    that.shootingStar(500, 29600, { y: 52, x: PARAMS.COORDINATES_X.str1.D });
	                    that.shootingStar(500, 29800, { y: 52, x: PARAMS.COORDINATES_X.str1.A });
	                    that.shootingStar(500, 30100, { y: 52, x: PARAMS.COORDINATES_X.str1.R[0] });
	                    that.shootingStar(500, 30400, { y: 52, x: PARAMS.COORDINATES_X.str1.N[0] });
	                    that.shootingStar(500, 30700, { y: 52, x: PARAMS.COORDINATES_X.str1.N[1] });
	                    that.shootingStar(500, 31070, { y: 52, x: PARAMS.COORDINATES_X.str1.E });
	                    that.shootingStar(500, 31370, { y: 52, x: PARAMS.COORDINATES_X.str1.O });
	
	                    /*                that.shootingStar(500, 29600, {y: 55, x: PARAMS.COORDINATES_X.str2.S});
	                     that.shootingStar(500, 29800, {y: 55, x: PARAMS.COORDINATES_X.str2.T});
	                     that.shootingStar(500, 30100, {y: 55, x: PARAMS.COORDINATES_X.str2.U[0]});
	                     that.shootingStar(500, 30400, {y: 55, x: PARAMS.COORDINATES_X.str2.U[1]});
	                     that.shootingStar(500, 30700, {y: 55, x: PARAMS.COORDINATES_X.str2.D});
	                     that.shootingStar(500, 31070, {y: 55, x: PARAMS.COORDINATES_X.str2.I});
	                     that.shootingStar(500, 31370, {y: 55, x: PARAMS.COORDINATES_X.str2.O});*/
	
	                    that.hideStars(500, durationSound);
	                    return [].concat(_toConsumableArray(that.curentStars), _toConsumableArray(that.shineFarFarStar(300, 30500, { y: -100, x: 0 })), _toConsumableArray(that.shineFarFarStar(300, 31600, { y: -65, x: PARAMS.COORDINATES_X.str2.U[0] })), _toConsumableArray(that.shineFarFarStar(300, 31800, { y: -79, x: PARAMS.COORDINATES_X.str2.T })), _toConsumableArray(that.shineFarFarStar(300, 32000, { y: -90, x: PARAMS.COORDINATES_X.str2.S })), _toConsumableArray(that.shineFarFarStar(300, 32200, { y: -100, x: 20 })), _toConsumableArray(that.shineFarFarStar(300, 32400, { y: -100, x: PARAMS.COORDINATES_X.str1.O })), _toConsumableArray(that.shineFarFarStar(300, 32600, { y: -90, x: PARAMS.COORDINATES_X.str1.E })), _toConsumableArray(that.shineFarFarStar(300, 32800, { y: -87, x: PARAMS.COORDINATES_X.str1.N[1] })), _toConsumableArray(that.shineFarFarStar(300, 33000, { y: -83, x: PARAMS.COORDINATES_X.str1.N[0] })), _toConsumableArray(that.shineFarFarStar(300, 33100, { y: -80, x: PARAMS.COORDINATES_X.str1.R[1] })), _toConsumableArray(that.shineFarFarStar(300, 33300, { y: -79, x: PARAMS.COORDINATES_X.str1.R[0] })), _toConsumableArray(that.shineFarFarStar(300, 33400, { y: -75, x: PARAMS.COORDINATES_X.str1.A })), _toConsumableArray(that.shineFarFarStar(300, 33500, { y: -65, x: PARAMS.COORDINATES_X.str1.D })));
	                }
	            });
	            return [].concat(_toConsumableArray(TimeLineStars), _toConsumableArray(TimeLineMR), _toConsumableArray(TimeLineFR), _toConsumableArray(TimeLineLetters));
	        }
	    }, {
	        key: 'timeLine',
	        value: function timeLine() {
	            var _ref;
	
	            var that = this;
	            var timeline = (_ref = new _moJs2.default.Timeline({
	                onPlaybackComplete: function onPlaybackComplete() {
	                    console.log('end onPlaybackComplete');
	                    that.showPanel();
	                },
	                onProgress: function onProgress(p) {
	                    p *= 100;
	                    $('#js-slider').val(p * 34014 / 100);
	                }
	            })).add.apply(_ref, _toConsumableArray(this.getTimeLineClasses()));
	            return timeline;
	        }
	    }, {
	        key: 'hidePanel',
	        value: function hidePanel() {
	            $('.panel').animate({
	                opacity: 0
	            }, 200, function () {});
	        }
	    }, {
	        key: 'showPanel',
	        value: function showPanel() {
	            console.log('showPanel');
	            var that = this;
	            $('.panel').animate({
	                opacity: 1
	            }, 200, function () {
	                that.timelineLastPointsTimer.play();
	            });
	        }
	    }, {
	        key: 'addPanel',
	        value: function addPanel($tag) {
	            var _this3 = this;
	
	            var timerID = void 0;
	            var duration = this.durationSound;
	            var $range = $('<div id="controls__timeline">').append('<input type="range" step="1" min="0" max="' + duration + '" value="0" id="js-slider">');
	            var $replayButton = $('<div class="replay_button" title="restart">').append('<svg><path d="M5.03868442,0.355114828 C5.18894493,0.105224017 5.48268728,-0.0462129771 5.76249569,\n            0.0127011539 C6.07958679,0.0633119511 6.33566986,0.367372131 6.34885061,0.703064059 C6.3544995,\n            0.854105656 6.31684022,1.00672884 6.2403919,1.13483742 C6.01933195,1.49425316 5.79074015,\n            1.84852874 5.56591427,2.2055721 C6.05774441,2.20636289 6.54957455,2.19805956 7.04102809,\n            2.21506162 C9.1710367,2.28741925 11.2053908,3.45779393 12.5065187,5.21216977 C13.1512455,\n            6.0749257 13.6238694,7.08476926 13.8483187,8.15748092 C14.1955372,9.7932377 13.9338053,\n            11.5464273 13.1945537,13.0252116 C12.5558524,14.3055066 11.5661666,15.3968019 10.3610698,\n            16.1006083 C9.29907824,16.7312663 8.06874971,17.0539101 6.8482126,16.9926236 C5.29175475,\n            16.9309417 3.75789246,16.3097732 2.57426144,15.2441787 C1.61093718,14.3830044 0.892398202,\n            13.2347719 0.482288694,11.9805731 C0.139212695,10.9481919 -0.00690529302,9.84938406 0.000249969294,\n            8.75848414 C0.0119243447,8.50226698 0.16030189,8.2606795 0.377595908,8.14403743 C0.630666239,\n            7.99932218 0.966586975,8.04360663 1.17634914,8.25118998 C1.34242654,8.40341777 1.41812169,\n            8.6378881 1.41096642,8.86524129 C1.41849828,9.8181477 1.55105893,10.7777759 1.87266914,\n            11.6721635 C2.24135345,12.7199652 2.88570365,13.6661499 3.73868623,14.3387199 C4.60974527,\n            15.0318506 5.68190484,15.4351554 6.77138768,15.5063268 C7.76257981,15.5818476 8.76958883,\n            15.339074 9.63801172,14.8345476 C11.0483516,14.0247748 12.0930199,12.5566663 12.4473937,\n            10.9118154 C12.6654409,9.91818311 12.6323007,8.86168272 12.3193521,7.89414662 C11.6670935,\n            5.84322314 9.9144308,4.23633033 7.89852979,3.80851094 C7.1287742,3.6376995 6.33830601,\n            3.69859061 5.55762923,3.68910109 C5.78207851,4.03467794 6.0008789,4.38460415 6.22231544,\n            4.73255338 C6.33679964,4.91048197 6.38123759,5.14099833 6.32437208,5.34937247 C6.25846835,\n            5.62733646 6.0219681,5.8483633 5.75232769,5.88908918 C5.49360847,5.93732759 5.21831916,\n            5.81277759 5.06881184,5.58740138 C4.61313461,4.87805943 4.16724879,4.16160033 3.71307793,\n            3.45107219 C3.52591133,3.19287804 3.48712227,2.8208096 3.65809538,2.54245022 C4.1145258,\n            1.81057064 4.58112422,1.08620361 5.03868442,0.355114828 L5.03868442,0.355114828 Z"></path>\n            </svg>');
	            $tag.append($replayButton, $range);
	            $replayButton.on('click', function () {
	                _this3.hidePanel();
	                _this3.restartAnimation();
	            });
	            $('#js-slider').on('input', function (e) {
	                clearTimeout(timerID);
	                _this3.timeline.setProgress(e.target.valueAsNumber / duration);
	                _this3.timelineLastPointsTimer.stop();
	                _this3.timelineLastPointsTimer.reset();
	                timerID = setTimeout(function () {
	                    _this3.timelineLastPointsTimer.play();
	                }, 3000);
	            });
	        }
	    }, {
	        key: 'addOverley',
	        value: function addOverley(delay) {
	            delay = delay ? delay : 700;
	            var $logo = $('.logo');
	            if ($('.panel').length === 0) {
	                var $shadow = $('<div>').addClass('panel');
	                $logo.after($shadow);
	                this.addPanel($shadow);
	                $logo.after($('<div>').addClass('overflow_logo'));
	                $('.overflow_logo').animate({
	                    opacity: 1
	                }, delay);
	            }
	        }
	    }, {
	        key: 'removeOverflow',
	        value: function removeOverflow() {
	            var that = this;
	            this.stopAnimation();
	            $('.panel , .overflow_logo').animate({
	                opacity: 0
	            }, 700, function () {
	                $(this).remove();
	                that.onEndAnimation();
	                $('#animate_logo').html('');
	            });
	        }
	    }, {
	        key: 'initLastPointsTimer',
	        value: function initLastPointsTimer(callbackEndTimeLine) {
	            var _ref2;
	
	            var TimeLinePT = new _PointsTimer2.default({
	                PARAMS: PARAMS,
	                timeLine: function timeLine(o) {
	                    return [].concat(_toConsumableArray(o.bubble(2000, 1000, { x: 300, y: 200 })), _toConsumableArray(o.bubble(2000, 3000, { x: 400, y: 200 })), _toConsumableArray(o.bubble(2000, 5000, { x: 500, y: 200 })));
	                }
	            });
	            this.timelineLastPointsTimer = (_ref2 = new _moJs2.default.Timeline({
	                onPlaybackComplete: function onPlaybackComplete() {
	                    console.log('hide animation');
	                    callbackEndTimeLine();
	                }
	            })).add.apply(_ref2, _toConsumableArray(TimeLinePT));
	            window.timelineLastPointsTimer = this.timelineLastPointsTimer;
	        }
	    }]);
	
	    return Animation;
	}();
	
	if (false) {
	    var loaderAnimationLogo = {
	        scriptPath: "/static/js/animate_logo.js",
	        init: function init() {
	            this.addPlayButton();
	        },
	        addPlayButton: function addPlayButton() {
	            $('.intro__title').after('<div class="play_animation swing animated infinite">' + '<svg fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" fill="currentColor" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="glass" x="0px" y="0px" viewBox="0 0 18 18" enable-background="new 0 0 18 18" xml:space="preserve">' + '<path d="M8.73794928,0.348150316 C9.11206309,0.27529234 9.51838182,0.296610044 9.86109583,0.47605654 C10.2191072,0.665217432 10.5062677,0.969062175 10.7198937,1.31068513 C10.7491465,1.3573682 10.7802779,1.41268629 10.8403937,1.42132131 C11.9978922,1.69278473 13.1035944,2.21790185 14.0149936,2.98938685 C14.7361155,3.59491758 15.3281492,4.36073586 15.7033365,5.22882515 C15.9494358,5.79576814 16.1067031,6.40345762 16.1542054,7.02059166 C16.1778223,7.33469049 16.1759437,7.65013854 16.1759437,7.9650469 C16.1821163,9.17907665 16.1746018,10.3931064 16.1791642,11.6068663 C16.1716497,12.0920465 16.1839949,12.6039412 16.4147969,13.0421684 C16.4695452,13.0872324 16.5454952,13.0920896 16.6104417,13.117455 C16.9434943,13.2264721 17.2784254,13.4040297 17.4705815,13.7097634 C17.6031584,13.9437184 17.6587119,14.223547 17.6146985,14.4898834 C17.5159367,15.0257943 17.019981,15.4640215 16.4746443,15.4731962 C14.8845265,15.4972124 13.2941402,15.4702279 11.7040223,15.4904662 C11.3795578,16.3329203 10.6525317,17.0293886 9.76850669,17.2366291 C9.2373939,17.354551 8.66817196,17.3340429 8.15852911,17.1330088 C7.44572691,16.8615454 6.861476,16.2759832 6.58397695,15.5625147 C6.56867961,15.5352604 6.56545912,15.4807518 6.52037223,15.492625 C5.12294712,15.4729264 3.72552201,15.4907361 2.3280969,15.4812915 C2.13218364,15.4767042 1.93600201,15.4845297 1.7406255,15.4694184 C1.41401394,15.440545 1.09384337,15.2883528 0.887463517,15.0282229 C0.66122396,14.7581087 0.578564668,14.3781678 0.660418838,14.036275 C0.727780793,13.7456527 0.906786468,13.4755385 1.16630444,13.3249653 C1.37617316,13.2019163 1.6120742,13.1371536 1.83965562,13.0559305 C1.98350426,12.746419 2.06267469,12.4072247 2.07179941,12.0656017 C2.08468138,10.5010441 2.0667003,8.93648657 2.08468138,7.37192901 C2.09648985,6.29255159 2.44376623,5.22612671 3.03741024,4.32970376 C3.49445171,3.64456895 4.08702222,3.05307012 4.76171528,2.58489017 C5.57945185,2.01848687 6.51205263,1.63422851 7.47524808,1.40189252 C7.75838299,0.922648946 8.18134093,0.479834361 8.73794928,0.348150316 L8.73794928,0.348150316 Z M5.89264468,3.58736194 C5.14575894,4.04609734 4.4949512,4.68104111 4.0778975,5.46008176 C3.7663149,6.03565977 3.57952637,6.68382591 3.56932815,7.34089691 C3.54597958,8.8800891 3.57362214,10.4195511 3.55778805,11.9587433 C3.55215219,12.3659385 3.47781251,12.7677367 3.41984365,13.1698048 C3.35623894,13.4005217 3.23439699,13.6112702 3.09859958,13.8063676 C7.12662983,13.8063676 11.1543917,13.8060978 15.182422,13.8066375 C15.0345477,13.6269211 14.9113639,13.4215696 14.8448071,13.1973289 C14.6166889,12.1152531 14.7119618,11.0034943 14.6963961,9.90657703 C14.6859295,9.01663035 14.7124985,8.12614398 14.6786833,7.23646714 C14.6472836,6.34840937 14.2919559,5.48949479 13.7436672,4.79896309 C13.1089619,3.99995396 12.2337932,3.40926467 11.2794541,3.06656234 C9.5258963,2.43782499 7.48786167,2.60809678 5.89264468,3.58736194 L5.89264468,3.58736194 Z"></path>' + '</svg></div>');
	            this.events();
	        },
	        addLoaderButton: function addLoaderButton() {
	            $('.intro__title').after('<div class="play_loader">' + '<div class="loader"></div>' + '</div>');
	            this.events();
	        },
	        hidePlayButton: function hidePlayButton() {
	            $('.play_animation').animate({
	                opacity: 0
	            }, 700, function () {
	                $(this).hide();
	            });
	        },
	        events: function events() {
	            var that = this;
	            $('.play_animation').on('click', function () {
	                that.loadScript();
	                that.hidePlayButton();
	            });
	        },
	        showButton: function showButton() {
	            $('.play_animation').show().animate({
	                opacity: 1
	            }, 700);
	        },
	        loadScript: function loadScript() {
	            var that = this;
	            if (process.env.NODE_ENV === 'development') {
	                that.hideLoaderButton();
	
	                var anim = window.animateLogo({
	                    soundSrc: 'din-dong.mp3',
	                    onEndAnimation: function onEndAnimation() {
	                        that.showButton();
	                    }
	                });
	                anim.sound.on('load', function () {
	                    anim.start();
	                });
	                /*                $.getScript(this.scriptPath, function() {
	                 var anim = window.animateLogo({
	                 soundSrc:       '/din-dong.mp3',
	                 onEndAnimation: function () {
	                 that.showButton();
	                 }
	                 });
	                 anim.start();
	                 });*/
	            }
	        }
	    };
	    loaderAnimationLogo.init();
	}
	window.animateLogo = function (options) {
	    return new Animation(options);
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	exports.star = exports.moon = exports.horizontLine = exports.mountains = exports.U2 = exports.U1 = exports.S2 = exports.S = exports.elipceR2 = exports.elipceR = exports.elipceD = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moJs = __webpack_require__(5);
	
	var _moJs2 = _interopRequireDefault(_moJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by frimko on 24.01.2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var elipceD = function (_mojs$CustomShape) {
					_inherits(elipceD, _mojs$CustomShape);
	
					function elipceD() {
									_classCallCheck(this, elipceD);
	
									return _possibleConstructorReturn(this, (elipceD.__proto__ || Object.getPrototypeOf(elipceD)).apply(this, arguments));
					}
	
					_createClass(elipceD, [{
									key: 'getShape',
									value: function getShape() {
													return '<path d="M0,120.5h13.9c39.6,0,59.6-30.6,59.1-61C73,29.8,52.8-0.2,13.3,0L0.1,0"/>';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 300;
									}
					}]);
	
					return elipceD;
	}(_moJs2.default.CustomShape);
	
	var elipceR = function (_mojs$CustomShape2) {
					_inherits(elipceR, _mojs$CustomShape2);
	
					function elipceR() {
									_classCallCheck(this, elipceR);
	
									return _possibleConstructorReturn(this, (elipceR.__proto__ || Object.getPrototypeOf(elipceR)).apply(this, arguments));
					}
	
					_createClass(elipceR, [{
									key: 'getShape',
									value: function getShape() {
													return '<path d="M48.6,78.1C60.5,70,66.3,56.7,66.5,42.9C66.5,21.6,52.1,0.1,23,0.1C17.3,0,9.9,0,2.3,0 C1.5,0,0.6,0-0.3,0"/>';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 300;
									}
					}]);
	
					return elipceR;
	}(_moJs2.default.CustomShape);
	
	var elipceR2 = function (_mojs$CustomShape3) {
					_inherits(elipceR2, _mojs$CustomShape3);
	
					function elipceR2() {
									_classCallCheck(this, elipceR2);
	
									return _possibleConstructorReturn(this, (elipceR2.__proto__ || Object.getPrototypeOf(elipceR2)).apply(this, arguments));
					}
	
					_createClass(elipceR2, [{
									key: 'getShape',
									value: function getShape() {
													return '<path d="M0,83.1H18l2.8-0.1c5.1-0.5,9.2-0.3,14.2-1.2l13.6-3.7"/>';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 300;
									}
					}]);
	
					return elipceR2;
	}(_moJs2.default.CustomShape);
	
	var U1 = function (_mojs$CustomShape4) {
					_inherits(U1, _mojs$CustomShape4);
	
					function U1() {
									_classCallCheck(this, U1);
	
									return _possibleConstructorReturn(this, (U1.__proto__ || Object.getPrototypeOf(U1)).apply(this, arguments));
					}
	
					_createClass(U1, [{
									key: 'getShape',
									value: function getShape() {
													return '<path d="M35,100C16.8,100,0,88.3,0,66.1V0"/>';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 300;
									}
					}]);
	
					return U1;
	}(_moJs2.default.CustomShape);
	
	var U2 = function (_mojs$CustomShape5) {
					_inherits(U2, _mojs$CustomShape5);
	
					function U2() {
									_classCallCheck(this, U2);
	
									return _possibleConstructorReturn(this, (U2.__proto__ || Object.getPrototypeOf(U2)).apply(this, arguments));
					}
	
					_createClass(U2, [{
									key: 'getShape',
									value: function getShape() {
													return '<path d="M35,0C16.8,0,0,11.7,0,33.9V100"/>';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 300;
									}
					}]);
	
					return U2;
	}(_moJs2.default.CustomShape);
	
	var S = function (_mojs$CustomShape6) {
					_inherits(S, _mojs$CustomShape6);
	
					function S() {
									_classCallCheck(this, S);
	
									return _possibleConstructorReturn(this, (S.__proto__ || Object.getPrototypeOf(S)).apply(this, arguments));
					}
	
					_createClass(S, [{
									key: 'getShape',
									value: function getShape() {
													return '<path d="M64.3,22.5c-0.6-2.6-1.7-5-3.1-7.2c-1.4-2.2-3.3-4.1-5.6-5.7s-5-2.9-8.2-3.8s-6.8-1.4-10.8-1.4\n\t\t\tc-8.5,0-14.9,1.6-19.3,4.7c-4.3,3.3-6.5,7.6-6.5,13.1c0,2.5,0.4,4.7,1.2,6.6s2.2,3.5,4.1,5s4.5,2.8,7.7,3.9\n\t\t\tc3.2,1.1,7.1,2.2,11.9,3.2c2.8,0.6,5.6,1.2,8.6,1.8c2.9,0.6,5.8,1.4,8.6,2.3c2.8,0.9,5.5,2,8,3.2c2.5,1.3,4.8,2.9,6.6,4.7\n\t\t\tc1.9,1.9,3.4,4.1,4.5,6.7c1.1,2.6,1.7,5.7,1.7,9.2c0,4.1-0.9,7.8-2.6,11.2c-1.7,3.4-4.1,6.4-7.1,8.8c-3,2.5-6.6,4.4-10.8,5.8\n\t\t\ts-8.7,2.1-13.7,2.1c-0.9,0-1.7,0-2.6,0"/>';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 300;
									}
					}]);
	
					return S;
	}(_moJs2.default.CustomShape);
	
	var S2 = function (_mojs$CustomShape7) {
					_inherits(S2, _mojs$CustomShape7);
	
					function S2() {
									_classCallCheck(this, S2);
	
									return _possibleConstructorReturn(this, (S2.__proto__ || Object.getPrototypeOf(S2)).apply(this, arguments));
					}
	
					_createClass(S2, [{
									key: 'getShape',
									value: function getShape() {
													return '<path d="M36.9,96.7c-5.3-0.2-10.1-0.9-14.2-2.1c-4.8-1.4-8.8-3.3-12.1-5.9c-3.3-2.5-5.8-5.6-7.5-9.2s-2.2-7.7-3-12.1" />';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 200;
									}
					}]);
	
					return S2;
	}(_moJs2.default.CustomShape);
	
	var mountains = function (_mojs$CustomShape8) {
					_inherits(mountains, _mojs$CustomShape8);
	
					function mountains() {
									_classCallCheck(this, mountains);
	
									return _possibleConstructorReturn(this, (mountains.__proto__ || Object.getPrototypeOf(mountains)).apply(this, arguments));
					}
	
					_createClass(mountains, [{
									key: 'getShape',
									value: function getShape() {
													return '\n        <style type="text/css">\n\t.mountain0{fill:#1D1F20;}\n</style>\n<g>\n\t<g>\n\t\t<g id="mountains">\n\t\t\t<g>\n\t\t\t\t<path class="mountain0" d="M93.3,41.6l4.7,3.8v0c-0.1,0-0.2,0-0.3-0.1c-1.2-1-2.4-1.9-3.5-2.9C93.9,42.1,93.6,41.9,93.3,41.6z"/>\n\t\t\t\t<path class="mountain0" d="M88.7,33.5l-5.9-12.7L77.5,24l-1.9,2.2c1.2-1.6,2.1-3.7,3.6-4.8c1.2-0.9,2.6-1.8,3.7-2.9\n\t\t\t\t\tc0.5-0.5,1.2-0.4,1.5,0.2c0.4,0.7,0.7,1.5,0.8,2.3c1.3,6.6,4,12.7,7.6,18.4c1.4,2.3,3.5,4.1,5.1,6l-4.7-3.8\n\t\t\t\t\tc-0.3-0.3-0.6-0.5-0.8-0.8L88.7,33.5z"/>\n\t\t\t\t<path class="mountain0" d="M81.3,41.8l-6.3-14.5c0.3,0.5,0.7,1,1.1,1.4c0.2,0.3,0.5,0.5,0.6,0.8c2.4,4.4,6.2,7.7,9.6,11.2\n\t\t\t\t\tc1.3,1.4,3,2.4,4.4,3.5c0,0.1-0.1,0.1-0.1,0.2l-6.8,0.8L81.3,41.8z"/>\n\t\t\t\t<path class="mountain0" d="M82.7,20.8l5.9,12.7l3.9,7.3c-3.2-3.4-5.5-7.3-7.1-11.8C84.7,27,83.9,25,83,23c-0.2-0.5-0.5-0.9-0.6-1.2\n\t\t\t\t\tc-3.2,0.2-4.4,3-6.7,4.4l1.9-2.2L82.7,20.8z"/>\n\t\t\t\t<path class="mountain0" d="M98,45.4C98,45.4,98,45.4,98,45.4C98,45.4,98,45.4,98,45.4L98,45.4z"/>\n\t\t\t\t<path class="mountain0" d="M74.9,27.3l6.3,14.5l2.6,3.5l-11,1.4c-1.8-2-3.8-4.1-5.7-6.2c-2.6-3-4.2-6.5-5.8-10.1\n\t\t\t\t\tc-0.4-0.9-0.8-1.9-2.2-1.4c-0.2,0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.7-0.3-0.9-0.2c-0.8,0.5-1.2-0.1-1.4-0.6\n\t\t\t\t\tc-0.6-1.5-1.3-2.9-1.7-4.5c-0.5-1.7-1-2.4-2.8-2.4c-0.8,0-1.5-0.2-2-0.7c0,0,0,0,0,0l0.2-0.4c0.3-0.5,0.3-0.8,0.5-1\n\t\t\t\t\tc0.4-0.6,0.9-1.2,1.2-1.9c1-2.9,3.6-4.4,5.5-6.6c0.7-0.9,1.6-1.2,2.7,0c0.9,1,2.3,1.4,3.7,2.2c0,0,0.3-0.3,0.5-0.5\n\t\t\t\t\tc0.3-0.6,0.5-1.2,0.9-1.7c0.4-0.6,1-1,1.5-1.5c0.4,0.5,1.1,0.9,1.3,1.5c0.7,1.8,1.2,3.7,1.8,5.5c0.3,0.9,0.3,2.1,1.7,2.1\n\t\t\t\t\tc0.2,0,0.4,0.4,0.5,0.7c0.2,0.7,0.1,1.6,1.3,1.6c0.1,0,0.4,0.7,0.4,1.1C73.1,23.5,73.8,25.5,74.9,27.3z"/>\n\t\t\t\t<path class="mountain0" d="M98,46.7H84.4v-0.5l-0.6-0.8l6.8-0.8c0-0.1,0.1-0.1,0.1-0.2c-1.5-1.2-3.1-2.2-4.4-3.5\n\t\t\t\t\tc-3.4-3.5-7.2-6.8-9.6-11.2c-0.2-0.3-0.4-0.5-0.6-0.8c-0.4-0.5-0.8-0.9-1.1-1.4l0.7-1c2.3-1.4,3.5-4.2,6.7-4.4\n\t\t\t\t\tc0.2,0.3,0.5,0.8,0.6,1.2c0.8,2,1.7,3.9,2.4,5.9c1.6,4.5,3.9,8.4,7.1,11.8l0.1,0.3l0.7,0.5c0.3,0.3,0.5,0.5,0.8,0.8\n\t\t\t\t\tc1.1,1,2.3,2,3.5,2.9c0.1,0.1,0.3,0.1,0.3,0.1L98,46.7z"/>\n\t\t\t\t<path class="mountain0" d="M67.7,44.8l4.3,1.6c-0.4-0.1-1.8-0.3-3.6-0.6c-2.2-0.3-5.2-0.7-8-0.9c-2.6-0.2-3.7-0.1-8.6,0\n\t\t\t\t\tc-0.7,0-0.1,0-14.3,0c-4,0-28.2,0-37.2,0c-0.1-0.1-0.3-0.2-0.4-0.3c2.4-3.6,4.7-7.2,7.1-10.8c0.2-0.4,0.6-0.7,0.7-1.1\n\t\t\t\t\tc0.6-2.5,2.4-4.2,3.9-6.1c1.5-1.8,2.9-3.8,4.4-5.6c0.8-0.9,1.5-1.9,2.4-2.8c0.8-1,1.7-1.1,2.8-0.3c1.6,1.2,1.7,1.1,2.8-0.5\n\t\t\t\t\tc0.7-1,1.6-2,2.5-2.8c0.3-0.3,1.1-0.2,1.6-0.1c0.4,0.1,0.7,0.4,1.2,0.8c0.5-0.8,0.9-1.6,1.3-2.3c0.4-0.6,0.7-1,1.6-0.7\n\t\t\t\t\tc0.9,0.4,1.3-0.4,1.7-1c0.3-0.6,0.5-1.2,0.8-1.8c0.1-0.3,0.3-0.7,0.5-0.8c1.8-0.5,1.6-2.1,2.2-3.3c0.8-1.6,1.8-3.2,2.9-4.6\n\t\t\t\t\tc0.3-0.5,1.2-1,1.7-0.9c0.6,0.2,1.2,0.9,1.3,1.5C44,4,44.3,6.6,44.9,9c0.3,1.1,0.9,2,1.4,3c0.4,0.8,0.8,1.6,1,2.5\n\t\t\t\t\tc0.5,1.5,1,3,1.5,4.5c0.2,0.4,0.4,0.8,0.7,1.1c0,0,0,0,0,0L67.7,44.8z"/>\n\t\t\t\t<path class="mountain0" d="M58.4,28.6c0.3,0.1,0.6,0.4,0.8,0.3c1.4-0.5,1.8,0.5,2.2,1.4c1.5,3.6,3.2,7.1,5.8,10.1\n\t\t\t\t\tc1.8,2.2,3.8,4.2,5.7,6.2c-0.4-0.1-0.6-0.2-0.6-0.2s0,0-0.1,0c0,0,0,0,0,0l-4.3-1.6L49.5,20.2c0.5,0.5,1.2,0.7,2,0.7\n\t\t\t\t\tc1.8,0,2.4,0.7,2.8,2.4c0.4,1.5,1.1,3,1.7,4.5c0.2,0.5,0.6,1.1,1.4,0.6C57.7,28.2,58.1,28.5,58.4,28.6z"/>\n\t\t\t</g>\n\t\t\t<g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n\t<polyline class="mountain0" points="0,44.7 0,46.7 98,46.7 91.5,38.8 \t"/>\n</g>\n<g>\n\t<g>\n\t\t<g id="XMLID_1_">\n\t\t\t<g>\n\t\t\t\t<path d="M92.9,39.4c1.4,2.3,3.5,4.1,5.1,6c0,0,0,0,0,0c0,0-0.2,0-0.4-0.1c-1.2-1-2.4-1.9-3.5-2.9c-4.1-3.7-6.9-8.2-8.8-13.4\n\t\t\t\t\tC84.7,27,83.9,25,83,23c-0.2-0.5-0.5-0.9-0.6-1.2c-3.2,0.2-4.4,3-6.7,4.4c1.2-1.6,2.1-3.7,3.6-4.8c1.2-0.9,2.6-1.8,3.7-2.9\n\t\t\t\t\tc0.5-0.5,1.2-0.4,1.5,0.2c0.4,0.7,0.7,1.5,0.8,2.3C86.6,27.7,89.3,33.8,92.9,39.4z"/>\n\t\t\t\t<path d="M64.6,14.4c-0.3,0.6-0.6,1.2-1,1.8c-0.2,0.3-0.7,0.7-0.9,0.6c-0.3-0.1-0.6-0.5-0.8-0.9c-0.2-0.5-0.3-1.2-0.5-1.7\n\t\t\t\t\tc-0.3-0.7-0.5-1.3-1.6-1.1c-0.3,0.1-0.9-0.8-1.4-1.2c-4.1,1.1-5.4,5.4-8.8,7.9c0.3-0.5,0.3-0.8,0.5-1c0.4-0.6,0.9-1.2,1.2-1.9\n\t\t\t\t\tc1-2.9,3.6-4.4,5.5-6.6c0.7-0.9,1.6-1.2,2.7,0c0.9,1,2.3,1.4,3.7,2.2c0,0,0.3-0.3,0.5-0.5c0.3-0.6,0.5-1.2,0.9-1.7\n\t\t\t\t\tc0.4-0.6,1-1,1.5-1.5c0.4,0.5,1.1,0.9,1.3,1.5c0.7,1.8,1.2,3.7,1.8,5.5c0.3,0.9,0.3,2.1,1.7,2.1c0.2,0,0.4,0.4,0.5,0.7\n\t\t\t\t\tc0.2,0.7,0.1,1.6,1.3,1.6c0.1,0,0.4,0.7,0.4,1.1c0,2.9,1.2,5.3,3,7.4c0.2,0.3,0.5,0.5,0.6,0.8c2.4,4.4,6.2,7.7,9.6,11.2\n\t\t\t\t\tc1.3,1.4,3,2.4,4.4,3.5c0,0.1-0.1,0.1-0.1,0.2c-0.7-0.4-1.5-0.7-2.2-1.2c-2.2-1.5-4.6-2.9-6.5-4.7c-3.5-3.4-6.8-6.9-9.8-10.6\n\t\t\t\t\tc-3.2-3.9-5.7-8.3-7.1-13.2C64.9,14.7,64.8,14.6,64.6,14.4z"/>\n\t\t\t\t<path d="M18.7,27.2c-0.5,0.7-1.7,1-1.2,2.3c0,0.1-0.1,0.3-0.2,0.4c-1.5,1.5-3,3-4.5,4.4c-0.7,0.7-1.3,1.4-1.9,2.1\n\t\t\t\t\tc1.2-3.3,9.1-13.1,10.8-13.1C20.6,24.8,19.7,26,18.7,27.2z"/>\n\t\t\t\t<path d="M33.5,14.7c-0.4-0.1-1,0.4-1.3,0.8c-0.4,0.5-0.5,1.2-0.8,1.8c-0.6,1.2-1,1.2-2,0.3c-0.2-0.2-0.7-0.4-0.9-0.2\n\t\t\t\t\tc-1.2,0.9-2.5,1.8-3.5,2.9c-1.4,1.6-1.6,1.7-3.4,0.6c-1-0.6-1.7-0.2-2.3,0.4c-2.1,2.1-4.4,4.1-6.2,6.5c-4,5.2-7.8,10.6-11.7,16\n\t\t\t\t\tc-0.3,0.4-0.6,0.8-0.9,1.1c-0.1-0.1-0.3-0.2-0.4-0.3c2.4-3.6,4.7-7.2,7.1-10.8c0.2-0.4,0.6-0.7,0.7-1.1c0.6-2.5,2.4-4.2,3.9-6.1\n\t\t\t\t\tc1.5-1.8,2.9-3.8,4.4-5.6c0.8-0.9,1.5-1.9,2.4-2.8c0.8-1,1.7-1.1,2.8-0.3c1.6,1.2,1.7,1.1,2.8-0.5c0.7-1,1.6-2,2.5-2.8\n\t\t\t\t\tc0.3-0.3,1.1-0.2,1.6-0.1c0.4,0.1,0.7,0.4,1.2,0.8c0.5-0.8,0.9-1.6,1.3-2.3c0.4-0.6,0.7-1,1.6-0.7c0.9,0.4,1.3-0.4,1.7-1\n\t\t\t\t\tc0.3-0.6,0.5-1.2,0.8-1.8c0.1-0.3,0.3-0.7,0.5-0.8c1.8-0.5,1.6-2.1,2.2-3.3c0.8-1.6,1.8-3.2,2.9-4.6c0.3-0.5,1.2-1,1.7-0.9\n\t\t\t\t\tc0.6,0.2,1.2,0.9,1.3,1.5C44,4,44.3,6.6,44.9,9c0.3,1.1,0.9,2,1.4,3c0.4,0.8,0.8,1.6,1,2.5c0.5,1.5,1,3,1.5,4.5\n\t\t\t\t\tc0.5,1.2,1.4,1.8,2.7,1.8c1.8,0,2.4,0.7,2.8,2.4c0.4,1.5,1.1,3,1.7,4.5c0.2,0.5,0.6,1.1,1.4,0.6c0.2-0.1,0.6,0.1,0.9,0.2\n\t\t\t\t\tc0.3,0.1,0.6,0.4,0.8,0.3c1.4-0.5,1.8,0.5,2.2,1.4c1.5,3.6,3.2,7.1,5.8,10.1c1.8,2.2,3.8,4.2,5.7,6.2c-0.1,0-0.3-0.1-0.6-0.2\n\t\t\t\t\tc-4.8-3.1-9.1-6.8-11.8-12c-0.1-0.1-0.1-0.2-0.2-0.3c-1.2-2-1.7-2-2.9,0c-0.6,1-1.1,2.3-2.5,2.2c-1.4-0.2-1.6-1.6-2-2.7\n\t\t\t\t\tc-0.6-2.2-1.1-4.4-1.7-6.5c-0.6-1.9-1.2-2.2-3.1-1.5c-1.8,0.6-3.3,0-3.9-1.9c-0.7-2.3-1.1-4.6-1.6-7c-0.6-2.5-1.1-5.1-1.7-7.6\n\t\t\t\t\tc-0.1-0.4-0.5-0.8-0.8-1.2c-0.4,0.3-0.8,0.6-1.1,1c-1,1.5-1.9,3-2.9,4.5C35.5,14.2,34.8,14.9,33.5,14.7z"/>\n\t\t\t</g>\n\t\t\t<g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 4929;
									}
					}]);
	
					return mountains;
	}(_moJs2.default.CustomShape);
	
	var horizontLine = function (_mojs$CustomShape9) {
					_inherits(horizontLine, _mojs$CustomShape9);
	
					function horizontLine() {
									_classCallCheck(this, horizontLine);
	
									return _possibleConstructorReturn(this, (horizontLine.__proto__ || Object.getPrototypeOf(horizontLine)).apply(this, arguments));
					}
	
					_createClass(horizontLine, [{
									key: 'getShape',
									value: function getShape() {
													return '<path d="M0.2,4.6c3.2-1.3,6.1-2,8.1-2.5c2.9-0.6,8.2-1.7,14.7-0.8c1.9,0.3,2.3,0.5,4.8,1c15.4,3.2,28.8,1.1,33.4-0.3\n\tc0.2-0.1,0.6-0.2,1.2-0.3c4.7-1.1,8.8,0.4,9.6,0.7c3,1,10.2,1.1,28.1-1.9"/>';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 360;
									}
					}]);
	
					return horizontLine;
	}(_moJs2.default.CustomShape);
	
	var moon = function (_mojs$CustomShape10) {
					_inherits(moon, _mojs$CustomShape10);
	
					function moon() {
									_classCallCheck(this, moon);
	
									return _possibleConstructorReturn(this, (moon.__proto__ || Object.getPrototypeOf(moon)).apply(this, arguments));
					}
	
					_createClass(moon, [{
									key: 'getShape',
									value: function getShape() {
													return '\n<style type="text/css">\n\t#areal .mountain0{fill:url(#SVGID_1_);}\n\t#moon.st1{fill:url(#moon_1_);}\n</style>\n<g id="areal">\n\t<radialGradient class="st0" id="SVGID_1_" cx="50.5" cy="49.8078" r="49.6551" gradientUnits="userSpaceOnUse">\n\t\t<stop  offset="0" style="stop-color:#FFFFFF"/>\n\t\t<stop  offset="1" style="stop-color:#000000;stop-opacity:0"/>\n\t</radialGradient>\n\t<rect x="0.5" y="0.5" class="mountain0" width="100" height="98.6"/>\n</g>\n<radialGradient id="moon_1_" cx="-138.8185" cy="680.7072" r="27.9801" gradientTransform="matrix(0.6995 0 0 -0.7135 145.1914 532.9861)" gradientUnits="userSpaceOnUse">\n\t<stop  offset="0" style="stop-color:#EBEAE5"/>\n\t<stop  offset="1" style="stop-color:#C0BDAD"/>\n</radialGradient>\n<path id="moon" class="st1" d="M67.7,50.4c0,9.2-7.4,16.6-16.6,16.6c-9.2,0-16.6-7.4-16.6-16.6c0,0,0,0,0,0\n\tc0-9.2,7.4-16.6,16.6-16.6S67.7,41.2,67.7,50.4C67.7,50.4,67.7,50.4,67.7,50.4z"/>\n';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 360;
									}
					}]);
	
					return moon;
	}(_moJs2.default.CustomShape);
	
	var star = function (_mojs$CustomShape11) {
					_inherits(star, _mojs$CustomShape11);
	
					function star() {
									_classCallCheck(this, star);
	
									return _possibleConstructorReturn(this, (star.__proto__ || Object.getPrototypeOf(star)).apply(this, arguments));
					}
	
					_createClass(star, [{
									key: 'getShape',
									value: function getShape() {
													return '\n    <g>\n\t\t<line class="st0" x1="50" y1="10" x2="50" y2="90"/>\n<line class="st1" x1="10" y1="50" x2="90" y2="50"/>\n<line class="st1" x1="28.8" y1="71.2" x2="71.2" y2="28.8"/>\n<line class="st1" x1="28.8" y1="28.8" x2="71.2" y2="71.2"/>\n\t</g>\n';
									}
					}, {
									key: 'getLength',
									value: function getLength() {
													return 360;
									}
					}]);
	
					return star;
	}(_moJs2.default.CustomShape);
	
	exports.elipceD = elipceD;
	exports.elipceR = elipceR;
	exports.elipceR2 = elipceR2;
	exports.S = S;
	exports.S2 = S2;
	exports.U1 = U1;
	exports.U2 = U2;
	exports.mountains = mountains;
	exports.horizontLine = horizontLine;
	exports.moon = moon;
	exports.star = star;

/***/ },
/* 102 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 103 */
102,
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 *  howler.js v2.0.2
	 *  howlerjs.com
	 *
	 *  (c) 2013-2016, James Simpson of GoldFire Studios
	 *  goldfirestudios.com
	 *
	 *  MIT License
	 */
	
	(function() {
	
	  'use strict';
	
	  /** Global Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create the global controller. All contained methods and properties apply
	   * to all sounds that are currently playing or will be in the future.
	   */
	  var HowlerGlobal = function() {
	    this.init();
	  };
	  HowlerGlobal.prototype = {
	    /**
	     * Initialize the global Howler object.
	     * @return {Howler}
	     */
	    init: function() {
	      var self = this || Howler;
	
	      // Internal properties.
	      self._codecs = {};
	      self._howls = [];
	      self._muted = false;
	      self._volume = 1;
	      self._canPlayEvent = 'canplaythrough';
	      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;
	
	      // Public properties.
	      self.masterGain = null;
	      self.noAudio = false;
	      self.usingWebAudio = true;
	      self.autoSuspend = true;
	      self.ctx = null;
	
	      // Set to false to disable the auto iOS enabler.
	      self.mobileAutoEnable = true;
	
	      // Setup the various state values for global tracking.
	      self._setup();
	
	      return self;
	    },
	
	    /**
	     * Get/set the global volume for all sounds.
	     * @param  {Float} vol Volume from 0.0 to 1.0.
	     * @return {Howler/Float}     Returns self or current volume.
	     */
	    volume: function(vol) {
	      var self = this || Howler;
	      vol = parseFloat(vol);
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!self.ctx) {
	        setupAudioContext();
	      }
	
	      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
	        self._volume = vol;
	
	        // Don't update any of the nodes if we are muted.
	        if (self._muted) {
	          return self;
	        }
	
	        // When using Web Audio, we just need to adjust the master gain.
	        if (self.usingWebAudio) {
	          self.masterGain.gain.value = vol;
	        }
	
	        // Loop through and change volume for all HTML5 audio nodes.
	        for (var i=0; i<self._howls.length; i++) {
	          if (!self._howls[i]._webAudio) {
	            // Get all of the sounds in this Howl group.
	            var ids = self._howls[i]._getSoundIds();
	
	            // Loop through all sounds and change the volumes.
	            for (var j=0; j<ids.length; j++) {
	              var sound = self._howls[i]._soundById(ids[j]);
	
	              if (sound && sound._node) {
	                sound._node.volume = sound._volume * vol;
	              }
	            }
	          }
	        }
	
	        return self;
	      }
	
	      return self._volume;
	    },
	
	    /**
	     * Handle muting and unmuting globally.
	     * @param  {Boolean} muted Is muted or not.
	     */
	    mute: function(muted) {
	      var self = this || Howler;
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!self.ctx) {
	        setupAudioContext();
	      }
	
	      self._muted = muted;
	
	      // With Web Audio, we just need to mute the master gain.
	      if (self.usingWebAudio) {
	        self.masterGain.gain.value = muted ? 0 : self._volume;
	      }
	
	      // Loop through and mute all HTML5 Audio nodes.
	      for (var i=0; i<self._howls.length; i++) {
	        if (!self._howls[i]._webAudio) {
	          // Get all of the sounds in this Howl group.
	          var ids = self._howls[i]._getSoundIds();
	
	          // Loop through all sounds and mark the audio node as muted.
	          for (var j=0; j<ids.length; j++) {
	            var sound = self._howls[i]._soundById(ids[j]);
	
	            if (sound && sound._node) {
	              sound._node.muted = (muted) ? true : sound._muted;
	            }
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Unload and destroy all currently loaded Howl objects.
	     * @return {Howler}
	     */
	    unload: function() {
	      var self = this || Howler;
	
	      for (var i=self._howls.length-1; i>=0; i--) {
	        self._howls[i].unload();
	      }
	
	      // Create a new AudioContext to make sure it is fully reset.
	      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
	        self.ctx.close();
	        self.ctx = null;
	        setupAudioContext();
	      }
	
	      return self;
	    },
	
	    /**
	     * Check for codec support of specific extension.
	     * @param  {String} ext Audio file extention.
	     * @return {Boolean}
	     */
	    codecs: function(ext) {
	      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
	    },
	
	    /**
	     * Setup various state values for global tracking.
	     * @return {Howler}
	     */
	    _setup: function() {
	      var self = this || Howler;
	
	      // Keeps track of the suspend/resume state of the AudioContext.
	      self.state = self.ctx ? self.ctx.state || 'running' : 'running';
	
	      // Automatically begin the 30-second suspend process
	      self._autoSuspend();
	
	      // Check if audio is available.
	      if (!self.usingWebAudio) {
	        // No audio is available on this system if noAudio is set to true.
	        if (typeof Audio !== 'undefined') {
	          try {
	            var test = new Audio();
	
	            // Check if the canplaythrough event is available.
	            if (typeof test.oncanplaythrough === 'undefined') {
	              self._canPlayEvent = 'canplay';
	            }
	          } catch(e) {
	            self.noAudio = true;
	          }
	        } else {
	          self.noAudio = true;
	        }
	      }
	
	      // Test to make sure audio isn't disabled in Internet Explorer.
	      try {
	        var test = new Audio();
	        if (test.muted) {
	          self.noAudio = true;
	        }
	      } catch (e) {}
	
	      // Check for supported codecs.
	      if (!self.noAudio) {
	        self._setupCodecs();
	      }
	
	      return self;
	    },
	
	    /**
	     * Check for browser support for various codecs and cache the results.
	     * @return {Howler}
	     */
	    _setupCodecs: function() {
	      var self = this || Howler;
	      var audioTest = null;
	
	      // Must wrap in a try/catch because IE11 in server mode throws an error.
	      try {
	        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
	      } catch (err) {
	        return self;
	      }
	
	      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
	        return self;
	      }
	
	      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');
	
	      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
	      var checkOpera = self._navigator && self._navigator.userAgent.match(/OPR\/([0-6].)/g);
	      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);
	
	      self._codecs = {
	        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
	        mpeg: !!mpegTest,
	        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
	        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
	        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
	        wav: !!audioTest.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ''),
	        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
	        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
	        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
	        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
	        weba: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
	        webm: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
	        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
	        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
	      };
	
	      return self;
	    },
	
	    /**
	     * Mobile browsers will only allow audio to be played after a user interaction.
	     * Attempt to automatically unlock audio on the first user interaction.
	     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
	     * @return {Howler}
	     */
	    _enableMobileAudio: function() {
	      var self = this || Howler;
	
	      // Only run this on mobile devices if audio isn't already eanbled.
	      var isMobile = /iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(self._navigator && self._navigator.userAgent);
	      var isTouch = !!(('ontouchend' in window) || (self._navigator && self._navigator.maxTouchPoints > 0) || (self._navigator && self._navigator.msMaxTouchPoints > 0));
	      if (self._mobileEnabled || !self.ctx || (!isMobile && !isTouch)) {
	        return;
	      }
	
	      self._mobileEnabled = false;
	
	      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
	      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
	      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
	      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
	        self._mobileUnloaded = true;
	        self.unload();
	      }
	
	      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
	      // http://stackoverflow.com/questions/24119684
	      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
	
	      // Call this method on touch start to create and play a buffer,
	      // then check if the audio actually played to determine if
	      // audio has now been unlocked on iOS, Android, etc.
	      var unlock = function() {
	        // Create an empty buffer.
	        var source = self.ctx.createBufferSource();
	        source.buffer = self._scratchBuffer;
	        source.connect(self.ctx.destination);
	
	        // Play the empty buffer.
	        if (typeof source.start === 'undefined') {
	          source.noteOn(0);
	        } else {
	          source.start(0);
	        }
	
	        // Setup a timeout to check that we are unlocked on the next event loop.
	        source.onended = function() {
	          source.disconnect(0);
	
	          // Update the unlocked state and prevent this check from happening again.
	          self._mobileEnabled = true;
	          self.mobileAutoEnable = false;
	
	          // Remove the touch start listener.
	          document.removeEventListener('touchend', unlock, true);
	        };
	      };
	
	      // Setup a touch start listener to attempt an unlock in.
	      document.addEventListener('touchend', unlock, true);
	
	      return self;
	    },
	
	    /**
	     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
	     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
	     * @return {Howler}
	     */
	    _autoSuspend: function() {
	      var self = this;
	
	      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
	        return;
	      }
	
	      // Check if any sounds are playing.
	      for (var i=0; i<self._howls.length; i++) {
	        if (self._howls[i]._webAudio) {
	          for (var j=0; j<self._howls[i]._sounds.length; j++) {
	            if (!self._howls[i]._sounds[j]._paused) {
	              return self;
	            }
	          }
	        }
	      }
	
	      if (self._suspendTimer) {
	        clearTimeout(self._suspendTimer);
	      }
	
	      // If no sound has played after 30 seconds, suspend the context.
	      self._suspendTimer = setTimeout(function() {
	        if (!self.autoSuspend) {
	          return;
	        }
	
	        self._suspendTimer = null;
	        self.state = 'suspending';
	        self.ctx.suspend().then(function() {
	          self.state = 'suspended';
	
	          if (self._resumeAfterSuspend) {
	            delete self._resumeAfterSuspend;
	            self._autoResume();
	          }
	        });
	      }, 30000);
	
	      return self;
	    },
	
	    /**
	     * Automatically resume the Web Audio AudioContext when a new sound is played.
	     * @return {Howler}
	     */
	    _autoResume: function() {
	      var self = this;
	
	      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
	        return;
	      }
	
	      if (self.state === 'running' && self._suspendTimer) {
	        clearTimeout(self._suspendTimer);
	        self._suspendTimer = null;
	      } else if (self.state === 'suspended') {
	        self.state = 'resuming';
	        self.ctx.resume().then(function() {
	          self.state = 'running';
	
	          // Emit to all Howls that the audio has resumed.
	          for (var i=0; i<self._howls.length; i++) {
	            self._howls[i]._emit('resume');
	          }
	        });
	
	        if (self._suspendTimer) {
	          clearTimeout(self._suspendTimer);
	          self._suspendTimer = null;
	        }
	      } else if (self.state === 'suspending') {
	        self._resumeAfterSuspend = true;
	      }
	
	      return self;
	    }
	  };
	
	  // Setup the global audio controller.
	  var Howler = new HowlerGlobal();
	
	  /** Group Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create an audio group controller.
	   * @param {Object} o Passed in properties for this group.
	   */
	  var Howl = function(o) {
	    var self = this;
	
	    // Throw an error if no source is provided.
	    if (!o.src || o.src.length === 0) {
	      console.error('An array of source files must be passed with any new Howl.');
	      return;
	    }
	
	    self.init(o);
	  };
	  Howl.prototype = {
	    /**
	     * Initialize a new Howl group object.
	     * @param  {Object} o Passed in properties for this group.
	     * @return {Howl}
	     */
	    init: function(o) {
	      var self = this;
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!Howler.ctx) {
	        setupAudioContext();
	      }
	
	      // Setup user-defined default properties.
	      self._autoplay = o.autoplay || false;
	      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
	      self._html5 = o.html5 || false;
	      self._muted = o.mute || false;
	      self._loop = o.loop || false;
	      self._pool = o.pool || 5;
	      self._preload = (typeof o.preload === 'boolean') ? o.preload : true;
	      self._rate = o.rate || 1;
	      self._sprite = o.sprite || {};
	      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
	      self._volume = o.volume !== undefined ? o.volume : 1;
	
	      // Setup all other default properties.
	      self._duration = 0;
	      self._state = 'unloaded';
	      self._sounds = [];
	      self._endTimers = {};
	      self._queue = [];
	
	      // Setup event listeners.
	      self._onend = o.onend ? [{fn: o.onend}] : [];
	      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
	      self._onload = o.onload ? [{fn: o.onload}] : [];
	      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
	      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
	      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
	      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
	      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
	      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
	      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
	      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
	      self._onresume = [];
	
	      // Web Audio or HTML5 Audio?
	      self._webAudio = Howler.usingWebAudio && !self._html5;
	
	      // Automatically try to enable audio on iOS.
	      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.mobileAutoEnable) {
	        Howler._enableMobileAudio();
	      }
	
	      // Keep track of this Howl group in the global controller.
	      Howler._howls.push(self);
	
	      // If they selected autoplay, add a play event to the load queue.
	      if (self._autoplay) {
	        self._queue.push({
	          event: 'play',
	          action: function() {
	            self.play();
	          }
	        });
	      }
	
	      // Load the source file unless otherwise specified.
	      if (self._preload) {
	        self.load();
	      }
	
	      return self;
	    },
	
	    /**
	     * Load the audio file.
	     * @return {Howler}
	     */
	    load: function() {
	      var self = this;
	      var url = null;
	
	      // If no audio is available, quit immediately.
	      if (Howler.noAudio) {
	        self._emit('loaderror', null, 'No audio support.');
	        return;
	      }
	
	      // Make sure our source is in an array.
	      if (typeof self._src === 'string') {
	        self._src = [self._src];
	      }
	
	      // Loop through the sources and pick the first one that is compatible.
	      for (var i=0; i<self._src.length; i++) {
	        var ext, str;
	
	        if (self._format && self._format[i]) {
	          // If an extension was specified, use that instead.
	          ext = self._format[i];
	        } else {
	          // Make sure the source is a string.
	          str = self._src[i];
	          if (typeof str !== 'string') {
	            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
	            continue;
	          }
	
	          // Extract the file extension from the URL or base64 data URI.
	          ext = /^data:audio\/([^;,]+);/i.exec(str);
	          if (!ext) {
	            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
	          }
	
	          if (ext) {
	            ext = ext[1].toLowerCase();
	          }
	        }
	
	        // Check if this extension is available.
	        if (Howler.codecs(ext)) {
	          url = self._src[i];
	          break;
	        }
	      }
	
	      if (!url) {
	        self._emit('loaderror', null, 'No codec support for selected audio sources.');
	        return;
	      }
	
	      self._src = url;
	      self._state = 'loading';
	
	      // If the hosting page is HTTPS and the source isn't,
	      // drop down to HTML5 Audio to avoid Mixed Content errors.
	      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
	        self._html5 = true;
	        self._webAudio = false;
	      }
	
	      // Create a new sound object and add it to the pool.
	      new Sound(self);
	
	      // Load and decode the audio data for playback.
	      if (self._webAudio) {
	        loadBuffer(self);
	      }
	
	      return self;
	    },
	
	    /**
	     * Play a sound or resume previous playback.
	     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
	     * @param  {Boolean} internal Internal Use: true prevents event firing.
	     * @return {Number}          Sound ID.
	     */
	    play: function(sprite, internal) {
	      var self = this;
	      var id = null;
	
	      // Determine if a sprite, sound id or nothing was passed
	      if (typeof sprite === 'number') {
	        id = sprite;
	        sprite = null;
	      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
	        // If the passed sprite doesn't exist, do nothing.
	        return null;
	      } else if (typeof sprite === 'undefined') {
	        // Use the default sound sprite (plays the full audio length).
	        sprite = '__default';
	
	        // Check if there is a single paused sound that isn't ended.
	        // If there is, play that sound. If not, continue as usual.
	        var num = 0;
	        for (var i=0; i<self._sounds.length; i++) {
	          if (self._sounds[i]._paused && !self._sounds[i]._ended) {
	            num++;
	            id = self._sounds[i]._id;
	          }
	        }
	
	        if (num === 1) {
	          sprite = null;
	        } else {
	          id = null;
	        }
	      }
	
	      // Get the selected node, or get one from the pool.
	      var sound = id ? self._soundById(id) : self._inactiveSound();
	
	      // If the sound doesn't exist, do nothing.
	      if (!sound) {
	        return null;
	      }
	
	      // Select the sprite definition.
	      if (id && !sprite) {
	        sprite = sound._sprite || '__default';
	      }
	
	      // If we have no sprite and the sound hasn't loaded, we must wait
	      // for the sound to load to get our audio's duration.
	      if (self._state !== 'loaded' && !self._sprite[sprite]) {
	        self._queue.push({
	          event: 'play',
	          action: function() {
	            self.play(self._soundById(sound._id) ? sound._id : undefined);
	          }
	        });
	
	        return sound._id;
	      }
	
	      // Don't play the sound if an id was passed and it is already playing.
	      if (id && !sound._paused) {
	        // Trigger the play event, in order to keep iterating through queue.
	        if (!internal) {
	          setTimeout(function() {
	            self._emit('play', sound._id);
	          }, 0);
	        }
	
	        return sound._id;
	      }
	
	      // Make sure the AudioContext isn't suspended, and resume it if it is.
	      if (self._webAudio) {
	        Howler._autoResume();
	      }
	
	      // Determine how long to play for and where to start playing.
	      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
	      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
	      var timeout = (duration * 1000) / Math.abs(sound._rate);
	
	      // Update the parameters of the sound
	      sound._paused = false;
	      sound._ended = false;
	      sound._sprite = sprite;
	      sound._seek = seek;
	      sound._start = self._sprite[sprite][0] / 1000;
	      sound._stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
	      sound._loop = !!(sound._loop || self._sprite[sprite][2]);
	
	      // Begin the actual playback.
	      var node = sound._node;
	      if (self._webAudio) {
	        // Fire this when the sound is ready to play to begin Web Audio playback.
	        var playWebAudio = function() {
	          self._refreshBuffer(sound);
	
	          // Setup the playback params.
	          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
	          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
	          sound._playStart = Howler.ctx.currentTime;
	
	          // Play the sound using the supported method.
	          if (typeof node.bufferSource.start === 'undefined') {
	            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
	          } else {
	            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
	          }
	
	          // Start a new timer if none is present.
	          if (timeout !== Infinity) {
	            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	          }
	
	          if (!internal) {
	            setTimeout(function() {
	              self._emit('play', sound._id);
	            }, 0);
	          }
	        };
	
	        var isRunning = (Howler.state === 'running');
	        if (self._state === 'loaded' && isRunning) {
	          playWebAudio();
	        } else {
	          // Wait for the audio to load and then begin playback.
	          self.once(isRunning ? 'load' : 'resume', playWebAudio, isRunning ? sound._id : null);
	
	          // Cancel the end timer.
	          self._clearTimer(sound._id);
	        }
	      } else {
	        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
	        var playHtml5 = function() {
	          node.currentTime = seek;
	          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
	          node.volume = sound._volume * Howler.volume();
	          node.playbackRate = sound._rate;
	
	          setTimeout(function() {
	            node.play();
	
	            // Setup the new end timer.
	            if (timeout !== Infinity) {
	              self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	            }
	
	            if (!internal) {
	              self._emit('play', sound._id);
	            }
	          }, 0);
	        };
	
	        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
	        var loadedNoReadyState = (self._state === 'loaded' && (window && window.ejecta || !node.readyState && Howler._navigator.isCocoonJS));
	        if (node.readyState === 4 || loadedNoReadyState) {
	          playHtml5();
	        } else {
	          var listener = function() {
	            // Begin playback.
	            playHtml5();
	
	            // Clear this listener.
	            node.removeEventListener(Howler._canPlayEvent, listener, false);
	          };
	          node.addEventListener(Howler._canPlayEvent, listener, false);
	
	          // Cancel the end timer.
	          self._clearTimer(sound._id);
	        }
	      }
	
	      return sound._id;
	    },
	
	    /**
	     * Pause playback and save current position.
	     * @param  {Number} id The sound ID (empty to pause all in group).
	     * @return {Howl}
	     */
	    pause: function(id) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to pause when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'pause',
	          action: function() {
	            self.pause(id);
	          }
	        });
	
	        return self;
	      }
	
	      // If no id is passed, get all ID's to be paused.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Clear the end timer.
	        self._clearTimer(ids[i]);
	
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound && !sound._paused) {
	          // Reset the seek position.
	          sound._seek = self.seek(ids[i]);
	          sound._rateSeek = 0;
	          sound._paused = true;
	
	          // Stop currently running fades.
	          self._stopFade(ids[i]);
	
	          if (sound._node) {
	            if (self._webAudio) {
	              // make sure the sound has been created
	              if (!sound._node.bufferSource) {
	                return self;
	              }
	
	              if (typeof sound._node.bufferSource.stop === 'undefined') {
	                sound._node.bufferSource.noteOff(0);
	              } else {
	                sound._node.bufferSource.stop(0);
	              }
	
	              // Clean up the buffer source.
	              self._cleanBuffer(sound._node);
	            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
	              sound._node.pause();
	            }
	          }
	        }
	
	        // Fire the pause event, unless `true` is passed as the 2nd argument.
	        if (!arguments[1]) {
	          self._emit('pause', sound ? sound._id : null);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Stop playback and reset to start.
	     * @param  {Number} id The sound ID (empty to stop all in group).
	     * @param  {Boolean} internal Internal Use: true prevents event firing.
	     * @return {Howl}
	     */
	    stop: function(id, internal) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to stop when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'stop',
	          action: function() {
	            self.stop(id);
	          }
	        });
	
	        return self;
	      }
	
	      // If no id is passed, get all ID's to be stopped.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Clear the end timer.
	        self._clearTimer(ids[i]);
	
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound) {
	          // Reset the seek position.
	          sound._seek = sound._start || 0;
	          sound._rateSeek = 0;
	          sound._paused = true;
	          sound._ended = true;
	
	          // Stop currently running fades.
	          self._stopFade(ids[i]);
	
	          if (sound._node) {
	            if (self._webAudio) {
	              // make sure the sound has been created
	              if (!sound._node.bufferSource) {
	                if (!internal) {
	                  self._emit('stop', sound._id);
	                }
	
	                return self;
	              }
	
	              if (typeof sound._node.bufferSource.stop === 'undefined') {
	                sound._node.bufferSource.noteOff(0);
	              } else {
	                sound._node.bufferSource.stop(0);
	              }
	
	              // Clean up the buffer source.
	              self._cleanBuffer(sound._node);
	            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
	              sound._node.currentTime = sound._start || 0;
	              sound._node.pause();
	            }
	          }
	        }
	
	        if (sound && !internal) {
	          self._emit('stop', sound._id);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Mute/unmute a single sound or all sounds in this Howl group.
	     * @param  {Boolean} muted Set to true to mute and false to unmute.
	     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
	     * @return {Howl}
	     */
	    mute: function(muted, id) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to mute when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'mute',
	          action: function() {
	            self.mute(muted, id);
	          }
	        });
	
	        return self;
	      }
	
	      // If applying mute/unmute to all sounds, update the group's value.
	      if (typeof id === 'undefined') {
	        if (typeof muted === 'boolean') {
	          self._muted = muted;
	        } else {
	          return self._muted;
	        }
	      }
	
	      // If no id is passed, get all ID's to be muted.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound) {
	          sound._muted = muted;
	
	          if (self._webAudio && sound._node) {
	            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
	          } else if (sound._node) {
	            sound._node.muted = Howler._muted ? true : muted;
	          }
	
	          self._emit('mute', sound._id);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
	     *   volume() -> Returns the group's volume value.
	     *   volume(id) -> Returns the sound id's current volume.
	     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
	     *   volume(vol, id) -> Sets the volume of passed sound id.
	     * @return {Howl/Number} Returns self or current volume.
	     */
	    volume: function() {
	      var self = this;
	      var args = arguments;
	      var vol, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // Return the value of the groups' volume.
	        return self._volume;
	      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
	        // First check if this is an ID, and if not, assume it is a new volume.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else {
	          vol = parseFloat(args[0]);
	        }
	      } else if (args.length >= 2) {
	        vol = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // Update the volume or return the current volume.
	      var sound;
	      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
	        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
	        if (self._state !== 'loaded') {
	          self._queue.push({
	            event: 'volume',
	            action: function() {
	              self.volume.apply(self, args);
	            }
	          });
	
	          return self;
	        }
	
	        // Set the group volume.
	        if (typeof id === 'undefined') {
	          self._volume = vol;
	        }
	
	        // Update one or all volumes.
	        id = self._getSoundIds(id);
	        for (var i=0; i<id.length; i++) {
	          // Get the sound.
	          sound = self._soundById(id[i]);
	
	          if (sound) {
	            sound._volume = vol;
	
	            // Stop currently running fades.
	            if (!args[2]) {
	              self._stopFade(id[i]);
	            }
	
	            if (self._webAudio && sound._node && !sound._muted) {
	              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
	            } else if (sound._node && !sound._muted) {
	              sound._node.volume = vol * Howler.volume();
	            }
	
	            self._emit('volume', sound._id);
	          }
	        }
	      } else {
	        sound = id ? self._soundById(id) : self._sounds[0];
	        return sound ? sound._volume : 0;
	      }
	
	      return self;
	    },
	
	    /**
	     * Fade a currently playing sound between two volumes (if no id is passsed, all sounds will fade).
	     * @param  {Number} from The value to fade from (0.0 to 1.0).
	     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
	     * @param  {Number} len  Time in milliseconds to fade.
	     * @param  {Number} id   The sound id (omit to fade all sounds).
	     * @return {Howl}
	     */
	    fade: function(from, to, len, id) {
	      var self = this;
	      var diff = Math.abs(from - to);
	      var dir = from > to ? 'out' : 'in';
	      var steps = diff / 0.01;
	      var stepLen = (steps > 0) ? len / steps : len;
	
	      // Since browsers clamp timeouts to 4ms, we need to clamp our steps to that too.
	      if (stepLen < 4) {
	        steps = Math.ceil(steps / (4 / stepLen));
	        stepLen = 4;
	      }
	
	      // If the sound hasn't loaded, add it to the load queue to fade when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'fade',
	          action: function() {
	            self.fade(from, to, len, id);
	          }
	        });
	
	        return self;
	      }
	
	      // Set the volume to the start position.
	      self.volume(from, id);
	
	      // Fade the volume of one or all sounds.
	      var ids = self._getSoundIds(id);
	      for (var i=0; i<ids.length; i++) {
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        // Create a linear fade or fall back to timeouts with HTML5 Audio.
	        if (sound) {
	          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
	          if (!id) {
	            self._stopFade(ids[i]);
	          }
	
	          // If we are using Web Audio, let the native methods do the actual fade.
	          if (self._webAudio && !sound._muted) {
	            var currentTime = Howler.ctx.currentTime;
	            var end = currentTime + (len / 1000);
	            sound._volume = from;
	            sound._node.gain.setValueAtTime(from, currentTime);
	            sound._node.gain.linearRampToValueAtTime(to, end);
	          }
	
	          var vol = from;
	          sound._interval = setInterval(function(soundId, sound) {
	            // Update the volume amount, but only if the volume should change.
	            if (steps > 0) {
	              vol += (dir === 'in' ? 0.01 : -0.01);
	            }
	
	            // Make sure the volume is in the right bounds.
	            vol = Math.max(0, vol);
	            vol = Math.min(1, vol);
	
	            // Round to within 2 decimal points.
	            vol = Math.round(vol * 100) / 100;
	
	            // Change the volume.
	            if (self._webAudio) {
	              if (typeof id === 'undefined') {
	                self._volume = vol;
	              }
	
	              sound._volume = vol;
	            } else {
	              self.volume(vol, soundId, true);
	            }
	
	            // When the fade is complete, stop it and fire event.
	            if (vol === to) {
	              clearInterval(sound._interval);
	              sound._interval = null;
	              self.volume(vol, soundId);
	              self._emit('fade', soundId);
	            }
	          }.bind(self, ids[i], sound), stepLen);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Internal method that stops the currently playing fade when
	     * a new fade starts, volume is changed or the sound is stopped.
	     * @param  {Number} id The sound id.
	     * @return {Howl}
	     */
	    _stopFade: function(id) {
	      var self = this;
	      var sound = self._soundById(id);
	
	      if (sound && sound._interval) {
	        if (self._webAudio) {
	          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
	        }
	
	        clearInterval(sound._interval);
	        sound._interval = null;
	        self._emit('fade', id);
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   loop() -> Returns the group's loop value.
	     *   loop(id) -> Returns the sound id's loop value.
	     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
	     *   loop(loop, id) -> Sets the loop value of passed sound id.
	     * @return {Howl/Boolean} Returns self or current loop value.
	     */
	    loop: function() {
	      var self = this;
	      var args = arguments;
	      var loop, id, sound;
	
	      // Determine the values for loop and id.
	      if (args.length === 0) {
	        // Return the grou's loop value.
	        return self._loop;
	      } else if (args.length === 1) {
	        if (typeof args[0] === 'boolean') {
	          loop = args[0];
	          self._loop = loop;
	        } else {
	          // Return this sound's loop value.
	          sound = self._soundById(parseInt(args[0], 10));
	          return sound ? sound._loop : false;
	        }
	      } else if (args.length === 2) {
	        loop = args[0];
	        id = parseInt(args[1], 10);
	      }
	
	      // If no id is passed, get all ID's to be looped.
	      var ids = self._getSoundIds(id);
	      for (var i=0; i<ids.length; i++) {
	        sound = self._soundById(ids[i]);
	
	        if (sound) {
	          sound._loop = loop;
	          if (self._webAudio && sound._node && sound._node.bufferSource) {
	            sound._node.bufferSource.loop = loop;
	            if (loop) {
	              sound._node.bufferSource.loopStart = sound._start || 0;
	              sound._node.bufferSource.loopEnd = sound._stop;
	            }
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   rate() -> Returns the first sound node's current playback rate.
	     *   rate(id) -> Returns the sound id's current playback rate.
	     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
	     *   rate(rate, id) -> Sets the playback rate of passed sound id.
	     * @return {Howl/Number} Returns self or the current playback rate.
	     */
	    rate: function() {
	      var self = this;
	      var args = arguments;
	      var rate, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // We will simply return the current rate of the first node.
	        id = self._sounds[0]._id;
	      } else if (args.length === 1) {
	        // First check if this is an ID, and if not, assume it is a new rate value.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else {
	          rate = parseFloat(args[0]);
	        }
	      } else if (args.length === 2) {
	        rate = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // Update the playback rate or return the current value.
	      var sound;
	      if (typeof rate === 'number') {
	        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
	        if (self._state !== 'loaded') {
	          self._queue.push({
	            event: 'rate',
	            action: function() {
	              self.rate.apply(self, args);
	            }
	          });
	
	          return self;
	        }
	
	        // Set the group rate.
	        if (typeof id === 'undefined') {
	          self._rate = rate;
	        }
	
	        // Update one or all volumes.
	        id = self._getSoundIds(id);
	        for (var i=0; i<id.length; i++) {
	          // Get the sound.
	          sound = self._soundById(id[i]);
	
	          if (sound) {
	            // Keep track of our position when the rate changed and update the playback
	            // start position so we can properly adjust the seek position for time elapsed.
	            sound._rateSeek = self.seek(id[i]);
	            sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
	            sound._rate = rate;
	
	            // Change the playback rate.
	            if (self._webAudio && sound._node && sound._node.bufferSource) {
	              sound._node.bufferSource.playbackRate.value = rate;
	            } else if (sound._node) {
	              sound._node.playbackRate = rate;
	            }
	
	            // Reset the timers.
	            var seek = self.seek(id[i]);
	            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
	            var timeout = (duration * 1000) / Math.abs(sound._rate);
	
	            // Start a new end timer if sound is already playing.
	            if (self._endTimers[id[i]] || !sound._paused) {
	              self._clearTimer(id[i]);
	              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
	            }
	
	            self._emit('rate', sound._id);
	          }
	        }
	      } else {
	        sound = self._soundById(id);
	        return sound ? sound._rate : self._rate;
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   seek() -> Returns the first sound node's current seek position.
	     *   seek(id) -> Returns the sound id's current seek position.
	     *   seek(seek) -> Sets the seek position of the first sound node.
	     *   seek(seek, id) -> Sets the seek position of passed sound id.
	     * @return {Howl/Number} Returns self or the current seek position.
	     */
	    seek: function() {
	      var self = this;
	      var args = arguments;
	      var seek, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // We will simply return the current position of the first node.
	        id = self._sounds[0]._id;
	      } else if (args.length === 1) {
	        // First check if this is an ID, and if not, assume it is a new seek position.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else {
	          id = self._sounds[0]._id;
	          seek = parseFloat(args[0]);
	        }
	      } else if (args.length === 2) {
	        seek = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // If there is no ID, bail out.
	      if (typeof id === 'undefined') {
	        return self;
	      }
	
	      // If the sound hasn't loaded, add it to the load queue to seek when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'seek',
	          action: function() {
	            self.seek.apply(self, args);
	          }
	        });
	
	        return self;
	      }
	
	      // Get the sound.
	      var sound = self._soundById(id);
	
	      if (sound) {
	        if (typeof seek === 'number' && seek >= 0) {
	          // Pause the sound and update position for restarting playback.
	          var playing = self.playing(id);
	          if (playing) {
	            self.pause(id, true);
	          }
	
	          // Move the position of the track and cancel timer.
	          sound._seek = seek;
	          sound._ended = false;
	          self._clearTimer(id);
	
	          // Restart the playback if the sound was playing.
	          if (playing) {
	            self.play(id, true);
	          }
	
	          // Update the seek position for HTML5 Audio.
	          if (!self._webAudio && sound._node) {
	            sound._node.currentTime = seek;
	          }
	
	          self._emit('seek', id);
	        } else {
	          if (self._webAudio) {
	            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
	            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
	            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
	          } else {
	            return sound._node.currentTime;
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
	     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
	     * @return {Boolean} True if playing and false if not.
	     */
	    playing: function(id) {
	      var self = this;
	
	      // Check the passed sound ID (if any).
	      if (typeof id === 'number') {
	        var sound = self._soundById(id);
	        return sound ? !sound._paused : false;
	      }
	
	      // Otherwise, loop through all sounds and check if any are playing.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (!self._sounds[i]._paused) {
	          return true;
	        }
	      }
	
	      return false;
	    },
	
	    /**
	     * Get the duration of this sound. Passing a sound id will return the sprite duration.
	     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
	     * @return {Number} Audio duration in seconds.
	     */
	    duration: function(id) {
	      var self = this;
	      var duration = self._duration;
	
	      // If we pass an ID, get the sound and return the sprite length.
	      var sound = self._soundById(id);
	      if (sound) {
	        duration = self._sprite[sound._sprite][1] / 1000;
	      }
	
	      return duration;
	    },
	
	    /**
	     * Returns the current loaded state of this Howl.
	     * @return {String} 'unloaded', 'loading', 'loaded'
	     */
	    state: function() {
	      return this._state;
	    },
	
	    /**
	     * Unload and destroy the current Howl object.
	     * This will immediately stop all sound instances attached to this group.
	     */
	    unload: function() {
	      var self = this;
	
	      // Stop playing any active sounds.
	      var sounds = self._sounds;
	      for (var i=0; i<sounds.length; i++) {
	        // Stop the sound if it is currently playing.
	        if (!sounds[i]._paused) {
	          self.stop(sounds[i]._id);
	          self._emit('end', sounds[i]._id);
	        }
	
	        // Remove the source or disconnect.
	        if (!self._webAudio) {
	          // Set the source to 0-second silence to stop any downloading.
	          sounds[i]._node.src = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=';
	
	          // Remove any event listeners.
	          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
	          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
	        }
	
	        // Empty out all of the nodes.
	        delete sounds[i]._node;
	
	        // Make sure all timers are cleared out.
	        self._clearTimer(sounds[i]._id);
	
	        // Remove the references in the global Howler object.
	        var index = Howler._howls.indexOf(self);
	        if (index >= 0) {
	          Howler._howls.splice(index, 1);
	        }
	      }
	
	      // Delete this sound from the cache (if no other Howl is using it).
	      var remCache = true;
	      for (i=0; i<Howler._howls.length; i++) {
	        if (Howler._howls[i]._src === self._src) {
	          remCache = false;
	          break;
	        }
	      }
	
	      if (cache && remCache) {
	        delete cache[self._src];
	      }
	
	      // Clear global errors.
	      Howler.noAudio = false;
	
	      // Clear out `self`.
	      self._state = 'unloaded';
	      self._sounds = [];
	      self = null;
	
	      return null;
	    },
	
	    /**
	     * Listen to a custom event.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to call.
	     * @param  {Number}   id    (optional) Only listen to events for this sound.
	     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
	     * @return {Howl}
	     */
	    on: function(event, fn, id, once) {
	      var self = this;
	      var events = self['_on' + event];
	
	      if (typeof fn === 'function') {
	        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
	      }
	
	      return self;
	    },
	
	    /**
	     * Remove a custom event. Call without parameters to remove all events.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
	     * @param  {Number}   id    (optional) Only remove events for this sound.
	     * @return {Howl}
	     */
	    off: function(event, fn, id) {
	      var self = this;
	      var events = self['_on' + event];
	      var i = 0;
	
	      if (fn) {
	        // Loop through event store and remove the passed function.
	        for (i=0; i<events.length; i++) {
	          if (fn === events[i].fn && id === events[i].id) {
	            events.splice(i, 1);
	            break;
	          }
	        }
	      } else if (event) {
	        // Clear out all events of this type.
	        self['_on' + event] = [];
	      } else {
	        // Clear out all events of every type.
	        var keys = Object.keys(self);
	        for (i=0; i<keys.length; i++) {
	          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
	            self[keys[i]] = [];
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Listen to a custom event and remove it once fired.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to call.
	     * @param  {Number}   id    (optional) Only listen to events for this sound.
	     * @return {Howl}
	     */
	    once: function(event, fn, id) {
	      var self = this;
	
	      // Setup the event listener.
	      self.on(event, fn, id, 1);
	
	      return self;
	    },
	
	    /**
	     * Emit all events of a specific type and pass the sound id.
	     * @param  {String} event Event name.
	     * @param  {Number} id    Sound ID.
	     * @param  {Number} msg   Message to go with event.
	     * @return {Howl}
	     */
	    _emit: function(event, id, msg) {
	      var self = this;
	      var events = self['_on' + event];
	
	      // Loop through event store and fire all functions.
	      for (var i=events.length-1; i>=0; i--) {
	        if (!events[i].id || events[i].id === id || event === 'load') {
	          setTimeout(function(fn) {
	            fn.call(this, id, msg);
	          }.bind(self, events[i].fn), 0);
	
	          // If this event was setup with `once`, remove it.
	          if (events[i].once) {
	            self.off(event, events[i].fn, events[i].id);
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Queue of actions initiated before the sound has loaded.
	     * These will be called in sequence, with the next only firing
	     * after the previous has finished executing (even if async like play).
	     * @return {Howl}
	     */
	    _loadQueue: function() {
	      var self = this;
	
	      if (self._queue.length > 0) {
	        var task = self._queue[0];
	
	        // don't move onto the next task until this one is done
	        self.once(task.event, function() {
	          self._queue.shift();
	          self._loadQueue();
	        });
	
	        task.action();
	      }
	
	      return self;
	    },
	
	    /**
	     * Fired when playback ends at the end of the duration.
	     * @param  {Sound} sound The sound object to work with.
	     * @return {Howl}
	     */
	    _ended: function(sound) {
	      var self = this;
	      var sprite = sound._sprite;
	
	      // Should this sound loop?
	      var loop = !!(sound._loop || self._sprite[sprite][2]);
	
	      // Fire the ended event.
	      self._emit('end', sound._id);
	
	      // Restart the playback for HTML5 Audio loop.
	      if (!self._webAudio && loop) {
	        self.stop(sound._id, true).play(sound._id);
	      }
	
	      // Restart this timer if on a Web Audio loop.
	      if (self._webAudio && loop) {
	        self._emit('play', sound._id);
	        sound._seek = sound._start || 0;
	        sound._rateSeek = 0;
	        sound._playStart = Howler.ctx.currentTime;
	
	        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
	        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	      }
	
	      // Mark the node as paused.
	      if (self._webAudio && !loop) {
	        sound._paused = true;
	        sound._ended = true;
	        sound._seek = sound._start || 0;
	        sound._rateSeek = 0;
	        self._clearTimer(sound._id);
	
	        // Clean up the buffer source.
	        self._cleanBuffer(sound._node);
	
	        // Attempt to auto-suspend AudioContext if no sounds are still playing.
	        Howler._autoSuspend();
	      }
	
	      // When using a sprite, end the track.
	      if (!self._webAudio && !loop) {
	        self.stop(sound._id);
	      }
	
	      return self;
	    },
	
	    /**
	     * Clear the end timer for a sound playback.
	     * @param  {Number} id The sound ID.
	     * @return {Howl}
	     */
	    _clearTimer: function(id) {
	      var self = this;
	
	      if (self._endTimers[id]) {
	        clearTimeout(self._endTimers[id]);
	        delete self._endTimers[id];
	      }
	
	      return self;
	    },
	
	    /**
	     * Return the sound identified by this ID, or return null.
	     * @param  {Number} id Sound ID
	     * @return {Object}    Sound object or null.
	     */
	    _soundById: function(id) {
	      var self = this;
	
	      // Loop through all sounds and find the one with this ID.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (id === self._sounds[i]._id) {
	          return self._sounds[i];
	        }
	      }
	
	      return null;
	    },
	
	    /**
	     * Return an inactive sound from the pool or create a new one.
	     * @return {Sound} Sound playback object.
	     */
	    _inactiveSound: function() {
	      var self = this;
	
	      self._drain();
	
	      // Find the first inactive node to recycle.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (self._sounds[i]._ended) {
	          return self._sounds[i].reset();
	        }
	      }
	
	      // If no inactive node was found, create a new one.
	      return new Sound(self);
	    },
	
	    /**
	     * Drain excess inactive sounds from the pool.
	     */
	    _drain: function() {
	      var self = this;
	      var limit = self._pool;
	      var cnt = 0;
	      var i = 0;
	
	      // If there are less sounds than the max pool size, we are done.
	      if (self._sounds.length < limit) {
	        return;
	      }
	
	      // Count the number of inactive sounds.
	      for (i=0; i<self._sounds.length; i++) {
	        if (self._sounds[i]._ended) {
	          cnt++;
	        }
	      }
	
	      // Remove excess inactive sounds, going in reverse order.
	      for (i=self._sounds.length - 1; i>=0; i--) {
	        if (cnt <= limit) {
	          return;
	        }
	
	        if (self._sounds[i]._ended) {
	          // Disconnect the audio source when using Web Audio.
	          if (self._webAudio && self._sounds[i]._node) {
	            self._sounds[i]._node.disconnect(0);
	          }
	
	          // Remove sounds until we have the pool size.
	          self._sounds.splice(i, 1);
	          cnt--;
	        }
	      }
	    },
	
	    /**
	     * Get all ID's from the sounds pool.
	     * @param  {Number} id Only return one ID if one is passed.
	     * @return {Array}    Array of IDs.
	     */
	    _getSoundIds: function(id) {
	      var self = this;
	
	      if (typeof id === 'undefined') {
	        var ids = [];
	        for (var i=0; i<self._sounds.length; i++) {
	          ids.push(self._sounds[i]._id);
	        }
	
	        return ids;
	      } else {
	        return [id];
	      }
	    },
	
	    /**
	     * Load the sound back into the buffer source.
	     * @param  {Sound} sound The sound object to work with.
	     * @return {Howl}
	     */
	    _refreshBuffer: function(sound) {
	      var self = this;
	
	      // Setup the buffer source for playback.
	      sound._node.bufferSource = Howler.ctx.createBufferSource();
	      sound._node.bufferSource.buffer = cache[self._src];
	
	      // Connect to the correct node.
	      if (sound._panner) {
	        sound._node.bufferSource.connect(sound._panner);
	      } else {
	        sound._node.bufferSource.connect(sound._node);
	      }
	
	      // Setup looping and playback rate.
	      sound._node.bufferSource.loop = sound._loop;
	      if (sound._loop) {
	        sound._node.bufferSource.loopStart = sound._start || 0;
	        sound._node.bufferSource.loopEnd = sound._stop;
	      }
	      sound._node.bufferSource.playbackRate.value = sound._rate;
	
	      return self;
	    },
	
	    /**
	     * Prevent memory leaks by cleaning up the buffer source after playback.
	     * @param  {Object} node Sound's audio node containing the buffer source.
	     * @return {Howl}
	     */
	    _cleanBuffer: function(node) {
	      var self = this;
	
	      if (self._scratchBuffer) {
	        node.bufferSource.onended = null;
	        node.bufferSource.disconnect(0);
	        try { node.bufferSource.buffer = self._scratchBuffer; } catch(e) {}
	      }
	      node.bufferSource = null;
	
	      return self;
	    }
	  };
	
	  /** Single Sound Methods **/
	  /***************************************************************************/
	
	  /**
	   * Setup the sound object, which each node attached to a Howl group is contained in.
	   * @param {Object} howl The Howl parent group.
	   */
	  var Sound = function(howl) {
	    this._parent = howl;
	    this.init();
	  };
	  Sound.prototype = {
	    /**
	     * Initialize a new Sound object.
	     * @return {Sound}
	     */
	    init: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Setup the default parameters.
	      self._muted = parent._muted;
	      self._loop = parent._loop;
	      self._volume = parent._volume;
	      self._muted = parent._muted;
	      self._rate = parent._rate;
	      self._seek = 0;
	      self._paused = true;
	      self._ended = true;
	      self._sprite = '__default';
	
	      // Generate a unique ID for this sound.
	      self._id = Math.round(Date.now() * Math.random());
	
	      // Add itself to the parent's pool.
	      parent._sounds.push(self);
	
	      // Create the new node.
	      self.create();
	
	      return self;
	    },
	
	    /**
	     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
	     * @return {Sound}
	     */
	    create: function() {
	      var self = this;
	      var parent = self._parent;
	      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;
	
	      if (parent._webAudio) {
	        // Create the gain node for controlling volume (the source will connect to this).
	        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
	        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
	        self._node.paused = true;
	        self._node.connect(Howler.masterGain);
	      } else {
	        self._node = new Audio();
	
	        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
	        self._errorFn = self._errorListener.bind(self);
	        self._node.addEventListener('error', self._errorFn, false);
	
	        // Listen for 'canplaythrough' event to let us know the sound is ready.
	        self._loadFn = self._loadListener.bind(self);
	        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);
	
	        // Setup the new audio node.
	        self._node.src = parent._src;
	        self._node.preload = 'auto';
	        self._node.volume = volume * Howler.volume();
	
	        // Begin loading the source.
	        self._node.load();
	      }
	
	      return self;
	    },
	
	    /**
	     * Reset the parameters of this sound to the original state (for recycle).
	     * @return {Sound}
	     */
	    reset: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Reset all of the parameters of this sound.
	      self._muted = parent._muted;
	      self._loop = parent._loop;
	      self._volume = parent._volume;
	      self._muted = parent._muted;
	      self._rate = parent._rate;
	      self._seek = 0;
	      self._rateSeek = 0;
	      self._paused = true;
	      self._ended = true;
	      self._sprite = '__default';
	
	      // Generate a new ID so that it isn't confused with the previous sound.
	      self._id = Math.round(Date.now() * Math.random());
	
	      return self;
	    },
	
	    /**
	     * HTML5 Audio error listener callback.
	     */
	    _errorListener: function() {
	      var self = this;
	
	      // Fire an error event and pass back the code.
	      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);
	
	      // Clear the event listener.
	      self._node.removeEventListener('error', self._errorListener, false);
	    },
	
	    /**
	     * HTML5 Audio canplaythrough listener callback.
	     */
	    _loadListener: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Round up the duration to account for the lower precision in HTML5 Audio.
	      parent._duration = Math.ceil(self._node.duration * 10) / 10;
	
	      // Setup a sprite if none is defined.
	      if (Object.keys(parent._sprite).length === 0) {
	        parent._sprite = {__default: [0, parent._duration * 1000]};
	      }
	
	      if (parent._state !== 'loaded') {
	        parent._state = 'loaded';
	        parent._emit('load');
	        parent._loadQueue();
	      }
	
	      // Clear the event listener.
	      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
	    }
	  };
	
	  /** Helper Methods **/
	  /***************************************************************************/
	
	  var cache = {};
	
	  /**
	   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
	   * @param  {Howl} self
	   */
	  var loadBuffer = function(self) {
	    var url = self._src;
	
	    // Check if the buffer has already been cached and use it instead.
	    if (cache[url]) {
	      // Set the duration from the cache.
	      self._duration = cache[url].duration;
	
	      // Load the sound into this Howl.
	      loadSound(self);
	
	      return;
	    }
	
	    if (/^data:[^;]+;base64,/.test(url)) {
	      // Decode the base64 data URI without XHR, since some browsers don't support it.
	      var data = atob(url.split(',')[1]);
	      var dataView = new Uint8Array(data.length);
	      for (var i=0; i<data.length; ++i) {
	        dataView[i] = data.charCodeAt(i);
	      }
	
	      decodeAudioData(dataView.buffer, self);
	    } else {
	      // Load the buffer from the URL.
	      var xhr = new XMLHttpRequest();
	      xhr.open('GET', url, true);
	      xhr.responseType = 'arraybuffer';
	      xhr.onload = function() {
	        // Make sure we get a successful response back.
	        var code = (xhr.status + '')[0];
	        if (code !== '0' && code !== '2' && code !== '3') {
	          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
	          return;
	        }
	
	        decodeAudioData(xhr.response, self);
	      };
	      xhr.onerror = function() {
	        // If there is an error, switch to HTML5 Audio.
	        if (self._webAudio) {
	          self._html5 = true;
	          self._webAudio = false;
	          self._sounds = [];
	          delete cache[url];
	          self.load();
	        }
	      };
	      safeXhrSend(xhr);
	    }
	  };
	
	  /**
	   * Send the XHR request wrapped in a try/catch.
	   * @param  {Object} xhr XHR to send.
	   */
	  var safeXhrSend = function(xhr) {
	    try {
	      xhr.send();
	    } catch (e) {
	      xhr.onerror();
	    }
	  };
	
	  /**
	   * Decode audio data from an array buffer.
	   * @param  {ArrayBuffer} arraybuffer The audio data.
	   * @param  {Howl}        self
	   */
	  var decodeAudioData = function(arraybuffer, self) {
	    // Decode the buffer into an audio source.
	    Howler.ctx.decodeAudioData(arraybuffer, function(buffer) {
	      if (buffer && self._sounds.length > 0) {
	        cache[self._src] = buffer;
	        loadSound(self, buffer);
	      }
	    }, function() {
	      self._emit('loaderror', null, 'Decoding audio data failed.');
	    });
	  };
	
	  /**
	   * Sound is now loaded, so finish setting everything up and fire the loaded event.
	   * @param  {Howl} self
	   * @param  {Object} buffer The decoded buffer sound source.
	   */
	  var loadSound = function(self, buffer) {
	    // Set the duration.
	    if (buffer && !self._duration) {
	      self._duration = buffer.duration;
	    }
	
	    // Setup a sprite if none is defined.
	    if (Object.keys(self._sprite).length === 0) {
	      self._sprite = {__default: [0, self._duration * 1000]};
	    }
	
	    // Fire the loaded event.
	    if (self._state !== 'loaded') {
	      self._state = 'loaded';
	      self._emit('load');
	      self._loadQueue();
	    }
	  };
	
	  /**
	   * Setup the audio context when available, or switch to HTML5 Audio mode.
	   */
	  var setupAudioContext = function() {
	    // Check if we are using Web Audio and setup the AudioContext if we are.
	    try {
	      if (typeof AudioContext !== 'undefined') {
	        Howler.ctx = new AudioContext();
	      } else if (typeof webkitAudioContext !== 'undefined') {
	        Howler.ctx = new webkitAudioContext();
	      } else {
	        Howler.usingWebAudio = false;
	      }
	    } catch(e) {
	      Howler.usingWebAudio = false;
	    }
	
	    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
	    // If it is, disable Web Audio as it causes crashing.
	    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
	    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	    var version = appVersion ? parseInt(appVersion[1], 10) : null;
	    if (iOS && version && version < 9) {
	      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
	      if (Howler._navigator && Howler._navigator.standalone && !safari || Howler._navigator && !Howler._navigator.standalone && !safari) {
	        Howler.usingWebAudio = false;
	      }
	    }
	
	    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
	    if (Howler.usingWebAudio) {
	      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
	      Howler.masterGain.gain.value = 1;
	      Howler.masterGain.connect(Howler.ctx.destination);
	    }
	
	    // Re-run the setup on Howler.
	    Howler._setup();
	  };
	
	  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return {
	        Howler: Howler,
	        Howl: Howl
	      };
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  // Add support for CommonJS libraries such as browserify.
	  if (true) {
	    exports.Howler = Howler;
	    exports.Howl = Howl;
	  }
	
	  // Define globally in case AMD is not available or unused.
	  if (typeof window !== 'undefined') {
	    window.HowlerGlobal = HowlerGlobal;
	    window.Howler = Howler;
	    window.Howl = Howl;
	    window.Sound = Sound;
	  } else if (typeof global !== 'undefined') { // Add to global in Node.js (for testing, etc).
	    global.HowlerGlobal = HowlerGlobal;
	    global.Howler = Howler;
	    global.Howl = Howl;
	    global.Sound = Sound;
	  }
	})();
	
	
	/*!
	 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
	 *  
	 *  howler.js v2.0.2
	 *  howlerjs.com
	 *
	 *  (c) 2013-2016, James Simpson of GoldFire Studios
	 *  goldfirestudios.com
	 *
	 *  MIT License
	 */
	
	(function() {
	
	  'use strict';
	
	  // Setup default properties.
	  HowlerGlobal.prototype._pos = [0, 0, 0];
	  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];
	  
	  /** Global Methods **/
	  /***************************************************************************/
	
	  /**
	   * Helper method to update the stereo panning position of all current Howls.
	   * Future Howls will not use this value unless explicitly set.
	   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
	   * @return {Howler/Number}     Self or current stereo panning value.
	   */
	  HowlerGlobal.prototype.stereo = function(pan) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Loop through all Howls and update their stereo panning.
	    for (var i=self._howls.length-1; i>=0; i--) {
	      self._howls[i].stereo(pan);
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the position of the listener in 3D cartesian space. Sounds using
	   * 3D position will be relative to the listener's position.
	   * @param  {Number} x The x-position of the listener.
	   * @param  {Number} y The y-position of the listener.
	   * @param  {Number} z The z-position of the listener.
	   * @return {Howler/Array}   Self or current listener position.
	   */
	  HowlerGlobal.prototype.pos = function(x, y, z) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? self._pos[1] : y;
	    z = (typeof z !== 'number') ? self._pos[2] : z;
	
	    if (typeof x === 'number') {
	      self._pos = [x, y, z];
	      self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
	    } else {
	      return self._pos;
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the direction the listener is pointing in the 3D cartesian space.
	   * A front and up vector must be provided. The front is the direction the
	   * face of the listener is pointing, and up is the direction the top of the
	   * listener is pointing. Thus, these values are expected to be at right angles
	   * from each other.
	   * @param  {Number} x   The x-orientation of the listener.
	   * @param  {Number} y   The y-orientation of the listener.
	   * @param  {Number} z   The z-orientation of the listener.
	   * @param  {Number} xUp The x-orientation of the top of the listener.
	   * @param  {Number} yUp The y-orientation of the top of the listener.
	   * @param  {Number} zUp The z-orientation of the top of the listener.
	   * @return {Howler/Array}     Returns self or the current orientation vectors.
	   */
	  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    var or = self._orientation;
	    y = (typeof y !== 'number') ? or[1] : y;
	    z = (typeof z !== 'number') ? or[2] : z;
	    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
	    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
	    zUp = (typeof zUp !== 'number') ? or[5] : zUp;
	
	    if (typeof x === 'number') {
	      self._orientation = [x, y, z, xUp, yUp, zUp];
	      self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
	    } else {
	      return or;
	    }
	
	    return self;
	  };
	
	  /** Group Methods **/
	  /***************************************************************************/
	
	  /**
	   * Add new properties to the core init.
	   * @param  {Function} _super Core init method.
	   * @return {Howl}
	   */
	  Howl.prototype.init = (function(_super) {
	    return function(o) {
	      var self = this;
	
	      // Setup user-defined default properties.
	      self._orientation = o.orientation || [1, 0, 0];
	      self._stereo = o.stereo || null;
	      self._pos = o.pos || null;
	      self._pannerAttr = {
	        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
	        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
	        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
	        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
	        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
	        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
	        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
	        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
	      };
	
	      // Setup event listeners.
	      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
	      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
	      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];
	
	      // Complete initilization with howler.js core's init function.
	      return _super.call(this, o);
	    };
	  })(Howl.prototype.init);
	
	  /**
	   * Get/set the stereo panning of the audio source for this sound or all in the group.
	   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Number}    Returns self or the current stereo panning value.
	   */
	  Howl.prototype.stereo = function(pan, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'stereo',
	        action: function() {
	          self.stereo(pan, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
	    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';
	
	    // Setup the group's stereo panning if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's stereo panning if no parameters are passed.
	      if (typeof pan === 'number') {
	        self._stereo = pan;
	        self._pos = [pan, 0, 0];
	      } else {
	        return self._stereo;
	      }
	    }
	
	    // Change the streo panning of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof pan === 'number') {
	          sound._stereo = pan;
	          sound._pos = [pan, 0, 0];
	
	          if (sound._node) {
	            // If we are falling back, make sure the panningModel is equalpower.
	            sound._pannerAttr.panningModel = 'equalpower';
	
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner || !sound._panner.pan) {
	              setupPanner(sound, pannerType);
	            }
	
	            if (pannerType === 'spatial') {
	              sound._panner.setPosition(pan, 0, 0);
	            } else {
	              sound._panner.pan.value = pan;
	            }
	          }
	
	          self._emit('stereo', sound._id);
	        } else {
	          return sound._stereo;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the 3D spatial position of the audio source for this sound or
	   * all in the group. The most common usage is to set the 'x' position for
	   * left/right panning. Setting any value higher than 1.0 will begin to
	   * decrease the volume of the sound as it moves further away.
	   * @param  {Number} x  The x-position of the audio from -1000.0 to 1000.0.
	   * @param  {Number} y  The y-position of the audio from -1000.0 to 1000.0.
	   * @param  {Number} z  The z-position of the audio from -1000.0 to 1000.0.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
	   */
	  Howl.prototype.pos = function(x, y, z, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change position when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'pos',
	        action: function() {
	          self.pos(x, y, z, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? 0 : y;
	    z = (typeof z !== 'number') ? -0.5 : z;
	
	    // Setup the group's spatial position if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's spatial position if no parameters are passed.
	      if (typeof x === 'number') {
	        self._pos = [x, y, z];
	      } else {
	        return self._pos;
	      }
	    }
	
	    // Change the spatial position of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof x === 'number') {
	          sound._pos = [x, y, z];
	
	          if (sound._node) {
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner || sound._panner.pan) {
	              setupPanner(sound, 'spatial');
	            }
	
	            sound._panner.setPosition(x, y, z);
	          }
	
	          self._emit('pos', sound._id);
	        } else {
	          return sound._pos;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
	   * space. Depending on how direction the sound is, based on the `cone` attributes,
	   * a sound pointing away from the listener can be quiet or silent.
	   * @param  {Number} x  The x-orientation of the source.
	   * @param  {Number} y  The y-orientation of the source.
	   * @param  {Number} z  The z-orientation of the source.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
	   */
	  Howl.prototype.orientation = function(x, y, z, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'orientation',
	        action: function() {
	          self.orientation(x, y, z, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? self._orientation[1] : y;
	    z = (typeof z !== 'number') ? self._orientation[2] : z;
	
	    // Setup the group's spatial orientation if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's spatial orientation if no parameters are passed.
	      if (typeof x === 'number') {
	        self._orientation = [x, y, z];
	      } else {
	        return self._orientation;
	      }
	    }
	
	    // Change the spatial orientation of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof x === 'number') {
	          sound._orientation = [x, y, z];
	
	          if (sound._node) {
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner) {
	              // Make sure we have a position to setup the node with.
	              if (!sound._pos) {
	                sound._pos = self._pos || [0, 0, -0.5];
	              }
	
	              setupPanner(sound, 'spatial');
	            }
	
	            sound._panner.setOrientation(x, y, z);
	          }
	
	          self._emit('orientation', sound._id);
	        } else {
	          return sound._orientation;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the panner node's attributes for a sound or group of sounds.
	   * This method can optionall take 0, 1 or 2 arguments.
	   *   pannerAttr() -> Returns the group's values.
	   *   pannerAttr(id) -> Returns the sound id's values.
	   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
	   *   pannerAttr(o, id) -> Set's the values of passed sound id.
	   *
	   *   Attributes:
	   *     coneInnerAngle - (360 by default) There will be no volume reduction inside this angle.
	   *     coneOuterAngle - (360 by default) The volume will be reduced to a constant value of
	   *                      `coneOuterGain` outside this angle.
	   *     coneOuterGain - (0 by default) The amount of volume reduction outside of `coneOuterAngle`.
	   *     distanceModel - ('inverse' by default) Determines algorithm to use to reduce volume as audio moves
	   *                      away from listener. Can be `linear`, `inverse` or `exponential`.
	   *     maxDistance - (10000 by default) Volume won't reduce between source/listener beyond this distance.
	   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
	   *                     Can be `HRTF` or `equalpower`.
	   *     refDistance - (1 by default) A reference distance for reducing volume as the source
	   *                    moves away from the listener.
	   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener.
	   * 
	   * @return {Howl/Object} Returns self or current panner attributes.
	   */
	  Howl.prototype.pannerAttr = function() {
	    var self = this;
	    var args = arguments;
	    var o, id, sound;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // Determine the values based on arguments.
	    if (args.length === 0) {
	      // Return the group's panner attribute values.
	      return self._pannerAttr;
	    } else if (args.length === 1) {
	      if (typeof args[0] === 'object') {
	        o = args[0];
	
	        // Set the grou's panner attribute values.
	        if (typeof id === 'undefined') {
	          self._pannerAttr = {
	            coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : self._coneInnerAngle,
	            coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : self._coneOuterAngle,
	            coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : self._coneOuterGain,
	            distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : self._distanceModel,
	            maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : self._maxDistance,
	            panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : self._panningModel,
	            refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : self._refDistance,
	            rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : self._rolloffFactor
	          };
	        }
	      } else {
	        // Return this sound's panner attribute values.
	        sound = self._soundById(parseInt(args[0], 10));
	        return sound ? sound._pannerAttr : self._pannerAttr;
	      }
	    } else if (args.length === 2) {
	      o = args[0];
	      id = parseInt(args[1], 10);
	    }
	
	    // Update the values of the specified sounds.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      sound = self._soundById(ids[i]);
	
	      if (sound) {
	        // Merge the new values into the sound.
	        var pa = sound._pannerAttr;
	        pa = {
	          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
	          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
	          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
	          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
	          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
	          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel,
	          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
	          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor
	        };
	
	        // Update the panner values or create a new panner if none exists.
	        var panner = sound._panner;
	        if (panner) {
	          panner.coneInnerAngle = pa.coneInnerAngle;
	          panner.coneOuterAngle = pa.coneOuterAngle;
	          panner.coneOuterGain = pa.coneOuterGain;
	          panner.distanceModel = pa.distanceModel;
	          panner.maxDistance = pa.maxDistance;
	          panner.panningModel = pa.panningModel;
	          panner.refDistance = pa.refDistance;
	          panner.rolloffFactor = pa.rolloffFactor;
	        } else {
	          // Make sure we have a position to setup the node with.
	          if (!sound._pos) {
	            sound._pos = self._pos || [0, 0, -0.5];
	          }
	
	          // Create a new panner node.
	          setupPanner(sound, 'spatial');
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /** Single Sound Methods **/
	  /***************************************************************************/
	
	  /**
	   * Add new properties to the core Sound init.
	   * @param  {Function} _super Core Sound init method.
	   * @return {Sound}
	   */
	  Sound.prototype.init = (function(_super) {
	    return function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Setup user-defined default properties.
	      self._orientation = parent._orientation;
	      self._stereo = parent._stereo;
	      self._pos = parent._pos;
	      self._pannerAttr = parent._pannerAttr;
	
	      // Complete initilization with howler.js core Sound's init function.
	      _super.call(this);
	
	      // If a stereo or position was specified, set it up.
	      if (self._stereo) {
	        parent.stereo(self._stereo);
	      } else if (self._pos) {
	        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
	      }
	    };
	  })(Sound.prototype.init);
	
	  /**
	   * Override the Sound.reset method to clean up properties from the spatial plugin.
	   * @param  {Function} _super Sound reset method.
	   * @return {Sound}
	   */
	  Sound.prototype.reset = (function(_super) {
	    return function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Reset all spatial plugin properties on this sound.
	      self._orientation = parent._orientation;
	      self._pos = parent._pos;
	      self._pannerAttr = parent._pannerAttr;
	
	      // Complete resetting of the sound.
	      return _super.call(this);
	    };
	  })(Sound.prototype.reset);
	
	  /** Helper Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create a new panner node and save it on the sound.
	   * @param  {Sound} sound Specific sound to setup panning on.
	   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
	   */
	  var setupPanner = function(sound, type) {
	    type = type || 'spatial';
	
	    // Create the new panner node.
	    if (type === 'spatial') {
	      sound._panner = Howler.ctx.createPanner();
	      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
	      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
	      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
	      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
	      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
	      sound._panner.panningModel = sound._pannerAttr.panningModel;
	      sound._panner.refDistance = sound._pannerAttr.refDistance;
	      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
	      sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
	      sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
	    } else {
	      sound._panner = Howler.ctx.createStereoPanner();
	      sound._panner.pan.value = sound._stereo;
	    }
	
	    sound._panner.connect(sound._node);
	
	    // Update the connections.
	    if (!sound._paused) {
	      sound._parent.pause(sound._id, true).play(sound._id);
	    }
	  };
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4),
	    root = __webpack_require__(1);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(163),
	    hashDelete = __webpack_require__(164),
	    hashGet = __webpack_require__(165),
	    hashHas = __webpack_require__(166),
	    hashSet = __webpack_require__(167);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4),
	    root = __webpack_require__(1);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(4),
	    root = __webpack_require__(1);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(22),
	    setCacheAdd = __webpack_require__(195),
	    setCacheHas = __webpack_require__(196);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 112 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(119);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(16),
	    keysIn = __webpack_require__(88);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(27),
	    isFlattenable = __webpack_require__(172);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(116),
	    baseIsNaN = __webpack_require__(123),
	    strictIndexOf = __webpack_require__(202);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(8),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(23),
	    equalArrays = __webpack_require__(65),
	    equalByTag = __webpack_require__(153),
	    equalObjects = __webpack_require__(154),
	    getTag = __webpack_require__(72),
	    isArray = __webpack_require__(2),
	    isBuffer = __webpack_require__(39),
	    isTypedArray = __webpack_require__(87);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(23),
	    baseIsEqual = __webpack_require__(55);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(40),
	    isMasked = __webpack_require__(175),
	    isObject = __webpack_require__(3),
	    toSource = __webpack_require__(84);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(8),
	    isLength = __webpack_require__(41),
	    isObjectLike = __webpack_require__(7);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(128),
	    baseMatchesProperty = __webpack_require__(129),
	    identity = __webpack_require__(37),
	    isArray = __webpack_require__(2),
	    property = __webpack_require__(221);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3),
	    isPrototype = __webpack_require__(34),
	    nativeKeysIn = __webpack_require__(189);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(122),
	    getMatchData = __webpack_require__(158),
	    matchesStrictComparable = __webpack_require__(75);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(55),
	    get = __webpack_require__(216),
	    hasIn = __webpack_require__(217),
	    isKey = __webpack_require__(33),
	    isStrictComparable = __webpack_require__(73),
	    matchesStrictComparable = __webpack_require__(75),
	    toKey = __webpack_require__(9);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 130 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(53);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var arraySample = __webpack_require__(48),
	    values = __webpack_require__(228);
	
	/**
	 * The base implementation of `_.sample`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 */
	function baseSample(collection) {
	  return arraySample(values(collection));
	}
	
	module.exports = baseSample;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(207),
	    defineProperty = __webpack_require__(64),
	    identity = __webpack_require__(37);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(6),
	    arrayMap = __webpack_require__(26),
	    isArray = __webpack_require__(2),
	    isSymbol = __webpack_require__(10);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(26);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(1);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(29);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(110),
	    arrayReduce = __webpack_require__(47),
	    mapToArray = __webpack_require__(74);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 142 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(111),
	    arrayReduce = __webpack_require__(47),
	    setToArray = __webpack_require__(79);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(6);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(29);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(16),
	    getSymbols = __webpack_require__(31);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(16),
	    getSymbolsIn = __webpack_require__(71);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(1);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 149 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(17),
	    root = __webpack_require__(1);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(24),
	    createCtor = __webpack_require__(17),
	    createHybrid = __webpack_require__(62),
	    createRecurry = __webpack_require__(63),
	    getHolder = __webpack_require__(69),
	    replaceHolders = __webpack_require__(35),
	    root = __webpack_require__(1);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(24),
	    createCtor = __webpack_require__(17),
	    root = __webpack_require__(1);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(6),
	    Uint8Array = __webpack_require__(44),
	    eq = __webpack_require__(36),
	    equalArrays = __webpack_require__(65),
	    mapToArray = __webpack_require__(74),
	    setToArray = __webpack_require__(79);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(67);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(209),
	    overRest = __webpack_require__(192),
	    setToString = __webpack_require__(80);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(54),
	    getSymbolsIn = __webpack_require__(71),
	    keysIn = __webpack_require__(88);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(193);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(73),
	    keys = __webpack_require__(11);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(6);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 160 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 161 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(59),
	    isArguments = __webpack_require__(38),
	    isArray = __webpack_require__(2),
	    isIndex = __webpack_require__(32),
	    isLength = __webpack_require__(41),
	    toKey = __webpack_require__(9);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(19);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 164 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(19);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(19);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(19);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 168 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(29),
	    cloneDataView = __webpack_require__(140),
	    cloneMap = __webpack_require__(141),
	    cloneRegExp = __webpack_require__(142),
	    cloneSet = __webpack_require__(143),
	    cloneSymbol = __webpack_require__(144),
	    cloneTypedArray = __webpack_require__(145);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(14),
	    getPrototype = __webpack_require__(70),
	    isPrototype = __webpack_require__(34);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 171 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(6),
	    isArguments = __webpack_require__(38),
	    isArray = __webpack_require__(2);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(20),
	    getData = __webpack_require__(68),
	    getFuncName = __webpack_require__(157),
	    lodash = __webpack_require__(229);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(148);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 176 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(13);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(13);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(13);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(13);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(106),
	    ListCache = __webpack_require__(12),
	    Map = __webpack_require__(21);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(18);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(18);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(18);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(18);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(219);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(60),
	    composeArgsRight = __webpack_require__(61),
	    replaceHolders = __webpack_require__(35);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(77);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 189 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(66);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module)))

/***/ },
/* 191 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(24);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 193 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(15),
	    isIndex = __webpack_require__(32);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 195 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 196 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(12);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 200 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(12),
	    Map = __webpack_require__(21),
	    MapCache = __webpack_require__(22);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(25),
	    arrayIncludes = __webpack_require__(113);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(20),
	    LodashWrapper = __webpack_require__(43),
	    copyArray = __webpack_require__(15);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(30);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_ARY_FLAG = 128;
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(52);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ },
/* 207 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(30);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(117);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(212),
	    fallbackHolder = __webpack_require__(85);
	
	/** Built-in value reference. */
	var push = Array.prototype.push;
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);
	
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      push.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var setPlaceholder,
	      isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      placeholder = isLib ? func : fallbackHolder,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isFunction': util.isFunction,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isFunction = helpers.isFunction,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null) {
	        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = mapping.aliasToReal[name] || name,
	        methodName = mapping.remap[realName] || realName,
	        oldOptions = options;
	
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func) {
	    var result,
	        realName = mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;
	
	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
	
	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    if (mapping.placeholder[realName]) {
	      setPlaceholder = true;
	      result.placeholder = func.placeholder = placeholder;
	    }
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  if (setPlaceholder) {
	    _.placeholder = placeholder;
	  }
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ },
/* 211 */
/***/ function(module, exports) {

	module.exports = {
	  'cap': false,
	  'curry': false,
	  'fixed': false,
	  'immutable': false,
	  'rearg': false
	};


/***/ },
/* 212 */
/***/ function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to track methods with placeholder support */
	exports.placeholder = {
	  'bind': true,
	  'bindKey': true,
	  'curry': true,
	  'curryRight': true,
	  'partial': true,
	  'partialRight': true
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'ary': __webpack_require__(205),
	  'assign': __webpack_require__(50),
	  'clone': __webpack_require__(206),
	  'curry': __webpack_require__(208),
	  'forEach': __webpack_require__(25),
	  'isArray': __webpack_require__(2),
	  'isFunction': __webpack_require__(40),
	  'iteratee': __webpack_require__(218),
	  'keys': __webpack_require__(56),
	  'rearg': __webpack_require__(222),
	  'toInteger': __webpack_require__(90),
	  'toPath': __webpack_require__(227)
	};


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var baseConvert = __webpack_require__(210),
	    util = __webpack_require__(213);
	
	/**
	 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
	 * version with conversion `options` applied. If `name` is an object its methods
	 * will be converted.
	 *
	 * @param {string} name The name of the function to wrap.
	 * @param {Function} [func] The function to wrap.
	 * @param {Object} [options] The options object. See `baseConvert` for more details.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function convert(name, func, options) {
	  return baseConvert(util, name, func, options);
	}
	
	module.exports = convert;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(214),
	    func = convert('sample', __webpack_require__(223), __webpack_require__(211));
	
	func.placeholder = __webpack_require__(85);
	module.exports = func;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(53);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(118),
	    hasPath = __webpack_require__(162);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(52),
	    baseIteratee = __webpack_require__(126);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name, the created function returns the
	 * property value for a given element. If `func` is an array or object, the
	 * created function returns `true` for elements that contain the equivalent
	 * source properties, otherwise it returns `false`.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, _.iteratee(['user', 'fred']));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, _.iteratee('user'));
	 * // => ['barney', 'fred']
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	 *     return func.test(string);
	 *   };
	 * });
	 *
	 * _.filter(['abc', 'def'], /ef/);
	 * // => ['def']
	 */
	function iteratee(func) {
	  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	}
	
	module.exports = iteratee;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(22);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 220 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(130),
	    basePropertyDeep = __webpack_require__(131),
	    isKey = __webpack_require__(33),
	    toKey = __webpack_require__(9);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(30),
	    flatRest = __webpack_require__(155);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = flatRest(function(func, indexes) {
	  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	});
	
	module.exports = rearg;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var arraySample = __webpack_require__(48),
	    baseSample = __webpack_require__(132),
	    isArray = __webpack_require__(2);
	
	/**
	 * Gets a random element from `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 * @example
	 *
	 * _.sample([1, 2, 3, 4]);
	 * // => 2
	 */
	function sample(collection) {
	  var func = isArray(collection) ? arraySample : baseSample;
	  return func(collection);
	}
	
	module.exports = sample;


/***/ },
/* 224 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(226);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(3),
	    isSymbol = __webpack_require__(10);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(26),
	    copyArray = __webpack_require__(15),
	    isArray = __webpack_require__(2),
	    isSymbol = __webpack_require__(10),
	    stringToPath = __webpack_require__(83),
	    toKey = __webpack_require__(9),
	    toString = __webpack_require__(91);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(137),
	    keys = __webpack_require__(11);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(20),
	    LodashWrapper = __webpack_require__(43),
	    baseLodash = __webpack_require__(28),
	    isArray = __webpack_require__(2),
	    isObjectLike = __webpack_require__(7),
	    wrapperClone = __webpack_require__(204);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 230 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(92);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(92);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 233 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/animate_logo.js
 **/